// China
export const locale = {
	lang: 'ch',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: '实际值' },
			GRAPH: {
				BASELINE_TIMESTAMP: '基准时间戳',
				NO_DATA: '未找到数据！',
				RUN_SIMULATION_TITLE: '运行模拟以查看图表结果',
				RUN_SIMULATION_HINT: '配置模拟参数后，点击“运行”。',
				RAW_TAG_DEPENDENCY: '原始标签依赖',
				BASELINE: '基准',
				SIMULATION: '模拟',
				SIMULATED: '模拟值',
			},
			SEARCH: {
				PLACEHOLDER: '搜索设施、系统、机组或标签',
				SEARCHING: '搜索中…',
				NO_RESULTS: '未找到匹配项',
				ERROR: '搜索失败，请重试。',
			},
			TABLE: {
				DELTA_TOOLTIP: '绝对变化（模拟值 − 基线）',
				DELTA_PERCENT_TOOLTIP: '相对于基线的百分比变化',
				IMPACT_PROGRESS: '影响进度',
				IMPACT: '影响',
			},
			IMPACTED_KPI: {
				TITLE: '受影响的计算KPI ({{count}})',
				NO_IMPACTED_KPIS: '暂无受影响的KPI',
				EMPTY_HINT: '在左侧选择原始标签以查看下游KPI影响。',
				LOADING: '正在加载计算标签...',
				SELECTION_HINT: '主系统中已选择{{total}}个KPI中的{{checked}}个 — 取消选中以从模拟中排除。“Driven by”标签显示哪些原始标签影响每个KPI。共享相同标签签名的同级系统在下方列为只读的跨系统影响。',
				CROSS_SYSTEM_IMPACT: '跨系统影响',
				KPI_COUNT: '{{count}} 个KPI',
				TAG_PARAMETER: '标签 / 参数',
				CALCULATED_TAG: '计算标签',
				DRIVEN_BY: '驱动因素：',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: '选择要模拟的原始标签',
				SELECT_RAW_TAGS_SUBTITLE: '从下方层级中选择标签',
				SIMULATION_SETUP_TITLE: '模拟设置',
				SIMULATION_SETUP_SUBTITLE: '在上方选择标签以开始',
				RUN: '运行',
				RESET: '重置',
				NO_TAGS_SELECTED: '未选择标签',
				NO_TAGS_SELECTED_DESC: '在上方选择原始标签以定义更改。',
				CLICK_TIMESTAMP_HINT: '点击图表上任意位置以选择运行状态时间戳。',
				CLICK_RANGE_HINT: '在图表上点击两次以选择运行状态范围。',
				SELECTED_OPERATING_STATE: '已选运行状态：',
				SELECTED_OPERATING_RANGE: '已选运行范围：',
				FIRST_POINT_PREFIX: '起点：',
				FIRST_POINT_SUFFIX: '— 再次点击以设置范围终点。',
				SIMULATION_RESULTS: '模拟结果',
				TABLE_VIEW: '表格视图',
				RUN_SIMULATION_TABLE_TITLE: '运行模拟以查看表格结果',
				TABLE_UNAVAILABLE_PERIOD: '表格视图不适用于时间段模拟',
				SWITCH_TO_SINGLE_POINT: '切换到“单点”模式或使用图表视图选项卡。',
				NO_KPI_ROWS: '没有可显示的KPI行',
				NO_KPI_ROWS_DESC: '所有受影响的KPI均未选中。请在受影响KPI选项卡中选择KPI以在此处查看。',
				GRAPH_VIEW: '图表视图',
				SIMULATION_TYPE_PERCENT: '百分比变化',
				SIMULATION_TYPE_ABSOLUTE: '绝对值',
				TIME_CONTEXT_SINGLE: '单点',
				TIME_CONTEXT_PERIOD: '时间段',
			},
			IMPACTED_KPIS_TAB_LABEL: '受影响的KPI',
			IMPACTED_KPIS_TAB_LABEL_COUNT: '受影响的KPI ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: '标签名称',
				TAG_ID: '标签ID',
				TAG_DESCRIPTION: '描述',
				ASSET_NAME: '资产名称',
				SYSTEM_NAME: '系统名称',
			},
		},
		TRANSLATOR: {
			SELECT: '选择你的语言',
		},
		VALIDATION: {
			REQUIRED: '此字段为必填项',
			PATTERN: '格式无效',
			MIN: '数值过小',
			MAX: '数值过大',
			MIN_LENGTH: '长度过短',
			MAX_LENGTH: '长度过长',
			SELECT_AT_LEAST_ONE: '请至少选择一个选项',
			INVALID: '无效值',
			FIELD_REQUIRED: '{{field}}为必填项',
		},
		COMMON: {
			NO_MATCHES: '未找到“{{keyword}}”的结果',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
			SELECT_A_SYSTEM: '请选择一个系统。',
			SELECT_DIFF_UNIT: '选择其他单元或工厂',
			SELECT_DIFF: '选择其他工厂、单元或系统',
			NO_TAGS_FOUND: '未找到标签',
			SELECT_FACILITY: '选择其他工厂',
			ADDED_FROM_ROOTY: '由{{name}}添加',
		},
		COMMENT_POPUP: {
			TITLE: '留下评论',
			ENTER_MESSAGE: '请输入您的消息',
			COMMENT_PLACEHOLDER: '添加评论，使用 @ 标记团队成员',
			FILE_SIZE_LIMIT_ERROR: '由于文件大小限制，{{fileName}} 上传失败。',
			UPLOAD_FAILED_ERROR: '{{fileName}} 上传失败。',
			INVALID_FILES_ERROR: '未选择有效文件。仅允许扩展名为 {{extensions}} 的文件',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: '重新生成假设',
			DESCRIPTION: '系统将根据针对因果链、建议和拟议证据提供的反馈重新生成所有假设。当前版本将保存至历史记录。',
			REGENERATION_CONTEXT: '重新生成上下文',
			TOTAL_FEEDBACKS: '反馈总数',
			ADDED_AS_EVIDENCE: '已添加为证据',
			APPROVED: '已批准',
			RELEARNED: '已重新学习',
			SETTINGS: '设置',
			DOCUMENT_INSIGHTS: '文档洞察',
			SAP_INSIGHTS: 'SAP 洞察',
			CONNECTED_SYSTEMS_REVIEW: '关联系统审查',
			ALERT_REVIEW_WINDOW: '告警审查窗口',
			DAYS: '天',
			RESET_AND_RERUN: '重置并重新运行',
			RESET_AND_RERUN_INFO: '将忽略此前的假设、反馈、建议和拟议证据。系统将仅使用最新可用数据从头生成根本原因分析。',
			VERSION_HISTORY_NOTE: '当前假设将保存至版本历史记录，您可以随时恢复以前的版本。',
			USER_CONSENT: '我理解此次运行将不使用此前的根本原因分析上下文。',
			CANCEL: '取消',
			REGENERATE_ALL: '全部重新生成',
			REGENERATE_ALL_TOOLTIP: '利用现有上下文改进当前根本原因分析',
			RESET_AND_RERUN_BTN: '重置并重新运行',
			RESET_AND_RERUN_TOOLTIP: '从头生成新的根本原因分析',
		},
		SHARE_REPORT_POPUP: {
			TITLE: '分享报告',
			ADD_PEOPLE: '添加人员',
			MESSAGE: '留言',
			MESSAGE_PLACEHOLDER: '输入留言（可选）',
			COPY_LINK: '复制链接',
			CANCEL: '取消',
			SEND: '发送',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: '此前已批准',
			PREVIOUSLY_RELEARNED: '此前已重新学习',
			SEE_LESS: '收起',
			SEE_MORE: '查看更多...',
			FEEDBACK_LABEL: '反馈',
			FEEDBACK_TOOLTIP: '此反馈将在根因分析重新运行时使用。',
			CANCEL: '取消',
			CONFIRM: '确认',
			RELEARNED_BY: '重新学习者：',
			NO_REASON_ADDED: '未添加原因',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: '输入您的消息以开始聊天',
			MESSAGE_PLACEHOLDER: '请输入您的消息...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: '后续建议',
			ASK_TITLE: '询问{{name}}',
			UPLOAD_TOOLTIP: '上传 PDF、Word、Excel、PNG、JPG 和 JPEG 文件，供{{name}}分析。',
			DISCLAIMER: '{{name}}提供人工智能辅助的回复，可能并不总是准确。请在采取行动前进行核实。',
			FEEDBACK_SUBTITLE: '请选择主要问题，以便我们改进{{name}}未来的回复。',
			POPUP_TITLE: '询问{{name}}',
			NOT_ENABLED: '当前用户未启用{{name}}。',
			SHARE: '分享',
			RENAME: '重命名',
			DELETE: '删除',
			HISTORY: '历史记录',
			CLOSE: '关闭',
			SEARCH: '搜索...',
			UNSAVED: '未保存',
			NO_HISTORY_HEADING: '暂无历史记录。',
			NO_HISTORY_DESC: '未找到历史数据。',
			START_NEW_CHAT: '开始新对话',
			AGENT_CONTEXT_TOOLTIP: '智能体上下文',
			CHAT_HISTORY_TOOLTIP: '聊天记录',
			UNPIN: '取消固定',
			PIN: '固定',
			FULL_SCREEN: '全屏',
			EXIT_FULL_SCREEN: '退出全屏',
			EXPAND: '展开',
			COLLAPSE: '折叠',
			INTRO_TITLE: '您好!需要帮助了解您正在查看的内容吗?',
			INTRO_DESC: '随便问我什么,或者我可以总结此屏幕、解释趋势、比较项目并建议下一步措施。',
			SUGGESTIONS: '建议',
			SUGGESTION_1: '用30秒总结此根因分析(发生了什么以及原因)。',
			SUGGESTION_2: '哪个假设最能得到此处所示证据的支持?',
			SUGGESTION_3: '比较各假设:每个假设最有力的证据是什么?',
			CP_INTRO_TITLE: '您好!需要帮助进行产能优化和情景规划吗?',
			CP_INTRO_DESC: '我可以帮助您构建规划模型、测试机组跳闸应急情况、模拟峰值负荷增长,并分析电力与水资源的可行性结果。',
			CP_SUGGESTION_1: '总结本次运行的总发电成本、燃料消耗和各电站明细。',
			CP_SUGGESTION_2: '我们的旋转备用裕度是多少?是否存在缺口时段?',
			CP_SUGGESTION_3: '如果H5_GT在高峰需求期间跳闸会怎样?',
			CP_SUGGESTION_4: '模拟该情景下峰值电力需求增长+5%。',
			LOADING_EARLIER: '正在加载更早的对话…',
			SHOW_EARLIER: '显示更早的对话',
			RESPONSE_STOPPED: '响应生成已停止',
			LOADING_ALT: '加载中',
			THINKING: '思考中',
			THOUGHT_FOR: '思考了{{seconds}}秒',
			DOWNLOAD_CSV: '下载CSV',
			COPY_CSV: '复制CSV',
			DOWNLOAD_IMAGE: '下载图片',
			COPY_IMAGE: '复制图片',
			WHAT_IF_SCENARIO_CREATED: '已创建What-If情景',
			CHANGE_APPLIED: '已应用的更改:',
			NEW_SCENARIO: '新情景:',
			VIEW_CONFIGURATION: '查看配置',
			RUN_OPTIMIZATION: '运行优化',
			RESULTS_COMPARISON: '结果比较',
			ALL_IMPROVED: '全部改善',
			KPI: 'KPI',
			BASE: '基准',
			WHAT_IF: 'What-If',
			YES: '是',
			NO: '否',
			CHANGED: '已更改',
			WHATIF_KPI_POWER_FEASIBLE: '电力可行性',
			WHATIF_KPI_WATER_FEASIBLE: '水量可行性',
			WHATIF_KPI_EST_COST: '预估成本',
			WHATIF_KPI_POWER_SHORTFALL: '电力缺口',
			WHATIF_KPI_WATER_SHORTFALL: '水量缺口',
			WHATIF_KPI_AVG_GENERATION: '平均发电量',
			WHATIF_KPI_AVG_HEADROOM: '平均余量',
			WHATIF_KPI_TOTAL_STARTS: '启动总次数',
			WHATIF_KPI_AVG_WATER_OUTPUT: '平均产水量',
			WHATIF_KPI_GAP_PERCENT: '差距 %',
			WHATIF_POWER_BALANCE: '电力平衡（MW）',
			WHATIF_TIME_AXIS: '时间',
			WHATIF_POWER_AXIS: '电力（MW）',
			WHATIF_WATER_OUTPUT: '产水量（MIGD）',
			WHATIF_WATER_AXIS: '水量（MIGD）',
			WHATIF_TRACE_DEMAND: '需求',
			WHATIF_TRACE_GEN: '发电',
			WHATIF_TRACE_WATER: '水量',
			NO_MAJOR_DIFF: '两个情景之间没有KPI变化超过5%。',
			VIEW_FULL_RESULTS: '查看完整结果',
			APPLY_AS_EVIDENCE: '应用为证据',
			ADDED_AS_EVIDENCE: '已添加为证据',
			ALREADY_ADDED_AS_EVIDENCE: '已添加为证据',
			ADD_AS_EVIDENCE: '添加为证据',
			BRANCH_VISIBILITY_NOTICE: '新消息仅您可见。',
			CONTINUE: '继续',
			SEARCH_SCENARIOS: '搜索情景...',
			FILTER_SCENARIOS: '筛选情景',
			SOURCE: '来源',
			ALL_SOURCES: '所有来源',
			HUMAN_MANUAL: '手动(人工)',
			AI_GENERATED: 'AI生成',
			STRATEGY_AUTO: '策略(自动)',
			DATE_MODIFIED: '修改日期',
			ALL_TIME: '所有时间',
			TODAY: '今天',
			LAST_7_DAYS: '最近7天',
			RECENT: '最近',
			OFFICIAL: '官方',
			ALL_SCENARIOS: '所有情景',
			NO_SCENARIOS_MATCH: '没有与"{{query}}"匹配的情景',
			DRAFT: '草稿',
			DISMISS: '关闭',
			CONTEXT_PREFIX: '上下文:',
			REMOVE_CONTEXT: '移除上下文',
			SELECT_A_SCENARIO: '选择情景',
			CLEAR_SCENARIO: '清除情景',
			LATEST_RUN_DEFAULT: '最新运行(默认)',
			DROP_FILES_HERE: '将文件拖放到此处',
			COMPOSER_PLACEHOLDER: '提出问题或请求...',
			ADD_FILES_OR_IMAGES: '添加文件或图片',
			LANGUAGE: '语言',
			MIC_BLOCKED: '麦克风访问被阻止。请允许麦克风权限',
			USE_VOICE_INPUT: '使用语音输入',
			VOICE_INPUT_ALT: '语音输入',
			STOP_RECORDING: '停止录音',
			STOP_RECORDING_ALT: '停止录音',
			STOP_GENERATION: '停止生成',
			SEND_ALT: '发送',
			FEEDBACK_WHAT_WENT_WRONG: '此响应哪里出了问题?',
			FEEDBACK_CATEGORY: '反馈类别',
			SELECT_AN_ISSUE: '选择一个问题',
			SELECT_CATEGORY_TO_CONTINUE: '请选择一个类别以继续',
			ADDITIONAL_DETAILS_OPTIONAL: '附加详情(可选)',
			FEEDBACK_COMMENT_PLACEHOLDER: '告诉我们更多关于问题的信息。',
			CANCEL: '取消',
			SUBMIT_FEEDBACK: '提交反馈',
			ERROR: '错误',
			FEEDBACK_SUBMIT_ERROR: '无法提交反馈。请重试。',
			TRY_AGAIN: '重试',
			OPEN_LINK: '打开链接',
			OPEN_DOCUMENT: '打开文档',
			PAGE_PREFIX: '第{{page}}页',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: '回答错误',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: '未回答我的问题',
			FEEDBACK_CATEGORY_MISSING_DATA: '缺少相关数据',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: '分析或推理错误',
			FEEDBACK_CATEGORY_POOR_CHART: '图表或可视化效果差',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: '文档回答质量差',
			FEEDBACK_CATEGORY_TOO_SLOW: '查询速度太慢',
			FEEDBACK_CATEGORY_INCOMPLETE: '回答不完整',
			FEEDBACK_CATEGORY_OTHER: '其他',
			CHATBOT_PRIVATE: '私有',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: '英语（美国）',
			LANGUAGE_ARABIC: '阿拉伯语',
			MODE_AUTO: '自动',
			MODE_GENERAL: '通用',
			MODE_DOCS: '文档',
			MODE_OPTIMIZER: '优化器',
			DATE_TODAY: '今天',
			DATE_YESTERDAY: '昨天',
			DATE_THIS_WEEK: '本周',
			DATE_LAST_WEEK: '上周',
			DATE_THIS_MONTH: '本月',
			DATE_LAST_MONTH: '上月',
			DATE_OLDER: '更早',
			CONTEXT: {
				FROM: '来自 {{source}} 的上下文',
				LAUNCHED_FROM: 'Rooty 从 {{source}} 启动',
				UPDATED: '上下文已更新',
				REMOVED: '上下文已移除',
				APPLIED: '上下文已应用',
				GENERAL: '现在使用通用聊天上下文',
				MORE: '更多',
				SEE_LESS: '收起',
				LABEL: {
					ALERT: '告警',
					RCA: 'RCA',
					SCOPE: '范围',
					SYSTEM: '系统',
					SCENARIO: '场景',
					SIMULATION_TYPE: '仿真类型',
					PREVIOUS: '之前',
					NEW: '新',
					SOURCE: '来源',
				},
				SOURCE: {
					ALERT: '告警详情',
					RCA: 'RCA',
					SYSTEM: '系统视图',
					WHAT_IF: '假设分析',
				},
				SUMMARY: {
					ALERT: '告警 {{value}}',
					RCA: '告警 {{value}} 的 RCA',
					SYSTEM: '系统 {{value}}',
					WHAT_IF: '假设分析：{{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: '谢谢，我们将用它来改进 Rooty。',
			TOAST_FEEDBACK_POSITIVE_THANKS: '感谢您的反馈。',
			TOAST_COPIED_MESSAGE: '已复制消息。',
			TOAST_LINK_COPIED: '已复制',
			TOAST_CHAT_DELETED: '对话已删除',
			TOAST_CHAT_DELETE_FAILED: '删除对话失败。',
			TOAST_NEW_CHAT_STARTED: '新对话已开始',
		},
		AGENT_CONTEXT: {
			CONSIDERED: '已考虑的代理上下文',
			ITEMS: '项',
			ADD: '添加代理上下文',
			UPDATED: '更新于',
			DIALOG_DESC: '为{{name}}和RCA记录可重复使用的操作指导。',
			DIALOG_DISCLAIMER: '此上下文可能会影响{{name}}和RCA未来对相似分析的响应。它不会影响异常检测或预测模型。',
			SIDEPANEL_DESC: '{{name}}和RCA可使用的可重复使用的操作知识。',
			SIDEPANEL_EMPTY: '为{{name}}和RCA记录可重复使用的操作知识，例如推理指导、调查手册和术语。',
			REMOVE_CONFIRM: '"<strong>{{title}}</strong>"将被移除，{{name}}或RCA将不再考虑它。<br>此操作无法撤销。',
			TITLE: '智能体上下文',
			READ_ONLY: '只读',
			ADD_SHORT: '添加',
			CLOSE: '关闭',
			SEARCH_PLACEHOLDER: '按标题或范围搜索...',
			EDIT: '编辑',
			DELETE: '删除',
			EMPTY_HEADING: '暂无智能体上下文',
			LAST_UPDATED_PREFIX: '最后更新',
			BY_PREFIX: '由',
			SECTION_CONTEXT_TYPE: '1. 上下文类型',
			SECTION_SCOPE: '2. 范围',
			SECTION_CONTEXT: '3. 上下文',
			SELECT_SCOPE: '选择范围',
			CONTEXT_TITLE_LABEL: '标题',
			CONTEXT_TITLE_PLACEHOLDER: '输入上下文标题',
			GUIDANCE_LABEL: '指导说明',
			GUIDANCE_PLACEHOLDER: '输入指导说明',
			PLAYBOOK_NAME_LABEL: '手册名称',
			PLAYBOOK_NAME_PLACEHOLDER: '输入手册名称',
			INVESTIGATION_STEPS_LABEL: '调查步骤',
			STEP_PLACEHOLDER: '输入步骤说明',
			ADD_STEP: '+ 添加步骤',
			TERM_HEADER: '术语',
			MEANING_HEADER: '含义',
			TERM_PLACEHOLDER: '添加术语',
			MEANING_PLACEHOLDER: '输入含义',
			CANCEL: '取消',
			CARD_REASONING_GUIDANCE_TITLE: '推理指导',
			CARD_REASONING_GUIDANCE_DESC: '帮助AI智能体推理行为的工厂特定解释规则。',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: '调查手册',
			CARD_INVESTIGATION_PLAYBOOK_DESC: '针对重复出现的运营问题的结构化故障排除工作流程。',
			CARD_TERMINOLOGY_TITLE: '术语',
			CARD_TERMINOLOGY_DESC: '工厂特定的别名、缩写和命名规范。',
			SAVE_IN_PROGRESS: '正在保存，请稍候。',
			SCOPE_REQUIRED: '保存前需要选择范围。',
			TITLE_REQUIRED: '保存前需要标题。',
			GUIDANCE_DESC_REQUIRED: '保存前需要指导说明。',
			PLAYBOOK_NAME_REQUIRED: '保存前需要手册名称。',
			STEPS_REQUIRED: '保存前必须填写所有调查步骤。',
			TERMINOLOGY_REQUIRED: '保存前所有术语条目必须同时包含术语和含义。',
			SOME_ERROR_OCCURRED: '发生了一些错误',
			EDIT_TITLE: '编辑智能体上下文',
			SAVE_CHANGES: '保存更改',
			DELETE_CONTEXT_TITLE: '删除此上下文？',
			DELETED_SUCCESSFULLY: '删除成功。',
		SECTION_GUIDANCE: '指导',
		TERMS_LABEL: '术语',
		REASONING_LABEL: '推理',
		PLAYBOOK_LABEL: '手册',
		},
		MENU: {
			NEW: '新',
			ACTIONS: '行动',
			CREATE_POST: '创建新帖子',
			PAGES: 'Pages',
			FEATURES: '特征',
			APPS: '应用',
			HOME: '主页',
			SYSTEM: '系统',
			ANALYSIS: '分析',
			CONFIGURATION: '配置',
			ALERTS: '警报',
			ALERT_TRIAGE: '警报分类',
			KNOWLEDGE_GRAPH: '知识图谱',
			ASSET_EXPLORER: '资产资源管理器',
			LIBRARY: '资料库',
			USER_MANAGEMENT: '用户管理',
			MODEL_WIZARD: '模型向导',
			DASHBOARD_WIZARD: '仪表板向导',
			IOW: 'IOW',
			PROCESS: '流程',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: '维护优化',
			RCM: 'RCM',
			SETTINGS: '设置',
			HAZOP: 'Hazop',
			CASES: '案例',
			CAPACITY_OPTIMIZATION: '容量优化',
			WHAT_IF: '假设分析',
			HEALTH_METRICS: '健康指标',
			PLATFORM_CONFIGURATION: '平台配置',
			DATA_MANAGEMENT: '数据管理',
			PLATFORM_POLICIES: '平台政策',
			CONNECTIONS_APIS: '连接与 API',
			MODULE_CONFIGURATION: '模块配置',
			AI_MANAGEMENT: 'AI 管理',
			ROOTY: '{{name}}',
			NOTIFICATION: '通知',
			HELP: '帮助',
			PROFILE: '我的个人资料',
			LOGOUT: '登出',
			LANGUAGE: '语言',
			BASIC_USER_GUIDE: '基础用户指南',
			ADVANCED_USER_GUIDE: '高级用户指南'
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: '密码必须包含：',
				MIN_CHARACTERS: '最少 8 个字符',
				UPPERCASE_LETTER: '至少 1 个大写字母',
				NUMBER: '至少 1 个数字',
				SPECIAL_CHARACTER: '至少 1 个特殊字符',
			},
			GENERAL: {
				OR: '要么',
				SUBMIT_BUTTON: '提交',
				NO_ACCOUNT: '没有账号？',
				SIGNUP_BUTTON: '注册',
				FORGOT_BUTTON: '忘记密码',
				BACK_BUTTON: '背部',
				PRIVACY: '隐私',
				LEGAL: '法律',
				CONTACT: '联系',
				VERIFY_BUTTON: '验证',
				ENTER_OTP: '输入验证码',
				HAVE_ACCOUNT: '我已有账号',
			},
			LOGIN: {
				TITLE: '创建帐号',
				BUTTON: '签到',
				SIGN_IN_MICROSOFT: '使用Microsoft登录',
				SIGN_IN_SAML: '使用SAML登录',
				REMEMBER_ME: '记住我',
				SIGNING_IN: '正在登录，请稍候...',
				BPCL_WELCOME: '欢迎使用BPCL基于人工智能的资产性能解决方案！',
			},
			RESET: {
				TITLE: '重置密码',
				SUCCESS: '密码修改成功。',
				NEWPASSWORD: '新密码',
				REENTERNEWPASSWORD: '确认密码',
				VERIFICATION_CODE_SENT: '请输入发送至以下地址的验证码',
				NO_CODE_RECEIVED: '没有收到验证码？',
				RESEND: '重新发送',
				RESEND_IN: '剩余',
			},
			FORGOT: {
				TITLE: '忘记密码？',
				DESC: '输入您的电子邮件以重置密码',
				SUCCESS: '验证码已发送至您的邮箱。',
				REQUEST_RESET_BUTTON: '请求重置密码',
				BACK_TO_SIGNIN: '返回登录',
			},
			REGISTER: {
				TITLE: '注册',
				DESC: '输入您的详细信息以创建帐户',
				SUCCESS: '您的账户已成功注册。',
				ORGANIZATION_NAME: '组织名称',
				NAME: '姓名',
				AGREE_PREFIX: '我同意',
				TERMS_CONDITIONS: '条款和条件',
				EMAIL_ALREADY_REGISTERED: '该电子邮箱已被注册。',
			},
			INPUT: {
				EMAIL: '电子邮件',
				EMAIL_ADDRESS: '电子邮件地址',
				FULLNAME: '姓名',
				PASSWORD: '密码',
				CONFIRM_PASSWORD: '确认密码',
				USERNAME: '用戶名'
			},
			PLACEHOLDER:{
				EMAIL: '输入电子邮箱',
				PASSWORD: '输入密码'
			},
			VERIFY:{
				VERIFY_EMAIL: '电子邮箱验证',
				BACK_TO_SIGNIN: '返回登录',
			},
			SUBSCRIPTION: {
				EXPIRED: '您的订阅已过期。',
				RENEW: '请立即续订或联系支持人员寻求帮助。',
			},
			VALIDATION: {
				INVALID: '{{name}}无效',
				INVALID_EMAIL: '输入有效的电子邮件地址',
				REQUIRED: '{{name}}是必填项',
				MIN_LENGTH: '{{name}}的最小长度为{{min}}',
				AGREEMENT_REQUIRED: '需要接受条款和条件',
				NOT_FOUND: '找不到请求的{{name}}',
				INVALID_LOGIN: '登录信息不正确',
				INVALID_RESET: '输入的OTP不正确或已过期。请重试。',
				REQUIRED_FIELD: '必填字段',
				MIN_LENGTH_FIELD: '最小字段长度：',
				MAX_LENGTH_FIELD: '最大字段长度：',
				INVALID_FIELD: '字段无效',
				OTP_REQUIRED: '输入发送到您电子邮件的验证码。'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: '顾客',
				CUSTOMERS_LIST: '客户名单',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: '健康指标',
			SYSTEM_MODEL_METRICS: '系统与模型健康指标',
			DATA_FEED_HEALTH: '数据流健康',
			QC_CHECK: 'QC检查',
			QC: {
				RAW_TAG_QC: '原始标签QC',
				CALCULATED_TAG_QC: '计算标签QC',
				MODEL_QC: '模型QC',
				COMING_SOON: '即将推出',
				CONFIGURATION: 'QC检查配置',
				ALL_TAGS: '所有标签',
				PROBLEM_TAGS: '问题标签',
				SEARCH: '搜索...',
				COLUMN_CONFIG: '列配置',
				ADD_TAG: '添加标签',
				EXPORT: '导出',
				UPLOAD: '上传标签 (Excel)',
				DOWNLOAD: '下载标签 (Excel)',
				VIEW: '查看',
				EDIT: '编辑',
				NO_TAGS_FOUND: '未找到标签',
				ADD_DESCRIPTION: '添加描述',
				ADD_UOM: '添加单位',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: '系统名称',
				COL_TAG_NAME: '标签名称',
				COL_TAG_ID: '标签ID',
				COL_TAG_DESCRIPTION: '标签描述',
				COL_UOM: '单位',
				COL_IR_UPPER: 'IR上限',
				COL_TRIP_UPPER: '跳闸上限',
				COL_ALARM_UPPER: '报警上限',
				COL_THRES_UPPER: '阈值上限',
				COL_OPS_UPPER: '运行上限',
				COL_OPS_LOWER: '运行下限',
				COL_THRES_LOWER: '阈值下限',
				COL_ALARM_LOWER: '报警下限',
				COL_TRIP_LOWER: '跳闸下限',
				COL_IR_LOWER: 'IR下限',
				COL_FLATLINE: '平线检测',
				COL_OUTLIER: '异常值检测',
				COL_RANGE: '超出范围检测',
				COL_MISSING_DATA: '缺失数据检测',
				COL_FLATLINE_ALERT: '平线警报生成',
				COL_OUTLIER_ALERT: '异常值警报生成',
				COL_RANGE_ALERT: '超出范围警报生成',
				COL_MISSING_DATA_ALERT: '缺失数据警报生成',
				COL_ATTENTION: '注意',
				COL_THRES_NOT: '阈值通知',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: '方向性',
				COL_IOW_LOWER: 'IOW 下限',
				COL_IOW_UPPER: 'IOW 上限',
				COL_ACTIONS: '操作',
				COL_DESCRIPTION: '描述',
				EDIT_TAG: '编辑标签',
				LOWER: '下限',
				UPPER: '上限',
				INSTRUMENT_RANGE: '仪器范围',
				TRIP_LIMITS: '跳闸限值',
				ALARM_LIMITS: '报警限值',
				THRESHOLD_LIMITS: '阈值限制',
				DIRECTIONALITY: '方向性',
				IOW_CRITICALITY: 'IOW关键性',
				FLATLINE_DETECTION: '平线检测',
				THRESHOLD_NOTIFICATION: '阈值通知',
				ASSET: '资产',
				CALCULATED_FLAG: '计算标志',
				REMARK: '备注',
				REMARK_PLACEHOLDER: '输入备注进行编辑',
				CANCEL: '取消',
				SAVE: '保存',
			},
			DATA_FEED: {
				TITLE: '数据流健康 (历史监控)',
				ALL_TAGS: '所有标签',
				GOOD_TAGS: '良好标签',
				BAD_TAGS: '不良标签',
				GROUP_BY: '分组依据',
				DOWNLOAD: '下载',
				NO_TAGS_FOUND_TITLE: '未找到标签',
				NO_TAGS_FOUND_DESC: '检查您的过滤器和日期范围',
				TAGS: '标签',
				SHOW: '显示',
				MORE_TAGS: '更多标签',
				NO_TAGS: '未找到标签。',
				SYSTEM_NAME: '系统名称',
				VALUE: '值',
				QUALITY: '质量',
				TIMESTAMP: '时间戳',
				TAG_NAME: '标签名称',
				TAG_ID: '标签ID',
			},
			MODEL_HEALTH: {
				TITLE: '系统与模型健康指标',
				ALL_SYSTEMS: '所有系统',
				PROBLEM_SYSTEMS: '问题系统',
				NO_PROBLEM_SYSTEMS: '未发现问题系统',
				SEARCH: '搜索...',
				REFRESH: '刷新数据',
				DOWNLOAD: '下载',
				SYSTEM_NAME: '系统名称',
				STATUS: '状态',
				DEPLOYED_VERSION: '已部署版本',
				LAST_DATA_PULL: '最后数据拉取',
				DATA_HEALTH: '数据健康',
				MODEL_HEALTH: '模型健康',
				PREDICTION_TIME: '预测时间',
				LAST_PREDICTION: '最后预测',
				PREDICTIONS_OLDER_THAN_2_HOURS: '预测超过2小时的系统被标记为问题系统',
				LAST_DATA_WRITTEN: '最后数据写入',
				LAST_ANOMALY_WRITTEN: '最后异常写入',
				FETCH_STATUS: '抓取状态',
				FETCH_RATE: '抓取率',
				FETCH_SAMPLING_RATE: '抓取采样率',
				PREDICTION_STATUS: '预测状态',
				PREDICTION_RATE: '预测率',
				SAMPLING_RATE: '采样率',
				ACTIONS: '操作',
				CUSTOMIZE_COLUMNS: '自定义列',
				NO_DATA_MATCHING: '所选资产无可用数据',
				DEPLOYED_DATE: '部署日期',
				DEPLOYED_BY: '部署者',
				DEPLOYMENT_NOTE: '部署备注',
				ACTIVE_ALERTS: '活动警报',
				RETRAINING_RECOMMENDED: {
					TITLE: '建议重新训练',
					DESCRIPTION: '最近的评估表明该模型可能不再反映当前运行行为。以下标签对此建议贡献最大。',
					CONTRIBUTING_TAGS: '贡献标签（最多5个）',
					TAG_NAME_AND_ID: '标签名称和ID',
					TAG_TOOLTIP: '名称: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: '贡献分数',
					LAST_EVALUATED: '最后评估',
					MODEL_VERSION: '模型',
					COPY_TAGS: '复制标签',
					COPY_FULL_DETAILS: '复制完整详情',
					RETRAIN_MODEL: '重新训练模型',
					RETRAIN: '重新训练',
					TIP_PREFIX: '提示：点击模型健康列中的',
					TIP_SUFFIX: '标签，查看建议重新训练的原因。',
					NO_TAGS: '未找到贡献标签。',
					TAGS_COPIED: '标签已复制。\n可在剪贴板中使用。',
					DETAILS_COPIED: '详情已复制。\n可在剪贴板中使用。',
					RECOMMENDED_DATE_RANGE: '建议重新训练日期范围',
					RECOMMENDED_DATE_RANGE_HINT: '使用此日期范围查看并使用最相关的数据重新训练模型。',
					NO_DATE_RANGE: '没有可用于重新训练模型的日期范围',
					ADD_COMMENT: '添加评论',
					ADD_COMMENT_PLACEHOLDER: '添加原因',
					START_RETRAINING: '开始重新训练',
					BACK: '返回',
					FORCE_INCLUDE_BANNER: '推荐区间已自动添加为 Force Include 范围。',
					TRAINING_PERIOD: '训练周期',
					EXISTING_TRAINING_REGION: '现有训练区间',
					CURRENT_MODEL_VERSION: '当前模型版本',
					RECOMMENDED_REGION: '推荐区间',
					FROM_MODEL_HEALTH_EVALUATION: '来自模型健康评估',
					NO_TRAINING_RANGES: '没有可用的训练区间。',
					LOADING_RANGES: '正在加载训练区间...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: '显示列',
				SEARCH: '搜索...',
				SELECT_ALL: '全选',
				RESET_TO_DEFAULT: '重置为默认'
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: '表达式',
				EXPRESSION_DESCRIPTION: '表达式说明'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: '运行质检',
				RUN_QC_SELECTED: '对所选运行质检',
				RUN_QC_TOOLTIP: '对当前记录运行数据质量代理',
				RUNNING: '正在运行质检',
				DETAIL_TITLE: '维护记录',
				TAB_DETAILS: '详情',
				TAB_REVIEW: '审查',
				NO_DETAILS: '无可用详情。',
				VIEW_DETAILS: '查看详情',
				FIELDS: {
					NOTIFICATION_NO: '通知编号',
					ORDER: '工单',
					TYPE: '类型',
					EQUIPMENT: '设备',
					EQUIPMENT_DESC: '设备描述',
					FUNCTIONAL_LOC: '功能位置',
					PLAN_GROUP: '计划组',
					PLAN_GROUP_DESC: '计划组描述',
					MAINTENANCE_PLANT: '维护工厂',
					MAINTENANCE_PLANT_DESC: '维护工厂描述',
					PLANT_SECTION: '工厂区域',
					PRIORITY: '优先级',
					DAMAGE: '损坏',
					DESCRIPTION: '描述',
					STATUS: '状态',
					USER_STATUS: '用户状态',
					CREATED_ON: '创建时间',
					COMPLETED_ON: '完成时间',
					BREAKDOWN_DURATION: '停机时长',
					INTERNAL_LABOUR: '内部人工成本',
					EXTERNAL_LABOUR: '外部人工成本',
					EXTERNAL_SERVICE: '外部服务成本'
				},
				LAST_RUN: '上次质检运行',
				VIEW_FINDINGS: '查看发现',
				FINDINGS_TITLE: '数据质量发现',
				NO_FINDINGS: '此记录未发现问题。',
				BLOCKERS: '阻断项',
				WARNINGS: '警告',
				RULE: '规则',
				FIELD: '字段',
				EVIDENCE: '证据',
				RECOMMENDATION: '建议',
				CONFIG_TITLE: '数据质量规则',
				SCOPE_GLOBAL: '全局',
				SCOPE_SYSTEM: '本系统',
				RULE_MANDATORY_FIELDS: '必填字段',
				MANDATORY_FIELDS_LABEL: '必需字段',
				SEVERITY: '严重程度',
				RULE_DESCRIPTION: '描述长度',
				MIN_LENGTH: '最小长度（字符）',
				RULE_DATES: '日期一致性',
				ALLOW_COMPLETION_BEFORE_CREATION: '允许完成日期早于创建日期',
				RULE_DUPLICATES: '重复检测',
				WINDOW_DAYS: '重复时间窗口（天）',
				RULE_PLANNING: '计划',
				REQUIRE_LABOR: '工单需要人工记录',
				RULE_COMPLETION: '完成',
				REQUIRE_ROOT_CAUSE: '已完成记录需要根本原因',
				RULE_TEXT_QUALITY: '文本质量（AI）',
				TEXT_QUALITY_HINT: '使用语言模型检查拼写和描述质量',
				CHECK_SPELLING: '检查拼写',
				CHECK_DESCRIPTION_MEANING: '检查描述是否有意义',
				CHECK_ROOT_CAUSE: '检查根本原因是否充分',
				RULE_WORK_ORDER: '需要工单',
				WORK_ORDER_HINT: '仅在通知已完成且属于下方所选通知类型时，标记缺失的工单。',
				WORK_ORDER_TYPES_LABEL: '需要工单的通知类型',
				RULE_SLA: 'SLA / 要求完成日期',
				SLA_CHECK_OVERDUE: '标记超过要求完成日期仍未完成的通知',
				SLA_CHECK_LATE: '标记在要求完成日期之后才完成的通知',
				RULE_BREAKDOWN_CONSISTENCY: '故障标志一致性',
				BREAKDOWN_CONSISTENCY_HINT: '将故障标志（Effect）与记录的停机时间进行核对。请选择本站点用于标记故障的 Effect 值。',
				BREAKDOWN_EFFECT_VALUES_LABEL: '表示故障的 Effect 值',
				RULE_AGING: '积压老化',
				MAX_OPEN_DAYS: '通知保持打开状态的最长天数',
				RULE_STATUS_CONSISTENCY: '状态关闭一致性',
				STATUS_CONSISTENCY_HINT: '将完成日期与工作流关闭状态进行核对。请选择本站点表示‘已关闭’的状态代码。',
				CLOSED_KEYWORDS_LABEL: '表示已关闭的状态代码',
				RULE_COST_SANITY: '成本合理性检查',
			},
			TABS: {
				DOCUMENTS: '文件',
				TAGS: '标签',
				MAINTENANCE: '维护',
				PIDS: 'P&IDs',
				RELIABILITY: '可靠性'
			},
			COMMON: {
				PROCESSING: '处理中',
				READY: '就绪',
				REVIEW: '审查',
				BLOCKED: '被阻止',
				PENDING: '待处理',
				SEARCH: '搜索...',
				SEARCH_RECORDS: '搜索记录...',
				ADD_DOCUMENT: '添加文件',
				NO_MATCHING: '未找到匹配文件。',
				LOADING: '加载数据中...',
				LOADING_MORE: '加载更多文件...',
				LOADING_MORE_RECORDS: '加载更多记录...',
				CANCEL: '取消',
				EDIT: '编辑',
				SAVE: '保存',
				SAVING: '保存中...',
				ASK_ROOTY: '向Rooty提问',
				DOWNLOAD: '下载',
				IMPORT_DATA: '导入数据',
				REPLACE_FILE: '替换文件',
				UPLOAD: '上传'
			},
			FILTERS: {
				ALL_ISSUES: '所有问题',
				CHOOSE_ISSUES: '选择要显示的问题',
				ALL_CLASSES: '所有分类',
				CHOOSE_CLASSES: '选择要显示的分类',
				GROUP_BY: '分组依据',
				ALL_TYPES: '所有类型',
				EVENT_TYPES: '事件类型',
				FILTER_ISSUE_TYPE: '问题类型'
			},
			IMPORT_BANNER: {
				IMPORTING: '正在导入 {{ count }} 个文件',
				IMPORTING_AUTO: '正在导入 {{ uploaded }} 个文件，剩余 {{ remaining }} 个（总计: {{ total }}）',
				INITIALIZING_AUTO: '正在初始化文档同步...',
				AUTO_TAKE_MINS: '请稍候，我们正在后台同步您的文档...',
				TAKE_30_MINS: '最多可能需要30分钟。',
				IMPORTED_SUCCESS: '成功导入 {{ count }} 个文件',
				SUMMARY: '导入摘要:',
				NEEDS_REVIEW: '需要审查',
				ALREADY_PRESENT: '已存在',
				REMOVED_AT_SOURCE: '已在源中删除',
				SYNC_FAILED: '同步失败'
			},
			TABLE_COLUMNS: {
				DOCUMENT: '文件',
				CLASS: '分类',
				DOC_TYPE: '文件类型',
				STATUS: '状态',
				SOURCE: '来源',
				ISSUES: '问题',
				LAST_UPDATED: '最后更新',
				ACTIONS: '操作',
				NOTIFICATION: '通知',
				EQUIPMENT: '设备',
				DESCRIPTION: '描述',
				TYPE: '类型',
				MAINTENANCE_PLANT: '维护工厂',
				FAILURE_MODE: '故障模式',
				SECTION: '剖面',
				DATES: '日期',
				CONTEXT: '上下文',
				TIME_HRS: '时间（小时）',
				RCA: '根本原因分析(RCA)',
				SOURCE_NAME: '源名称',
				PATH: '路径',
				SYNC_FREQUENCY: '同步频率',
				LAST_SYNCED: '上次同步时间',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: '尚未导入文件',
				NO_DOCS_SUBTITLE: '手动添加文件或使用 AI 上传工具。',
				NO_MAINT_TITLE: '尚未导入维护数据。',
				NO_MAINT_SUBTITLE: '选择“导入数据”以开始添加维护数据。'
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: '文件上传',
				UPLOAD_MANUALLY: '手动上传文件',
				BULK_UPLOAD_TITLE: '带有文件夹模板的批量上传',
				BULK_UPLOAD_DESC: '下载文件夹结构，将文件放入相应的文件夹中，然后上传整个文件夹。',
				DOWNLOAD_TEMPLATE: '下载模板',
				DRAG_DROP: '将文件拖放到此处或',
				BROWSE: '浏览',
				SUPPORTS: '支持 PDF、Word、Excel 和图片。',
				SELECTED_FILES: '选定的文件',
				APPLY_TO_ALL: '应用于所有:',
				CLASS: '分类',
				DOC_TYPE: '文档类型',
				LINKED_TO: '链接至',
				SELECT_CLASS: '选择分类',
				SELECT_DOC_TYPE: '选择文档类型',
				CHOOSE_LINK: '选择链接位置',
				FILE_SELECTED: '已选文件',
				FILES_SELECTED: '已选文件',
				CONFIRM_IMPORT: '确认/导入',
				REPLACE_HINT: '请上传此文档的正确替换文件。理想情况下，该文件应与最初预期的文件相同。',
				DUPLICATE_BADGE: '重复',
				DUPLICATES_SKIPPED_BANNER: '检测到 {{count}} 个重复文件。它们已被排除，不会上传。',
				DUPLICATES_SKIPPED_INLINE: '（已跳过 {{count}} 个重复）',
				REMOVE_DUPLICATES: '移除重复项'
			},
			DOC_VIEWER: {
				DOC_DETAILS: '文档详情',
				PREVIEW: '预览',
				FULL_SCREEN: '全屏',
				NO_PREVIEW: '不可预览',
				NO_PREVIEW_DESC: '无法在此浏览器中预览此文件类型。',
				METADATA: '元数据',
				DOC_IDENTIFICATION: '文档识别',
				DOC_NAME: '文档名称',
				DOC_ID: '文档ID',
				DOC_CLASS: '文档类别',
				DOC_TYPE: '文件类型',
				MISSING: '缺失',
				DOC_SOURCE: '文档来源',
				FILE_SIZE: '文件大小',
				FILE_UPLOAD_SOURCE: '文件上传',
				EXTERNAL_SOURCE: '外部（Sharepoint，Google Drive等）',
				VERSIONING: '版本控制',
				UPLOADED_ON: '上传时间',
				LAST_MODIFIED: '最后修改',
				EFFECTIVE_DATE: '生效日期',
				EXPIRY_DATE: '到期日期',
				REVISION: '修订',
				VERSION_1: '版本 1',
				VERSION_2: '版本 2',
				STATUS: '状态',
				STATUS_UPLOADING: '上传中',
				STATUS_QUEUED: '排队中',
				STATUS_PROCESSING: '处理中',
				STATUS_READY: '就绪',
				STATUS_PENDING: '待处理',
				LINKED_TO: '链接至',
				FACILITIES: '设施',
				UNITS: '单位',
				SYSTEMS: '系统',
				CHOOSE_LINK_DESC: '选择链接位置（您可以将文档链接到设施、单位或系统）',
				EXTRACTED_DATA: '提取数据',
				NO_EXTRACTED_DATA: '无可用提取数据。'
			},
			TOOLTIPS: {
				ISSUE_FILTER: '问题过滤',
				CLASS_FILTER: '分类过滤',
				CUSTOMIZE_COLUMNS: '自定义列',
				VIEW_DETAILS: '查看详情',
				DELETE_FILE: '删除文件',
				STATUS_QUEUED_PROCESSING: '您的文档已加入队列，稍后将进行处理。',
				STATUS_READY: '您的文档已处理完毕，可以使用了。'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: '重复项',
				TITLE: '解决重复项',
				SUMMARY: '所选文件中有 {{dupes}} / {{total}} 个存在重复项',
				DESCRIPTION: '原始文件将被保留。其余 {{unaffected}} 个文件不受影响。',
				MERGE_TAGS: '移除重复项并合并标签 ({{count}})',
				NO_MERGE_TAGS: '移除重复项，不合并标签 ({{count}})',
				FAILURE: '部分重复项移除失败',
				TOAST_MERGED: '已移除 {{count}} 个重复文件。标签已与原始文件合并。',
				TOAST_NOT_MERGED: '已移除 {{count}} 个重复文件。原始文件的标签保持不变。'
			},
			CONNECTED_SOURCES: {
				CLOSE: '关闭',
				DISCONNECT_MSG: '断开 {{provider}} 将停止文档同步，并阻止 UptimeAI 访问已连接的 {{provider}} 帐户中的文件。<br/>已导入 UptimeAI 的文档将保持可用，但不再接收来自 {{provider}} 的更新。',
				DISCONNECT_TITLE: '断开 {{provider}} 集成？',
				DISCONNECT_OK: '断开 {{provider}}',
				FETCH_SOURCES_FAILED: '获取已连接的源失败。',
				SOURCE_UPDATED_SUCCESS: '源更新成功。',
				SOURCE_CONNECTED_SUCCESS: '源连接成功。',
				TRIGGERING_SYNC: '正在触发同步...',
				SYNC_STARTED_SUCCESS: '同步已成功启动。',
				FAILED_TRIGGER_SYNC: '触发同步失败。',
				INACTIVE_REASON_COVERED: '由活动父源 \'{{name}}\' ({{path}}) 涵盖',
				REAL_TIME: '实时',
				ONE_TIME: '一次性',
				DAILY: '每天',
				HOURLY: '每小时',
				WEEKLY: '每周',
				MONTHLY: '每月',
				NA: 'N/A',
				PAUSED: '已暂停',
				INACTIVE: '未激活',
				UNKNOWN: '未知',
				TITLE: '已连接的源',
				ACTIVE: '活跃',
				CONNECT_SOURCE: '连接源',
				NO_SOURCES_HEADING: '暂无已连接的源。',
				NO_SOURCES_CONTENT: '连接一个源以浏览并导入文件。',
				NEVER: '从不',
				SYNC_NOW: '立即同步',
				MONITOR: '监控',
				SETTINGS: '设置',
				DISCONNECT: '断开连接',
				SYNC_ACTIVITY: '同步活动',
				NO_RECENT_ACTIVITY: '未找到最近的同步活动。',
				STATUS_SUCCESS: '成功',
				STATUS_PARTIAL: '部分成功',
				STATUS_FAILED: '失败',
				STATUS_RUNNING: '运行中',
				SYNC_FAILED_ERROR: '同步因错误而失败。',
				SYNC_STATS: '+ {{new}} 新增 · {{updated}} 更新 · {{skipped}} 未更改',
				SYNC_STATS_PARTIAL: '+ {{new}} 新增 · {{updated}} 更新 · {{skipped}} 未更改 · {{failed}} 失败',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: '连接到 Document Locator 数据库以持续同步文档。'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: '数据库类型',
						HOST: '服务器主机',
						PORT: '端口',
						DATABASE: '数据库名称',
						USER: '用户名',
						PASSWORD: '密码',
						ENCRYPT: '加密连接',
						TRUST_CERT: '信任服务器证书',
						SP_FILE_INFO: '文件信息存储过程',
						SP_FILE_CONTENT: '文件内容存储过程',
						SP_PLACEHOLDER: '请输入存储过程名称'
					}
				},
				TITLE: '连接源',
				STEP_1: '连接到源',
				STEP_2: '验证源',
				STEP_3: '源详情',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: '连接到SharePoint库以持续同步文档。',
				CONNECT_TO_SHAREPOINT: '连接到SharePoint',
				CONNECT_TO_PROVIDER: '连接到 {{provider}}',
				CONNECTION_VERIFIED: '连接已验证。',
				DESCRIPTOR_LOAD_FAILED: '无法加载此来源的配置。',
				TEST_CONNECTION_REQUIRED: '请在连接前成功测试连接。',
				API_INTEGRATION: 'API集成',
				API_DESC: '连接到文档管理API以自动同步文件。',
				CMMS: 'CMMS',
				CMMS_DESC: '连接到您的CMMS（SAP PM、Maximo等）以持续同步文档。',
				COMING_SOON: '即将推出',
				OAUTH_TAB: '使用Microsoft登录（OAuth）',
				TOKEN_TAB: '访问令牌（手动）',
				SIGN_IN_MICROSOFT: '使用Microsoft登录',
				OAUTH_DESC: '连接您的Microsoft帐户以浏览SharePoint库并导入文档。',
				SECURE_AUTH: '安全认证',
				SECURE_AUTH_DESC: '使用Microsoft OAuth。您的凭据永远不会存储在此应用程序中。',
				READ_ONLY: '只读访问',
				READ_ONLY_DESC: '应用程序仅读取文档。不会在SharePoint中修改或删除任何文件。',
				TOKEN_PLACEHOLDER: '粘贴您的SharePoint访问令牌',
				TOKEN_WARNING: '访问令牌会过期。建议使用OAuth以获得不间断同步。',
				MANUAL_AUTH_DESC: '请输入您的Azure应用程序注册凭据。这些凭据将安全地存储在服务器上。',
				TENANT_ID_LABEL: '租户 ID',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: '客户端 ID (应用程序 ID)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: '客户端密码',
				CLIENT_SECRET_PLACEHOLDER: '粘贴您的客户端密码值',
				SAVE_CREDENTIALS: '保存并继续',
				STEP_CONNECTION_CONFIG: '连接配置',
				APP_CONNECTION_CONFIG: '应用程序连接配置',
				NEW_CONNECTION: '新连接',
				ACTIVE_CONNECTION_CONFIG: '活动连接配置',
				PROVIDER: '提供商',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: '应用程序 ID (客户端 ID)',
				REGISTER_CONFIG_DESC: '输入详细信息以注册新的应用注册/客户端凭据配置。',
				CONFIG_NAME_LABEL: '配置名称',
				CONFIG_NAME_PLACEHOLDER: '例如: SharePoint Production',
				BACK_TO_SELECTION: '返回选择',
				SAVE_CONNECTION_BTN: '保存连接',
				PLEASE_SELECT_CONNECTION: '请先选择或注册一个连接配置。',
				RESTORED_SESSION_FOR: '已恢复认证会话: {{user}}',
				PLEASE_COMPLETE_SIGNIN: '请先完成Microsoft登录。',
				SELECT_APP_REGISTRATION: '请先选择或注册一个App Registration连接。',
				FAILED_AUTH_URL: '获取Microsoft授权URL失败。',
				ERROR_REQ_AUTH_LINK: '请求授权链接时出错。',
				FILL_ALL_FIELDS: '请填写所有连接配置字段。',
				APP_REG_SAVED: '应用注册配置保存成功。',
				FAILED_SAVE_CONFIG: '保存配置失败。',
				SITE_URL_LABEL: 'SharePoint站点URL（SharePoint站点集合的完整URL）',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: '库路径',
				LIBRARY_PATH_DESC: '（文档库的路径，例如 /Shared Documents/Equipment）',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: '文件类型过滤器（仅导入匹配这些类型的文件；留空表示全部）',
				SYNC_FREQUENCY: '同步频率',
				SYNC_AUTO: '自动（实时）',
				SYNC_HOURLY: '每小时',
				SYNC_DAILY: '每天',
				SYNC_DAILY_DESC: '在计划时间每24小时同步一次',
				SYNC_WEEKLY: '每周',
				SYNC_BIWEEKLY: '每两周',
				SYNC_MONTHLY: '每月',
				CONFLICT_LABEL: '冲突解决（如何处理系统中已存在的文档）',
				CONFLICT_KEEP_NEWEST: '保留最新版本',
				TEST_CONNECTION: '测试连接',
				TEST_SUCCESS: '连接成功 - 找到{{count}}个匹配的文档文件',
				CANCEL: '取消',
				CONNECT_AND_SYNC: '连接并开始同步',
				AUTH_SUCCESS: '您已成功验证。单击下面的“下一步”以配置源详细信息。',
				APP_ONLY_SYNC_DESC: '仅应用同步使用选定的应用程序注册配置在后台运行。无需单独的用户登录。',
				FILE_TYPE_FILTER_DESC: '仅导入与这些类型匹配的文件； 取消选中以导入所有文件。',
				NEXT: '下一步',
				AUTHENTICATED_PROFILE: '已验证的 Microsoft 配置文件',
				USER_NAME: '用户名',
				EMAIL_ADDRESS: '电子邮箱地址',
				SIGN_IN_DIFFERENT_ACCOUNT: '使用其他帐户登录'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: '维护', COMING_SOON: '即将推出' },
			COMMON: { CANCEL: '取消', SAVE: '保存', EDIT: '编辑', DOWNLOAD: '下载', UPLOAD: '上传', DELETE: '删除', SELECT_ALL: '全选', SEARCH: '搜索活动...', EDIT_CONFIGURATION: '编辑配置', SAVE_CONFIGURATION: '保存配置', APPLY_TEMPLATE: '应用模板', TEMPLATE_MANAGER: '模板管理器', SAVED_CONFIGURATION: '保存的配置', CONFIGURE: '配置', BETA_ANALYTICS: 'β 分析', UPDATE_TEMPLATE: '更新模板', SAVE_TEMPLATE: '保存模板', FINISH_SAVE_PACKAGE: '完成并保存包', DONE: '完成', RE_GENERATE: '重新生成', YES: '是', NO: '否', LOADING: 'Loading...', COPY: '复制', APPLYING_TEMPLATE: '正在应用模板', LOADING_TEMPLATE: '正在加载模板', TO: '到' },
			HEADER: { CONFIG_FOR: '配置 PM、FMEA、CM:', SELECT_EQUIPMENT: '请选择设备' },
			EQUIPMENT_EMPTY: { TITLE: '选择设备', DESC: '从层次结构面板中选择设备以进行配置', ACTIVITIES: 'PM活动、FMEA、CM。', NO_TEMPLATE_TITLE: '未应用模板', NO_TEMPLATE_DESC: '应用模板以配置该设备的PM活动、FMEA和CM。' },
			COMING_SOON: { TITLE: '即将推出', DESC: '此功能目前正在开发中，将在未来的更新中提供。' },
			MANAGER: { TITLE: '模板管理器', EDIT_TEMPLATE: '编辑模板', LINKED_ASSETS: '链接资产', SUB_HEADER: '管理可重复使用的 PM、CM 和故障模式模板', COL_NAME: '模板名称', COL_DESC: '描述', COL_TYPE: '类型', COL_ASSETS: '链接资产', COL_ASSET: '资产', COL_CREATOR: '创建者', COL_DATE: '最后修改', EMPTY_TITLE: '未找到模板', EMPTY_DESC: '保存的 PM、CM 和故障模式模板将显示在这里。', SELECT_DESC: '选择预构建模板应用到您的设备。', SEARCH_TEMPLATE: '搜索模板...', EQ_TEMPLATE_LIBRARY: '设备模板库', COL_STATUS: '状态', STATUS_IN_PROGRESS: '进行中', STATUS_READY: '可供使用', STATUS_DEPRECATED: '已弃用', LIFECYCLE: '更多操作', LOCK: '锁定并标记为就绪', LOCK_HINT: '模板完成度达到 100% 后方可锁定。', UNLOCK: '解锁', DEPRECATE: '弃用', REACTIVATE: '重新启用', DUPLICATING: '正在创建 {{name}} 的副本模板...' },
			UPLOAD: { TITLE_PM: '上传 PM 模板', TITLE_CM: '上传 CM 模板', TITLE_FM: '上传故障模式模板', TEMPLATE_NAME: '模板名称', ENTER_TEMPLATE: '输入模板名称', DRAG_DROP: '将文件拖放到此处或', BROWSE: '浏览', REMOVE_FILE: '删除文件' },
			PM: { TITLE: 'PM 配置', CONFIG_FOR: '配置 PM 检查表为:', SELECT_HOW: '选择您希望如何配置 PM 活动', APPLY_TEMPLATE: '应用模板', IMPORT_SAP: '从 SAP 导入', UPLOAD_TEMPLATE: '上传模板', DOWNLOAD_TEMPLATE: '下载模板', CHECKLIST_TEMPLATE: 'PM 检查表模板', SAVE_TEMPLATE: '保存模板', EDIT_TEMPLATE: '编辑模板', OVERALL_VARS: '整体 PM 级别变量', OVERALL_TIME: '总时间（小时）', MUST_BE_POSITIVE: '请输入大于 0 的数字', OVERALL_MANNING: '总人员编制', TECH_COUNT: '技术人员（数量）', HELPER_COUNT: '助手（数量）', COST_PARTS: '零件成本（如有）（美元）', COST_CONS: '消耗品成本（美元）', PM_INTERVAL: '当前 PM 间隔（天）', PROD_LOSS: '生产损失（美元）', TAB_CHECKLIST: 'PM 检查表', ACTIVITIES_CHECKLIST: 'PM 活动检查表', ACTIVITIES_CHECKLIST_DESC: '此检查表模板中定义的所有 PM 活动列表', ENRICH_ROOTY: '使用 Rooty 丰富检查表', ROOTY_LOADING: 'Rooty 正在分析您的 PM 活动...', ROOTY_BUNDLE_TITLE: '活动捆绑建议', ROOTY_BUNDLE_DESC: '查看以下建议的捆绑包。确认后继续生成构建标志。', ROOTY_CONFIRM_BUNDLES: '看起来不错 — 生成构建标志', ROOTY_CONFIRM_FLAGS: '看起来不错 — 生成每项活动的时间', ROOTY_FLAGS_READY: '构建标志已生成。查看下面的选项卡。', ROOTY_FLAGS_OUTPUT: '构建标志分析', ROOTY_NO_SYSTEM: '保存PM活动以启用增强功能', TAB_BUNDLES: '活动包', BUN_TITLE: 'PM 活动包', BUN_DESC: '将 PM 活动分组为逻辑组合以进行高效调度', TAB_FLAGS: '构建标志', FLAG_TITLE: '构建标志', FLAG_DESC: '将活动分类为监管、程序或操作', TAB_TIME: '每次活动的时间', TIME_TITLE: '每次活动的时间', TIME_DESC: '估算每个 PM 活动所需的时间', TAB_BETA: '定义 β', BETA_TITLE: '定义 β', BETA_DESC: '设置每次活动的 PM 频率对 CM/故障的敏感度', RE_GENERATE: '重新生成', CHECKLIST_CONFIG: 'PM 检查表配置', CONFIG_CHECKLIST_FOR: '配置检查表为:', ROOTY_CANNED_1: '正在读取检查表...', ROOTY_CANNED_2: '正在分析 PM 活动...', ROOTY_CANNED_3: '正在准备建议...' },
			PM_APPLY: { TITLE: 'PM 检查表模板库', STEP_1: '选择模板', STEP_2: '选择设备', STEP_1_DESC: '选择一个预构建的 PM 检查表模板应用到您的设备。模板包含从最佳实践中配置的 PM 活动序列。', EMPTY: '未找到模板。', CONFIG_FOR: '配置的 PM 模板', EXEC_SUCCESS: '跨间隔边界成功执行。', PM_ACTIVITIES: 'PM 活动', INTERVAL: '间隔：', APPLIES_TO: '适用于：', EQ_TITLE: '选择要应用模板的设备', EQ_SELECTED: '选定的设备', SELECT_TEMPLATE: '选择模板', APPLY_TEMPLATE: '应用模板' },
			CM: { TITLE: 'CM 配置', CONFIG_FOR: '配置 CM 活动为:', SELECT_HOW: '选择您希望如何配置 CM 活动', APPLY_TEMPLATE: '应用模板', UPLOAD_TEMPLATE: '上传模板', DOWNLOAD_TEMPLATE: '下载模板', CM_VARS: 'CM 级别变量', EQ_REDUNDANCY: '设备冗余', PROD_LOSS: '生产损失', TECH_COUNT: '所需技术人员数量', HELP_COUNT: '所需助手数量', COST_CONS: '消耗品成本（如有）', SPARES_COST: '考虑备件成本', YES: '是', NO: '否', LABOUR_VARS: '劳动力变量', WRENCH_TIME_VARS: '扳手时间变量', WRENCH_WARNING: '故障持续时间可能包含等待时间 — 推荐使用扳手时间估算而非基于持续时间的值', COL_FAILURE_MODE: '故障模式', COL_ACTIVITY: '活动', COL_CM_COUNT: 'CM 计数', COL_WRENCH_TIME: '估计扳手时间（小时）', COL_CONFIDENCE: '置信度', COL_OVERRIDE: '覆盖（小时）' },
			FM: { TITLE: '故障模式配置', CONFIG_FOR: '配置故障模式为:', SELECT_HOW: '选择您希望如何配置故障模式', SAVED_CONF: '保存的配置', RCM_ANALYSIS: 'RCM 分析', APPLY_LIB: '从模板库应用', APPLY_LIB_DESC: '为您的设备类使用预构建的故障模式模板', APPLY_LIB_AVAIL: '可用模板：ACW 泵模板', UPLOAD_RCM: '上传之前的 RCM 分析', UPLOAD_RCM_DESC: '从现有的 RCM 研究文件（Excel/CSV）导入故障模式', NEW_STUDY: '创建新的 FMEA 研究', NEW_STUDY_DESC: '使用引导式向导启动新的 FMEA', APPLY_TEMPLATE: '应用模板', CREATE_ROOTY: '通过 ROOTY 创建', UPLOAD_EXCEL: '从 Excel 上传', DOWNLOAD_TEMPLATE: '下载模板', COL_FM_ID: 'FM ID', COL_SUBSYSTEM: '子系统', COL_COMPONENT: '组件', COL_FUNCTION: '功能', COL_FUNC_FAIL: '功能失效', COL_FAILURE_MODE: '故障模式', COL_CONSEQUENCE_CAT: '影响类别', COL_FAILURE_BEHAVIOR: '故障行为', COL_PDM_APPLICABILITY: 'PdM适用性', COL_LIKELY_CAUSES: '可能原因', COL_SYMPTOMS: '症状/指标', COL_LOCAL_EFFECTS: '局部影响', COL_SYSTEM_EFFECTS: '系统影响', COL_PLANT_EFFECTS: '工厂影响', COL_EFFECTS: '影响', COL_IMPACTS: '影响', COL_EFFECT: '影响', COL_TYPE: '类型', COL_STATUS: '状态', COL_EVIDENCES: '证据', COL_TOTAL_COST: '总成本', COL_CATEGORY: '类别', COF_RATING: 'CoF 等级', COF_CATEGORY: 'CoF 类别', COST_SUMMARY: '成本摘要', REPAIR_COST: '维修成本（美元）', SAFETY_RISK_COST: '安全风险成本（美元）', PROD_LOSS: '生产损失（美元）', OUTAGE_DURATION: '停机时间（小时）', TOTAL_COST_USD: '总成本（美元）', CONSEQUENCE_RATING: '后果等级', SAFETY: '安全', OPERATIONAL: '运营', ENVIRONMENTAL: '环境', REPUTATIONAL: '声誉', CLASSIFICATION_HIDDEN: '分类：隐藏故障', SUPPORTING_EVIDENCE: '支持证据', VIEW_EVIDENCE: '查看完整证据面板', NO_FM_FOUND: '未找到故障模式配置...', EXPAND_ADDITIONAL_INFO: '附加信息', PERF_STANDARD: '性能标准', FM_ANCHOR_LEVEL: 'FM锚定级别', FM_TYPE: 'FM类型', SYMPTOM_CHILDREN: '症状子项', CURRENT_CONTROLS: '当前控制措施', EVIDENCE_SOURCE: '证据来源', WO_EVIDENCE_REFS: 'WO证据参考', VALIDATION_OUTCOME: '验证结果', UNVALIDATED_JUSTIFICATION: '未验证理由', CONFIDENCE: '置信度', PF_INTERVAL: 'P-F间隔估计' },
			EDITOR: {
				SAVING: '保存中...',
				SAVE_TEMPLATE: '保存模板',
				SAVE_ACTIVITY: '保存活动',
				SAVE_PACKAGE: '保存设备包',
				CREATE_TEMPLATE: '创建模板',
				EMPTY_TEMPLATE: '空模板',
				CREATE_VIA_ROOTY: '通过Rooty创建',
				SAVE_CONTINUE: '保存并继续',
				SAVE_TO_CONFIGURE: '保存模板以开始配置 PM、FMEA 和 CM。',
				DOWNLOAD: '下载模板',
				UPLOAD: '上传模板',
				PM_CHECKLIST: 'PM 检查表',
				FMEA_CONFIG: '故障模式配置',
				CM_CHECKLIST: 'CM 检查表（即将推出）',
				DESC: '描述',
				TEMPLATE_NAME: '模板名称',
				OVERALL_PM_VARS: '整体 PM 级别变量',
				SAVE_PM_ACTIVITY: '保存 PM 活动',
				SAVE_FMEA_CONFIG: '保存 FMEA 配置',
				SAVE_CM_CONFIG: '保存 CM 配置',
				RE_GENERATE: '重新生成',
				SAVED_INTERNALLY: '已成功内部保存:',
				DEFINE_PM: '定义 PM 检查清单',
				DEFINE_FM: '定义 FMEA 配置',
				DEFINE_CM: '定义 CM 配置',
				DEFINE_WRENCH_TIME: '定义扳手时间变量',
				DEFINE_DESC: '下载样本或上传完成的模板以生成。',
				NO_PM_ATTACHED: '未附加 PM 配置',
				NO_FM_ATTACHED: '未附加故障模式配置',
				NO_CM_ATTACHED: '未附加 CM 配置',
				PM_CONFIG_TAB: 'PM 配置',
				FM_CONFIG_TAB: 'FMEA 配置',
				CM_CONFIG_TAB: 'CM 配置',
				PM_FM_MAPPING_TAB: 'PM -> FM 映射',
				DEFINE_PM_FM: '定义 PM-FM 映射',
				DEFINE_PM_FM_DESC: '配置哪些 PM 活动可以缓解此设备的故障模式。',
				PM_FM_MAPPING_MATRIX: 'PM-FM 映射矩阵',
				PM_FM_MAPPING_SUBHEADER: '为 {{equipment}} 配置缓解故障模式的 PM 活动',
				PM_FM_SEARCH_PM: '搜索 PM 活动...',
				PM_FM_SHOW_ALL: '显示全部',
				PM_FM_SHOW_MAPPED: '已映射',
				PM_FM_SHOW_UNMAPPED: '未映射',
				PM_FM_SHOW_ZERO_COVERAGE: '无覆盖',
				PM_FM_LEGEND_FULL: '1 = 完全映射',
				PM_FM_LEGEND_PARTIAL: '0.1-0.9 = 部分关联',
				PM_FM_LEGEND_EMPTY: '空 = 未映射',
				PM_FM_CONFIRM_ALL: '确认剩余全部',
				PM_FM_CONFIRM_ROW: '确认映射',
				PM_FM_UNMAP: '取消映射',
				PM_FM_NO_PM_ATTACHED: '未配置 PM 活动',
				PM_FM_NO_FM_ATTACHED: '未配置故障模式',
				PM_FM_STALE_BANNER: '自生成此映射以来 PM 或 FMEA 已更改。新增或变更的活动会在下方显示为未映射——可直接进行映射，或使用"重新生成"让 Rooty 从头重新分析（这将覆盖您已审核的映射）。',
				PM_FM_REGENERATE: '重新生成',
				PM_FM_UNMAPPED_COUNT: '{{count}} 项未映射',
				PM_FM_ZERO_COVERAGE_HEADING: '无覆盖的故障模式',
				PM_FM_NEW_PM_PROPOSALS: '新 PM 建议',
				PM_FM_ACCEPT_PROPOSAL: '接受建议'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: '案例配置',
				LAST_UPDATED_BY: '最后更新者：{{name}} - {{date}}',
				MATRIX_TITLE: '可能性影响矩阵',
				MATRIX_SUBTITLE: '(常数 M1 — 可用于计算)',
				VALUE_INPUT_TITLE: '数值输入',
				VALUE_INPUT_SUBTITLE: '(用户可为案例数值字段输入的数值)',
				CALCULATIONS_TITLE: '计算',
				CALCULATIONS_SUBTITLE: '(案例内用户配置的数值计算)',
				OPTIONAL_TITLE: '可选',
				OPTIONAL_SUBTITLE: '(为跟踪目的可添加到案例中的其他字段)',
				COL_CONSTANT: '常数',
				COL_UNIT_FIELD: '单位字段',
				COL_FIELD_UOM: '字段单位',
				COL_DEFAULT_VALUE: '默认值',
				COL_ACTIONS: '操作',
				COL_CALCULATION: '计算项',
				COL_UOM: '单位',
				COL_FORMULA: '公式',
				COL_FIELD: '字段',
				COL_VALUE: '值',
				COL_UNIT_OF_MEASURE: '计量单位',
				ADD: '添加',
				ADD_ROW: '添加行',
				CANCEL: '取消',
				SAVE: '保存',
				SAVE_SUCCESS: '案例配置保存成功',
				IMPACT: '影响',
				LIKELIHOOD: '可能性',
				DELETE_ROW: '删除行',
				PLACEHOLDER_UNIT_FIELD: '输入单位字段',
				PLACEHOLDER_FIELD_UOM: '输入字段单位',
				PLACEHOLDER_DEFAULT_VALUE: '输入默认值',
				PLACEHOLDER_CALCULATION: '输入计算项名称',
				PLACEHOLDER_UOM: '输入单位',
				PLACEHOLDER_FORMULA: '输入公式',
				PLACEHOLDER_FIELD_NAME: '输入字段名称',
				DUPLICATE_FIELD_NAME: '字段名称必须唯一',
				PLACEHOLDER_VALUE: '输入值',
				PLACEHOLDER_UNIT_OF_MEASURE: '输入计量单位',
				RESET_TO_DEFAULTS: '恢复默认设置',
				RESET_MATRIX_CONFIRM_TITLE: '恢复默认设置？',
				RESET_MATRIX_CONFIRM_DESC: '这将把<strong>可能性影响矩阵</strong>恢复为原始默认值。您所做的任何自定义更改都将丢失。',
				RESET_MATRIX_CONFIRM_OK: '确认',
				LOAD_ERROR: '加载案例配置失败',
				SAVE_ERROR: '保存案例配置失败',
				RESET_ERROR: '重置案例配置失败',
				CONSTANT_USED_IN_FORMULA: '此常量已在公式中使用',
				FORMULA: {
					UNDEFINED_CONSTANT: '常量“{{constant}}”未定义',
					INVALID_CHARACTER: '公式包含不受支持的字符或运算符',
					UNBALANCED_PARENTHESES: '公式的括号不匹配',
					EMPTY_PARENTHESES: '公式包含空括号',
					MISSING_OPERATOR: '公式中缺少值之间的运算符',
					INVALID_OPERATOR_POSITION: '公式中的运算符位置无效',
					TRAILING_OPERATOR: '公式不能以运算符结尾'
				}
			},
			FILTER: {
				TITLE: '筛选',
				SEARCH: '搜索'
			},
			ASSET_TEMPLATE: {
				TITLE: '资产模板列表',
				SEARCH: '搜索',
				TOOLTIP_ADD: '添加新资产',
				TOOLTIP_DELETE: '删除资产',
				TOOLTIP_SYNC: '同步',
				TOOLTIP_SYNC_PROGRESS: '同步进行中',
				SYNC_STARTED_TOAST: '资产模板同步已开始。',
				SYNC_COMPLETED_TOAST: '资产模板同步已完成。',
				SYNC_FAILED_TOAST: '资产模板同步失败{{errorSuffix}}。',
				COL_INDEX: '序号',
				COL_TEMPLATE_NAME: '模板名称',
				COL_APPLICATION: '应用',
				COL_CREATED_ON: '创建时间',
				COL_ACTIONS: '操作',
				NO_RECORDS: '未找到记录',
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
				LOADING: '加载中...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: '上传标签SCADA映射',
				TITLE: '标签列表',
				SEARCH: '搜索',
				TOOLTIP_ADD: '添加新标签',
				TOOLTIP_UPLOAD: '上传标签',
				TOOLTIP_DOWNLOAD: '下载标签列表',
				TOOLTIP_TAG_MAPPING: '访问标签映射',
				TOOLTIP_DELETE: '删除标签',
				TOOLTIP_NO_FAILURE_MODES: '无关联故障模式',
				TOOLTIP_VIEW_CHANGES: '查看变更',
				COL_INDEX: '序号',
				COL_NAME: '名称',
				COL_TAG_ID: '标签ID',
				COL_SHARED: '共享',
				COL_UNIT: '单位',
				COL_FAILURE_MODES: '故障模式',
				COL_MODELLING: '用于建模',
				COL_CALCULATED: '已计算',
				COL_DESCRIPTION: '描述',
				COL_ASSET: '资产',
				COL_ACTIONS: '操作',
				NO_TAGS: '所选资产没有可用标签',
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索'
			},
			FAILURE_MODE: {
				TITLE: '故障模式列表',
				SEARCH: '搜索',
				TOOLTIP_UPLOAD: '上传故障模式',
				TOOLTIP_ADD: '添加新故障模式',
				TOOLTIP_EDIT: '编辑故障模式',
				TOOLTIP_FILTER: '筛选',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_EDIT_DIRECTIONALITY: '编辑标签方向性',
				COL_INDEX: '序号',
				COL_NAME: '名称',
				COL_DESCRIPTION: '描述',
				COL_TAG: '标签',
				COL_ASSET: '资产',
				COL_RECOMMENDATIONS: '建议',
				COL_ACTIONS: '操作',
				NO_RECORDS: '未找到记录'
			},
			DIGITIZATION: {
				TITLE: '数字化列表',
				SEARCH: '搜索',
				TOOLTIP_ADD: '添加新数字化',
				TOOLTIP_DELETE: '删除数字化',
				COL_INDEX: '序号',
				COL_MANUFACTURER: '制造商',
				COL_MODEL: '型号',
				COL_INDUSTRY_TYPE: '行业类型',
				COL_MODIFIED_ON: '修改时间',
				COL_CREATED_ON: '创建时间',
				NO_RECORDS: '未找到记录',
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索'
			},
			TABS: {
				ASSET_TEMPLATE: '资产模板',
				ASSETS: '资产',
				DIGITIZATION: '数字化',
				SETTINGS: '设置',
				CASES: '案例'
			},
			SETTINGS: {
				TITLE: '更新设置',
				COL_INDEX: '#',
				COL_PAGE_NAME: '页面名称',
				COL_LAST_UPDATED: '最后更新',
				COL_UPDATED_BY: '更新人',
				TOOLTIP_SETTINGS: '设置',
				LOADING: '正在加载设置...',
				NO_SETTINGS: '未找到设置'
			},
			ASSETS: {
				TITLE: '资产列表',
				SEARCH: '搜索',
				TOOLTIP_FILTER: '筛选资产',
				TOOLTIP_DELETE: '删除资产',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				COL_INDEX: '序号',
				COL_NAME: '资产名称',
				COL_TYPE: '资产类型',
				COL_UNIT: '单元',
				COL_SYSTEM: '系统',
				COL_APPLICATION: '应用',
				COL_CONFIGURATION: '配置',
				COL_INDUSTRY: '行业',
				COL_AUTHOR: '作者',
				COL_MAKE_MODEL: '品牌与型号',
				COL_MAINTENANCE: '维护数据',
				NO_RECORDS: '未找到记录',
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
			},
			FM_MAPPING_MENU: {
				HIGH: '高',
				LOW: '低',
				STABLE: '稳定',
				REFERENCE: '参考',
				UNMAPPED: '未映射',
				TOOLTIP_HIGH_PRIMARY: '高 - 主要故障模式',
				TOOLTIP_HIGH_SECONDARY: '高 - 次要故障模式',
				TOOLTIP_LOW_PRIMARY: '低 - 主要故障模式',
				TOOLTIP_LOW_SECONDARY: '低 - 次要故障模式',
				TOOLTIP_STABLE_PRIMARY: '稳定 - 主要故障模式',
				TOOLTIP_STABLE_SECONDARY: '稳定 - 次要故障模式',
				TOOLTIP_REFERENCE: '参考故障模式',
				FM_LOGIC: 'FM逻辑',
				HIGH_INCREASING: '高/增加',
				LOW_DECREASING: '低/减少',
				RULE_BASED: '基于规则',
				UNMAP: '取消映射',
				RULE_BASED_CONDITION: '基于规则的条件',
				OPERATOR: '运算符',
				COMPARE_TO: '比较对象',
				ENTER_VALUE: '输入值',
				NUMERIC_INPUT_ONLY: '仅数字输入',
				PREFERENCE: '偏好',
				APPLY: '应用'
			},
			QUICK_FILTER: {
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
				CLOSE: '关闭',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: '哎呀！制造商和型号名称已被占用。请修改后重新提交。',
				MANUFACTURER: '制造商',
				MANUFACTURER_NAME: '制造商名称',
				MODEL: '型号',
				MODEL_NAME: '型号名称',
				INDUSTRY_TYPE: '行业类型',
				ENTER: '输入',
				SELECT: '选择',
				IS: '是',
				CUT_IN_SPEED: '切入速度(m/s)',
				CUT_IN_SPEED_LABEL: '切入速度',
				CUT_OFF_SPEED: '切出速度(m/s)',
				CUT_OFF_SPEED_LABEL: '切出速度',
				CAPACITY_KWH: '输入KWH值',
				CAPACITY: '容量',
				IS_REQUIRED: '是必填项',
				SMALLER_THAN_CUTOFF: '应小于切出值',
				GREATER_THAN_CUTIN: '应大于切入值',
				GREATER_THAN_ZERO: '应大于0',
				POWER_CURVE: '功率曲线',
				REQUIRED: '必填',
				UPLOAD_POWER_CURVE: '上传功率曲线',
				DOWNLOAD_SAMPLE: '下载示例/之前上传的文件',
				VIEW_POWER_CURVE: '查看上传的功率曲线数据',
				ERROR_CODE_MAP: '错误代码映射',
				UPLOAD_SCADA: '上传SCADA事件代码',
				VIEW_SCADA: '查看上传的SCADA事件代码数据',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				NAME: '名称',
				IS: '是',
				PRIORITY: '优先级',
				REQUIRED: '必填',
				START_TIME: '开始时间（小时）',
				START_TIME_LABEL: '开始时间',
				END_TIME: '结束时间（小时）',
				END_TIME_LABEL: '结束时间',
				IS_REQUIRED: '是必填项',
				TIME_RANGE: '范围应在0.1到48小时之间',
				DESCRIPTION: '描述',
				RELIABILITY_SAVINGS: '可靠性节省（潜在）',
				MAINTENANCE_SAVINGS: '维护节省（潜在）',
				PERFORMANCE_SAVINGS: '性能节省（潜在）',
				REMARK: '备注',
				REMARK_TO_EDIT: '编辑备注',
				ENTER: '输入',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				TAG_NAME: '标签名称',
				DIRECTIONALITY: '方向性',
				SELECT: '选择',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				RECOMMENDATION: '建议',
				IS: '是',
				CATEGORY: '类别',
				SELECT: '选择',
				SELECT_FAILURE: '选择故障',
				FAILURE: '故障',
				REMARK: '备注',
				REMARK_TO_EDIT: '编辑备注',
				ENTER: '输入',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			TAGS_POPUP: {
				FORECASTING: '预测',
				PERFORMANCE_DEGRADATION: '性能劣化',
				PERFORMANCE_DEGRADATION_HINT: '（为此测点启用干预时间预测）',
				DYNAMIC_DEVIATION_THRESHOLD: '动态偏差阈值',
				DEVIATION_LOW: '低',
				DEVIATION_MEDIUM: '中',
				DEVIATION_HIGH: '高',
				ERRATIC_DETECTION: '不稳定检测',
				ERRATIC_ALERT: '不稳定报警',
				MISSING_DATA_DETECTION: '缺失数据检测',
				OUTLIER_DETECTION: '异常值检测',
				OUT_OF_RANGE_DETECTION: '超出范围检测',
				DATA_QUALITY_ALERT_GENERATION: '数据质量报警生成',
				DATA_QUALITY_ALERT_DESC: '选择哪些检测到的数据质量问题应生成报警。关闭报警生成不会停止数据质量计算。值仍将显示在数据质量表中。',
				FLATLINE_ALERT: '平线报警',
				MISSING_DATA_ALERT: '缺失数据报警',
				OUTLIER_ALERT: '异常值报警',
				OUT_OF_RANGE_ALERT: '超出范围报警',
				ALERTS_NOTIFICATIONS_KPI: '警报、通知和 KPI',
				OPERATIONAL_LIMITS: '运行限制',
				ADDITIONAL_SETTINGS: '附加设置',
				NO_TAGS_WITH_TAGID_MAPPED: '未找到映射的 TagId',
				FUNCTION_NAME: '函数名称',

				DATA_QUALITY_DETECTION: '数据质量检测',
				SELECT_TAG_TO_ADD_MORE: '选择第一个标签以启用添加更多标签',
				ENTER_FORMULA: '输入公式*',
				LOWER: '下限',
				UPPER: '上限',
				START: '开始',
				END: '结束',
				DEADLINE: '截止日期',
				FORMULA_PLACEHOLDER: '输入公式，例如 (t1+t2)*t3',
				SELECT_TAG: '选择标签',
				SELECT_KEY: '选择键',
				VALUE: '值',
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				TAG_NAME: '标签名称',
				DESCRIPTION: '描述',
				TAG_ID: '标签ID',
				UNIT: '单元',
				INSTRUMENT_RANGE: '仪器量程',
				TRIP_LIMITS: '跳闸限制',
				THRESHOLD_ALERT: '阈值警报',
				THRESHOLD_ALERT_DELAY: '阈值警报延迟',
				IOW_CRITICALITY: 'IOW关键性',
				DIRECTIONALITY: '方向性',
				DIRECTION: '方向',
				FLATLINE_DETECTION: '平线检测',
				ATTENTION: '注意',
				THRESHOLD_NOTIFICATION: '阈值通知',
				KPI: 'KPI',
				STRING_CURRENT: '串电流',
				STRING_CAPACITY: '串容量',
				SCADA_ERROR_CODES: 'SCADA错误代码',
				COMMA_SEPARATED_ERROR_CODES: '添加逗号分隔的错误代码',
				ASSET: '资产',
				CALCULATED_FLAG: '计算标志',
				REMARK: '备注',
				REMARK_TO_EDIT: '编辑备注',
				FUNCTION_TABLE: '函数表',
				PARAMETERS: '参数',
				CONSTANTS: '常量',
				PLOT_CONTINUOUS: '绘制为连续折线趋势（忽略缺失值）',
				ENTER: '输入',
				SELECT: '选择',
				WRITE_CUSTOM_CODE: '编写自定义代码',
				UPLOAD_TAGS: '上传标签',
				DOWNLOAD_CORRELATION_CSV: '下载相关性CSV格式',
				UPLOAD_CORRELATION_CSV: '上传相关性CSV',
				DELETE: '删除',
				ADD: '添加',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改',
				ALARM_LIMITS: '报警限值',
				THRESHOLD_LIMITS: '阈值限制',
				CORRELATION_CSV_UPLOAD_LABEL: '上传相关性CSV',
				TRIAL_RUN: '试运行',
				SELECT_PYTHON_FUNCTION: '选择Python函数',
				SEARCH_FUNCTIONS_PLACEHOLDER: '搜索函数...',
				NO_MATCHING_FUNCTION_FOUND: '未找到匹配的函数',
				SELECT_FUNCTION_ERROR: '请选择一个Python函数',
				DEPRECATED: '已弃用',
				DEPRECATED_FORMULA_TOOLTIP: '此公式已弃用。请选择更新后的公式。',
				DEPRECATED_FORMULA_ERROR: '此公式已弃用。请选择更新后的公式。',
				CUSTOM_FORMULA_INVALID_VARS: '使用了无效变量',
				CUSTOM_FORMULA_INVALID_SYNTAX: '无效的变量/数学表达式',
				CUSTOM_FORMULA_REQUIRED: '公式为必填项',
				SEARCH_ASSETS_PLACEHOLDER: '搜索资产...',
				NO_MATCHING_ASSET_FOUND: '未找到匹配的资产',
				SEARCH_DOTS: '搜索...',
				NO_MATCHING_TAG_FOUND: '未找到匹配的标签',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: '未找到映射了 TagId 的标签。',
				SEARCH_PLAIN: '搜索',
				NO_MATCHING_KEY_FOUND: '未找到匹配的键',
				PARAMETER_NAME_HINT: '参数名称',
				CONSTANT_NAME_HINT: '常量名称',
				DISPLAY_EXPRESSION: '显示表达式',
				DISPLAY_EXPRESSION_PLACEHOLDER: '请输入表达式',
				EXPRESSION_DESCRIPTION: '表达式说明',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: '请输入表达式说明'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: '资产删除确认',
				CONFIRM_MSG: '确定要删除此资产吗？',
				ASSOCIATED_ITEMS_MSG: '是否也要删除与该资产关联的以下项目？',
				DELETE_TAGS: '删除关联标签',
				DELETE_FAILURE_MODES: '删除关联故障模式',
				DELETING: '正在删除...',
				CANCEL: '取消',
				DELETE: '删除'
			},
			FM_INFO: {
				TITLE: '故障模式信息',
				TOOLTIP_ADD: '添加',
				TOOLTIP_EDIT: '编辑',
				TOOLTIP_UPLOAD: '上传',
				TOOLTIP_DOWNLOAD: '下载',
				TOOLTIP_EDIT_MAPPING: '编辑映射',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				UPLOAD_FAILURE_MODES: '上传故障模式',
				UPLOAD_FM_TAG_MAPPINGS: '上传故障到标签映射',
				DOWNLOAD_FAILURE_MODES: '下载故障模式',
				DOWNLOAD_FM_TAG_MAPPINGS: '下载故障到标签映射',
				COL_FAILURE_MODE: '故障模式',
				COL_START_TIME: '开始时间',
				COL_END_TIME: '结束时间',
				COL_PRIORITY: '优先级',
				COL_ACTIONS: '操作',
				PRIORITY_DESCRIPTION: '影响优先级说明',
				NO_RECORDS: '所选资产没有可用的故障模式'
			},
			RECOMMENDATIONS: {
				TITLE: '建议',
				TOOLTIP_ADD: '添加',
				TOOLTIP_EDIT: '编辑',
				TOOLTIP_UPLOAD: '上传',
				TOOLTIP_DOWNLOAD: '下载',
				TOOLTIP_EDIT_MAPPING: '编辑机制到建议的映射',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				UPLOAD_RECOMMENDATIONS: '上传建议',
				UPLOAD_REC_FM_MAPPINGS: '上传建议到FM映射',
				DOWNLOAD_RECOMMENDATIONS: '下载建议',
				DOWNLOAD_REC_FM_MAPPINGS: '下载建议到FM映射',
				COL_RECOMMENDATIONS: '建议',
				COL_CATEGORY: '类别',
				NO_RECORDS: '所选资产没有可用的建议'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: '资产模板中已进行以下更改。请确认是否需要将这些更改同步到使用此模板创建的资产。',
				ASSETS: '资产',
				SELECT_ALL: '全选',
				TAGS: '标签',
				FAILURES: '故障',
				RECOMMENDATIONS: '建议',
				CLOSE_TOOLTIP: '关闭弹窗',
				CANCEL: '关闭',
				DONT_SYNC: '不同步',
				DONT_SYNC_TOOLTIP: '不同步更改',
				SYNC: '同步',
				SYNC_TOOLTIP: '同步更改'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: '标签列表',
				SEARCH: '搜索',
				TOOLTIP_SEARCH: '搜索',
				TOOLTIP_ADD: '添加新标签',
				TOOLTIP_UPLOAD: '上传标签',
				TOOLTIP_DOWNLOAD: '下载标签列表',
				TOOLTIP_CLONE: '克隆标签',
				TOOLTIP_DELETE: '删除标签',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				COL_INDEX: '序号',
				COL_TAG_TYPE: '标签类型',
				COL_NAME: '名称',
				COL_DESCRIPTION: '标签描述',
				COL_UNIT: '单元',
				COL_FAILURE_MODES: '故障模式',
				COL_DIRECTIONALITY: '方向性',
				COL_CALCULATED: '已计算',
				COL_ACTIONS: '操作',
				NO_RECORDS: '所选资产没有可用标签',
				TOOLTIP_NO_FM: '无关联故障模式',
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
				LOADING: '加载中...'
			},
			SUBSYSTEMS: {
				TITLE: '子系统',
				SEARCH: '搜索'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				NAME: '名称',
				IS: '是',
				ALREADY_TAKEN: '已被使用',
				TEMPLATE_NAME: '模板名称',
				APPLICATION: '应用',
				TEMPLATE_APPLICATION: '模板应用',
				PLEASE_ENTER: '请输入',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			ASSETS_FM_INFO: {
				TITLE: '故障模式信息',
				TOOLTIP_ADD: '添加',
				TOOLTIP_EDIT: '编辑',
				TOOLTIP_UPLOAD: '上传',
				TOOLTIP_DOWNLOAD: '下载',
				TOOLTIP_EDIT_MAPPING: '编辑标签到机制',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				UPLOAD_FAILURE_MODES: '上传故障模式',
				UPLOAD_FM_TAG_MAPPINGS: '上传故障到标签映射',
				DOWNLOAD_FAILURE_MODES: '下载故障模式',
				DOWNLOAD_FM_TAG_MAPPINGS: '下载故障到标签映射',
				COL_STATUS: '状态',
				COL_FAILURE_MODE: '故障模式',
				COL_PRIORITY: '优先级',
				COL_START_TIME: '开始时间',
				COL_END_TIME: '结束时间',
				COL_ACTIONS: '操作',
				PRIORITY_DESCRIPTION: '影响优先级说明',
				NO_RECORDS: '所选资产没有可用的故障模式'
			},
			TAG_FM_POPUP: {
				TITLE: '标签到机制',
				TAG_NAME: '标签名称',
				SEARCH_TAG: '搜索标签',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改',
				NO_RECORDS: "未找到标签和故障模式",
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: '建议',
				TOOLTIP_ADD: '添加',
				TOOLTIP_EDIT: '编辑',
				TOOLTIP_UPLOAD: '上传',
				TOOLTIP_DOWNLOAD: '下载',
				TOOLTIP_EDIT_MAPPING: '编辑机制到建议的映射',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_VIEW_CHANGES: '查看更改',
				UPLOAD_RECOMMENDATIONS: '上传建议',
				UPLOAD_REC_FM_MAPPINGS: '上传建议到FM映射',
				DOWNLOAD_RECOMMENDATIONS: '下载建议',
				DOWNLOAD_REC_FM_MAPPINGS: '下载建议到FM映射',
				COL_RECOMMENDATIONS: '建议',
				COL_CATEGORY: '类别',
				COL_ACTIONS: '操作',
				NO_RECORDS: '所选资产没有可用的建议'
			},
			REC_FM_POPUP: {
				TITLE: '机制到建议',
				RECOMMENDATION: '建议',
				CATEGORY: '类别',
				OFFLINE: '离线',
				ONLINE: '在线',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			ASSET_DELETE: {
				TITLE: '资产删除确认',
				CONFIRM_MSG: '确定要删除此资产吗？',
				ASSOCIATED_ITEMS_MSG: '是否也要删除与该资产关联的以下项目？',
				DELETE_TAGS: '删除关联标签',
				DELETE_FAILURE_MODES: '删除关联故障模式',
				DELETING: '正在删除...',
				CANCEL: '取消',
				DELETE: '删除'
			},
			ASSET_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				ASSET_NAME: '资产名称',
				ASSET_MODEL: '资产型号',
				ASSET_ID: '资产ID',
				DEPLOYED_DATE: '部署日期',
				SYSTEM: '系统',
				MAINTENANCE_DATA: '维护数据',
				PROVIDER_DATA: '供应商数据',
				ENTER: '输入',
				SELECT: '选择',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: '标签到机制上传',
				TITLE_REC_FM: '建议到机制上传',
				TAG_NAME_MAPPING: '标签名称映射',
				REC_NAME_MAPPING: '建议名称映射',
				TAG_NAME: '标签名称',
				RECOMMENDATION_NAME: '建议名称',
				TAG_NAME_OPTIONS: '标签名称选项',
				REC_NAME_OPTIONS: '建议名称选项',
				OPTIONS_PLACEHOLDER: '选项',
				NO_TAG_SUGGESTIONS: '未找到建议。此标签将不会用于最终映射。',
				TAG_DELETED_FROM_MAPPING: '标签已从映射中删除',
				NO_REC_SUGGESTIONS: '未找到建议。此建议将不会用于最终映射。',
				REC_DELETED_FROM_MAPPING: '建议已从映射中删除',
				FM_DELETED_FROM_MAPPING: '故障模式已从映射中删除',
				ACTIONS: '操作',
				FM_MAPPING: '故障模式映射',
				FM_NAME: '故障模式名称',
				FM_OPTIONS: '故障模式选项',
				TOOLTIP_CLEAR: '清除选择',
				TOOLTIP_DELETE_TAG: '删除标签',
				TOOLTIP_UNDO_TAG: '撤销标签删除',
				TOOLTIP_DELETE_FM: '删除故障模式',
				TOOLTIP_UNDO_FM: '撤销故障模式删除',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: '不稳定检测',
				ERRATIC_ALERT: '不稳定报警',
				MISSING_DATA_DETECTION: '缺失数据检测',
				OUTLIER_DETECTION: '异常值检测',
				OUT_OF_RANGE_DETECTION: '超出范围检测',
				DATA_QUALITY_ALERT_GENERATION: '数据质量报警生成',
				DATA_QUALITY_ALERT_DESC: '选择哪些检测到的数据质量问题应生成报警。关闭报警生成不会停止数据质量计算。值仍将显示在数据质量表中。',
				FLATLINE_ALERT: '平线报警',
				MISSING_DATA_ALERT: '缺失数据报警',
				OUTLIER_ALERT: '异常值报警',
				OUT_OF_RANGE_ALERT: '超出范围报警',
				ALERTS_AND_NOTIFICATIONS: '警报和通知',
				OPERATIONAL_LIMITS: '运行限制',
				DATA_QUALITY_DETECTION: '数据质量检测',
				SELECT_TAG_TO_ADD_MORE: '选择第一个标签以启用添加更多标签',
				LOWER_RANGE: '下限范围',
				UPPER_RANGE: '上限范围',
				LOWER: '下限',
				UPPER: '上限',
				ALARM_LIMITS: '报警限值',
				THRESHOLD_LIMITS: '阈值限制',
				START: '开始',
				END: '结束',
				FORMULA_PLACEHOLDER: '输入公式，例如 (t1+t2)*t3',
				SELECT_TAG: '选择标签',
				VALUE: '值',
				DELETE: '删除',
				ADD: '添加',
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				TAG_TYPE: '标签类型',
				TAG_NAME: '标签名称',
				TAG_DESCRIPTION: '标签描述',
				DESCRIPTION: '描述',
				UNIT: '单元',
				INSTRUMENT_RANGE: '仪器量程',
				TRIP_LIMITS: '跳闸限制',
				THRESHOLD_ALERT: '阈值警报',
				THRESHOLD_ALERT_DELAY: '阈值警报延迟',
				DESIGN_VALUE: '设计值',
				DIRECTIONALITY: '方向性',
				DIRECTION: '方向',
				IOW_CRITICALITY: 'IOW关键性',
				FLATLINE_DETECTION: '平线检测',
				ATTENTION: '注意',
				THRESHOLD_NOTIFICATION: '阈值通知',
				CALCULATED_FLAG: '计算标志',
				PARAMETERS: '参数',
				CONSTANTS: '常量',
				UPLOAD_TAGS: '上传标签',
				ENTER: '输入',
				SELECT: '选择',
				SELECT_PYTHON_FUNCTION: '选择Python函数',
				SEARCH_FUNCTIONS_PLACEHOLDER: '搜索函数...',
				NO_MATCHING_FUNCTION_FOUND: '未找到匹配的函数',
				SELECT_FUNCTION_ERROR: '请选择一个Python函数',
				SEARCH_TAG_TYPE_PLACEHOLDER: '搜索标签类型...',
				NO_MATCHING_TAG_TYPE_FOUND: '未找到匹配的标签类型',
				SEARCH_DOTS: '搜索...',
				NO_MATCHING_TAG_FOUND: '未找到匹配的标签',
				PARAMETER_NAME_HINT: '参数名称',
				CONSTANT_NAME_HINT: '常量名称',
				DISPLAY_EXPRESSION: '显示表达式',
				DISPLAY_EXPRESSION_PLACEHOLDER: '请输入表达式',
				EXPRESSION_DESCRIPTION: '表达式说明',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: '请输入表达式说明',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: '标签到机制',
				TAG_NAME_MAPPING: '标签名称映射',
				TAG_NAME: '标签名称',
				TAG_NAME_OPTIONS: '标签名称选项',
				OPTIONS_PLACEHOLDER: '选项',
				NO_TAG_SUGGESTIONS: '未找到建议。此标签将不会用于最终映射。',
				TAG_DELETED_FROM_MAPPING: '标签已从映射中删除',
				FM_DELETED_FROM_MAPPING: '故障模式已从映射中删除',
				ACTIONS: '操作',
				FM_MAPPING: '故障模式映射',
				FM_NAME: '故障模式名称',
				FM_OPTIONS: '故障模式选项',
				TOOLTIP_CLEAR: '清除选择',
				TOOLTIP_DELETE_TAG: '删除标签',
				TOOLTIP_UNDO_TAG: '撤销标签删除',
				TOOLTIP_DELETE_FM: '删除故障模式',
				TOOLTIP_UNDO_FM: '撤销故障模式删除',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				NAME: '名称',
				PRIORITY: '优先级',
				START_TIME: '开始时间（小时）',
				START_TIME_LABEL: '开始时间',
				END_TIME: '结束时间（小时）',
				END_TIME_LABEL: '结束时间',
				IS: '是',
				REQUIRED: '必填',
				DESCRIPTION: '描述',
				RELIABILITY_SAVINGS: '可靠性节省（潜在）',
				MAINTENANCE_SAVINGS: '维护节省（潜在）',
				PERFORMANCE_SAVINGS: '性能节省（潜在）',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "标签模板故障模式映射",
				TAG_NAME: "标签名称",
				SEARCH_TAG: "搜索标签",
				NAME: "名称",
				TAG_ID: "标签ID",
				CANCEL: "取消",
				CANCEL_TOOLTIP: "取消更改",
				SAVE: "保存",
				SAVE_TOOLTIP: "保存更改",
				NO_RECORDS: "未找到标签和故障模式",
				NO_MATCHES: '未找到“{{keyword}}”的结果',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '尝试使用其他关键字或清除搜索',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				RECOMMENDATION: '建议',
				IS: '是',
				CATEGORY: '类别',
				SELECT: '选择',
				SELECT_FAILURE: '选择故障',
				FAILURE: '故障',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: '机制到建议',
				RECOMMENDATION: '建议',
				CATEGORY: '类别',
				OFFLINE: '离线',
				ONLINE: '在线',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: '子系统模板列表',
				SEARCH: '搜索',
				TOOLTIP_ADD: '添加新子系统模板',
				TOOLTIP_EDIT: '编辑子系统模板',
				TOOLTIP_DELETE: '删除子系统模板',
				COL_INDEX: '序号',
				COL_NAME: '名称',
				COL_DESCRIPTION: '描述',
				COL_CREATED_ON: '创建时间'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: '子系统模板删除确认',
				CONFIRM_MSG: '您确定要删除该子系统模板吗？',
				DELETING: '正在删除...',
				CANCEL: '取消',
				DELETE: '删除'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: '添加子系统模板',
				EDIT_TITLE_PREFIX: '编辑子系统模板',
				NAME: '名称',
				DESCRIPTION: '描述',
				NAME_TAKEN_ERROR: '名称已被占用',
				NAME_REQUIRED_ERROR: '名称为必填项',
				FORM_ERROR: '哎呀！请修改部分内容后重新提交。',
				CANCEL: '取消',
				CANCEL_TOOLTIP: '取消更改',
				SAVE: '保存',
				SAVE_TOOLTIP: '保存更改'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: '高级分析',
				RENEWABLES: '可再生能源',
				SUMMARY: '摘要',
				DOWNTIME: '停机时间',
				UNDERPERFORMANCE: '性能不足',
				CURTAILMENT: '削减',
				SOILING_LOSS: '污染损耗',
				LOSS_BUCKETING: '损耗分类',
				MAINTENANCE: '维护'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: '选择分析',
				SEARCH_ANALYSIS: '搜索分析...',
				NO_MATCHING_ANALYSIS: '未找到匹配的分析',
				PUBLIC: '公开',
				SAVE_ALL: '全部保存',
				TOOLTIP_SAVE_ALL: '保存所有更改',
				TOOLTIP_DOWNLOAD: '下载所有分析的统计数据',
				ANALYSIS_TYPE: '分析类型'
			},
			HEADER: {
				CREATED_BY: '由',
				CREATED_ON: '创建于：'
			},
			EMPTY_STATE: {
				HEADING: '选择现有分析或创建新分析',
				CONTENT: '请选择或添加一个分析。'
			},
			DESCRIPTION_LABEL: '描述：',
			POPUP: {
				FORM_ERROR: '出错了！请修改一些字段后重新提交。',
				NAME_PLACEHOLDER: '名称',
				NAME_ERROR_TAKEN: '已被使用',
				NAME_HINT: '请输入',
				NAME_HINT_STRONG: '分析名称',
				DESC_PLACEHOLDER: '描述',
				DESC_ERROR_PREFIX: '描述',
				DESC_HINT: '请输入',
				DESC_HINT_STRONG: '分析描述',
				SELECT_FACILITY: '选择设施',
				SEARCH_FACILITY: '搜索',
				NO_MATCHING_FACILITY: '未找到匹配的设施',
				TOOLTIP_CANCEL: '取消更改',
				TOOLTIP_SAVE: '保存更改',
				BTN_CANCEL: '取消',
				BTN_SAVE: '保存'
			},
			SAVE_CONFIRMATION: {
				TITLE: '未保存的更改',
				MESSAGE: '有未保存的更改，是否要继续？',
				BTN_CANCEL: '取消',
				BTN_SAVE_CONTINUE: '保存并继续',
				BTN_DISCARD: '放弃更改并继续'
			},
			COMMON: {
				BTN_OK: '确定',
				BTN_CANCEL: '取消',
				BTN_CLOSE: '关闭',
				BTN_RESET: '重置',
				BTN_SAVE: '保存',
				LOADING: '加载中...',
				NO_RECORDS: '未找到记录',
				SEARCH: '搜索',
				SEARCH_PLACEHOLDER: '搜索...',
				TOOLTIP_DELETE: '删除',
				TOOLTIP_ADD: '添加',
				TOOLTIP_DOWNLOAD: '下载',
				TOOLTIP_CANCEL: '取消更改',
				TOOLTIP_SAVE: '保存更改',
				TOOLTIP_REMOVE_CARD: '移除卡片',
				DATE_RANGE: '日期范围'
			},
			FILTER: {
				TITLE: '筛选',
				UNIT: '单位',
				SYSTEM: '系统',
				SEARCH_SYSTEM: '搜索系统...',
				NO_MATCHING_SYSTEM: '未找到匹配的系统'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: '设施类型',
				SELECT_FACILITY: '选择设施',
				TOOLTIP_CARD_VIEW: '卡片视图',
				TOOLTIP_TABLE_VIEW: '表格视图',
				SEARCH_SYSTEM: '搜索系统...',
				NO_SYSTEM_FOUND: '未找到系统',
				GROUP_BY: '分组依据：',
				ENABLE_CLUSTERING: '启用聚类',
				SELECT_CLUSTER: '选择聚类',
				WIND_DIRECTION: '风向',
				SELECTED_DATE_RANGE: '选定日期范围',
				START_DATE: '开始日期',
				END_DATE: '结束日期',
				CONFIGURE_LOSS: '配置损耗',
				SAP_FILTER_TITLE: 'SAP字段筛选：'
			},
			BUCKETING_TABLE: {
				SEARCH: '搜索',
				SORT_BY: '排序依据',
				SORT_NONE: '无',
				SORT_ASC: '升序',
				SORT_DESC: '降序',
				COL_NAME: '名称',
				COL_GENERATION: '发电量（MWh）',
				COL_EFFICIENCY: '性能效率（%）',
				COL_BREAKDOWN_COUNT: '故障次数',
				COL_NOTIFICATION_COUNT: '通知次数',
				COL_CLOSED: '已关闭',
				COL_OPEN: '未关闭',
				COL_BLOCK: '区块',
				COL_EFF_LOSS: '效率损失',
				COL_INV: '逆变器',
				COL_TIME: '时间（时:分）',
				COL_CURTAILMENT_LOSS: '限电损失（MWh）',
				COL_GEN_LOSS: '发电损失（MWh）',
				COL_GEN_LOSS_NET: '发电净损失（MWh）',
				COL_GEN_LOSS_MWH: '发电损失（MWh）',
				COL_AVAILABILITY: '可用率',
				COL_REV_LOSS: '收入损失',
				COL_MAINTENANCE_COST: '维护成本',
				COL_DOWNTIME: '停机时间',
				COL_DURATION_PCT: '持续时间%',
				COL_MTTR: 'MTTR（时:分）',
				COL_ASSET: '资产',
				COL_MTBF: 'MTBF（时:分）',
				COL_IDEAL_GEN: '理想发电量（KWh）',
				COL_SOILING_LOSS: '污染损耗（KWh）',
				COL_SOILING_LOSS_PCT: '污染损耗（占理想发电量%）',
				COL_SCHEDULED_DATE: '计划清洁日期',
				COL_LAST_CLEANED: '上次清洁',
				COL_LAST_CLEANED_DAYS: '（天前）',
				COL_NOTIFICATION_NO: '通知编号',
				COL_EQUIPMENT_ID: '设备ID',
				COL_FUNCTIONAL_LOC: '功能位置',
				COL_EQUIPMENT: '设备',
				COL_DESCRIPTION: '描述',
				COL_CREATED_BY: '创建人',
				COL_CREATED_ON: '创建日期',
				COL_MAINTENANCE_PLANT: '维护工厂',
				COL_PLAN_GROUP: '计划组',
				COL_COMPLETED_ON: '完成日期',
				COL_COMPLETED_BY: '完成人',
				COL_COMPONENT: '组件'
			},
			POWER_CURVE: {
				TITLE_PREFIX: '功率曲线设置：',
				OEM: 'OEM功率曲线',
				CALCULATED: '计算功率曲线',
				START_DATE: '开始日期',
				STOP_DATE: '结束日期',
				DATE_RANGE_ERROR: '开始日期必须早于结束日期。',
				ADD_COMMENT: '添加备注',
				COMMENT_ERROR: '请输入有效的备注。'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: '最小最大值筛选',
				GREATER_THAN: '大于',
				LESS_THAN: '小于'
			},
			TAG_FILTER: {
				SELECT_TAG: '选择标签',
				NO_MATCHING_TAG: '未找到匹配的标签'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: '未找到匹配的标签'
			},
			LIST_XY_CARD: {
				X_AXIS: 'X轴',
				Y_AXIS: 'Y轴',
				SEARCH_X: '搜索X...',
				SEARCH_Y: '搜索Y...',
				NO_MATCHING_X: '未找到匹配的X值',
				NO_MATCHING_Y: '未找到匹配的Y值'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: '下载标签数据',
				TOOLTIP_NO_ACCESS: '您无权访问此分析项目中使用的单元和系统，因此已被禁用。',
				TOOLTIP_REMOVE_FILTER: '移除筛选',
				LOCK_X_AXIS: '锁定X轴（日期）',
				MULTI_AXIS: '多轴',
				TRIP_LIMIT: '跳闸限值',
				ALARM_LIMIT: '报警限值',
				THRESHOLD_LIMIT: '阈值限制',
				INSTRUMENT_RANGE: '仪器范围',
				LOCK_X_AXIS_ALERT_TOOLTIP: '在告警比较中无法解锁',
				TYPE_SIGNAL_VS_TIME: '信号 vs 时间 @ 不同时段',
				TYPE_SIGNAL_VS_SIGNAL: '信号 vs 信号 @ 不同时段',
				TYPE_STATE_SIGNAL: '运行状态信号分析',
				TYPE_STATE_SIGNAL_VS_SIGNAL: '运行状态下信号 vs 信号',
				TYPE_MULTISIGNAL: '运行状态下多信号分析',
				TYPE_MULTISIGNAL_VS_SIGNAL: '运行状态下多信号 vs 信号',
				TYPE_FULL_SYSTEM: '系统/设备比较',
				TYPE_ALERT_COMPARISON: '告警比较'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: '标题',
				DESC_PLACEHOLDER: '描述',
				PLOT_TYPE_LABEL: '图形类型',
				QUICK_PLOT: '快速图形',
				AXIS_TYPE_LABEL: '轴类型',
				AXIS_MULTI: '多轴',
				AXIS_SINGLE: '单轴'
			},
			SUMMARY: {
				LOADING: '正在处理数据，请稍候！',
				NO_DATA: '暂无数据。',
				NO_RENEWABLE_ASSETS: '未找到可再生能源资产',
				NO_RENEWABLE_ASSETS_SUBTITLE: '没有资产匹配所选过滤器',
				NO_SYSTEMS: '未找到系统',
				NO_SYSTEMS_SUBTITLE: '没有系统匹配所选过滤器和日期范围。',
				NO_DOWNTIME_DATA: '暂无停机数据',
				NO_DOWNTIME_DATA_SUBTITLE: '所选过滤器和日期范围暂无停机数据。',
				NO_PERFORMANCE_DATA: '暂无性能数据',
				NO_PERFORMANCE_DATA_SUBTITLE: '所选过滤器和日期范围暂无性能数据。',
				NO_CURTAILMENT_DATA: '暂无限电数据',
				NO_CURTAILMENT_DATA_SUBTITLE: '所选过滤器和日期范围暂无限电数据。',
				NO_LOSS_DATA: '暂无损失数据',
				NO_LOSS_DATA_SUBTITLE: '所选过滤器和日期范围暂无损失数据。',
				NO_MAINTENANCE_DATA: '暂无维护时间数据',
				NO_MAINTENANCE_DATA_SUBTITLE: '所选过滤器和日期范围暂无维护时间数据。',
				NO_SOILING_LOSS_DATA: '暂无污染损耗数据',
				NO_SOILING_LOSS_DATA_SUBTITLE: '所选过滤器和日期范围暂无污染损耗数据。',
			},
			AVAILABILITY: {
				TIME_BASED: '时间可用率',
				ENERGY_BASED: '能量可用率',
				TARGET_SUFFIX: '目标',
				TOTAL_LOSS_TITLE: '总损失（MWh）',
				ROW_DOWNTIME: '停机时间（时:分）',
				ROW_LOST_PRODUCTION: '发电损失（MWh）',
				ROW_LOST_REVENUE: '收入损失',
				ROW_MTBF: 'MTBF（平均故障间隔时间 - 时:分）',
				ROW_MTTR: 'MTTR（平均修复时间 - 时:分）',
				COL_NAME: '名称',
				COL_VALUE: '数值'
			},
			PERFORMANCE: {
				LOST_GENERATION: '发电损失（MWh）',
				LOST_REVENUE: '收入损失',
				BEST_PERFORMING: '最佳性能',
				WORST_PERFORMING: '最差性能',
				SHOW_TOP: '显示前：',
				TOTAL_LOSS_TITLE: '总损失（MWh）',
				PERF_CURVE_TITLE: '功率曲线',
				WIND_ROSE_TITLE: '风玫瑰图'
			},
			CURTAILMENT: {
				LOST_GENERATION: '发电损失（MWh）',
				LOST_REVENUE: '收入损失',
				SHOW_TOP: '显示前：',
				TOTAL_LOSS_TITLE: '总损失（MWh）'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: '总损失（MWh）',
				SOILING_CURVE_SUFFIX: '污染损耗曲线',
				TOOLTIP_SAVE: '保存',
				TOOLTIP_CANCEL: '取消',
				SECTION_SOILING: '污染',
				SECTION_TEMPERATURE: '温度',
				SECTION_OTHERS: '其他',
				REF_SETTING: '参考设置',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: '选择单位',
				SELECT_SYSTEM: '选择系统',
				SELECT_ASSET: '选择资产',
				SELECT_TAG: '选择标签',
				SEARCH: '搜索',
				SEARCH_SYSTEM: '搜索系统...',
				NO_MATCHING_UNIT: '未找到匹配的单位',
				NO_MATCHING_SYSTEM: '未找到匹配的系统',
				NO_MATCHING_ASSET: '未找到匹配的资产',
				NO_MATCHING_TAG: '未找到匹配的标签',
				APPLY_ON: '应用于',
				CLEANING_CYCLE: '清洁周期',
				CLEANING_CYCLE_HINT: '（天数）',
				BTN_START_EXPERIMENT: '开始实验',
				TOOLTIP_FORCE_STOP: '强制停止进行中的实验',
				TOOLTIP_UPLOAD_SOILING: '上传污染比率',
				CLEANING_UPDATE: '清洁更新',
				TOOLTIP_UPLOAD_CLEANING: '上传清洁计划',
				TOOLTIP_DOWNLOAD_CLEANING: '下载清洁更新报告',
				CHOOSE_DATE: '选择日期',
				DATE_HINT: '月/日/年',
				BTN_UPDATE: '更新'
			},
			LOSS: {
				LOST_GENERATION: '发电损失（MWh）',
				LOST_REVENUE: '收入损失',
				EFFECTIVE_PR: '有效PR',
				HIGHEST_LOSS_BUCKET: '最高损失类别',
				LOSS_BUCKETING_TITLE: '损失分类（MWh）'
			},
			MAINTENANCE: {
				CHART_TITLE: '维护时间（时:分）',
				BAD_ACTORS_TITLE: '主要问题设备',
				NOTIFICATION_STATUS: '通知状态',
				SHDJ_DISTRIBUTION: '按单位SHDJ分布',
				PENDING_DEFECTS_TITLE: '待处理缺陷及老化报告',
				COL_GROUP_SECTION: '组/部门',
				COL_0_30: '0 - 30天',
				COL_31_90: '31 - 90天',
				COL_91_180: '91 - 180天',
				COL_181_365: '181 - 365天',
				COL_365_500: '365 - 500天',
				COL_GRAND_TOTAL: '总计',
				MONTHLY_DEFECTS_PREFIX: '月度缺陷状态 -',
				TOTAL_MTD: '月累计缺陷总数',
				YEARLY_DEFECTS_PREFIX: '年度缺陷状态 - 财年',
				TOTAL_YTD: '年累计缺陷总数',
				PM_COMPLIANCE_PREFIX: 'PM合规报告 -',
				COL_EQUIPMENT: '设备',
				COL_SCHEDULED: '已计划',
				COL_PENDING: '待处理',
				COL_COMPLETED: '已完成',
				COL_COMPLIANCE: '合规率（%）'
			},
			MESSAGES: {
				SERVER_ERROR: '内部服务器错误',
				SAVE_SUCCESS: '分析已成功保存。',
				UPDATE_SUCCESS: '分析已更新。',
				ADD_SUCCESS: '分析已添加。',
				COPY_SUCCESS: '分析已复制。',
				CARD_GENERATED: '已成功生成新的分析卡片',
				POWER_CURVE_STARTED: '功率曲线计算已开始，对象为',
				POWER_CURVE_FAILED: '功率曲线计算失败，对象为'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: '通知',
			MARK_ALL_READ: '全部标记为已读',
			SETTINGS: '设置',
			TAB_ALL: '全部',
			TAB_UNREAD: '新未读',
			TAB_ASSIGNED: '分配给我',
			NOTIFICATIONS_SUFFIX: '条通知',
			TOOLTIP_MARK_READ: '标记为已读',
			TOOLTIP_MARK_UNREAD: '标记为未读',
			TOOLBAR_ITEM: '项',
			TOOLBAR_ITEMS: '项',
			TOOLBAR_SELECTED: '已选择',
			TOOLBAR_MARK_READ: '标记为已读',
			TOOLBAR_MARK_UNREAD: '标记为未读',
			TOOLBAR_CLEAR: '清除消息',
			ERROR_TITLE: '无法加载通知',
			ERROR_DESC: '获取通知时出错，请重试。',
			NOTIF_OFF_TITLE: '通知已关闭',
			NOTIF_OFF_DESC: '启用通知以在此处接收更新。',
			EMPTY_DEFAULT_TITLE: '暂无通知',
			EMPTY_DEFAULT_DESC: '您目前没有任何通知。收到通知后，将在此处显示。',
			EMPTY_CAUGHT_UP_TITLE: '您已全部查阅。',
			EMPTY_UNREAD_DESC: '新的警报和更新通知将显示在此处。',
			EMPTY_ASSIGNED_DESC: '分配给您的通知将显示在此处。',
			EMPTY_ALL_TITLE: '暂无通知',
			EMPTY_ALL_DESC: '更新将显示在此处',
			GROUP_TODAY: '今天',
			GROUP_YESTERDAY: '昨天',
			GROUP_THIS_WEEK: '本周早些时候',
			GROUP_THIS_MONTH: '本月早些时候',
			GROUP_LAST_MONTH: '上个月',
			GROUP_OLDER: '更早',
			SETTINGS_HEADER: '用户偏好设置',
			SETTINGS_TAB_NOTIFICATIONS: '通知',
			SETTINGS_TAB_AUDIBLE: '声音警报',
			SETTINGS_COL_TYPE: '类型',
			SETTINGS_COL_EMAIL: '邮件',
			SETTINGS_COL_PLATFORM: '平台',
			SETTINGS_COL_AUDIBLE: '声音',
			SETTINGS_ALERTS_HEADER: '警报',
			SETTINGS_ALERTS_DESC: '生成新警报时触发的通知。',
			SETTINGS_AUDIBLE_ALERTS_DESC: '在创建这些警报时播放声音警报。',
			SETTINGS_NEW_ANOMALY: '新异常警报',
			SETTINGS_NEW_HIGH_ANOMALY: '新高异常警报',
			SETTINGS_NEW_LOW_ANOMALY: '新低异常警报',
			SETTINGS_NEW_THRESHOLD: '新阈值警报',
			SETTINGS_OWNERSHIP_HEADER: '警报归属与分配',
			SETTINGS_OWNERSHIP_DESC: '与警报责任相关的通知。',
			SETTINGS_ALERT_OWNER: '指定为警报负责人',
			SETTINGS_ALERT_WATCHER: '指定为警报观察者',
			SETTINGS_ACTIVITY_HEADER: '警报活动',
			SETTINGS_ACTIVITY_DESC: '控制用户在分配后是否持续接收更新。',
			SETTINGS_OWNED_ALERTS: '负责警报的更新',
			SETTINGS_WATCHED_ALERTS: '关注警报的更新',
			SETTINGS_SYSTEM_HEADER: '系统更新',
			SETTINGS_SYSTEM_DESC: '与AI / 系统操作相关的通知。',
			SETTINGS_MODEL_RETRAINING: '模型重训练已完成',
			SETTINGS_AUDIBLE_FOOTER_NOTE: '声音警报将响一次，或以选定的频率持续通知，直到您点击警报查看警报详细信息。',
			PDF_HEADER: '案例管理 - PDF已生成',
			PDF_GENERATED_BEFORE: '案例管理 PDF 已成功生成。',
			PDF_DOWNLOAD_LINK: '下载 PDF',
			PDF_GENERATED_AFTER: '或使用发送到您邮箱的链接访问。下载链接将于 {{expiry}} 过期。',
			PDF_LINK_EXPIRED_TOOLTIP: '此下载链接已过期。请重新生成 PDF 后再下载。',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: '资产模板同步已开始 – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: '资产模板同步已完成 – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: '资产模板同步失败 – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: '维护优化',
			TAB_RESULTS: '结果与价值',
			TAB_SCHEDULES: 'PM计划',
			TAB_RUN_HISTORY: '运行历史',

			// Run History
			RH_COL_SL_NO: '序号',
			RH_COL_RUN_DATE: '运行日期',
			RH_COL_NAME: '名称',
			RH_COL_CREATOR: '创建者',
			RH_COL_SCOPE: '范围',
			RH_COL_STATUS: '状态',
			RH_COL_TOTAL_VALUE: '总价值',
			RH_COL_APPROVED: '已批准',
			RH_COL_ACTIONS: '操作',
			RH_VIEW: '查看',
			RH_EQUIPMENTS: '台设备',
			RH_SEARCH_PLACEHOLDER: '搜索运行...',
			RH_EMPTY: '当前选择未找到优化运行。',
			RH_STATUS_PENDING: '待处理',
			RH_STATUS_RUNNING: '运行中',
			RH_STATUS_PROCESSING: '处理中',
			RH_STATUS_COMPLETED: '已完成',
			RH_STATUS_FAILED: '失败',
			BTN_RUN_OPTIMIZATION: '运行优化',
			LAST_RUN_PREFIX: '上次优化运行：',

			// PM Schedules
			PM_DOWNLOAD_TITLE: '下载选项',
			PM_DOWNLOAD_SUBTITLE: '使用以下按钮将PM计划导出为可上传到SAP或您的CMMS的格式：',
			PM_DOWNLOAD_ALL_TITLE: '下载全部（CSV）',
			PM_DOWNLOAD_ALL_DESC: '所有PM活动的合并列表',
			PM_DOWNLOAD_PER_EQ_TITLE: '按设备报告',
			PM_DOWNLOAD_PER_EQ_DESC: '按层级中所选资产过滤',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: '合并计划',
			PM_DOWNLOAD_CONSOLIDATED_DESC: '按新间隔分组',
			PM_SEARCH_PLACEHOLDER: '搜索...',
			PM_GROUP_BY_INTERVAL: '分组依据：间隔',
			PM_FILTER: '筛选',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'PM计划名称',
			PM_COL_ACCESS_CLASS: '访问类别',
			PM_COL_BUNDLE_NAME: '捆绑包名称',
			PM_COL_BUNDLE_ID: '捆绑包ID',
			PM_COL_PREV_INTERVAL: '上一PM间隔',
			PM_COL_CURR_INTERVAL: '当前PM间隔',
			PM_EACH: '每',
			PM_DAYS: '天',

			// Results & Values
			RV_TOTAL: '合计',
			RV_POTENTIAL_VALUE: '潜在价值',
			RV_PM_SCHEDULING: 'PM排程',
			RV_CM_REDUCTION: 'CM减少',
			RV_FAILURE_REDUCTION: '故障 / 停机减少',
			RV_BY_REC_TYPE: '按建议类型',
			RV_TOTAL_ACTIVITIES: '已检查活动总数',
			RV_INCREASES: '增加',
			RV_DECREASES: '减少',
			RV_NO_CHANGES: '无变化',
			RV_REMOVE: '移除',
			RV_ADD: '添加',
			RV_WHERE_VALUE: '价值所在',
			RV_BY_STATUS: '按状态',
			RV_TOTAL_SCHEDULES: '计划总数',
			RV_PENDING: '待处理',
			RV_APPROVED: '已批准',
			RV_REJECTED: '已拒绝',
			RV_SEARCH_PLACEHOLDER: '搜索...',
			RV_GROUP_BY_SYSTEM: '分组依据：系统',
			RV_FILTER: '筛选',
			RV_COL_FREQ_REC: '频率建议',
			RV_COL_HIERARCHY: '层级 / PM名称',
			RV_COL_REC_INTERVAL: '建议间隔（天）',
			RV_COL_SAVINGS: '总节省（$/年）',
			RV_COL_PM: 'PM（$/年）',
			RV_COL_CM: 'CM（$/年）',
			RV_COL_FAILURE_RISK: '故障风险（$/年）',
			RV_COL_APPROVE: '批准 / 拒绝',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: '活动',
			RV_COL_ROLE: '角色',
			RV_COL_STANDALONE: '独立',
			RV_COL_EFFECTIVE: '生效',
			RV_COL_EVIDENCE: '证据',
			RV_COL_VALUE: '价值',
			RV_COL_STATUS: '状态',
			RV_BH_CURRENT: '当前',
			RV_BH_EFFECTIVE: '生效',
			RV_BH_OUTCOME: '结果',
			RV_BH_DRIVER: '驱动项',
			RV_BH_VALUE: '价值',
			RV_BH_CONFIDENCE: '置信度',
			RV_BH_STATUS: '状态',
			RV_BH_ACTIVITIES: '个活动',
			RV_BH_DRIVERS: '个驱动项',
			RV_BH_OVERRIDES: '个覆盖项',
			RV_BH_UNCHANGED: '无变化',
			RV_BH_NONE: '无',
			RV_BH_NO_CHANGE: '无变化',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: '深入分析',
			RV_BUNDLE_SUMMARY: '捆绑摘要',
			RV_LAST_RUN: '上次运行',
			RV_NO_RESULTS: '此选择没有优化结果。',
			RV_SELECT_NODE: '选择设施、单元或系统以查看结果。',
			RV_LOADING: '正在加载结果...',

			// MC Recommendation panel
			MC_PANEL_TITLE: '深度分析面板 — 建议',
			MC_ASK_ROOTY: '询问Rooty',
			MC_APPROVE: '批准',
			MC_REJECT: '拒绝',
			MC_CURRENT_FREQ: '当前频率',
			MC_REC_FREQ: '建议频率',
			MC_SHOW: '显示',
			MC_COMPACT: '紧凑',
			MC_ADVANCED: '高级',
			MC_TAB_DECISION: '决策',
			MC_TAB_OBSERVATIONS: '观察',
			MC_TAB_FAILURE_MODES: '故障模式',
			MC_DECISION_TITLE: '决策',
			MC_WHY_NOW: '为什么现在',
			MC_EXPECTED_VALUE: '预期价值',
			MC_SECONDARY_ACTION: '次要操作',
			MC_REC_CONFIDENCE: '建议置信度',
			MC_SAVINGS_BREAKDOWN: '节省明细',
			MC_TOTAL_ANNUAL_SAVINGS: '年度总节省',
			MC_PREDICTIONS: '预测',
			MC_EXPECTED_OUTCOME: '接受建议后的预期结果',
			MC_INTERVAL_SENSITIVITY: '间隔敏感度（β / η）',
			MC_ANNUAL_CM_COUNT: '年度CM数量',
			MC_CURRENT_CM_COUNT: '当前CM数量：',
			MC_PREDICTED_CM_COUNT: '预测新CM数量：',
			MC_ANNUAL_BD_COUNT: '年度停机数量',
			MC_CURRENT_BD_COUNT: '当前停机数量：',
			MC_PREDICTED_BD_COUNT: '预测新停机数量：',
			MC_PM_FREQUENCY: 'PM频率',
			MC_CURRENT: '当前：',
			MC_RECOMMENDED: '建议：',
			MC_FM_LINK: '故障模式标签页',
			MC_OBS_REACTIVE_VS_PREVENTIVE: '被动与预防成本比',
			MC_OBS_CM_TIMING: 'CM事件时序分析',
			MC_OBS_EARLY: '早期',
			MC_OBS_MID: '中期',
			MC_OBS_LATE: '晚期',
			MC_OBS_POST_PM: 'PM后复发',
			MC_OBS_EVIDENCE_LOG: '打开完整证据日志 →',
			MC_FM_SERVED_BY: '由此PM覆盖',
			MC_FM_SORT: '排序',
			MC_FM_BY_ROLE: '按角色',
			MC_FM_EXPAND_ALL: '全部展开',
			MC_FM_PRIMARY: '主要',
			MC_FM_SUPPORTING: '辅助',
			MC_FM_INCIDENTAL: '附带',
			MC_FM_AGG_B: '聚合B',
			MC_FM_CM_COUNT: 'CM数量/年',
			MC_FM_BREAKDOWNS: '停机/年',
			MC_FM_DIAGNOSIS: '诊断',
			MC_FM_TIMING: '时序',
			MC_FM_SENSITIVITY: '敏感度（β）',
			MC_FM_IMPACT: '影响',
			MC_FM_EVENTS: '事件',
			MC_FM_DATE_COL: '日期',
			MC_FM_EVENT_COL: '事件',
			MC_FM_COST_COL: '费用',
			MC_FM_CLASS_COL: '类别',
			MC_TAG_INCREASE_FREQ: '增加频率',
			MC_TAG_TIMING: '时间驱动',
			MC_TAG_CASE2: '情形2',
			MC_TAG_CBM: '+ CBM安全网',
			MCB_OPEN_EVIDENCE_LOG: '打开证据日志',
			MCB_DECISION_STANDALONE: '独立建议',
			MCB_DECISION_EFFECTIVE: '有效捆绑建议',
			MCB_EFFECTIVE_IS_STANDALONE: '独立结果也是有效结果',
			MCB_EXPECTED_IMPACT: '预期影响',
			MCB_EFFECTIVE_BUNDLE_RESULT: '有效捆绑结果',
			MCB_PM_COST: 'PM 成本',
			MCB_PM_COST_SUB: '额外年度 PM 支出',
			MCB_CM_SAVINGS: 'CM 节省',
			MCB_CM_SAVINGS_SUB: '预期年度减少',
			MCB_BD_SAVINGS: '故障节省',
			MCB_BD_SAVINGS_SUB: '预期年度减少',
			MCB_NET_VALUE: '年度净价值',
			MCB_NET_VALUE_SUB: '捆绑传播后',
			MCB_CONFIDENCE: '置信度',
			MCB_DRIVER_BASED: '基于驱动项',
			MCB_WHY: '为何有此建议',
			MCB_ADVANCED_PENDING: '高级详情即将推出。',
			MCB_OBS_WHAT: '引擎观察到的内容',
			MCB_OBS_ECONOMIC: '经济筛查',
			MCB_OBS_TIMING: '时序',
			MCB_OBS_POSTPM: 'PM 后复发',
			MCB_TIMING_DISTRIBUTION: '时序分布',
			MCB_EARLY: '早期',
			MCB_MIDDLE: '中期',
			MCB_LATE: '晚期',
			MCB_FM_BUILDUP: '故障模式构建',
			MCB_FM_BUILDUP_SUB: '精简视图显示结论。高级视图展示每个 FM 的诊断、预测、置信度和证据追踪。',
			MCB_DETAILS: '详情',
			MCB_FM_DIAGNOSIS: '诊断',
			MCB_FM_EVIDENCE: '证据',
			MCB_FM_TIMING: '时序',
			MCB_FM_CONTRIBUTION: '贡献',
			MCB_FM_STANDALONE: '独立',
			MCB_FM_EFFECTIVE: '有效',
			MCB_FM_ROUTE: '路径',
			MCB_FM_INTERVAL_CONTRIB: '间隔贡献',
			MCB_FM_VALUE: '价值',
			MCB_FM_STATUS: '状态',
			MCB_FM_ADMIN_INTERPRETATION: '管理员解读',
			MCB_FM_INTERVAL_DRIVER: '间隔驱动项',
			MCB_FM_OVERRIDDEN: '被覆盖的 FM',
			MCB_FM_NON_INTERVAL: '非间隔',
			MCB_STANDALONE_NOT_REALIZED: '独立的 {{code}} 节省未实现，不得计入设备或组合总额。',
			MCB_CONF_DATA_SUFFICIENCY: '数据充分性',
			MCB_CONF_TIMING_QUALITY: '时序质量',
			MCB_CONF_MAPPING_QUALITY: '映射质量',
			MCB_CONF_PRIOR_CONFIRMATION: '先验确认',
			MCB_OBS_ACTIONABILITY: '可操作性',
			MCB_OBS_CONDITION_MODIFIER: '状态修正因子',
			MCB_OBS_DATA_GATE: '数据门',
			MCB_PRED_DETAILS: '预测详情',
			MCB_PRED_B_BASE: 'B 基准',
			MCB_PRED_ASSET_MODIFIER: '资产修正因子',
			MCB_PRED_B_OPTIMIZATION: 'B 优化',
			MCB_PRED_CM: 'CM 预测',
			MCB_PRED_BD: 'BD 预测',
			MCB_D_SEC_A: 'A. 数据门与分类',
			MCB_D_SEC_B: 'B. 时序模式',
			MCB_D_SEC_C: 'C. 负担、状态与可操作性',
			MCB_D_SEC_D: 'D. 经济筛查与诊断',
			MCB_D_SEC_E: 'E. B 构建',
			MCB_D_SEC_F: 'F. 预测与价值',
			MCB_D_SEC_G: 'G. 事件证据',
			MCB_D_ROUTE: '路径',
			MCB_D_PM_CYCLES: 'PM 周期',
			MCB_D_QUALIFYING_EVENTS: '合格事件',
			MCB_D_MAPPING_CONFIDENCE: '映射置信度',
			MCB_D_MEAN_MX: '平均 Mx',
			MCB_D_SPREAD: '离散度 Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM 原始值',
			MCB_D_EFF_CM_BURDEN: '有效 CM 负担',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'PM 负担',
			MCB_D_CM_BD_BURDEN: 'CM + BD 负担',
			MCB_D_RA_COST: 'Ra 成本',
			MCB_D_DIAGNOSIS: '诊断',
			MCB_D_B_BASE: 'B 基准',
			MCB_D_DIRECTION: '方向',
			MCB_D_CONCENTRATION: '集中度',
			MCB_D_B_OPT: 'B 优化',
			MCB_D_INTERVAL: '间隔',
			MCB_D_CM_PREDICTION: 'CM 预测',
			MCB_D_STANDALONE_NET: '独立净值',
			MCB_D_EFF_BUNDLE_NET: '有效捆绑净值',
			MCB_D_COL_EVENT: '事件',
			MCB_D_COL_DATE: '日期',
			MCB_D_COL_CLASS: '类别',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: '成本',

			// Run Configuration Dialog
			RC_TITLE: '运行配置',
			RC_TAB_SCOPE: '范围',
			RC_TAB_CONFIGURE: '配置',
			RC_TAB_IMPORT: '导入数据',
			RC_TAB_DATA_QC: '数据QC',
			RC_TAB_MAPPING: '映射',
			RC_SAVE: '保存',
			RC_CANCEL: '取消',
			RC_PREVIOUS: '上一步',
			RC_NEXT: '下一步',
			RC_RUN: '运行',
			RC_CONFIGURE_TITLE: '配置分析',
			RC_CONFIGURE_DESC: '设置分析配置文件、阈值和调整参数。大多数用户应选择一个配置文件并仅调整主要参数。高级参数控制内部算法行为。',
			RC_ASSET_CLASS_TITLE: '资产类别覆盖',
			RC_ASSET_CLASS_DESC: '风险容忍参数的每类A/B/C输入',
			RC_ANALYSIS_WINDOW_TITLE: '分析窗口',
			RC_ANALYSIS_WINDOW_DESC: '定义CMMS数据分析的时间段',
			RC_DURATION: '持续时间',
			RC_INITIAL_DATE: '初始日期',
			RC_END_DATE: '结束日期',
			RC_ANALYSIS_PERIOD_PREFIX: '分析周期：',
			RC_MONTHS: '个月',
			RC_SAP_NOTIFICATIONS: 'SAP通知：',
			RC_FETCHING: '获取中...',
			RC_RECORDS: '条记录',
			RC_ANALYSIS_PROFILE_TITLE: '分析配置文件',
			RC_ANALYSIS_PROFILE_DESC: '将所有参数设置为预先校准的默认值。您可以在下方覆盖各个值。',
			RC_DATA_SUFFICIENCY_TITLE: '数据充分性要求',
			RC_DATA_SUFFICIENCY_DESC: '算法采取行动前需要多少证据',
			RC_MIN_PM_CYCLES: '最少PM周期',
			RC_MIN_FM_EVENTS: '最少FM事件',
			RC_RECENCY_HALF_LIFE: '近期性半衰期（h）',
			RC_POST_PM_WINDOW: 'PM后窗口（d）',
			RC_CYCLES: '个周期',
			RC_RESET_TO_BASE: '重置为基准',
			RC_PM_CM_RATIO_TITLE: 'PM/CM比率阈值（Ra）',
			RC_PM_CM_RATIO_DESC: '相对于故障负担，PM支出何时过高或过低？两个比率始终被计算和报告。',
			RC_PRIMARY_RATIO_LABEL: '诊断逻辑的主要比率',
			RC_OVER_MAINTAINED: '过度维护（案例1）',
			RC_UNDER_MAINTAINED: '维护不足（案例2）',
			RC_INTERVAL_ADJ_TITLE: '间隔调整限制',
			RC_INTERVAL_ADJ_DESC: '每个建议周期的最大间隔变化。延长与缩短的单独限制。',
			RC_INTERVAL_ROUNDING: '间隔舍入',
			RC_ROUND_TO: '舍入至',
			RC_DIRECTION: '方向',
			RC_ADJ_MODE: '调整模式：百分比',
			RC_ADVANCED_PARAMS_TITLE: '高级参数',
			RC_ADVANCED_PARAMS_DESC: '内部算法调整 — 时序分析、路由、敏感度、置信度层级',
			RC_ADVANCED_WARNING: '这些参数控制内部信号处理。在不了解公式的情况下更改它们可能会产生误导性结果。上面的配置文件选择器为每个参数设置合理的默认值。仅在有特定原因时才覆盖。',
			RC_PARAM_COL_PARAM: '参数',
			RC_PARAM_COL_DESC: '描述',
			RC_PARAM_COL_EFFECT: '效果',
			RC_PARAM_COL_VALUE: '值',
			RC_GOAL_SEEKER_TITLE: '目标求解模式',
			RC_GOAL_SEEKER_DESC: '优化以实现特定预算削减目标',
			RC_GOAL_SEEKER_CURRENT: '当前',
			RC_GOAL_SEEKER_TARGET: '目标削减：',
			RC_CONSTRAINTS: '约束条件',
			RC_EXCLUDE_CRITICALITY: '排除资产重要性',
			RC_EXCLUDE_EQ_TYPES: '排除设备类型',
			RC_SCOPE_TITLE: '范围',
			RC_SCOPE_DESC: '定义优化运行的范围。',
			RC_IMPORT_TITLE: '导入数据',
			RC_IMPORT_DESC: '配置的分析窗口内所选系统的SAP通知。',
			RC_PM_EVENTS: 'PM事件',
			RC_CM_EVENTS: 'CM事件',
			RC_FAILURE_EVENTS: '故障事件',
			RC_NO_RECORDS: '在所选窗口中未找到此事件类型的记录',
			RC_COL_NOTIFICATION: '通知',
			RC_COL_EQUIPMENT: '设备',
			RC_COL_DESCRIPTION: '描述',
			RC_COL_TYPE: '类型',
			RC_COL_CREATED_ON: '创建日期',
			RC_COL_COMPLETED_ON: '完成日期',
			RC_COL_PLAN_GROUP: '计划组',
			RC_DATA_QC_TITLE: '数据QC',
			RC_DATA_QC_DESC: '审查数据质量检查。',
			RC_MAPPING_TITLE: '映射',
			RC_MAPPING_DESC: '配置CM-FM映射。',
			RC_MAPPING_GROUP_BY: '分组方式',
			RC_MAPPING_GROUP_FM: '故障模式',
			RC_MAPPING_GROUP_PREVENTABILITY: '可预防性',
			RC_MAPPING_SEARCH_PLACEHOLDER: '搜索通知、工单、设备、描述',
			RC_MAPPING_LOW_CONFIDENCE: '低置信度',
			RC_MAPPING_EDITED: '已编辑',
			RC_MAPPING_REGENERATE: '重新生成',
			RC_MAPPING_DOWNLOAD: '下载',
			RC_MAPPING_UPLOAD: '上传',
			RC_MAPPING_RESET_ALL: '全部重置',
			RC_MAPPING_COL_ORDER: '工单号',
			RC_MAPPING_COL_EQUIPMENT_ID: '设备ID',
			RC_MAPPING_COL_WO_DESC: '工单描述',
			RC_MAPPING_COL_WO_TYPE: '工单类型',
			RC_MAPPING_COL_MAPPED_FM: '映射的故障模式',
			RC_MAPPING_COL_PREVENTABILITY: '可预防性',
			RC_MAPPING_EVENT: '个事件',
			RC_MAPPING_EVENTS: '个事件',
			RC_MAPPING_AVG_FM_CONF: '平均FM置信度',
			RC_MAPPING_AVG_PREV_CONF: '平均可预防性置信度',
			RC_MAPPING_NO_RECORDS: '没有可用于映射的CM/BD通知',
			RC_MAPPING_NO_FILTERED_RESULTS: '没有映射与当前筛选条件匹配',
			RC_MAPPING_GENERATING: '正在将CM/故障事件映射到故障模式...',
			RC_MAPPING_GENERATION_ERROR: '生成CM/BD到故障模式的映射失败。',
			RC_MAPPING_UNMAPPED: '未映射',
			RC_MAPPING_SYMPTOM_ONLY: '仅症状',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: '无法重新归因于根本原因故障模式 — 已从优化计算中排除。',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: '此为对"无匹配"这一判断本身的置信度，而非对某个具体故障模式的置信度。',
			RC_MAPPING_NO_RATIONALE: '未提供理由。',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: '标识与来源',
			RC_MAPPING_DETAIL_WO_CONTENT: '工单内容',
			RC_MAPPING_DETAIL_DURATION: '持续时间',
			RC_MAPPING_DETAIL_FM_MAPPING: '故障模式映射',
			RC_MAPPING_DETAIL_PREVENTABILITY: '可预防性',
			RC_MAPPING_DETAIL_AUDIT: '审计',
			RC_MAPPING_DETAIL_EVENT_CLASS: '工单类型 / 事件类别',
			RC_MAPPING_DETAIL_SCHED_START: '计划开始',
			RC_MAPPING_DETAIL_SCHED_FINISH: '计划结束',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: '作业代码',
			RC_MAPPING_DETAIL_DAMAGE_CODE: '损坏代码',
			RC_MAPPING_DETAIL_CAUSE_CODE: '原因代码',
			RC_MAPPING_DETAIL_MATERIAL_COST: '材料成本',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: '许可证签发',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: '许可证关闭',
			RC_MAPPING_DETAIL_CM_DURATION: 'CM持续时间（小时）',
			RC_MAPPING_DETAIL_DURATION_SOURCE: '持续时间来源',
			RC_MAPPING_DETAIL_FM_ID_NAME: '故障模式ID / 名称',
			RC_MAPPING_DETAIL_FM_TYPE: '故障模式类型',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: '故障模式种类',
			RC_MAPPING_DETAIL_CONFIDENCE: '置信度',
			RC_MAPPING_DETAIL_SOURCE: '来源',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: '重新归因自',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: '仅症状',
			RC_MAPPING_DETAIL_RATIONALE: '理由',
			RC_MAPPING_DETAIL_CLASS: '类别',
			RC_MAPPING_DETAIL_KEY_SIGNALS: '关键信号',
			RC_MAPPING_DETAIL_EDITED_BY: '编辑人',
			RC_MAPPING_DETAIL_EDITED_AT: '编辑时间',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: '故障模式代理运行',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: '可预防性代理运行',
			RC_MAPPING_DETAIL_EXISTING: '已存在',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: '不可用',
			RC_MAPPING_REGEN_CONFIRM_TITLE: '重新生成映射？',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '将重新生成{{count}}行手动编辑的内容，并以您的修正作为本次运行的指导。',

			// Select option labels
			OPT_6_MONTHS: '6个月',
			OPT_12_MONTHS: '12个月',
			OPT_15_MONTHS: '15个月',
			OPT_24_MONTHS: '24个月',
			OPT_36_MONTHS: '36个月',
			OPT_1_CYCLE: '1个周期（激进型）',
			OPT_2_CYCLES: '2个周期（基准型）',
			OPT_3_CYCLES: '3个周期（保守型）',
			OPT_WEEKLY: '每周（7天）',
			OPT_BIWEEKLY: '每两周（14天）',
			OPT_MONTHLY: '每月（30天）',
			OPT_NEAREST: '最近',
			OPT_UP: '向上',
			OPT_DOWN: '向下',
			OPT_CRIT_A: 'A（关键）',
			OPT_CRIT_B: 'B（重要）',
			OPT_CRIT_C: 'C（标准）',
			OPT_CRIT_D: 'D（低）',
			OPT_PROFILE_BASE_NAME: '基准',
			OPT_PROFILE_BASE_SUBTITLE: '均衡，默认',
			OPT_PROFILE_CONSERVATIVE_NAME: '保守',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: '较少建议，较高信任',
			OPT_PROFILE_AGGRESSIVE_NAME: '激进',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: '更多建议，更高潜在节省',
			OPT_PCT_SHORTER_10: '缩短10%',
			OPT_PCT_SHORTER_20: '缩短20%',
			OPT_PCT_SHORTER_25: '缩短25%',
			OPT_PCT_SHORTER_50: '缩短50%',
			OPT_PCT_LONGER_10: '延长10%',
			OPT_PCT_LONGER_20: '延长20%',
			OPT_PCT_LONGER_25: '延长25%',
			OPT_PCT_LONGER_50: '延长50%'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: '出错了！请修改部分内容后重试。',
			CANCEL: '取消',
			SAVE: '保存',
			CANCEL_CHANGES: '取消更改',
			SAVE_CHANGES: '保存更改',
			NO_RECORDS: '未找到记录',
			PLEASE_WAIT: '请稍候....',
			SEARCH: '搜索',
			ACTIONS: '操作',
			NAME: '名称',
			EMAIL: '电子邮件',
			PHONE: '电话',
			FACILITY: '设施',
			UNITS: '单元',
			SYSTEMS: '系统',
			SYSTEM: '系统',
			UNIT: '单元',
			USER: '用户',
			SELECT_FACILITY: '选择设施',
			SELECT_FACILITIES: '选择设施',
			SELECT_UNITS: '选择单元',
			SELECT_SYSTEMS: '选择系统',
			SELECT_SYSTEM: '选择系统',
			SELECT_UNIT: '选择单元',
			SELECT_USER: '选择用户',
			SEARCH_UNIT: '搜索单元...',
			NO_MATCHING_UNIT: '未找到匹配的单元',
			SEARCH_SYSTEM: '搜索系统...',
			NO_MATCHING_SYSTEM: '未找到匹配的系统',
			ROLES: {
				LIST_TITLE: '角色列表',
				NEW_ROLE: '新建角色',
				CREATE_ROLE_TOOLTIP: '创建新角色',
				SEARCH_USER: '搜索用户',
				FETCH_SELECTED: '获取已选',
				FETCH_SELECTED_TOOLTIP: '获取选中的角色',
				COL_TITLE: '标题',
				VIEW_ROLE: '查看',
				EDIT_ROLE: '编辑',
				ROLE_SUFFIX: '角色',
				DELETE_ROLE: '删除角色',
				PERMISSIONS_HEADING: '权限：',
				ENTER_TITLE: '输入标题',
				TITLE_REQUIRED: '标题',
				TITLE_REQUIRED_STRONG: '必填',
				TITLE_HINT: '请输入',
				TITLE_HINT_STRONG: '标题',
			},
			USERS: {
				TAB_USERS: '用户',
				TAB_USER_GROUPS: '用户组',
				USER_LIST: '用户列表',
				FILTERED_USER_LIST: '筛选后的用户列表',
				SHOW_DEACTIVATED: '显示已停用',
				DOWNLOAD_TOOLTIP: '下载用户列表',
				DOWNLOAD: '下载',
				NEW_USER: '新建用户',
				NEW_USER_TOOLTIP: '创建新用户',
				UPLOAD_USER: '上传用户',
				UPLOAD_USER_TOOLTIP: '批量创建用户',
				SEARCH_USER: '搜索用户',
				COL_SL_NO: '序号',
				COL_USERNAME: '用户名',
				COL_EMAIL: '电子邮件',
				COL_NAME: '名称',
				COL_ROLES: '角色',
				COL_ADMIN: '管理员',
				COL_ENTERPRISE_ADMIN: '企业管理员',
				COL_PHONE: '电话',
				COL_LAST_ACTIVE: '最后活跃时间',
				COL_STATUS: '状态',
				STATUS_ACTIVE: '活跃',
				STATUS_DEACTIVATED: '已停用',
				EDIT_USER: '编辑用户',
				DELETE_USER: '删除用户',
			},
			USER_GROUPS: {
				TITLE: '用户组',
				ADD_TOOLTIP: '添加用户组',
				NEW_GROUP: '新建用户组',
				COL_SL_NO: '序号',
				EDIT_TOOLTIP: '编辑用户',
				DELETE_TOOLTIP: '删除用户',
				NAME_REQUIRED: '名称',
				NAME_REQUIRED_STRONG: '必填',
				NAME_HINT: '请输入',
				NAME_HINT_STRONG: '名称',
				NO_USER_GROUPS: '尚未创建用户组',
				CREATE_GROUP_GET_STARTED: '创建一个新的用户组以开始',
			},
			USER_EDIT: {
				USER_INFO_HEADING: '用户信息',
				SYSTEM_ACCESS_HEADING: '系统访问',
				FACILITY_ADMIN_HEADING: '设施管理员访问',
				MODULE_ACCESS_HEADING: '模块访问',
				EMAIL_LABEL: '电子邮件',
				EMAIL_HINT: '输入电子邮件',
				PASSWORD_LABEL: '密码',
				PASSWORD_HINT: '（最少8个字符，至少一个特殊字符、一个大写字母和一个数字）',
				PASSWORD_REQUIRED: '密码',
				PASSWORD_REQUIRED_STRONG: '必填',
				NAME_LABEL: '名称',
				NAME_HINT: '输入名称',
				PHONE_LABEL: '电话',
				PHONE_HINT: '输入电话',
				PHONE_REQUIRED: '电话号码',
				PHONE_REQUIRED_STRONG: '必填',
				ENTERPRISE_ADMIN: '企业管理员',
				OPT_WHATSAPP: '启用WhatsApp',
				INTERNAL: '内部',
				MODEL_RETRAINING: '模型重新训练',
				FACILITIES_LABEL: '设施',
				SELECT_ALL: '全选',
				MODULE_LABEL: '模块',
				SELECT_MODULES_HINT: '选择模块',
				SEARCH_MODULES: '搜索模块...',
				NO_MATCHING_MODULE: '未找到匹配的模块',
				MODULE_REQUIRED: '至少需要选择一个模块。',
				SAVE_TOOLTIP: '保存',
				CANCEL_TOOLTIP: '取消',
			},
			UPLOAD_USERS: {
				TITLE: '上传用户列表',
				SELECT_CSV: '选择CSV文件',
				CSV_REQUIRED: 'CSV文件',
				CSV_REQUIRED_STRONG: '必填',
				SELECT_FILE: '选择文件',
				DOWNLOAD_FORMAT_TOOLTIP: '下载CSV格式',
				SUBMIT: '提交',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: '电子邮件',
				EMAIL_REQUIRED_STRONG: '必填',
				EMAIL_HINT: '请输入',
				EMAIL_HINT_STRONG: '电子邮件',
				PASSWORD_REQUIRED: '密码',
				PASSWORD_REQUIRED_STRONG: '必填',
				PASSWORD_HINT: '输入',
				PASSWORD_HINT_STRONG: '密码',
				NAME_REQUIRED: '名称',
				NAME_REQUIRED_STRONG: '必填',
				NAME_HINT: '输入',
				NAME_HINT_STRONG: '名称',
				PHONE_REQUIRED: '电话号码',
				PHONE_REQUIRED_STRONG: '必填',
				PHONE_HINT: '请输入',
				PHONE_HINT_STRONG: '电话',
				FACILITY_HINT: '选择',
				SYSTEM_HINT: '选择',
				SYSTEMS_PLACEHOLDER: '系统',
				SYSTEM_HINT_STRONG: '系统',
				FACILITY_HINT_STRONG: '设施',
			},
			CONFIRMATION: {
				REASON_REQUIRED: '原因必填。',
			},
			USER_ROLES: {
				SELECT_ROLE: '选择角色',
				ASSIGN_TOOLTIP: '分配角色',
				ASSIGN: '分配',
				ASSIGNED_ROLES: '已分配角色：',
				REMOVE_TOOLTIP: '移除角色',
			},
			ADDRESS: {
				FORM_ERROR: '出错了！请修改部分内容后重试。',
				ADDRESS_LINE: '输入地址行',
				ADDRESS_LINE_REQUIRED: '地址行',
				ADDRESS_LINE_REQUIRED_STRONG: '必填',
				ADDRESS_LINE_HINT: '请输入',
				ADDRESS_LINE_HINT_STRONG: '地址行',
				CITY: '城市',
				CITY_REQUIRED: '城市',
				CITY_REQUIRED_STRONG: '必填',
				CITY_HINT: '请输入',
				CITY_HINT_STRONG: '城市',
				STATE: '输入省/州',
				STATE_REQUIRED: '省/州',
				STATE_REQUIRED_STRONG: '必填',
				STATE_HINT: '请输入',
				STATE_HINT_STRONG: '省/州',
				POSTCODE: '输入邮政编码',
				POSTCODE_REQUIRED: '邮政编码',
				POSTCODE_REQUIRED_STRONG: '必填',
				POSTCODE_HINT: '请输入',
				POSTCODE_HINT_STRONG: '邮政编码',
			},
			SOCIAL: {
				FORM_ERROR: '出错了！请修改部分内容后重试。',
				LINKEDIN: '输入LinkedIn地址',
				LINKEDIN_HINT: '请输入',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: '输入Facebook地址',
				FACEBOOK_HINT: '请输入',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: '输入Twitter地址',
				TWITTER_HINT: '请输入',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: '输入Instagram地址',
				INSTAGRAM_HINT: '请输入',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: '地址',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: '出错了！密码不匹配。',
				PASSWORD: '输入密码',
				PASSWORD_REQUIRED: '密码',
				PASSWORD_REQUIRED_STRONG: '必填',
				PASSWORD_HINT: '请输入',
				PASSWORD_HINT_STRONG: '密码',
				CONFIRM_PASSWORD: '确认密码',
				CONFIRM_REQUIRED: '确认密码',
				CONFIRM_REQUIRED_STRONG: '必填',
				CONFIRM_HINT: '请确认',
				CONFIRM_HINT_STRONG: '密码',
				CHANGE_BUTTON: '更改密码',
				SAVE_CHANGES: '保存更改',
			},
		},
		SYSTEM_VIEW: {
			PARTS: '零部件',
			ACTIVE: '活跃',
			SYSTEM: '系统',
			SEARCH_SYSTEM: '搜索系统...',
			NO_MATCHING_SYSTEM: '未找到匹配的系统',
			OPEN_ALERTS: '未解决警报',
			ACTIVE_ALERTS: '活跃警报',
			UNACK_ALERTS: '未确认警报',
			RELIABILITY: '可靠性',
			MEAN_TIME_BETWEEN_ALERTS: '警报平均间隔时间',
			UPTIME: '正常运行时间',
			DAYS: '天',
			PERFORMANCE_CURVES: '性能曲线',
			OPEN_IN_NEW_TAB: '在新标签页中打开',
			TAB_ANOMALY: '异常',
			TAB_SYSTEM_DETAILS: '系统详情',
			TAB_DATA_QUALITY: '数据质量',
			TAB_PERFORMANCE: '性能',
			CLEAR_SIMULATION: '清除模拟',
			SIMULATION: '模拟',
			CLICK_TO_START_PREDICTION: '点击开始预测',
			PREDICTION_RUNNING: '预测运行中',
			NO_OF_DAYS: '天数',
			OK: '确定',
			RESET: '重置',
			RETRAINING: '重新训练',
			MORE: '更多',
			TAGS: '标签',
			SEARCH_TAG: '搜索标签...',
			NO_MATCHING_TAG: '未找到匹配的标签',
			ASSET_LABEL: '资产:',
			NAME_LABEL: '名称:',
			TAG_ID_LABEL: '标签ID:',
			CANCEL: '取消',
			ASSETS: '资产',
			SEARCH_ASSET: '搜索资产...',
			NO_MATCHING_ASSET: '未找到匹配的资产',
			RESET_ASSET_SELECTION: '重置资产选择',
			DATA_QUALITY: {
				SEARCH_TAG: '搜索标签',
				DOWNLOAD_TOOLTIP: '下载标签数据质量报告',
				DOWNLOAD: '下载',
				COL_TAG_NAME: '标签名称',
				COL_MISSING_DATA: '缺失数据',
				COL_FLAT_LINE: '平线',
				COL_OUTLIER: '异常值',
				COL_OUT_OF_RANGE: '超出范围',
				COL_TOTAL_INVALID_DATA: '总无效数据',
				COL_ACTIONS: '操作',
				MORE_ACTIONS: '更多操作',
				NO_RECORDS: '在选定的时间范围内未找到数据质量事件',
				LOADING: '加载中...',
				SHUTDOWN_TAG: '停机标签',
				TRIP: '跳闸',
				TRIP_LIMIT: '跳闸限值',
				ALARM: '报警',
				ALARM_LIMIT: '报警限值',
				THRESHOLD: '阈值',
				THRESHOLD_LIMIT: '阈值限值',
				INSTRUMENT: '仪表',
				INSTRUMENT_RANGE: '仪表量程',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: '未找到图片',
				ASSET_DETAILS: '资产详情',
				CURRENT_ALERTS_EQUIPMENT: '当前警报/设备',
				EQUIPMENT_DISTRIBUTION: '设备分布',
				TOP_FAILURE_MODES: '每台设备的主要故障模式',
				CUSTOM_INPUTS: '自定义输入',
				SELECT_TAG: '选择标签',
				UPDATE: '更新',
				SPECIFY_VALUE: '指定值',
				TIMESTAMP: '时间戳',
				LAB_DATA: '实验室数据',
				NO_DATA_FOUND: '未找到数据',
			},
			ALERT_SETTINGS: {
				TITLE: '警报设置',
				CANCEL: '取消',
				FAILURE_MODE: '故障模式',
				AGGREGATED_ANOMALY_SCORE: '聚合异常评分',
				INSTRUMENT_HEALTH: '仪器健康/数据质量',
				FLATLINE: '1: 平线',
				MISSING_DATA: '2: 缺失数据',
				OUT_OF_RANGE: '3: 超出范围',
				OUTLIERS: '4: 异常值',
			},
			DIAGNOSTICS: {
				TITLE: '系统诊断',
				CANCEL: '取消',
				ROOT_CAUSE_ICON_ALT: '根本原因图标',
				NOT_GENERATED_YET: '您尚未生成系统诊断。',
				RUN_TO_PROCEED: '请运行诊断以继续。',
				GENERATION_FAILED: '上次系统诊断生成失败。',
				RUN_AGAIN: '请重新运行诊断以继续。',
				GENERATE_NOW: '立即生成',
				REGENERATE: '重新生成',
				FAILED_AT: '系统诊断生成失败于',
				LAST_GENERATED: '上次生成',
				GENERATING: '正在生成系统诊断',
				SEVERITY: '严重性:',
				ISSUE: '问题:',
				IMPACT: '影响:',
				ACTION: '操作:',
				PRIORITY: '优先级:',
			},
			PERFORMANCE_CURVE: {
				TAG: '标签',
				FILTER_TAG_VALUE: '过滤标签值',
				SEARCH_TAG: '搜索标签...',
				NO_TAG_FOUND: '未找到标签',
				GREATER_THAN: '大于',
				LESS_THAN: '小于',
				OK: '确定',
				DATE_RANGE: '日期范围',
				START_DATE: '开始日期',
				END_DATE: '结束日期',
				SELECT: '选择',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: '平台配置',
			TABS: {
				ORGANISATION_SETUP: '组织设置',
				ASSET_REGISTRY: '资产登记',
				MODULE_HIERARCHY: '模块层级',
				PROPERTY_TEMPLATES: '属性模板',
			},
			COMING_SOON: '即将推出',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: '组织详情',
				FACILITY_SETUP: '设施',
				PLANT_ECONOMICS: '经济参数',
			},
			COMMON: {
				SAVE_CHANGES: '保存更改',
				CANCEL: '取消',
				CONFIRM: '确认',
				EDIT: '编辑',
				DELETE: '删除',
				LOADING: '加载中...',
				SEARCH: '搜索...',
				CLOSE: '关闭',
				SAVED_SUCCESSFULLY: '保存成功',
				ERROR_SAVING: '保存更改时出错',
				TIMEZONE: '时区',
				LATITUDE: '纬度',
				LONGITUDE: '经度',
				SELECT_TIMEZONE: '选择时区',
			},
			CLIENT: {
				TITLE: '组织详情',
				SUBTITLE: '配置组织详情',
				LOGO: '徽标',
				UPLOAD_LOGO: '上传徽标',
				HQ_ADDRESS: '总部地址',
				ENTERPRISE_NAME: '企业名称',
				INDUSTRY_SECTOR: '行业部门',
				STREET_ADDRESS: '街道地址',
				CITY: '城市',
				STATE: '州/省',
				COUNTRY: '国家',
				ZIP_CODE: '邮政编码',
				ZOOM_LEVEL: '缩放级别',
				BUSINESS: '业务',
				NOTES: '备注',
				SELECT_INDUSTRY_SECTOR: '选择行业部门',
				PLACEHOLDER_BUSINESS: '请输入业务详情',
				PLACEHOLDER_NOTES: '请输入备注',
			},
			FACILITY: {
				TITLE: '设施',
				SUBTITLE: '定义设施位置和参数',
				ADD_FACILITY: '添加设施',
				GROUP_BY: '分组依据',
				COL_NAME: '名称',
				COL_LOCATION: '位置',
				COL_CAPACITY: '容量（MW）',
				COL_REGION: '区域',
				COL_INDUSTRY: '行业',
				NO_FACILITIES_SEARCH: '未找到设施。',
				TRY_ADJUSTING: '请尝试调整搜索查询。',
				NO_FACILITIES_YET: '尚未设置任何设施。',
				CLICK_TO_GET_STARTED: "点击'添加设施'开始使用。",
				DELETE_TITLE: '删除设施',
				DELETE_DESCRIPTION: '您确定要永久删除设施"{{name}}"吗？',
				DELETE_WAIT: '正在删除设施...',
				DELETED_SUCCESS: '设施删除成功',
				DELETE_ERROR: '删除设施时出错',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: '添加设施',
				TITLE_EDIT: '编辑设施',
				UPDATED_SUCCESS: '设施更新成功',
				UPDATE_ERROR: '更新设施时出错',
				CREATED_SUCCESS: '设施创建成功',
				CREATE_ERROR: '创建设施时出错',
				FACILITY_NAME: '设施名称',
				FACILITY_CODE: '设施代码',
				LOCATION: '位置',
				REGION: '区域',
				CURRENCY: '货币',
				INSTALLED_CAPACITY: '安装容量（MW）',
				INDUSTRY: '行业',
				GIS_LOCATION: 'GIS位置',
				PLACEHOLDER_FACILITY_NAME: '工厂名称',
				PLACEHOLDER_LOCATION: '城市，州/省',
				SELECT_REGION: '选择区域',
				SELECT_CURRENCY: '选择货币',
				SELECT_INDUSTRY: '选择行业',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: '设施信息',
				TAB_HISTORIAN_INFO: '历史数据库信息',
				TAB_SAP_INFO: 'SAP 信息',
				ENTERPRISE: '企业',
				ADDRESS: '地址',
				CITY: '城市',
				STATE: '州/省',
				COUNTRY: '国家',
				ZIP: '邮编',
				ZOOM_LEVEL: '缩放级别',
				APPLICATION: '应用',
				NOTES: '备注',
				CUSTOMER_ADVOCATE: '客户代表',
				HISTORIAN_TYPE: '历史数据库类型',
				ACCESS_METHOD: '访问方式',
				ACCESS_URL: '访问 URL',
				RESOURCE_URL: '资源 URL',
				DATA_FETCH_SETTINGS: '数据获取设置',
				FORWARD_AGGREGATE: '转发聚合',
				FETCH_RATE: '获取频率',
				FETCH_RATE_UNIT: '获取频率单位',
				ENABLE_SAMPLING: '启用采样',
				SAMPLING_RATE: '采样频率',
				SAMPLING_RATE_UNIT: '采样频率单位',
				PREDICTION_SETTINGS: '预测设置',
				PREDICTION_RATE: '预测频率',
				PREDICTION_RATE_UNIT: '预测频率单位',
				DQ_ALERTS: '数据质量警报',
				START_DELAY: '开始延迟（小时）',
				END_DELAY: '结束延迟（小时）',
				FUNCTIONAL_LOC_MAPPING: '功能位置/设备编号映射',
				UPLOAD_FUNCTIONAL_LOC: '上传功能位置/设备编号数据',
				DOWNLOAD_FUNCTIONAL_LOC: '下载功能位置/设备编号映射',
				SAP_DATA: 'SAP 数据',
				UPLOAD_SAP_DATA: '上传 SAP 数据',
				DOWNLOAD_SAP_FORMAT: '下载 SAP 数据格式',
				UPDATE_SAP_DATA: 'SAP 许可数据更新',
				UPLOAD_UPDATE_SAP_DATA: '上传 SAP 许可数据更新',
				DOWNLOAD_UPDATE_SAP_FORMAT: '下载 SAP 许可数据更新格式',
				CMMS_WRITE_INTEGRATION: 'CMMS 写入集成',
				CMMS_LAST_DATA_PULL: 'CMMS上次数据提取',
				IP_ADDRESS: 'IP 地址',
				USER_NAME: '用户名',
				PASSWORD: '密码',
				TEST: '测试',
				TEST_WRITE_INTEGRATION: '测试写入集成',
			},
			PLANT_ECONOMICS: {
				TITLE: '经济参数',
				SUBTITLE: '设置经济因素和成本参数',
				SELECT_FACILITY_MSG: '请选择一个设施来管理其经济参数。',
				SECTION_TITLE: '生产经济学参数',
				CHOOSE_FACILITY: '选择设施...',
				PRODUCTION_DETAILS: '生产详情',
				LABOR_SALARY: '劳动力薪资参数（每小时）',
				UPDATED_SUCCESS: '工厂经济学更新成功',
				UPDATE_ERROR: '更新工厂经济学时出错',
				COST_PER_UNIT: '单位生产成本',
				CAPACITY_HOUR: '每小时产能（例如MWh）',
				REVENUE_HOUR: '每小时收入',
				MARGIN_PERCENT: '利润率（%）',
				OTHER_COSTS: '其他固定闲置成本',
				TECHNICIAN: '技术员',
				HELPER: '助手',
				SUPERVISOR: '主管',
				MANAGER: '经理',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: '解释标签',
			SELECTED_TAG: '所选标签',
			CAUSAL_TAGS: '因果标签',
			TAG_SINGULAR: '标签',
			TAG_PLURAL: '标签',
			CONTRIBUTOR_SCORE: '分数',
			NO_CONTRIBUTORS: '未找到此时间戳的贡献标签。',
			LOADING_CAUSAL_TAGS: '正在加载因果标签...',
			CLOSE: '关闭',
			ASSET: '资产',
			FULLSCREEN: '全屏',
			EXIT_FULLSCREEN: '退出全屏',
			EXPAND: '展开',
			COLLAPSE: '收起',
			EXPLAIN: '解释',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "正在加载报告…",
			REPORT_IN_PROGRESS: "报告正在生成中，请 5 分钟后再回来查看。",
			REPORT_FAILED: "无法生成该报告，请重新共享。",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: '{{kind}} 详情',
				NO_VALUES: '没有有效的 {{kind}} 数值。',
				ON_DEMAND_NO_FORECAST: '所选时间点没有可用的预测。请将标记拖动到其他时间点后重试。',
				MIN: '最小值 =',
				CURRENT_VALUE: '当前值',
				VS_BASELINE: '相对基线',
				ACTIVE_DURATION: '活动时长',
				SAMPLE_DENSITY: '样本密度',
				FORECAST: '预测 {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: '警报级 TTF',
						DESCRIPTION: 'TTF = min（各贡献测点的 TTF）。最早预测到的突破决定下方显示的汇总值。',
					},
					ALERT_LIST: {
						TITLE: '警报级 TTF',
						DESCRIPTION: 'TTF = min（各失效模式的 TTF）。最早预测到的突破决定下方显示的汇总值。',
					},
					FAILURE_MODE: {
						TITLE: '失效模式 TTF',
						DESCRIPTION: 'TTF = min（各贡献测点的 TTF）。最早预测到的突破决定下方显示的汇总值',
					},
					TAG: {
						TITLE: '测点级 TTF',
						DESCRIPTION: '根据近期变化率外推，预测该测点的投影值距离突破其运行限值的天数。',
					},
				},
				TTI: {
					ALERT: {
						TITLE: '警报级 — 距干预时间',
						DESCRIPTION: '该警报在受监控的性能劣化指标中最早的干预预测。',
					},
					ALERT_LIST: {
						TITLE: '警报级 — 距干预时间',
						DESCRIPTION: '该警报各失效模式中最早的干预预测。',
					},
					FAILURE_MODE: {
						TITLE: '失效模式 — 距干预时间',
						DESCRIPTION: '基于与该失效模式关联的性能指标，最早预测到的运行干预。',
					},
					TAG: {
						TITLE: '测点级 — 距干预时间',
						DESCRIPTION: '该测点预测的最早运维干预时间。',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "数据质量设置",
				DETECTION_TITLE: "数据质量检测",
				ALERT_GEN_TITLE: "数据质量预警生成",
				ALERT_GEN_DESC: "选择哪些检测到的DQ问题应生成预警。关闭预警生成不会停止DQ计算。",
				FLATLINE_DETECTION: "平线检测",
				MISSING_DATA_DETECTION: "数据缺失检测",
				OUTLIER_DETECTION: "异常值检测",
				OUT_OF_RANGE_DETECTION: "超范围检测",
				ERRATIC_DETECTION: "不稳定检测",
				FLATLINE_ALERT: "平线预警",
				MISSING_DATA_ALERT: "数据缺失预警",
				OUTLIER_ALERT: "异常值预警",
				OUT_OF_RANGE_ALERT: "超范围预警",
				ERRATIC_ALERT: "不稳定预警",
				CLOSE_TOOLTIP: "关闭"
			},
			DETAIL: {
				NO_DATA_URL: "未找到提供URL的数据。",
				NO_DATA_URL_DESC: "请验证输入的URL后重试。",
				FAILURE_MODES: "故障模式",
				SEARCH: "搜索...",
				SORT_FAILURE_SCORE: "按故障评分排序",
				SORT_CREATION_DATE: "按创建日期排序",
				OTHER_ACTIVE_ALERTS: "其他活跃警报",
				NEW_FAILURE: "新增故障",
				ALERT_TITLE_PLACEHOLDER: "警报标题",
				SEARCH_OWNER: "搜索负责人...",
				SEARCH_WATCHERS: "搜索关注者..",
				ASSIGN_OWNER: "分配负责人",
				ADD_WATCHERS: "添加关注者",
				VERSION_HISTORY: "版本历史",
				COPY_LINK: "复制警报链接",
				BOOKMARK: "收藏警报",
				REMOVE_BOOKMARK: "取消收藏",
				FETCHING_SYSTEM_DETAILS: "正在获取系统详情",
				RESTORE_VERSION: "恢复版本",
				CANNOT_DELETE_VERSION: "根因分析进行中时无法删除版本",
				DELETE_VERSION: "删除版本",
				EDIT: "编辑",
				CLOSE: "关闭",
				DOWNLOAD: "下载",
				SHARE: "分享",
				ANOMALY_SCORE: "异常评分",
				TIMELINE: "时间线",
				VERSIONS: "版本",
				NO_DATA_AVAILABLE: "暂无数据",
				EXPORT_REPORT: "导出报告",
				TIME_TO_FAILURE_IN: "距故障时间 {{unit}}",
				TIME_TO_INTERVENTION_IN: "距干预时间 {{unit}}",
				SWITCH_TO_FM_VIEW: '切换到FM视图',
				SWITCH_TO_RCA_VIEW: '切换到根因分析视图',
				CREATED_ON: '创建于',
				MENU_CREATED_ON: '创建于',
				STATE: '状态',
				DUE_DATE: '到期日期',
				STATUS: '状态',
				OWNER: '负责人',
				WATCHERS: '关注人',
				WATCHER: '关注人',
				LAST_RUN_PREFIX: '上次运行:',
				MENU_LAST_RUN: '上次运行',
				RUN_NOW: '立即运行',
				MENU_RUN_NOW: '立即运行',
				MORE: '更多',
				REPORT_ISSUE: '报告问题',
				NAV: {
					THRESHOLD: '阈值',
					DATA_QUALITY: '数据质量',
					ACTIVITY_LOGS: '活动日志',
					DISCUSSION: '讨论',
					ANALYSIS_VIEWS: '分析与视图',
					RETRAIN_MODEL: '重新训练模型',
					FEEDBACK: '反馈',
					DISPLAY_TAGS: '显示标签',
					PREFERRED_SETTINGS: '偏好设置',
					DOCUMENTS: '文档',
					WORK_ORDERS: '工单',
					ROOT_CAUSE_ANALYSIS: '根因分析',
				},
				TAGS_TOOLTIP: "标签",
				TIME_TO_TRIP: "到故障时间",
				DAYS: "天",
				CMMS_NUMBER: "CMMS编号",
				STACKED_VIEW: "堆叠视图",
				OVERLAY_VIEW: "叠加视图",
				GRID_VIEW: "网格视图",
				NO_RECOMMENDATIONS: "暂无推荐",
				RECOMMENDATIONS: "推荐",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "添加建议",
					ADD: "添加",
					CANCEL: "取消",
					UPDATE: "更新",
					EMPTY_TITLE: "暂无推荐",
					EMPTY_HINT: "添加一条推荐后将显示在此处。",
				},
				SEARCH_CATEGORY: "搜索分类...",
				NO_CATEGORY: "未找到匹配分类",
				SELECT_CATEGORY: "选择分类",
				SEARCH_COMPONENT: "搜索组件...",
				NO_COMPONENT: "未找到匹配组件",
				SELECT_COMPONENT: "选择组件",
				SEARCH_ERROR: "搜索错误...",
				NO_ERROR_FOUND: "未找到匹配错误",
				SELECT_ERROR: "选择错误",
				ALERT_DETAILS_TITLE: "警报详情",
				EMPTY_DATA_ALT: "无数据",
				NO_OPEN_FAILURE_MODES: "没有未处理的故障模式。",
				RELATED_ALERTS: "相关警报",
				TOP_CONTRIBUTING_TAGS: "对异常分数贡献最大的标签",
				NO_TAGS_TO_DISPLAY: "无标签可显示。",
				NO_DATA_ALT: "无数据",
				SELECT_FM_OR_ADD_TAGS: "选择故障模式或添加标签以查看图表。",
				BREAKDOWN_CATEGORY_LABEL: "故障类别",
				BREAKDOWN_COMPONENT_LABEL: "故障部件",
				BREAKDOWN_ERROR_LABEL: "错误",
				SAVE: "保存",
				FILTER_TAGS: "筛选标签",
				NO_MATCHING_RESULT: "无匹配结果",
				START_TYPING: "开始输入以查看匹配标签。",
				NO_MATCHING_RESULTS: "无匹配结果",
				CLOSE_TOOLTIP: "关闭",
				EDIT_DISABLED: "您对此设施处于只读模式",
				MULTI_SELECT_DISABLED: "只有警报负责人可以多选故障模式",
				SPLIT_MERGE_OWNER: "只有警报负责人才能分离故障模式。",
				SPLIT_MERGE_STATUS: "只有特定状态的警报才能被分离或合并。",
				SPLIT_MERGE_APPROVED: "只有已批准或未处理的故障模式才能被分离到新警报或与现有警报合并。",
				SPLIT_MERGE_ACTION: "将故障模式移至新警报或与现有警报合并。",
				SPLIT_MERGE_IN_PROGRESS: "该警报正在进行拆分或合并。请等待操作完成。",
				SPLIT_MERGE_DISMISS: "关闭",
				TITLE_EMPTY: "请输入标题以继续。",
				TITLE_TOO_LONG: "标题不能超过60个字符。",
				MAINTENANCE_RECORDS_DIALOG: "检测到现有维护记录。<br>是否要删除它们以继续重新学习？",
				FAILURE_DELETED: "故障模式\"{{name}}\"已成功删除",
				FAILURE_DELETE_ERROR: "删除\"{{name}}\"时出错。请重试。",
				FAILURE_ADDED: "故障模式\"{{name}}\"已成功添加",
				USED_IN_MODEL: "用于模型和计算标签",
				ONGOING: "进行中",
				FAILURE_TIMELINE: {
					TITLE: "“{{name}}”的时间线",
					SORT_BY: "排序方式",
					SORT_TIMELINE: "时间线",
					SORT_ASSETS: "资产",
					LIMIT_TO_SYSTEM: "将结果限制在此系统",
					ASSET: "资产",
					REASON: "原因",
					RECOMMENDATIONS: "建议",
					NOT_AVAILABLE: "无",
					NO_DATA: "未找到数据。",
					MENU_LABEL: "故障时间线",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "创建工单",
				GENERATING: "正在生成根因分析",
				GENERATE: "生成根因分析",
				PERCENT_COMPLETED: "% 已完成",
				GO_BACK: "返回",
				RUN_NOW: "立即运行",
				CANCEL: "取消",
				NOTIFY_ME: "通知我",
				ALREADY_IN_PROGRESS: "根因分析生成已在进行中",
				RERUN: "重新运行",
				VIEW_TRACES: "查看追踪",
				TITLE: "根因分析",
				HYPOTHESES: "假设",
				COMMENTS: "评论",
				EVIDENCE_POINTS: "证据点",
				DISCUSSION_TOOLTIP: "用于与您的团队内部讨论",
				APPROVED: "已批准",
				APPROVE: "批准",
				EDIT: "编辑",
				RELEARNED: "已重新学习",
				RELEARN: "重新学习",
				SUSPECTED_CAUSE: "疑似原因",
				CAUSAL_CHAIN: "因果链",
				STEPS: "步骤",
				RECOMMENDATIONS: "建议",
				CHART_TAGS: "图表标签",
				EXPORT_AS_PDF: "导出为PDF",
				PROPOSED_EVIDENCE: "提议的证据",
				ADD_TO_EVIDENCE: "添加为证据",
				EVIDENCE_ADDED_BY: "由 {{user}} 于 {{date}} {{time}} 添加",
				EVIDENCE_ADDED: "添加于 {{date}} {{time}}",
				ALREADY_ADDED: "已添加为证据",
				DRAG_TO_REORDER: "点击并拖动以重新排序",
				TABS: {
					TAGS: "标签",
					WORK_ORDERS: "工单",
					DOCUMENTS: "文档",
					SYSTEM_DETAILS: "系统详情",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "未添加标签作为证据",
					NO_TAGS_EVIDENCE_DESC: "当标签被提议为证据时，标签图表和支持详情将出现在此处。",
					NO_WORK_ORDERS: "未关联工单",
					NO_WORK_ORDERS_DESC: "当维护记录与此根本原因关联时，工单将出现在此处。",
					NO_DOCUMENT_EVIDENCE: "无文档证据",
					NO_DOCUMENT_EVIDENCE_DESC: "添加现有文档或上传新文档作为证据。",
					UPLOAD_NEW_DOCUMENT: "上传新文档",
					NO_PROPOSED_EVIDENCE: "尚无提议的证据",
					NO_PROPOSED_EVIDENCE_DESC: "添加标签、工单、文档或P&ID参考以支持此假设。",
					NO_TAGS_LINKED: "未关联标签",
					NO_TAGS_LINKED_DESC: "当标签添加到此假设时，标签图表和支持详情将出现在此处。",
					SELECT_TAG_HEADING: "未选择标签",
					SELECT_TAG_DESC: "点击左侧假设中的标签，或将标签拖到此处，以查看其图表。",
					NO_DOCUMENTS: "无可用文档",
					NO_DOCUMENTS_DESC: "当技术手册、报告和PDF与此假设关联时将出现在此处。",
					NO_SYSTEM_DETAILS: "无可用系统详情",
					NO_SYSTEM_DETAILS_DESC: "当设备数据关联时，P&ID、系统规格和技术详情将出现在此处。",
				},
				WO: {
					WORK_ORDER: "工单",
					MANUALLY_ADDED: "手动添加",
					DESCRIPTION: "描述",
					NOTIFICATION_NO: "通知编号",
					TYPE: "类型",
					EQUIPMENT: "设备",
					PLANNING_GROUP: "计划组",
					STATUS: "状态",
					USER_STATUS: "用户状态",
					CREATED_BY: "创建人",
					COMPLETED_BY: "完成人",
					CREATED_ON: "创建于",
					COMPLETED_ON: "完成于",
					CAUSE: "原因",
					CAUSE_DESC: "原因描述",
					ACTIVITY_GROUP: "活动组",
					ACTIVITY_DESC: "活动描述",
					SEE_LESS: "收起",
					SEE_MORE: "展开",
					ADDED_WITH_ROOTY: "通过{{name}}添加",
					ADDED_MANUALLY: "手动添加",
				},
				PDF: {
					ALERT_REPORT: "警报报告",
					HYPOTHESIS: "假设",
					TITLE_LABEL: "标题",
					SYSTEM: "系统",
					TYPE: "类型",
					CREATED_ON: "创建于",
					OWNER: "负责人",
					STATE: "状态",
					DUE_DATE: "截止日期",
					STATUS: "状态",
					WATCHERS: "关注者",
					HYPOTHESES_PREFIX: "假设",
					PAGE: "页",
					ZOOM: "缩放：",
					SIZE: "尺寸：",
				},
				FEEDBACK: {
					APPROVE_HEADER: "批准假设",
					RELEARN_HEADER: "重新学习假设",
					COMMENT_PLACEHOLDER: "添加您的反馈或备注...",
					REVISION_INFO: "修订所需",
				},
				SNACKBAR: {
					REPORT_QUEUED: "已请求报告。准备就绪后，我们会将下载链接发送至 {{email}}。",
					RCA_COMPLETED: "根因分析生成成功。",
					RCA_NOTIFY: "根因分析生成完成后将通知您。",
					RCA_FAILED: "根因分析生成失败。",
					REPORT_REQUEST_FAILED: "无法请求报告。请重试。",
					REMOVE_WO_ERROR: "从证据中删除工单时出错。",
					NO_RCA_DATA_AVAILABLE: "暂无根本原因分析数据，请运行根本原因分析以生成洞察。",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "批准假设",
					APPROVE_CAUSAL: "批准因果链步骤",
					APPROVE_RECOMMENDATION: "批准建议",
					RELEARN_HYPOTHESES: "重新学习假设",
					RELEARN_CAUSAL: "重新学习因果链步骤",
					RELEARN_RECOMMENDATION: "重新学习建议",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "将此标签添加为提议证据？",
				ADD_DOCS_EVIDENCE: "将{{count}}个文档添加为提议证据？",
				ADD_WOS_EVIDENCE: "将此工单添加为证据？",
				REMOVE_RC_EVIDENCE_DESC: "删除此根本原因证据？此操作无法撤销。",
					REMOVE_EVIDENCE_TITLE: "确认",
					REMOVE_EVIDENCE_DESC: "删除此证据？此操作无法撤销。",
					ERROR_TITLE: "错误！",
					OK: "确定",
					CONFIRM: "确认",
					CANCEL: "取消",
					EVIDENCE_LOCKED: "根因分析证据无法移动到提议证据部分。",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "为此证据添加背景信息",
					EDIT_TITLE: "编辑此证据的背景信息",
					CLOSE: "关闭",
					SUBTITLE: "帮助根因分析理解此证据为何相关，以及在下次重新运行时应如何使用。",
					FIELD_LABEL: "为什么此证据相关?",
					FIELD_LABEL_OPTIONAL: "为什么此证据相关?(可选)",
					FIELD_PLACEHOLDER: "例如：此工单提到泵跳闸前密封件发生泄漏。",
					FIELD_ERROR: "请提供背景信息以继续",
					CANCEL: "取消",
					UPDATE_CONTEXT: "更新背景信息",
					ADD_EVIDENCE: "添加证据",
					ABORT_TITLE: "证据将不会被添加",
					ABORT_DESC: "根因分析需要简短描述以了解应如何使用此证据。如果您现在取消，此证据将不会在下次根因分析重新运行时被考虑。",
					ABORT_CANCEL: "取消添加证据",
					ABORT_GO_BACK: "返回",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "待处理缺陷",
			},
			METRICS: {
				HEALTH_SCORE: "健康评分",
				TOTAL_ALERTS: "警报总数",
				UNACKNOWLEDGED: "未确认",
				REVIEWING: "审查中",
				PENDING: "待处理",
				UNKNOWN: "未知",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "系统概览",
				SYSTEM_HEALTH_INDICATORS: "系统健康指标",
				PRIORITY_ACTIONS: "优先操作",
				PRIORITY_TOOLTIP: "当前需要您关注的事项。未确认及待处理 - 已报告缺陷的异常警报。",
				NO_PRIORITY_ACTIONS: "无优先操作",
				ALL_CAUGHT_UP: "全部处理完毕 - 无需立即关注 ",
				MONITORING_TRACKING: "监控与跟踪",
				MONITORING_TOOLTIP: "正在跟踪的较低优先级项目。状态为处理中和监视中的异常警报。",
				IN_PROCESS: "处理中",
				ON_WATCH: "监视中",
				RUNNING_STATE: "运行状态",
				AT_RISK: "有风险",
				REVIEW: "待审查",
				HEALTHY: "健康",
				CURRENT: "当前",
				THRESHOLD: "阈值",
				NO_DATA_FOUND: "未找到数据",
				VIEW_ALL: "查看全部 →",
				NO_ALERTS_ARE: "没有{{title}}的警报",
				NO_DATA: "无数据",
			},
			TABLE: {
				HEADERS: {
					STATUS: "状态",
					ALERT_NAME: "警报名称",
					SYSTEM_NAME: "系统名称",
					TYPE: "类型",
					LOSS: "损失 (kWh)",
					START: "开始",
					STOP: "停止",
					DURATION: "持续时间",
					LAST_ACTIVE: "最后活动",
					CREATED_ON: "创建于",
					STATE: "状态",
					OWNER: "负责人",
					WATCHERS: "关注者",
					FORECAST: "预测",
					CATCH: "捕获",
					UPPER_LIMIT: "上限",
					VALUE: "值",
					LOWER_LIMIT: "下限",
					LAST_SYSTEM_UPDATE: "最后系统更新",
					LAST_USER_UPDATE: "最后用户更新",
					DISCUSSION: "讨论",
					TOTAL_VALUE: "总值",
					RELIABILITY_SAVING: "可靠性节省",
					MAINTENANCE_SAVING: "维护节省",
					PERFORMANCE_SAVING: "性能节省",
					ALERT_DRIVEN_MAINTENANCE: "警报驱动维护",
				},
				NEW_FAILURE_ADDED: "已添加新故障模式",
				TIME_TO_TRIP_DAYS: "距故障 {{n}} 天",
				OPEN_IN_NEW_TAB: "在新标签页中打开",
				RCA_AVAILABLE: "根本原因分析可用",
				ASSIGN_OWNER: "分配负责人",
				ADD_WATCHERS: "添加关注者",
				SEARCH_OWNER: "搜索负责人...",
				SEARCH_WATCHERS: "搜索关注者...",
				NO_APPROVED_FM: "未找到已批准的故障模式",
				EXTRA_MORE: "+ 另外 {{count}} 个",
				CUSTOMIZE_COLUMNS: "自定义列",
				BOOKMARK_ALERT: "收藏警报",
				REMOVE_BOOKMARK: "取消收藏",
				VIEW_ONLY_MODE: "您处于该设施的只读模式",
				SYSTEM_TOOLTIP: "系统：{{system}}\n机组：{{unit}}\n设施：{{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "未确认",
					IN_PROCESS: "处理中",
					ON_WATCH: "监视中",
					PENDING_DEFECT: "待处理 - 已报告缺陷",
					CLOSED_MAINT_DEFERRED: "已关闭 - 维护延期",
					CLOSED_NO_ACTION: "已关闭 - 无计划措施",
					CLOSED_RESOLVED: "已关闭 - 已解决",
					REJECTED: "已拒绝",
				},
				STATE: {
					TENTATIVE: "暂定",
					ACTIVE: "活动",
					RETURNED_TO_NORMAL: "已恢复正常",
					CLOSED: "已关闭",
					NOISE_DISCARDED: "噪声/已丢弃",
				},
				TYPE: {
					H_ANOMALY: "高异常",
					L_ANOMALY: "低异常",
					DATA_QUALITY: "数据质量",
					USER_REPORTED: "用户报告",
					THRESHOLD: "阈值",
					DIAGNOSIS: "诊断",
					DIGITAL: "数字",
				},
				SUBTYPE: {
					OUTLIER: "离群值",
					OUT_OF_RANGE: "超出范围",
					FLATLINE: "平直线",
					MISSING: "缺失",
					UNKNOWN: "未知",
					PAINT_BRUSHING: "刷漆",
				},
				THRESHOLD_ALERT: "阈值警报",
				DATA_QUALITY_ALERT: "数据质量警报",
				TITLE_TOOLTIP: "标题：{{title}}",
				TITLE_ID_TOOLTIP: "标题：{{title}}\n警报 ID：{{id}}",
				DAYS: "{{n}} 天",
				HOURS: "{{n}} 小时",
				DAYS_SHORT: "{{n}}天",
				HOURS_SHORT: "{{n}}小时",
				POTENTIAL: "(潜在)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "预览文档",
				CLOSE: "关闭",
				DOWNLOAD_FILE: "下载文件",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} 条警报",
				SHOW_MORE_ALERTS: "再显示 {{count}} 条警报",
				COLUMN_SAVED: "列视图已保存",
				SOMETHING_WENT_WRONG: "出现错误，请重试",
				TAKES_FEW_SECONDS: "这可能需要几秒钟...",
				BULK_RESULT: "{{total}} 条警报中的 {{success}} 条已{{msg}}",
				STATUS_CLOSED_NO_ACTION: "状态设置为已关闭 - 无计划措施",
				ACTION_UPDATED: "{{action}}已更新",
				ACTION_STATUS: "状态",
				ACTION_BOOKMARK: "书签",
				ACTION_SUBSCRIBERS: "关注者",
			},
			DIALOG: {
				ADD_COMMENT: "添加备注*",
				COMMENT_REQUIRED: "请添加备注以继续",
				ADD_A_REASON: "添加原因",
				SELECTED_FAILURE_MODES: "已选故障模式",
				SELECT_ALL: "全选",
				CANCEL: "取消",
				CLOSE: "关闭",
				ADD: "添加",
				OK: "确定",
				MARK_AS_CATCH: "标记为已捕获",
			},
			APPROVE: {
				TITLE: "批准故障模式",
				EDIT_TITLE: "编辑 - 批准故障模式",
				RECOMMENDATIONS_FOR: "{{name}}的建议",
				ADD_RECOMMENDATION_PLACEHOLDER: "添加建议...",
				APPROVE: "批准",
				UPDATE: "更新",
			},
			RELEARN: {
				TITLE: "重新学习故障模式",
				RELEARN: "重新学习",
			},
			BULK_UPDATE: {
				PROCESSING: "处理中",
				COMPLETED: "批量更新完成！",
				DOWNLOAD_REPORT: "下载报告",
				SELECT_DUE_DATE: "选择截止日期",
				DUE_DATE_HINT: "截止日期默认为今天起28天，可根据需要调整。",
				DUE_DATE_TOOLTIP: "为所选警报选择截止日期",
				UPDATED_SUCCESSFULLY: "更新成功",
				UPDATE_FAILED: "更新失败",
				SHOWING: "显示 {{shown}}/{{total}}",
			},
			SPLIT_MERGE: {
				TITLE: "拆分/合并故障模式",
				SUBTITLE: "将已批准或未处理的故障模式移至新警报或与现有警报合并。",
				APPROVED: "已批准",
				APPROVED_ON: "已于 {{date}} 批准",
				APPROVED_FAILURE_MODES: "已批准的故障模式",
				FAILURE_MODES: "故障模式",
				TAB_CREATE: "创建新警报",
				TAB_MERGE: "合并到现有",
				ALERT_TITLE: "警报标题",
				SYSTEM: "系统",
				UNIT: "机组",
				SEVERITY: "严重程度",
				SELECT_SEVERITY: "选择严重程度",
				OWNER: "负责人",
				CREATED_ON: "创建于",
				STATUS: "状态",
				SELECT_TARGET_ALERT: "选择目标警报",
				SEARCH_PLACEHOLDER: "搜索...",
				LOADING: "加载中...",
				NOT_OWNER_MESSAGE: "您不是状态为“处理中”、“监视中”、“无计划措施”或“待处理缺陷”的警报的负责人。",
				PROCESSING_TOOLTIP: "正在处理，请稍候！",
				PROCESSING: "处理中...",
				SUBMIT_CREATE: "创建新警报",
				SUBMIT_MERGE: "合并到警报",
				VIEW_CREATE: "打开新警报",
				VIEW_MERGE: "打开警报",
				GO_BACK: "返回",
				SUCCESS_CREATE: "新警报已成功创建。",
				SUCCESS_MERGE: "已成功与现有警报合并。",
				FAILED_CREATE: "警报创建失败。请重试。",
				FAILED_MERGE: "警报合并失败。请重试。",
				PENDING: "请求已排队。将在当前预测批次完成后处理。",
				CONFLICT: "该警报已有一个拆分/合并请求正在进行中。",
				CONFLICT_DESTINATION: "目标警报已有一个拆分/合并请求正在进行中。",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '2025年8月25日',
			},
			FILTER: {
				FILTER_BY: "筛选条件",
				SEARCH_BY_ALERT_NAME: "按警报名称搜索...",
				CLEAR_SEARCH: "清除搜索",
				STATE: "状态",
				ANOMALY: "异常",
				ACTIVE: "活动",
				RETURNED_TO_NORMAL: "已恢复正常",
				OTHER_ALERT_TYPES: "其他警报类型",
				CATCH: "捕获",
				TRUE: "是",
				FALSE: "否",
				AGENTS: "智能体",
				HAS_RCA: "已生成根因分析",
				NO_RCA: "未生成根因分析",
				BOOKMARK_AND_CASES: "书签和案例",
				ONLY_TRACKED_CASES: "仅显示有跟踪案例的警报",
				DIAGNOSIS_CONDITIONS: "诊断条件",
				TRIP_BREAKDOWN: "跳闸/故障",
				UNDER_PERFORMANCE: "性能不足",
				SMB_DOWN: "SMB 停机",
				SMB_UNDER_PERF: "SMB 性能不足",
				CURTAILMENT: "限电",
				OUT_OF_ENV_SCOPE: "超出环境范围",
				DATA_QUALITY_TYPE: "数据质量类型",
				OUTLIER: "离群值",
				OUT_OF_RANGE: "超出范围",
				FLATLINE: "平直线",
				MISSING: "缺失",
				TAG_STATUS: "测点状态",
				TAG_STATUS_INFO: "仅适用于数据质量（DQ）警报",
				USED_IN_MODEL: "在模型中使用",
				DROPPED_TAGS: "已丢弃的测点",
				WATCHERS: "关注者",
				SEARCH_PLACEHOLDER: "输入以搜索",
				CLEAR_ALL: "全部清除",
			},
			COLUMNS: {
				NUMBER: "编号",
				ALERT_NAME: "警报名称",
				STATUS: "状态",
				SYSTEM: "系统",
				TYPE: "类型",
				DATE: "日期",
				CREATED_ON: "创建于",
				STATE: "状态",
				OWNER: "负责人",
				WATCHERS: "关注者",
				CATCH: "捕获",
				FORECAST: "预测",
				UPPER_LIMIT: "上限",
				VALUE: "值",
				LOWER_LIMIT: "下限",
				LAST_SYSTEM_UPDATE: "最后系统更新",
				LAST_USER_UPDATE: "最后用户更新",
				TOTAL_VALUE: "总值",
				RELIABILITY_SAVINGS: "可靠性节省",
				MAINTENANCE_SAVINGS: "维护节省",
				PERFORMANCE_SAVINGS: "性能节省",
				ALERT_DRIVEN_MAINTENANCE: "警报驱动维护",
				DISCUSSION: "讨论",
				LOSS: "损失 (kWh)",
				START: "开始",
				STOP: "停止",
				DURATION: "持续时间",
			},
			NO_ALERTS: {
				TITLE: "未找到警报",
				SUBTITLE: "请修改筛选条件或日期范围以查看结果",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "显示列",
				SEARCH_PLACEHOLDER: "输入以搜索",
				SELECT_ALL: "全选",
				RESET_TO_DEFAULT: "重置为默认",
			},
			PAGE_TITLE: "警报",
			OVERVIEW_TAB: "概览",
			SEARCH_PLACEHOLDER: "搜索...",
			NO_MATCHING_RESULTS: "无匹配结果",
			SEARCH_OWNER_PLACEHOLDER: "搜索负责人...",
			SELECT_OWNERS: "选择负责人",
			ALL_STATUSES: "所有状态",
			STATUS_FILTER: "状态筛选",
			CHOOSE_STATUSES: "选择要显示的状态",
			FILTERS: "筛选",
			GROUP_BY: "分组方式",
			MORE: "更多",
			SELECT_ALERTS_FOR_CASE: "选择要在此案例中标记的警报",
			SHOWING_RESULTS_FOR: '"{{term}}" 的搜索结果',
			CHIP: {
				THRESHOLD: "阈值",
				HIGH_ANOMALY_SHORT: "高异常",
				LOW_ANOMALY_SHORT: "低异常",
				DATA_QUALITY: "数据质量",
				DIAGNOSIS: "诊断",
			},
			TYPE: {
				THRESHOLD: "阈值",
				HIGH_ANOMALY: "高异常",
				LOW_ANOMALY: "低异常",
				DATA_QUALITY: "数据质量",
				DIAGNOSIS: "诊断",
			},
			AUTO_REFRESH: {
				LABEL: "自动刷新",
				OFF: "关",
				LIVE: "实时",
				MIN_5: "5分钟",
				MIN_15: "15分钟",
				MIN_30: "30分钟",
				HOUR_1: "1小时",
			},
			MORE_MENU: {
				EXPORT_DATA: "导出数据",
				EXPAND_ALL_GROUPED: "展开所有分组项",
				COLLAPSE_ALL_GROUPED: "折叠所有分组项",
				EXPAND_ALL_WITHIN_GROUP: "展开组内所有项",
				COLLAPSE_ALL_WITHIN_GROUP: "折叠组内所有项",
				SWITCH_TO_CLASSIC: "切换到经典视图",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}}新事件",
				TYPE_ALERTS: "{{count}}个{{type}}警报",
				COUNT_NEW_EVENTS: "{{count}}个新事件",
				COUNT_TYPE_NEW_EVENTS: "{{count}}个{{type}}新事件",
				SYSTEM_OPEN_ALERTS: "系统：{{name}}\n未处理警报：{{count}}",
				UNIT_OPEN_ALERTS: "机组：{{name}}\n未处理警报：{{count}}",
				FACILITY_OPEN_ALERTS: "设施：{{name}}\n未处理警报：{{count}}",
				EDIT_DISABLED_CLOSED: "已关闭/已拒绝的警报禁用编辑操作。"
			},
		},
		MODEL_WIZARD: {
		NO_CUSTOMER_TAGS_AVAILABLE: '暂无客户标签',
		MAP_CUSTOMER_TAGS_CONTENT: '添加或导入客户标签以将它们与资产标签进行映射。',
		SYSTEM_SUMMARY: {
			TITLE: "系统技术摘要",
			GENERATE: "生成摘要",
			PLACEHOLDER: "提供该系统的详细技术摘要，或根据可用文档和关联系统生成摘要。",
			HELPER: "您可以编辑生成的摘要，也可以手动编写。",
			DRAWER_TITLE: "生成系统技术摘要",
			SOURCE_DOCS: "源文档",
			SOURCE_DOCS_DESC: "选择说明系统设计、操作、控制逻辑或设备行为的文档。",
			DOCS_SELECTED: "已选文档",
			SELECT_DOCUMENTS: "选择文档",
			UPLOAD_TITLE: "上传支持文档",
			UPLOAD_DESC: "上传文档管理器中尚不存在的其他文件。",
			UPLOAD_FAILED: "上传失败",
			VIEW_FILE: "查看文件",
			PROCESSING: "处理中...",
			COMPLETED: "已完成",
			FAILED: "失败",
			DUPLICATE_UPLOAD: "「{{name}}」已添加——已跳过重复上传。",
			ALREADY_UPLOADED_USED: "「{{name}}」已上传并用于训练。",
			CONNECTED_SYSTEMS: "关联系统",
			CONNECTED_DESC: "添加影响该系统行为的上游、下游或并行系统。",
			UPSTREAM: "上游系统",
			SELECT_UPSTREAM: "选择上游系统",
			DOWNSTREAM: "下游系统",
			SELECT_DOWNSTREAM: "选择下游系统",
			PARALLEL: "并行系统",
			SELECT_PARALLEL: "选择并行系统",
			SEARCH_SYSTEM: "搜索系统",
			SEARCH_FACILITY: "搜索设施",
			SEARCH_UNIT: "搜索单元",
			NO_SYSTEMS: "未找到系统",
			OPTIONAL_META: "可选系统元数据",
			OPTIONAL_META_DESC: "可选详细信息可以提高所生成技术摘要的质量。",
			PRIMARY_COMPONENT: "主要组件",
			FLUID_MEDIUM: "流体/介质",
			CRITICAL_CONTROL_NODES: "关键控制节点",
			AUXILIARY_SYSTEMS: "辅助系统",
			DIAG_UPSTREAM: "诊断标记 - 上游故障",
			DIAG_DOWNSTREAM: "诊断标记 - 下游故障",
			ADDITIONAL_CONTEXT: "添加附加上下文",
			OPTIONAL: "可选",
			DOCUMENTS_COUNT: "个文档",
			CONNECTED_COUNT: "个关联系统",
			VIEW_SOURCES: "查看来源",
			VIEW_SOURCES_DESC: "用于生成此描述的文档和关联系统。",
			NO_DOCS_USED: "没有用于生成此描述的文档。",
			NO_SYSTEMS_USED: "没有用于生成此描述的关联系统。",
			NO_SOURCES: "无可用来源",
			NO_SOURCES_DESC: "没有用于生成此描述的文档或关联系统。",
			REGENERATE: "重新生成",
			CLICK_TO_EDIT: "点击编辑",
			GENERATION_STARTED: "正在生成系统描述……这可能需要一些时间。",
			ALREADY_IN_PROGRESS: "该系统的系统描述正在生成中。请等待其完成后再重新生成。",
			GENERATION_FAILED: "系统描述生成失败。",
			GENERATION_FAILED_TEXT: "系统生成失败。",
			LAST_UPDATED: "最后更新",
			BY: "由",
			DOCUMENTS: "文档",
			SELECT_DOCS_TITLE: "选择源文档",
			SELECT_DOCS_DESC: "从设施、机组或系统级别选择说明系统设计、操作、控制逻辑或设备行为的文档。",
			DOCUMENT_SCOPE: "文档范围",
			SCOPE_FACILITY: "设施",
			SCOPE_UNIT: "机组",
			SCOPE_SYSTEM: "系统",
			SEARCH_SCOPE_FACILITY: "搜索设施",
			SEARCH_SCOPE_UNIT: "搜索设施、机组",
			SEARCH_SCOPE_SYSTEM: "搜索设施、机组、系统",
			SEARCH_SCOPE: "搜索范围",
			NO_SCOPES: "未找到匹配的范围。请尝试其他关键字。",
			ALL_TYPES: "所有类型",
			SEARCH_DOCS: "搜索文档...",
			UPDATED: "更新于",
			NO_DOCS_TITLE: "未找到文档",
			NO_DOCS_DESC: "没有匹配的文档。请尝试更改筛选条件。",
			LOADING_MORE: "正在加载更多文档...",
			SELECTED_DOCS: "已选文档",
			ADD: "添加",
			DOCUMENTS_WORD: "个文档",
			ADD_DOCUMENTS: "添加文档",
			CANCEL: "取消",
			REGENERATE_CONFIRM_TITLE: "重新生成系统描述？",
			REGENERATE_CONFIRM_MESSAGE: "重新生成将用新生成的内容替换当前的系统描述。此操作无法撤销。",
		},
			ESCALATION_CONFIG: {
				TITLE: "升级配置",
				DELAY_LABEL: "升级延迟（天）",
				LEVEL_LABEL: "级别",
				LEVEL_PLACEHOLDER: "请输入级别",
				SELECT_USERS: "选择用户",
				SEARCH_USERS_PLACEHOLDER: "按邮箱ID搜索",
				NO_MATCHING_EMAIL: "未找到匹配的邮箱ID",
				EMAILS_LABEL: "添加以逗号分隔的邮箱ID",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ 添加级别",
				ADD_LEVEL_TOOLTIP: "添加级别",
				REMOVE_TOOLTIP: "删除",
				CONFIG_TYPE_UNIT: "使用单元配置",
				CONFIG_TYPE_CUSTOM: "使用自定义配置",
				CONFIG_TYPE_NONE: "无升级配置",
			},
			NO_ASSET_TAGS_FOUND: '没有可用的资产标签',
			NO_MAPPED_TAGS_FOUND: '没有可用的映射标签',
		ASSET_INFORMATION: "资产信息",
		NO_ASSET_FOUND: "未找到资产",
		EQUIPMENT: "设备",
		TEMPLATE: "模板",
		APPLICATION: "应用",
		INDUSTRY: "行业",
		CONFIGURATION_COL: "配置",
		MODEL_CONFIGURATION: "模型配置",
		MODELING_TECHNIQUE: "建模方法",
		SCALER: "缩放器",
		SMOOTHING: "平滑",
		SELECT_SMOOTHING_FUNCTION: "选择平滑函数",
		SMOOTHING_FUNCTION: "平滑函数",
		WINDOW_SIZE: "窗口大小",
		IN_HOURS: "（小时）",
		IN_DAYS: "（天）",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "多项式阶数",
		VALUE_REQUIRED: "值为必填项",
		VALUE_MIN_1: "值必须大于或等于1",
		NONE: "无",
		ANOMALY_SCORE_CALC_METHOD: "异常分数计算方法",
		ANOMALY_CALC_DEFAULT: "默认（所有标签的RMS）",
		ANOMALY_CALC_NEW: "新方法（资产标签RMS之和）",
		PREDICTION_TIME_PERIOD: "预测时间段",
		TRAINING_TIME_PERIOD: "训练时间段",
		CALENDAR_SELECTION: "日历选择",
		CHART_BASED_SELECTION: "图表选择",
		START_TIME: "开始时间",
		END_TIME: "结束时间",
		START_TIME_REQUIRED: "开始时间为必填项",
		END_TIME_REQUIRED: "结束时间为必填项",
		STARTUP_TRAINING_BUFFER: "启动训练缓冲",
		SHUTDOWN_TRAINING_BUFFER: "停机训练缓冲",
		TRAINING_BUFFER_GROUP: "训练缓冲",
		TRAINING_BUFFER_STARTUP_SHORT: "启动（天）",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "停机（天）",
		TRAINING_CONDITIONS: "训练条件",
		METHOD1_RANGE_FILTER: "方法1：范围过滤",
		METHOD2_CONDITION_FILTER: "方法2：条件过滤",
		LOAD_TAG: "负荷标签",
		REFERENCE_TAG: "参考标签",
		NUM_OF_BINS: "分箱数量",
		QUANTILE_CONDITION: "分位数条件",
		LESS_THAN: "小于",
		GREATER_THAN: "大于",
		EQUAL_TO: "等于",
		VALUE: "值",
		TAG: "标签",
		MIN: "最小值",
		MAX: "最大值",
		CONDITION: "条件",
		AND: "与",
		OR: "或",
		ADD: "添加",
		CLOSE: "关闭",
		ADD_NOTE: "添加备注",
		VIEW_NOTE: "查看备注",
		VIEW_EDIT_NOTE: "查看/编辑备注",
		NOTE_FOR_DATE_RANGE: "日期范围：{{range}}",
		ENTER_NOTES: "请输入备注",
		SEARCH_TAGS: "搜索标签...",
		NO_MATCHING_TAGS: "未找到匹配的标签",
		SELECT_TRAINING_REGIONS: "自动选择训练区域",
		ADD_TRAINING_RANGE: "添加训练范围",
		DELETE_TRAINING_RANGE: "删除训练范围",
		NAME: "名称",
		TAG_ID: "标签ID",
		UNIT_SETUP: "单元设置",
		SCHEMATIC: "示意图",
		EQUIPMENT_LIST: "设备列表",
		UNITS: '单元',
		CAPACITY: '容量',
		SYSTEM_INFORMATION: '系统信息',
		DESCRIPTION: '描述',
		CRITICALITY: '重要性',
		COMMENTS: '备注',
		SEARCH: '搜索',
		NO_UNIT_FOUND: '未找到单元',
		NO_SYSTEM_FOUND: '未找到系统',
		CUSTOMER: '客户',
		FACILITY: '设施',
		UNIT: '单元',
		SYSTEM: '系统',
		ORIGINAL_AUTHOR: '原始作者',
		TRAINING_DATASET: '训练数据集',
		VALIDATION_LOSS: '验证损失',
		LAST_DEPLOYED: '最后部署',
		ON: '开启',
		SELECTED_VERSION: '所选版本',
		DEPLOYED_PERIOD: '部署周期',
		STATUS: '状态',
		MARK_AS_IMPORTANT: '标记为重要',
		DISABLE: '禁用',
		DELETE: '删除',
		DELETE_VERSION_TOOLTIP: '删除版本',
		TAB_FACILITY_SETUP: '设施设置',
		TAB_TAG_MAPPING: '标签映射',
		TAB_DATA_SYNC: '数据同步',
		TAB_DATA_IMPORT: '数据导入与处理',
		TAG_MAPPING_REQUIRED_TOOLTIP: '需要完成标签映射，然后此选项卡才会启用。',
		TAB_MODEL_BUILDING: '模型构建',
		RECALCULATING_TOOLTIP: '正在重新计算',
		CUSTOMER_TAG_LIST: '客户标签列表',
		TAGS_BTN: '标签',
		MODEL_BUILDING_CONFIG_TOOLTIP: '模型构建步骤配置',
		TAGS_TO_BE_MAPPED: '待映射标签',
		UPLOAD_SYSTEM_TAGS: '上传系统标签',
		DOWNLOAD_FACILITY_TAGS: '下载设施标签',
		ASSETS_PLACEHOLDER: '资产',
		SEARCH_IN_ALL_FIELDS: '在所有字段中搜索',
		COL_NAME: '名称',
		COL_DESCRIPTION: '描述',
		COL_UNIT: '单元',
		CUSTOMER_TAGS: '客户标签',
		UPLOAD_TAGS_TOOLTIP: '上传标签',
		DOWNLOAD_TAGS_TOOLTIP: '下载标签',
		TAG_MAPPING_NO_ASSET_TOOLTIP: '至少需要创建1个资产才能执行标签映射',
		MAP_SELECTED: '映射所选',
		IMPORT_WO_MAPPING: '导入工单映射',
		TAGS_MAPPED: '已映射标签',
		SAVE_CHANGES: '保存更改',
		UNMAP_SELECTED: '取消映射所选',
		UNMAPPED_TAGS: '未映射标签',
		COL_TAG_NAME: '标签名称',
		COL_ASSET: '资产',
		COL_TAG_ID: '标签ID',
		COL_THRESHOLD_HIGH: '阈值上限',
		COL_THRESHOLD_LOW: '阈值下限',
		COL_TRIP_HIGH: '跳闸上限',
		COL_TRIP_LOW: '跳闸下限',
		COL_ALARM_HIGH: '报警上限',
		COL_ALARM_LOW: '报警下限',
		COL_DIRECTIONALITY: '方向性',
		COL_FLATLINE_DETECTION: '平线检测',
		COL_MISSING_DATA_DETECTION: '缺失数据检测',
		COL_OUTLIER_DETECTION: '异常值检测',
		COL_RANGE_DETECTION: '超出范围检测',
		COL_FLATLINE_ALERT_GENERATION: '平线报警生成',
		COL_MISSING_DATA_ALERT_GENERATION: '缺失数据报警生成',
		COL_OUTLIER_ALERT_GENERATION: '异常值报警生成',
		COL_RANGE_ALERT_GENERATION: '超出范围报警生成',
		COL_ATTENTION: '关注',
		COL_THRESHOLD_NOTIFICATION: '阈值通知',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: '显示列',
		VIEW_CHANGES_TOOLTIP: '查看更改',
		EDIT_TAG_TOOLTIP: '编辑标签',
		VIEW_PIDS_TOOLTIP: '查看PID',
		IN_PROGRESS: '进行中',
		CORRECT_RECORDS_MSG: '请更正有错误的记录并重新上传。',
		DOWNLOAD_ERROR_RECORDS: '下载错误记录',
		RELEVANT_INFORMATION: '相关信息',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: '图片',
		TEST_REPORTS_PANEL: '测试报告',
		PROCEDURES_PANEL: '程序',
		TAG_DATA: '标签数据',
		SEARCH_TAG: '搜索标签',
		SEARCH_ASSET: '搜索资产',
		EXPORT_DQ_METRICS_TOOLTIP: '导出DQ指标',
		EXPORT: '导出',
		TAG_SELECTION_PLACEHOLDER: '标签选择',
		PREPROCESSING_STATS_PLACEHOLDER: '预处理统计',
		TAG_MAPPING_PLACEHOLDER: '标签映射',
		TAG_TYPE_PLACEHOLDER: '标签类型',
		OPERATING_REGION_PLACEHOLDER: '运行区域',
		COL_PLOT: '图形',
		COL_CORR: '相关',
		COL_MODEL: '模型',
		COL_TAGS: '标签',
		SHUTDOWN_TAG_TOOLTIP: '停机标签',
		COL_MAX: '最大值',
		COL_MIN: '最小值',
		COL_STD_DEV: '标准差',
		COL_AGGREGATE_TAG: '聚合标签',
		COL_MEAN_SHIFT: '均值偏移',
		COL_VARIANCE: '方差',
		COL_MEAN: '均值',
		COL_DEVIATION_SCORE: '偏差分数',
		COL_OP_UPPER: '运行上限',
		COL_OP_LOWER: '运行下限',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: '异常值',
		COL_FLATLINE: '平线',
		COL_OUT_OF_RANGE: '超出范围',
		COL_TOTAL_INVALID_DATA: '总无效数据',
		NO_RECORDS_FOUND: '未找到记录',
		NO_DATA_AVAILABLE_SYSTEM: '所选系统没有可用数据。请拉取新数据或上传',
		CHOOSE_MODEL_VERSION_MSG: '选择模型版本以查看标签图形',
		SELECT_PLOT_CHECKBOX_MSG: '选择标签的图形复选框以查看图表',
		TAG_CORRELATION_TITLE: '标签相关性',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: '标签相关性条件',
		CORR_GREATER_THAN_OPTION: '显示相关性大于以下值的标签',
		CORR_LESS_THAN_OPTION: '显示相关性小于以下值的标签',
		CORR_VALUE_PLACEHOLDER: '相关值',
		SELECT_RANGE_LABEL: '选择范围',
		SELECT_RANGE_TOOLTIP: '在图表上拖动以选择日期范围',
		REMOVE_RANGE_LABEL: '删除范围',
		REMOVE_RANGE_TOOLTIP: '在图表上拖动以从建模中排除日期范围',
		SYSTEM_DATA_FILTER_LABEL: '系统数据过滤器',
		SELECTED_DATE_RANGES_LABEL: '已选择的日期范围：',
		CONFIRM_SELECTION: '确认选择',
		REMOVED_DATE_RANGES_LABEL: '已删除的日期范围：',
		EDIT_MODEL_TITLE: '编辑模型',
		FORM_ERROR_MSG: '哎呀！请更改一些内容后重试。',
		OP_LOWER_PLACEHOLDER: '运行下限',
		OP_UPPER_PLACEHOLDER: '运行上限',
		REQUIRED: '必填',
		CANCEL_CHANGES_TOOLTIP: '取消更改',
		CANCEL: '取消',
		SAVE_DATA_TOOLTIP: '保存数据',
		SAVE: '保存',
		SIMULATION: '仿真',
		SHOW_FAILURE_INFO: '显示故障信息',
		OK: '确定',
		RESET_ASSET_SELECTION_TOOLTIP: '重置资产选择',
		CLOSE_CROSSHAIR_TOOLTIP: '关闭十字线',
		CROSSHAIR: '十字线',
		LOADING: '加载中...',
		NO_FAILURE_MODE_FOUND: '未找到故障模式。',
		MODEL_PARAMETERS_PANEL: '模型参数',
		BOILER_HEALTH_PANEL: '锅炉健康',
		ALERT_PARAMETERS_PANEL: '警报参数',
		FAILURE_PARAMETERS_PANEL: '故障参数',
		APPLY_SOURCE_VERSION_FEEDBACK: '应用源版本反馈',
		COMMENT_PLACEHOLDER: '注释',
		SAVE_MODEL: '保存模型',
		SAVE_MODEL_TOOLTIP: '保存模型',
		RESAVE: '重新保存',
		RESAVE_TOOLTIP: '重新保存模型',
		DEPLOY_MODEL_TOOLTIP: '部署模型',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: '部署不被允许，因为 {{version}} 模型包含已从系统取消映射的标签',
		DEPLOY: '部署',
		GO_LIVE_CSV_TOOLTIP: '通过CSV流/Historian上线',
		GO_LIVE: '上线',
		GO_LIVE_OPTIONS_TITLE: '上线选项',
		DATA_SOURCE_TYPE_PLACEHOLDER: '数据源类型',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: '从以下日期开始预测',
		FROM_DATE_REQUIRED: '起始日期是',
		GO_LIVE_BTN: '上线',
		GO_LIVE_TOOLTIP: '上线',
		THRESHOLD_PLACEHOLDER: '阈值',
		AUTOMATIC_OPTION: '自动',
		MANUAL_OPTION: '手动',
		RISK_PROFILE_PLACEHOLDER: '风险概况',
		CREATE_CONDITION: '创建条件',
		RETURN_CONDITION: '返回条件',
		EXCEED_FOR_PLACEHOLDER: '超出持续时间',
		OUT_OF_PLACEHOLDER: '总计',
		DOWN_FOR_PLACEHOLDER: '下降持续时间',
		ALARM_THRESHOLD_PLACEHOLDER: '警报阈值',
		ADD_TOOLTIP: '添加',
		GENERATE_ALERT_TOOLTIP: '生成警报',
		UPDATE: '更新',
		SELECT_DATE_PLACEHOLDER: '选择日期',
		DATE_REQUIRED_ERROR: '日期是',
		HEALTH_PLACEHOLDER: '健康值',
		REMOVE_TOOLTIP: '删除',
		GENERATE_BOILER_HEALTH_TOOLTIP: '生成锅炉健康值',
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: '异常加权阈值',
		LOW_OPTION: '低',
		MEDIUM_OPTION: '中',
		HIGH_OPTION: '高',
		CUTOFF_PARTIAL_MATCH: '部分匹配截止值',
		IN_PERCENTAGE_HINT: '以百分比',
		CUTOFF_FULL_MATCH: '完全匹配截止值',
		UPDATE_FAILURE_TOOLTIP: '更新故障',
		START_DELAY_PLACEHOLDER: '开始延迟',
		NO_OF_HOURS_HINT: '（小时数）',
		END_DELAY_PLACEHOLDER: '结束延迟',
		GROUPING: '分组',
		DOWN_CONDITION_PLACEHOLDER: '下降条件',
		ANOMALY_SCORE_THRESHOLD: '异常分数阈值',
		FILTER_FAILURE_PLACEHOLDER: '过滤故障',
		VALUE_BETWEEN_0_1: '输入0到1之间的值',
		FEEDBACKS: '反馈',
		LIVE_FEEDBACKS: '实时反馈',
		PREVIOUS_FEEDBACKS: '历史反馈',
		BAND_LEARNING_BEHAVIOUR: '带学习行为',
		CONSERVATIVE: '保守',
		CONSERVATIVE_TOOLTIP: '在所选训练区域周围创建较窄的带',
		MODERATE: '适中',
		MODERATE_TOOLTIP: '在所选训练区域周围创建平衡的带',
		AGGRESSIVE: '积极',
		AGGRESSIVE_TOOLTIP: '在所选训练区域周围创建较宽的带',
		UPDATE_FEEDBACK: '更新反馈',
		UPDATE_PARAMETERS_TOOLTIP: '更新参数',
		DATA_IMPORT_PANEL: '数据导入',
		PRE_PROCESSING_PANEL: '预处理',
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: '已上传CSV',
		SELECT_SOURCE_HINT: '选择导入数据的来源',
		SAMPLING_RATE_PLACEHOLDER: '采样率',
		SAMPLING_RATE_REQUIRED: '采样率',
		IN_MINUTES_HINT: '（分钟）',
		SELECT_CSV_FILE_PLACEHOLDER: '选择CSV文件',
		CSV_FILE_REQUIRED: 'CSV文件是',
		SELECT_FILE_BTN: '选择文件',
		DATA_SYNC_MORE_DATA_TOOLTIP: '要获取更多数据，请转到数据同步选项卡并提出数据拉取请求。',
		DATA_SET_NAME_PLACEHOLDER: '数据集名称',
		IMPORT_TOOLTIP: '导入',
		IMPORT_DATA: '导入数据',
		STATE_IDENTIFICATION_PANEL: '状态识别',
		EXCLUDE_REGION_PANEL: '排除区域',
		PRE_PROCESSING_CONFIG_PANEL: '预处理配置',
		MODEL_TAG_SELECTION_PANEL: '模型标签选择',
		PROCESS_TOOLTIP: '处理',
		PROCESS_DATA: '处理数据',
		SHUTDOWN_TAG_PLACEHOLDER: '停机标签',
		CONDITION_PLACEHOLDER: '条件',
		LESS_THAN_OPTION: '小于',
		GREATER_THAN_OPTION: '大于',
		EQUAL_TO_OPTION: '等于',
		VALUE_PLACEHOLDER: '值',
		SHUTDOWN_CONDITION_PLACEHOLDER: '停机条件',
		AND_OPTION: '且',
		OR_OPTION: '或',
		SHUTDOWN_SPAN_PLACEHOLDER: '停机时间段',
		IN_HOURS_HINT: '（小时）',
		SHUTDOWN_TRANSITION_PLACEHOLDER: '停机过渡',
		STARTUP_TRANSITION_PLACEHOLDER: '启动过渡',
		EXCLUDE_REGION_TAG_PLACEHOLDER: '排除区域标签',
		EXCLUDE_CONDITION_PLACEHOLDER: '排除条件',
		OUTLIER_DETECTION_METHOD: '异常值检测方法',
		OUTLIER_DETECTION_THRESHOLD: '异常值检测阈值',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: '插值方法',
		INTERPOLATION_CONFIG: '插值配置',
		FLATLINE_THRESHOLD_TIME: '平线阈值时间',
		FLATLINE_TIME_BASE: '平线时间基准',
		HOURS_OPTION: '小时',
		MINUTES_OPTION: '分钟',
		SECONDS_OPTION: '秒',
		CROSS_CORRELATION: '交叉相关',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: '异常值检测',
		INTERPOLATION_GROUP: '插值',
		FLATLINE_GROUP: '平线',
		LABEL_METHOD: '方法',
		LABEL_THRESHOLD: '阈值',
		LABEL_CONFIGURATION: '配置',
		FLATLINE_DETECTION_SHORT: '检测',
		FLATLINE_THRESHOLD_TIME_SHORT: '阈值时间',
		FLATLINE_TIME_BASE_SHORT: '时间基准',
		DATA_DENSITY_THRESHOLD: '标签选择的数据密度阈值',
		DATA_DENSITY_REQUIRED: '数据密度阈值是',
		GLOBAL_PREPROCESSING: '全局预处理',
		RANGE_PREPROCESSING: '范围预处理',
		DENSITY_HINT: '密度',
		REFRESH_TABLE_DATA_TOOLTIP: '刷新表格数据',
		LAST_DATA_PULL_LABEL: '最近数据拉取：',
		UPLOAD_CSV_TOOLTIP: '上传CSV',
		NO_RAW_TAGS_TOOLTIP: '此系统中没有原始标签，因此无法上传文件',
		UPLOAD_BTN: '上传',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: '另一个进程正在运行',
		NO_RAW_TAG_MAPPED_TOOLTIP: '没有原始标签与此系统映射',
		NEW_DATA_PULL_REQUEST: '新数据拉取请求',
		ADD_NEW_DATA_PULL_TOOLTIP: '添加新数据拉取请求',
		DELETE_SYSTEM_DATA_TOOLTIP: '删除系统数据',
		STOP_DATA_PULL_TOOLTIP: '停止数据拉取',
		COL_SERIAL_NO: '序号',
		COL_DATA_REQUESTED_FOR: '请求的数据时间范围',
		COL_REQUESTED_ON: '请求日期',
		COL_ACCESS_METHOD: '访问方法',
		COL_REQUEST_TYPE: '请求类型',
		COL_FILE_NAME: '文件名',
		COL_PULLED_BY: '拉取者',
		COL_DATA_RECEIVED: '接收数据',
		COL_ACTIONS: '操作',
		DATA_REPULL_TOOLTIP: '重新拉取数据',
		TAG_PULL_REQUEST: '标签拉取请求',
		COL_VALUE: '值',
		COL_MISSING: '缺失',
		COL_OUTLIER: '异常值',
		TRIP_LIMIT_TOOLTIP: '跳闸限制',
		TRIP_LABEL: '跳闸',
		ALARM_LIMIT_TOOLTIP: '报警限制',
		ALARM_LABEL: '报警',
		THRESHOLD_LIMIT_TOOLTIP: '阈值限制',
		THRESHOLD_LABEL: '阈值',
		INSTRUMENT_RANGE_TOOLTIP: '仪器量程',
		INSTRUMENT_LABEL: '仪器',
		HIGH_LABEL: '高：',
		LOW_LABEL: '低：',
		AVG_LABEL: '平均：',
		DATA_PULL_REQUEST: '数据拉取请求',
		SELECT_TAGS_PLACEHOLDER: '选择标签',
		FROM_DATE_PLACEHOLDER: '开始日期',
		SELECT_FROM_DATE_HINT: '开始日期',
		TO_DATE_PLACEHOLDER: '结束日期',
		TO_DATE_REQUIRED: '结束日期是',
		SELECT_TO_DATE_HINT: '结束日期',
		PULL_DATA_TOOLTIP: '拉取数据',
		PULL_DATA: '拉取数据',
		STATUS_PANEL: {
			SUMMARY: '摘要',
			TAG_SUMMARY: '标签摘要',
			RECORDS: '条记录',
			TOTAL_TAGS: '标签总数',
			TAGS_IN_MODEL: '模型中的标签',
			TAGS_MAPPED_TO_FM: '已映射故障模式的标签',
			TAGS_WITH_NO_FM: '未映射故障模式的标签',
			PROCESSING_TIME: '处理时间',
			TRAINING_TIME: '训练时间',
			TOTAL_TAGS_DROPPED: '丢弃标签总数',
			ALERTS_GENERATED: '生成的警报',
			PRECISION_PREVIOUS: '先前精度',
			PRECISION_CURRENT: '当前精度',
			PHASE_DATA_IMPORT: '数据导入',
			PHASE_PREPROCESSING: '数据预处理',
			PHASE_MODELING: '建模',
			PHASE_ALERT_FEEDBACK: '警报反馈',
			PHASE_READY_TO_DEPLOY: '准备部署',
			DROPPED_TAGS: '丢弃的标签',
			CALCULATED_TAGS_DROPPED: '丢弃的计算标签',
			RAW_TAGS_DROPPED: '丢弃的原始标签',
			TAGS_DROPPED_PREPROCESSING: '预处理中丢弃的标签',
			TAGS_DROPPED_MANUALLY: '手动丢弃的标签',
			HIGH_DEVIATION_TAGS: '高偏差标签',
			EXPORT: '导出',
			COL_TAG_NAME: '标签名称',
			COL_TAG_ID: '标签 ID',
			COL_DESCRIPTION: '描述',
			COL_UNIT: '单位',
			COL_CALCULATED: '计算标签',
			COL_DROPPED_DUE_TO: '丢弃原因类型',
			COL_REASON: '原因',
			YES: '是',
			NO: '否',
			DROPPED_DUE_IMPORT: '导入',
			DROPPED_DUE_PREPROCESSING: '预处理',
			DROPPED_DUE_MANUAL: '手动',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: '尚未丢弃任何标签',
			NO_HIGH_DEVIATION: '运行模型构建以填充高偏差标签',
			NO_HIGH_DEVIATION_EMPTY: '未找到高偏差标签',

			PHASE_DEPLOYED: '已部署',
			DROPPED_DUE_CALCULATED: '计算标签',
			STEP_STATUS: '状态',
			STEP_STATUS_COMPLETED: '已完成',
			STEP_PREPROCESSING_TIME: '预处理时间',
			STEP_TRAINING_TIME: '训练时间',
			STEP_PREDICTION_TIME: '预测时间',
			STEP_ALERTS_GENERATED: '生成的警报',
			STEP_PRECISION_CURRENT: '当前精度',
			STEP_PRECISION_PREVIOUS: '先前精度',
			REASON_UNSELECTED_FROM_MODEL: '从模型中取消选择',
			REASON_INVALID_DATA: '{{percent}}% 无效数据',
			STEP_SECONDS_VALUE: '{{value}} 秒',
		},
		UPLOAD_CSV_TITLE: '上传CSV',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: '创建工单通知',
				CREATE_DESC: '为此案例创建工单通知',
				DESCRIPTION: '描述',
				DESCRIPTION_PLACEHOLDER: '描述需要执行的工作（必填）',
				DESCRIPTION_REQUIRED: '描述为必填项',
				PRIORITY: '优先级',
				DUE_DATE: '截止日期',
				ASSIGNED_TO: '分配给',
				ESTIMATED_HOURS: '预计工时',
				HOURS_PLACEHOLDER: '输入小时数',
				CANCEL: '取消',
				CONFIRM: '确认',
				UNASSIGNED: '未分配',
				CREATED: '工单 {{number}} 已创建',
				CREATED_PLAIN: '工单已创建',
				FAILED: '无法创建工单',
				CREATE_BUTTON: '创建工单',
				NONE_YET: '暂无工单',
				VIEW_TITLE: '工单 {{number}}',
				VIEW_SUB: '由此案例创建的工单',
				CREATED_BY: '创建人：{{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: '来自告警分诊的案例',
				FROM_TRIAGE_DESC: '此案例的告警位于告警分诊中；请在那里打开以查看其遥测和证据',
				HIERARCHY: '告警分诊层级',
				NO_FLOC: '无功能位置',
				ALERTS: '分诊告警',
				ADD_ALERTS: '添加告警',
				ADD_ALERTS_TIP: '搜索分诊告警并添加到此案例',
				AUTO_FIND: '自动查找',
				AUTO_FIND_TIP: '与此案例告警同批次或在事件前后同一功能位置的告警',
				AUTO_FIND_DESC: '源告警前后窗口内的批次组或同一功能位置',
				EVENT_START: '事件开始',
				VIA_SOURCE: '来源',
				VIA_MANUAL: '已添加',
				VIA_AUTO: '自动找到',
				ALERT_MISSING: '已不在分诊队列中',
				OPEN_TRIAGE: '在告警分诊中打开',
				REMOVE_ALERT: '从案例中移除',
				SEARCH_PLACEHOLDER: '按告警ID、标签、名称或功能位置搜索…',
				SEARCHING: '搜索中…',
				NO_MATCH: '没有匹配的告警',
				ADD: '添加',
				NO_SUGGESTIONS: '此窗口内没有其他告警',
				REASON_GROUP: '同一批次组',
				REASON_FLOC: '同一功能位置（±{{hours}} 小时内）',
				SELECT_ALL: '全选',
				ADD_SELECTED: '添加所选（{{count}}）',
				EVIDENCE: '证据',
				KIND_FACT: '事实',
				KIND_TAG: '标签',
				KIND_MAINTENANCE: '维护',
				KIND_REPORT: '报告',
				KIND_NOTE: '备注',
				NO_EVIDENCE: '暂无证据',
				REMOVE_EVIDENCE: '移除证据',
				ADD_EVIDENCE_PLACEHOLDER: '添加到{{kind}}…',
				BY_AGENT: '分诊代理',
				BY_ENGINEER: '工程师',
				ALERT_REMOVED: '已从案例中移除告警',
				ALERTS_ADDED: '已添加 {{count}} 条告警',
				EVIDENCE_ADDED: '已添加证据',
				EVIDENCE_REMOVED: '已移除证据',
				ACTION_FAILED: '操作失败',
				HIERARCHY_SOURCE: '层级',
				SOURCE_TRIAGE: '告警分诊',
				SOURCE_PLATFORM: '平台系统',
				SELECT_FLOC: '功能位置',
				ROOT: '全部',
				FLOC_SEARCH: '搜索功能位置代码或名称…',
				FLOC_REQUIRED: '请选择功能位置',
				NO_CHILDREN: '没有下级',
				RELATED_TRIAGE_ALERTS: '分诊告警（可选）',
				SELECT_ALERTS: '选择告警',
			},
			SELECT_STATUS: '选择状态',
			SELECT_CATEGORY: '选择类别',
			UNASSIGNED: '未分配',
			UNKNOWN_CREATOR: '未知创建者',
			ALL_CASES: '所有案例',
			CREATE_CASE: '创建案例',
			CASE_MANAGEMENT: '案例管理',
			UNKNOWN: '未知',
			UNCATEGORIZED: '未分类',
			TITLE: '案例',
			SEARCH_PLACEHOLDER: '搜索...',
			NO_MATCHING_RESULTS: '没有找到匹配的结果',
			SEARCH_OWNER_PLACEHOLDER: '搜索负责人...',
			SEARCH_WATCHERS_PLACEHOLDER: '搜索关注者...',
			SELECT_OWNERS: '选择负责人',
			FILTERS: '过滤器',
			GROUP_BY: '分组',
			MORE: '个更多',
			CASES_COUNT: '{{count}} 个案例',
			NO_CASES_FOUND: '没有可用的案例',
			SYSTEM_TAGS: '系统标签',
			CHECK_FILTERS_DATE_RANGE: '请修改筛选条件或日期范围以查看结果',
			CHIP: {
				OPEN: '活动中',
				PENDING: '处理中',
				CLOSED: '已关闭',
			},
			GROUP_BY_OPTION: {
				NONE: '无',
				STATUS: '状态',
				CATEGORY: '类别',
				SYSTEM: '系统',
				OWNER: '负责人',
				CREATOR: '创建者'
			},
			STATUS_OPTION: {
				1: '客户通知',
				2: '现场通知',
				3: '现场调查',
				4: '待维护',
				5: '延期维护',
				6: '待停机',
				7: '案例已解决',
				8: '无需采取措施'
			},
			CATEGORY_OPTION: {
				1: '可靠性',
				2: '工艺',
				3: '仪表',
				4: '机械',
				5: '电气',
				6: '开停机',
				7: '其他'
			},
			COLUMNS: {
				SELECT: '选择',
				NUMBER: '编号',
				CASE_ID: '案例 ID',
				CASE_NAME: '案例名称',
				SYSTEM_NAME: '系统名称',
				ALERT_NAME: '告警名称',
				CATEGORY: '类别',
				STATUS: '状态',
				CATCH: 'Catch',
				SOURCE: '来源',
				OWNER: '所有者',
				WATCHERS: '观察者',
				CREATED_BY: '创建者',
				CREATED_ON: '创建时间',
				SYSTEM_ANALYSIS: '系统分析与解读',
				DUE_DATE: '截止日期',
				ESTIMATED_VALUE: '预估价值',
				AGREED_VALUE: '商定价值',
				LAST_MODIFIED: '最后修改时间',
				RCH: '根本原因假设',
				FEEDBACK_OUTCOME: '反馈与结果',
				WORK_ORDER: '工单',
				POTENTIAL_IMPACT: '潜在影响',
			},
			MANAGEMENT: {
				FAILURE_MODE: '失效模式',
				SELECTED_VIEW: '已选视图',
				USER_PREFERENCE_SETTINGS: '用户首选项设置',
				CASES_LAYOUT: '案例布局',
				SIMPLIFIED: '简化版',
				ADVANCED_DEFAULT: '高级（默认）',
				LINKED_ALERT_REMOVED: '关联告警已移除',
				LINKED_ALERT_REMOVED_DESC: '此案例的关联告警已不再可用',
				LINK_NEW_ALERT: '关联新告警',
				DRAG_TO_REORDER: 'Click and drag to reorder',
				NO_TAGS_AVAILABLE_FOR_FM: '此失效模式无可用标签。',
				NO_TAGS_AVAILABLE_FOR_ALERT: '此告警无可用标签。',
				NO_TAGS_ADDED: '尚未添加标签',
				ADD_TAGS_FROM_DISPLAY_TAGS: '请使用右侧的“显示标签”面板为此案例添加标签',
				VIEW_SETTINGS: '视图设置',
				DISPLAY_TAGS: '显示标签',
				ASSET: '资产',
				SELECT_STATUS: '选择状态',
				SELECT_CATEGORY: '选择类别',
				SEARCH_OWNER: '搜索所有者...',
				SEARCH_WATCHERS: '搜索关注者...',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: '在新标签页中打开',
				CUSTOMIZE_COLUMNS: '自定义列',
				ONLY_OWNER_CATCH_TOOLTIP: '只有案例所有者才能将其标记为捕获',
				ONLY_OWNER_EDIT_TOOLTIP: '只有案例所有者或创建者才能修改此项',
				MARKED_AS_CATCH_TOOLTIP: '已标记为 Catch。打开案例详情以进行更新。',
				NOT_MARKED_AS_CATCH_TOOLTIP: '未标记为 Catch。打开案例详情以更改此项。',
				OPEN_CASE: '{{count}} 个活动中案例',
				OPEN_CASES: '{{count}} 个活动中案例',
				PENDING_CASE: '{{count}} 个待处理案例',
				PENDING_CASES: '{{count}} 个待处理案例',
				OPEN_TOOLTIP: '活动中案例 (包括):\n客户通知\n现场通知\n现场调查',
				PENDING_TOOLTIP: '待处理案例 (包括):\n待维护\n延期维护\n待停机',
				CLOSED_TOOLTIP: '已关闭案例 (包括):\n案例已解决\n无需采取措施'
			},
			COMMON_DIALOG: {
				SELECT_ALL: '全选',
				REPORT_PDF_FILE_NAME: '报告 PDF 文件名',
				INCLUDE_EVIDENCE_ATTACHMENTS: '包括证据附件',
				GENERATING_REPORT_FOR: '您正在为 {{count}} 个跟踪的案例生成报告',
				SELECT_FMS_TIMELINE: '请从时间线中选择故障模式以添加到案例中。',
				SELECT_FMS_FOR_RECOMMENDATIONS: '选择故障模式以获取建议',
				RECOMMENDATIONS_FOR: '{{name}} 的建议',
				NO_RECS_FOR_FM: '此故障模式没有建议。',
				NO_OPEN_FMS: '没有打开的故障模式。',
				NO_FMS_SELECTED: '未选择故障模式。请选择一个或多个以继续。',
				FMS_SELECTED: '已选择 {{count}} 个故障模式',
				SELECT_FMS_TO_CONTINUE: '请选择至少一个故障模式以继续',
				SELECT_RECS_TO_CONTINUE: '请选择至少一个建议以继续',
				SELECT_ANALYSIS_TO_CONTINUE: '请选择至少一个分析以继续',
				SELECT_VIEW_TO_CONTINUE: '请选择至少一个视图以继续',
				SELECT_ITEM_TO_CONTINUE: '请选择至少一个项目以继续',
				ADD_SELECTED_RECOMMENDATIONS: '添加选中的建议',
				ADD_SELECTED_ANALYSIS: '添加选中的分析',
				ADD_SELECTED_VIEWS: '添加选中的视图',
				ADD_SELECTED_FAILURE_MODES: '添加选中的故障模式',
			},
			FILTER: {
				FILTER_BY: '过滤条件',
				SEARCH_PLACEHOLDER: '按名称或ID搜索...',
				STATUS: '状态',
				CATEGORY: '类别',
				CATCH: '捕获',
				CREATED_BY: '创建者',
				WATCHERS: '关注者',
				CLEAR_ALL: '清除全部'
			},
			DETAILS: {
				CASE_NARRATIVE: '案例说明',
				SYSTEM_ANALYSIS: '系统分析与说明',
				RCH: '根本原因假设',
				POTENTIAL_IMPACT: '潜在影响',
				PROPOSED_ACTIONS: '建议的措施',
				FEEDBACK_OUTCOME: '反馈与结果',
				WORK_ORDER: '工单',
				MARK_AS_CATCH: '标记为捕获',
				SYSTEM_ANALYSIS_PLACEHOLDER: '总结观察到的情况、开始时间和当前的运行状况...',
				RCH_PLACEHOLDER: '描述怀疑或确认的根本原因。如果相关，链接 to 故障模式 (FM) 或事件...',
				TAG_RELATED_FAILURE_MODES: '与测点相关的故障模式',
				ADD_FAILURE_MODES_TOOLTIP: '添加故障模式',
				ADD_FMS: '添加 FM',
				RECOMMENDED_ACTIONS: '推荐措施',
				ADD_SELECTED: '添加已选',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: '添加所选的推荐措施',
				ADD_RECOMMENDATIONS_TOOLTIP: '添加推荐措施',
				ADD_MORE: '添加更多',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: '添加更多推荐措施',
				PROPOSED_ACTIONS_PLACEHOLDER: '建议的措施、时间表、未执行的风险...',
				POTENTIAL_IMPACT_PLACEHOLDER: '描述潜在的业务/运营影响（例如停机风险、质量损失、安全性、成本）...',
				FEEDBACK_OUTCOME_PLACEHOLDER: '现场记录、实施的措施、经验教训...',
				WORK_ORDER_PLACEHOLDER: '例如 WO-2026-001248（请输入您维护系统中的工单编号或参考号。）',
				CANCEL: '取消',
				SAVE: '保存',
				EVIDENCE_ATTACHMENTS: '证据与附件',
				SAVED_ANALYSIS: '保存的分析',
				NO_SAVED_ANALYSIS_AVAILABLE: '无可用保存的分析',
				ADD_SAVED_ANALYSIS: '添加保存的分析',
				ADD_ANALYSIS: '添加分析',
				LINK_ALERT_TO_ADD_ANALYSIS: '标记包含已保存分析的相关告警以在此处添加',
				SAVED_VIEWS: '保存的视图',
				ONLY_OWNERS_SAVE_TAG_VIEWS: '只有告警负责人或案例负责人才能保存或修改测点视图。',
				SAVE_CURRENT_TAG_VIEW: '保存当前测点视图',
				SAVE_CURRENT_VIEW: '保存当前视图',
				NO_SAVED_VIEWS_AVAILABLE: '无可用保存的视图',
				ADD_SAVED_VIEWS: '添加保存的视图',
				ADD_VIEW: '添加视图',
				LINK_ALERT_TO_ADD_VIEWS: '标记包含已保存视图的相关告警以在此处添加',
				TAG_RELATED_ALERTS: '与测点相关的告警',
				ADD_ALERTS: '添加告警',
				UPLOAD_EVIDENCES: '上传证据',
				UPLOAD_PLACEHOLDER: '附加、拖放或粘贴证据...',
				VALUE_IMPACT: '价值影响',
				VALUE_CALCULATION_INPUTS: '价值计算输入',
				LIKELIHOOD: '可能性（%）',
				IMPACT: '影响',
				LIKELIHOOD_IMPACT_MATRIX: '可能性与影响矩阵',
				SAVINGS: '节省',
				CONTRIBUTION_FACTOR: '贡献系数',
				ESTIMATED_VALUE: '预估价值（USD）',
				AGREED_VALUE: '约定价值（USD）',
				TOTAL_PRODUCTION_LOST: '总生产损失（KBOE）',
				TOTAL_FLARING_AVOIDED: '避免燃放量（MT CO2）',
				PRODUCTIVITY: '生产效率（小时）',
				EMISSIONS: '排放量（吨）',
				SELECT_VALUE: '选择数值',
				ENTER_VALUE: '输入数值',
				EXPORT_AS_PDF: '导出为 PDF',
				SAVE_CASE_FIRST: '请先保存案例',
				GENERATE_PDF: '生成 PDF',
				SEND_VIA_EMAIL: '通过邮件发送',
				SHARE_VIA_EMAIL: '通过邮件共享',
				CLEAR_ALL: '清除全部',
				CLEAR_ALL_TOOLTIP: '清除所有信息',
				SAVE_TOOLTIP: '保存信息',
				OPTIONAL_FIELD_SAVE_ERROR: '保存可选字段更改失败'
			},
			EMAIL: {
				SEND_VIA_MAIL: '通过邮件发送',
				RECEIVER_EMAIL_IDS: '接收者邮箱 ID',
				SEARCH_USER: '搜索用户',
				SELECT_ENTER_EMAIL_IDS: '选择/输入邮箱 ID',
				DONE: '完成',
				SELECT: '选择',
				PLEASE_SELECT_RECIPIENTS: '请选择接收者',
				SUBJECT: '主题',
				DEFAULT_SUBJECT: 'Uptime AI: 案例已创建',
				ASSET: '资产',
				OWNER: '负责人',
				CREATED_BY: '创建者',
				CREATED_ON: '创建时间',
				CASE_STATUS: '案例状态',
				CATEGORY: '类别',
				MODIFIED_ON: '最后修改时间',
				CASE_NAME: '案例名称',
				USERS: '用户',
				CANCEL: '取消',
				SEND_EMAIL: '发送邮件',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: '请选择接收者',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: '故障模式添加成功',
				ANALYSIS_ADDED_SUCCESS: '所选分析添加成功',
				VIEWS_ADDED_SUCCESS: '所选视图添加成功',
				FMS_ADDED_SUCCESS_ALT: '所选故障模式添加成功',
				ALL_RECOMMENDATIONS_ADDED: '已添加已批准故障模式的所有推荐措施',
				RECOMMENDATIONS_ADDED_SUCCESS: '所选推荐措施添加成功',
				GENERATING_PDF: '正在生成 PDF... 准备就绪后我们将向您发送电子邮件。',
				NO_VALID_FILES: '未选择有效文件。仅允许扩展名为 {{extensions}} 的文件',
				UPLOAD_SIZE_LIMIT: '{{name}} 因文件大小限制而上传失败。',
				UPLOAD_FAILED: '{{name}} 上传失败。',
				FAILED_TO_GENERATE_PDF: '生成 PDF 失败',
				BULK_REPORT_TITLE: '生成汇总案例报告',
				PREPARING_DOWNLOAD: '正在准备下载，这可能需要一点时间。',
				CSV_DOWNLOAD_SUCCESS: 'CSV 下载成功',
				CSV_DOWNLOAD_FAILED: '导出 CSV 失败',
				SELECT_STATUS_TO_SAVE: '请选择案例状态以保存案例',
				SELECT_CATEGORY_TO_SAVE: '请选择案例类别以保存案例',
				CASE_ADDED_SUCCESS: '案例成功添加',
				CASE_UPDATED_SUCCESS: '案例成功更新',
				ENTER_TITLE_TO_PROCEED: '请编写一个标题以继续'
			}
		},
		IOW: {
			FACILITY: '设施',
			SELECT_FACILITY: '选择设施',
			SEARCH_FACILITY: '搜索设施...',
			NO_FACILITY_FOUND: '未找到匹配的设施',
			UNIT: '单元',
			SELECT_UNIT: '选择单元',
			SEARCH_UNIT: '搜索单元...',
			NO_UNIT_FOUND: '未找到匹配的单元',
			SYSTEM: '系统',
			SELECT_SYSTEM: '选择系统',
			SEARCH_SYSTEM: '搜索系统...',
			NO_SYSTEM_FOUND: '未找到匹配的系统',
			TAGS: '标签',
			SELECT_TAGS: '选择标签',
			SEARCH_TAG: '搜索标签...',
			NO_TAG_FOUND: '未找到匹配的标签',
			CASE_STATUS: '案例状态',
			EXCEEDANCE_TYPE: '超限类型',
			SELECT_EXCEEDANCE_TYPE: '选择超限类型',
			SELECT_ALL: '全选',
			ANALYSE_TOP_TRENDS: '分析前20个趋势',
			SAVE: '保存',
			COPY: '复制',
			ADD_NEW: '新增',
			EDIT: '编辑',
			DELETE: '删除',
			DOWNLOAD: '下载',
			ACTIVE_EXCEEDANCES: '活动超限',
			DATE_RANGE_DISABLED_TOOLTIP: '选择活动超限筛选器时，日期范围选择不适用。',
			SELECT_DATE_RANGE: '选择日期范围',
			ENTER_DATE_RANGE: '输入日期范围',
			START_DATE: '开始日期',
			END_DATE: '结束日期',
			APPLY_TIME_CHANGE: '应用时间更改',
			SUMMARY: '摘要',
			SELECT_SYSTEM_MESSAGE: '请选择一个系统以查看超限。',
			LOADING: '加载中...',
			NO_EXCEEDANCE_FOUND: '未找到超限。',
			NO_ACTIVE_EXCEEDANCE_FOUND: '未找到活动超限。',
			NO_DATA_AVAILABLE: '所选时间范围内无可用数据',
			TRY_SELECTING_DIFFERENT_RANGE: '请尝试选择其他日期范围',
			CRUNCHING_DATA: '正在处理数据，请稍候！',
			TOTAL_EXCEEDANCES: '系统超限总数',
			GROUP_TRENDS: '分组趋势',
			TRENDS_PER_CHART: '趋势 / 图表（最多8个）',
			CANCEL: '取消',
			PROCEED: '继续',
			SELECT: '选择',
			SELECT_DATE_RANGE_LABEL: '选择日期范围',
			DATE_RANGE: '日期范围',
			DATE_RANGE_REQUIRED: '日期范围为必填项。',
			REGROUP_EXCEEDENCES: '重新分组超限',
			DURATION_MINUTES: '持续时间（分）',
			DURATION_REQUIRED: '持续时间为必填项。',
			ENTER_VALID_NUMBER: '请输入有效数字。',
			DOWNLOAD_TITLE: '下载IOW报告',
			GROUP_BY_SYSTEM: '按系统分组',
			GROUP_BY_UOM: '按计量单位分组',
			GROUP_COUNT_REQUIRED: '分组数量为必填项。',
			MIN_VALUE_2: '最小值为2。',
			MAX_VALUE_8: '最大值为8。',
			GROUP_COUNT_INVALID: '分组数量无效。',
			WATCHERS: '关注者',
			CLOSE: '关闭',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: '保存',
				CANCEL: '取消',
				DELETE: '删除',
				EDIT: '编辑',
				CLOSE: '关闭',
				LOADING: '加载中...',
				SEARCH: '搜索...',
				ACTIONS: '操作',
				NAME: '名称',
				DESCRIPTION: '描述',
				STATUS: '状态',
				TYPE: '类型',
				CREATED: '创建时间',
				LAST_UPDATED: '最后更新',
				DOWNLOAD: '下载',
				UPLOAD: '上传',
				IMPORT: '导入',
				EXPORT: '导出',
				RUN: '运行',
				STOP: '停止',
				YES: '是',
				NO: '否',
				APPLY: '应用',
				RESET: '重置',
				CONFIRM: '确认',
				BACK: '返回',
				NEXT: '下一步',
			},
			NAV: {
				SCENARIOS: '场景',
				DASHBOARD: '仪表板',
				COMPARISON: '对比',
				SETTINGS: '设置',
				MODELS: '模型',
				SIMULATION: '模拟',
				REALTIME: '实时',
				TOPOLOGY: '拓扑',
				STRATEGIC: '战略',
			},
			LANDING: {
				TITLE: '容量优化',
				SUBTITLE: '优化整个机队的电力和水生产',
			},
			SCENARIO: {
				TITLE: '场景库',
				NEW_SCENARIO: '新建场景',
				SEARCH_SCENARIO: '搜索场景',
				DUPLICATE: '复制',
				RUN_OPTIMIZATION: '运行优化',
				FORCE_STOP: '强制停止',
				VIEW_RESULTS: '查看结果',
				SCENARIO_NAME: '场景名称',
				CLASSIFICATION: '分类',
				SOLVER: '求解器',
				RUN_MODE: '运行模式',
				STATUS_READY: '就绪',
				STATUS_RUNNING: '运行中',
				STATUS_COMPLETED: '已完成',
				STATUS_FAILED: '失败',
				PROMOTE: '提升',
				ALTERNATIVE_SOLVER: '备用求解器',
			},
			CONFIG: {
				TITLE: '场景配置',
				TABS: {
					AVAILABILITY: '资产可用性',
					DEMAND: '需求预测',
					CONSTRAINTS: '约束条件',
					SOLVER: '求解器与运行',
					TESTING: '测试配置文件',
					GROWTH_FACTOR: '增长因子',
					SWRO_AVAILABILITY: 'SWRO可用性',
				},
				HORIZON: '时域（小时）',
				STEP: '步长（分钟）',
				START_HOUR: '开始小时',
				TARGET_DATE: '目标日期',
				LATITUDE: '纬度',
				LONGITUDE: '经度',
				PERF_CURVE: '性能曲线来源',
				OEM_CURVES: 'OEM设计曲线',
				HISTORICAL_ML: '历史数据（ML）',
				PLANNING_OFFLINE: '规划（离线）',
				LIVE_REALTIME: '实时',
				UPLOAD_CSV: '上传CSV',
				DOWNLOAD_CSV: '下载CSV',
				POWER_MW: '功率（MW）',
				WATER_MIGD: '水量（MIGD）',
				POWER_IMPORT: '电力进口',
				POWER_EXPORT: '电力出口',
				WATER_IMPORT: '水进口',
				WATER_EXPORT: '水出口',
				INITIAL_STATUS: '初始状态',
				DURATION_IN_STATE: '处于状态的持续时间（小时）',
				ON: '开',
				OFF: '关',
			},
			CONSTRAINTS: {
				TITLE: '约束配置',
				ANCILLARY_SERVICES: '辅助服务',
				MIN_UP_DOWN_TIME: '最短启停时间',
				RAMP_LIMITS: '爬坡限制',
				FIXED_LOADS: '固定负载',
				AGC_DISPATCH: 'AGC调度',
				ALLOW_LOAD_SHEDDING: '允许甩负荷',
				ALLOW_WATER_SHORTAGE: '允许缺水',
				ENFORCE_FUEL_LIMITS: '执行燃料限制',
				SPINNING_RESERVE: '旋转备用（MW）',
				OPERATING_RESERVE: '运行备用（MW）',
				WATER_RESERVE: '水储备（MIGD）',
			},
			GROWTH_FACTOR: {
				TITLE: '增长因子配置',
				ADJUSTMENT_TYPE: '调整类型',
				VALUE: '增长因子值',
				TARGET_METRIC: '目标指标',
				START_TIME: '开始时间',
				END_TIME: '结束时间',
			},
			SWRO: {
				TITLE: 'SWRO可用性配置',
				SELECT_PLANTS: '选择SWRO工厂',
				FLAT_VALUE: '固定可用性值',
			},
			DASHBOARD: {
				TITLE: '优化结果',
				STATION_FILTER: '站点筛选',
				ALL_STATIONS: '所有站点',
				TOTAL_COST: '总成本',
				POWER_GENERATION: '发电量',
				WATER_PRODUCTION: '产水量',
				FUEL_CONSUMPTION: '燃料消耗',
			},
			COMPARISON: {
				TITLE: '场景对比',
				SEARCH_SCENARIO: '搜索场景',
				BASELINE: '基准',
				SELECT_BASELINE: '选择基准',
			},
			SETTINGS: {
				TITLE: '设置',
				PLATFORM: '平台设置',
				DATA_MGMT: '数据管理',
				MODULE_CONFIG: '模块配置',
				TAGS: '标签',
				TEMPLATES: '模板',
				TOPOLOGY: '拓扑',
				TRAINING: '培训',
				USERS: '用户',
			},
			PLATFORM_SETUP: {
				TITLE: '平台与设施设置',
				ENTERPRISE_NAME: '企业名称',
				STREET_ADDRESS: '街道地址',
				CITY: '城市',
				STATE: '省/州',
				COUNTRY: '国家',
				ZIP_CODE: '邮政编码',
				LATITUDE: '纬度',
				LONGITUDE: '经度',
				INDUSTRY: '行业',
				TIMEZONE: '时区',
				BUSINESS: '业务',
				NOTES: '备注',
				COST_PER_UNIT: '每单位成本（$）',
				CAPACITY_PER_HOUR: '每小时产能',
				REVENUE_PER_HOUR: '每小时收入（$）',
				OPERATIONAL_MARGIN: '运营利润率（%）',
				TECHNICIAN_SALARY: '技术员工资（$/小时）',
				HELPER_SALARY: '助手工资（$/小时）',
			},
			USER_MGMT: {
				TITLE: '用户管理',
				ADD_USER: '添加用户',
				USERNAME: '用户名',
				DISPLAY_NAME: '显示名称',
				PASSWORD: '密码',
				ROLE: '角色',
				ADMIN: '管理员',
				SUPER_USER: '超级用户',
				USER: '用户',
				NO_PERMISSION: '您没有访问此部分的权限。',
			},
			SIMULATION: {
				TITLE: '灵敏度模拟',
				TARGET_EQUIPMENT: '目标设备',
				SWEEP_PARAMETER: '扫描参数',
				START_VALUE: '起始值',
				END_VALUE: '结束值',
				STEPS: '步骤',
				RUN_SWEEP: '运行扫描',
			},
			REALTIME: {
				TITLE: '实时仪表板',
				CONFIRMED_TARGET: '已确认目标',
				SELECT_DATE: '选择日期',
				SCENARIO_NAME: '场景名称',
				HORIZON_HOURS: '时域（小时）',
				SOLVER: '求解器',
				PERF_CURVE: '性能曲线',
				START_MODE: '启动模式',
				RAMP_LIMITS: '爬坡限制',
				MIN_UP_DOWN: '最短启停时间',
				ANCILLARY: '辅助服务',
				IMPORT_SCENARIO: '从场景导入',
			},
			TOPOLOGY: {
				TITLE: 'SCADA拓扑',
				POWER_VIEW: '电力',
				WATER_VIEW: '水',
				AUTO_CORRECT: '自动校正',
				FLEET_OVERVIEW: '机队概览',
			},
			DEMAND: {
				HORIZON: '时域（小时）',
				STEP: '步长（分钟）',
				START_HOUR: '开始小时',
				UPDATE_PLAN: '更新需求计划',
				UPDATE_PLAN_TOOLTIP: '将所有排程表重新采样到新的时间网格，并对已输入的数值进行插值。',
				UPDATE_PLAN_HINT: '排程参数已更改 — 点击“更新需求计划”以重新采样各表。',
				SOLAR_INPUT: '太阳能输入',
				SOLAR_PHASES_ACTIVE: '个阶段已启用',
			},
			TAG_EXPLORER: {
				TITLE: '标签浏览器',
				SUBTITLE: '绘制任意已映射标签的历史值。数据点在服务端聚合，因此选择较长时间范围也能保持流畅。',
				TAGS: '标签',
				TAGS_PLACEHOLDER: '最多选择 10 个标签',
				TAGS_SEARCH_PLACEHOLDER: '按参数或标签名称搜索...',
				START_DATE: '开始日期',
				END_DATE: '结束日期',
				PLOT: '绘图',
				LOADING_TAGS: '正在加载标签列表...',
				QUERYING: '正在查询历史数据...',
				NO_DATA_FOR: '此时间范围内以下标签无数据：',
				UNITS_DROPPED: '图表一次仅显示两种单位；单位为 {{units}} 的序列未绘制。',
				BUCKET_HINT: '已按 {{bucket}} 间隔聚合。',
				COL_PARAMETER: '参数',
				COL_TAG: '标签',
				COL_UNIT: '单位',
				COL_POINTS: '数据点数',
				COL_MIN: '最小值',
				COL_MAX: '最大值',
				COL_AVERAGE: '平均值',
				GROUP_SYSTEM_DEMAND: '系统需求',
				GRID_POWER_DEMAND: '全网电力需求',
				GRID_WATER_DEMAND: '全网供水需求',
				AXIS_TIME: '时间',
				AXIS_VALUE: '数值',
				REQUEST_FAILED: '请求失败（{{status}}）',
				SERVER_UNREACHABLE: '无法连接到服务器。',
			},
		},
		DISPLAY_TAGS: {
			HEADER: '显示其他标签',
			CLOSE: '关闭',
			SEARCH_PLACEHOLDER: '搜索...',
			FILTER_TOOLTIP: '筛选标签',
			SELECT_SYSTEM: '选择系统',
			ALL_SYSTEMS: '所有系统',
			FILTER_BY: '筛选方式',
			ALL_TAGS: '所有标签',
			MODELED_TAGS: '已建模标签',
			SHOW_CALCULATED_TAGS: '显示计算标签',
			NO_MATCHING_RESULTS: '没有匹配的结果',
			START_TYPING: '开始输入以查看匹配的标签。',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: '暂无当前批次',
				NO_CURRENT_BATCHES_CONTENT: '一旦流程开始，活动中或运行中的批次就会显示在这里。',
				NO_PAST_BATCHES_TITLE: '暂无历史批次',
				NO_PAST_BATCHES_CONTENT: '批次运行结束后，已完成、已停止或失败的批次会显示在这里。'
			},
			LIST: {
				PAGE_TITLE: '流程',
				SEARCH_PLACEHOLDER: '按批次ID搜索',
				CURRENT_BATCHES_TAB: '当前批次',
				PAST_BATCHES_TAB: '历史批次',
				FILTER: {
					SYSTEM: '系统',
					SEARCH_SYSTEM: '搜索系统',
					CREATED_BETWEEN: '创建时间范围',
					STARTED_ON: '开始于',
					CLEAR_DATE: '清除日期',
					OWNER: '负责人',
					SEARCH_OWNER: '搜索负责人',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: '批次名称 / ID',
				COL_START_DATE_TIME: '开始日期 / 时间',
				COL_END_DATE_TIME: '结束日期 / 时间',
				COL_LAST_UPDATED: '最后更新',
				COL_DURATION: '持续时间',
				COL_RUN_TIME: '运行时间',
				COL_STATUS: '状态',
				COL_OWNER: '负责人',
				COL_WATCHERS: '关注者',
				COL_PERCENT_COMPLETE: '完成百分比',
				COL_PROJECTED_PRODUCT: '预计产品',
				COL_FINAL_PRODUCT: '最终产品',
				SELECT_COLUMNS: '选择列',
				SAVE_VIEW: '保存视图',
				APPLY: '应用',
				LOADING: '加载中...',
				NO_RECORDS: '未找到记录',
			},
			DETAILS: {
				TITLE_PREFIX: '流程详情',
				BATCH_NAME: '批次名称',
				FACILITY: '设施',
				UNIT: '单元',
				SYSTEM: '系统',
				STATUS: '状态',
				START_DATE_TIME: '开始日期 / 时间',
				LAST_UPDATED: '最后更新',
				OVERLAY: '叠加',
				STACKED: '堆叠',
				GRID: '网格',
				SELECT_OWNER: '选择负责人',
				WATCHERS_TOOLTIP: '关注者',
				FILTER: {
					LAB_PARAMETERS: '实验室参数',
					BATCH: '批次',
					OTHERS: '其他',
					SEARCH_BATCH: '搜索批次',
				},
				GOLDEN_BATCH_BAND: '黄金批次带',
				PREDICTION: '预测',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: '仪表盘向导',
			ADD_NEW_DASHBOARD: '添加新仪表盘',
			CREATE_DASHBOARD: '创建仪表盘',
			SEARCH: '搜索',
			EDIT_MODE: '编辑模式',
			SAVE_DASHBOARD: '保存仪表盘',
			PUBLIC: '公开',
			PRIVATE: '私有',
			SENSOR_DATA: '传感器数据',
			NON_SENSOR_DATA: '非传感器数据',
			ENTER_DATE_RANGE: '输入日期范围',
			START_DATE: '开始日期',
			END_DATE: '结束日期',
			APPLY_TIME_CHANGE: '应用时间更改',
			MORE: '更多',
			NOTHING_CREATED: '您尚未创建任何内容',
			LOADING: '加载中...',
			NO_DATA: '所选属性没有可用数据',
			CONFIGURE_ATTRIBUTES: '配置要渲染的属性',
			SELECT_CHART_TYPE: '选择图表类型',
			CONFIG_ONLY_WIDGET: '这是仅配置的组件，不会显示图形',
			TYPE_OF_CONFIG: '配置类型：',
			GROUP_KEY: '组键：',
			SPECIFICATION_LIMIT: '规格限制',
			PLEASE_ADD_STATS: '请添加统计卡片',
			ADD_ATTRIBUTES: '添加要显示的属性',
			PROCESSING_DATA: '正在处理数据，请稍候...',
			EDIT: '编辑',
			DUPLICATE: '复制',
			REMOVE: '删除',
			CANCEL: '取消',
			SAVE: '保存',
			BACK: '返回',
			PERFORMANCE_CURVE_OF: '性能曲线',
			NO_WIDGETS_AVAILABLE: '没有可用的组件。请添加一个组件开始使用',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: '还没有仪表盘',
					CONTENT: '创建您的第一个仪表盘，在一个地方监控关键指标、趋势和洞察。',
				},
				MY_DASHBOARD: {
					HEADING: '您还没有创建仪表盘',
					CONTENT: '您创建的仪表盘将显示在这里。',
				},
				SHARED: {
					HEADING: '还没有共享给您的仪表盘',
					CONTENT: '他人共享给您的仪表盘将显示在这里。',
				},
				PRIVATE: {
					HEADING: '还没有私有仪表盘',
					CONTENT: '您创建并设为私有的仪表盘将显示在这里。',
				},
				SEARCH: {
					HEADING: '未找到仪表盘',
					CONTENT: '请尝试使用不同的关键词或清除搜索。',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: '协作者',
				SEARCH_PLACEHOLDER: '按姓名或邮箱搜索',
				COLLABORATED_WITH: '已与',
				USERS: '位用户协作',
				ALL_USERS: '所有用户',
				OWNER: '所有者',
				CANCEL: '取消',
				SAVE: '保存',
				CANCEL_CHANGES: '取消更改',
				SAVE_CHANGES: '保存更改',
				ROLE: {
					FULL: '完全',
					FULL_DESC: '完全访问权限',
					EDIT: '编辑',
					EDIT_DESC: '查看和编辑权限',
					VIEW: '查看',
					VIEW_DESC: '仅查看权限',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: '创建面板',
				EDIT_PANEL: '编辑面板',
				CANCEL: '取消',
				SAVE: '保存',
				SELECT_CHART_TYPE: '图表类型',
				ADD_TITLE: '标题',
				PANEL_NAME: '面板名称',
				ADDITIONAL_GRAPH_OPTIONS: '附加图表选项',
				SETTINGS: '设置',
			},
			DASHBOARD_POPUP: {
				TITLE: '仪表盘',
				SELECT_TYPE: '选择仪表盘类型',
				TYPE_DASHBOARD: '仪表盘',
				TYPE_CONFIG: '配置',
				TYPE_PERFORMANCE_CURVES: '性能曲线',
				NAME: '名称',
				NAME_TAKEN: '名称已被占用',
				NAME_REQUIRED: '名称为必填项',
				LEVEL: '级别',
				SELECT_LEVEL: '选择级别',
				FACILITY: '设施',
				SELECT_FACILITY: '选择设施',
				FACILITY_REQUIRED: '设施为必填项',
				UNIT: '单元',
				SELECT_UNIT: '选择单元',
				UNIT_REQUIRED: '单元为必填项',
				CANCEL: '取消',
				SAVE: '保存',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: '启用快速绘图',
				SELECT_UNITS: '选择单元',
				SEARCH_UNIT: '搜索单元...',
				NO_UNIT_FOUND: '未找到匹配的单元',
				SELECT_SYSTEMS: '选择系统',
				SEARCH_SYSTEM: '搜索系统...',
				NO_SYSTEM_FOUND: '未找到匹配的系统',
				ADD: '添加',
				PREVIEW: '预览',
				PREVIEW_CHART: '预览图表',
				DRAG_AND_DROP: '拖放',
				COPY: '复制',
				DELETE: '删除',
				EDIT: '编辑',
				LABEL: '标签',
				TAG: '标签',
				X_TAG: 'X 标签',
				Y_TAG: 'Y 标签',
				Z_TAG: 'Z 标签',
				SEARCH_TAG: '搜索标签...',
				NO_TAG_FOUND: '未找到匹配的标签',
				DESIGN_VALUE_TAG: '设计值标签',
				CALC_TYPE: '计算类型',
				CALC_ORIGINAL: '原始',
				CALC_AVERAGE: '平均值',
				CALC_MOVING_AVG: '移动平均',
				CALC_MAX: '最大值',
				CALC_MIN: '最小值',
				CALC_SUM: '总和',
				CALC_MEDIAN: '中位数',
				CALC_MOVING_DELTA: '移动差值',
				CALC_COUNT_EVENT: '计数事件',
				AGGREGATE: '聚合',
				AGGREGATE_WINDOW: '聚合窗口',
				COUNT_WINDOW: '计数窗口',
				AGGREGATE_WINDOW_UNIT: '聚合窗口单位',
				COUNT_WINDOW_UNIT: '计数窗口单位',
				WINDOW_SIZE: '窗口大小',
				MINUTES: '分钟',
				HOURS: '小时',
				DAYS: '天',
				WEEKS: '周',
				GREATER_THAN: '大于',
				LESS_THAN: '小于',
				EQUAL_TO: '等于',
				RESET_FILTER: '重置筛选',
				SELECT_AXIS: '选择轴',
				X_AXIS: 'X 轴',
				Y_AXIS: 'Y 轴',
				SPEC_LABEL: '标签（最多6个字符）',
				DESCRIPTION: '描述',
				VALUE: '值',
				ENABLE_TREND_CHART: '启用趋势图',
				ADD_TITLE: '添加标题',
				ADD_SUBTITLE: '添加副标题',
				UNIT: '单位',
				SELECT_ICON: '选择图标',
				SEARCH_ICONS: '搜索图标...',
				FORMULA: '公式',
				FORMULA_PLACEHOLDER: '输入公式，例如 (A+B)*C',
				ERROR_INVALID_VARS: '使用了无效变量',
				ERROR_INVALID_SYNTAX: '无效的数学表达式',
				ERROR_FORMULA_REQUIRED: '公式为必填项',
				ERROR_LESS_THAN_THRESHOLD: '此值应小于"小于"阈值',
				ERROR_GREATER_THAN_THRESHOLD: '此值应大于"大于"阈值',
				SELECT_CHILDREN: '选择子项',
				AT_LEAST_ONE: '至少需要选择1个选项',
				TITLE_REQUIRED: '标题为必填项',
				TITLE_DUPLICATE: '此标题已用于另一个公式',
				ADD_A_TITLE: '添加标题',
				DELETE_BUTTON: '删除',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: '添加行',
				ADD_COLUMN: '添加列',
				COLUMN_NAME: '列名',
				DELETE_COLUMN: '删除列',
				DATE_FILTER: '日期筛选',
				ROWS: '行',
				NUMBER_OF_ROWS: '行数',
				SELECT_TAG: '选择标签',
				CONFIGURE_TAG: '配置标签',
				DELETE_ROW: '删除行',
				APPLY_DATE_FILTERS: '对列应用日期筛选',
				NONE: '无',
				SELECT_FY_START: '选择财年第一天',
				CANCEL: '取消',
				APPLY: '应用',
				SEARCH_TAG: '搜索标签...',
				NO_TAG_FOUND: '未找到匹配的标签',
				GREATER_THAN: '大于',
				LESS_THAN: '小于',
				EQUAL_TO: '等于',
				LESS_GREATER_ERROR: '"小于"值必须大于"大于"值',
				IGNORE_NULLS: '忽略空值',
				AGGREGATION: '聚合',
				DEFINE_COLOR: '定义标签值以设置文字颜色',
				LESSER_THAN: '小于',
				PICK_COLOR: '选择颜色',
				COLOR: '颜色',
				LESSER_THAN_ERROR: '值必须小于定义的较大值',
				GREATER_THAN_ERROR: '值必须大于定义的较小值',
				BETWEEN: '介于',
				AND: '和',
				BETWEEN_RANGE_ERROR: '请输入有效范围，下限应小于上限',
			},
			RECENT: '最近',
			FAVOURITES: '收藏',
			CREATED_BY_ME: '我创建的',
			TAB_ALL: '全部',
			TAB_MY_DASHBOARD: '我的仪表盘',
			TAB_SHARED: '共享',
			TAB_PRIVATE: '私有',
			ALL_DASHBOARDS: '所有仪表盘',
			MY_DASHBOARDS: '我的仪表盘',
			SHARED_DASHBOARDS: '共享仪表盘',
			PRIVATE_DASHBOARDS: '私有仪表盘',
			COL_NAME: '名称',
			COL_CREATED_ON: '创建时间',
			COL_UPDATED_ON: '更新时间',
			COL_OWNED_BY: '所有者',
			COL_SHARED: '共享',
			COPY_LINK: '复制链接',
			RENAME: '重命名',
			OPEN_IN_NEW_TAB: '在新标签页中打开',
			SELECT: '选择',
			SELECT_PERFORMANCE_CURVE: '选择性能曲线',
			MENU_EDIT_DASHBOARD: '编辑仪表盘',
			MENU_COPY_DASHBOARD: '复制仪表盘',
			MENU_PUBLISH: '发布',
			MENU_UNPUBLISH: '取消发布',
			MENU_DELETE_DASHBOARD: '删除仪表盘',
			MONGO: {
				SELECT_GRAPH_FIRST: '*请先选择图表类型',
				LABEL_USED: '标签已使用',
				REQUIRED: '*必填',
				DEFINE_RELATION: '定义关系',
				INVALID_VARIABLE: '公式中存在无效变量。',
				INVALID_RELATION: '与来源的关系无效。',
				INVALID_FORMULA_SYNTAX: '公式语法无效。',
				SOURCE: '来源',
				ATTRIBUTE: '属性',
				DISPLAY_ATTRIBUTE: '显示属性',
				GROUP_BY_ATTR: '分组依据',
				AGGREGATION: '聚合',
				OPEN_FILTERS: '打开过滤器',
				REMOVE_COLUMN: '删除列',
				ADD_ATTRIBUTE: '添加属性',
				RAW_ATTRIBUTE: '原始属性',
				CALC_ATTRIBUTE: '计算属性',
				ADD_RAW_ATTRIBUTE_COL: '添加原始属性列',
				ADD_CALC_ATTRIBUTE_COL: '添加计算属性列',
				GROUP_BY: '分组依据',
				GROUP_DISPLAY_TYPE: '分组显示类型',
				SORT_BY: '排序方式',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: '并排',
				NA: '无',
				STACK_BY: '堆叠依据',
				NO_OF_BINS: '区间数',
				SLICERS: '切片器（最多选择 {{limit}} 个）',
				SELECT_UP_TO: '最多选择',
				DRILL_DOWN: '向下钻取',
				DRILL_DOWN_ATTRS: '向下钻取属性（最多选择 {{limit}} 个）',
				SELECT_ATTRS: '选择属性',
			},
			TAG_AGG: {
				SELECT_TAG: '选择标签',
				SELECT_AGGREGATE_TYPE: '选择聚合类型',
				ENABLE_AGGREGATE: '启用聚合',
			},
			SIDE_PANEL: {
				SETTINGS: '设置',
				SAVE: '保存',
				CLOSE: '关闭',
				PANEL: '面板',
				AXIS: '轴',
				GRAPH_OPTIONS: '图表选项',
				SELECT_CONFIG_TYPE: '选择配置类型',
				EXCEL_CONFIG: 'Excel 配置',
				TAG_GROUP: '标签组',
				PANEL_DESCRIPTION: '面板描述',
				X_AXIS_MIN: 'X 轴最小值',
				X_AXIS_MAX: 'X 轴最大值',
				X_AXIS_UNIT: 'X 轴单位',
				Y_AXIS_UNIT: 'Y 轴单位',
				SHOW_LEGEND: '显示图例',
				OVERLAP_LEGENDS: '重叠图例',
				TABLE_MODE: '表格模式',
				TITLE_COLOR: '标题颜色',
				BORDER_COLOR: '边框颜色',
				TREND_CHART_COLOR: '趋势图颜色',
				UPLOAD: '上传',
				DOWNLOAD: '下载',
				UPLOAD_BASE_CURVE: '上传基准曲线',
				BASE_CURVE_FORMAT: '基准曲线格式',
				DELETE_CURVE_GRAPH: '删除曲线图',
			},
			SINGLE_STATS: {
				ADD_STAT: '添加统计',
				COLOR_PICKER: '颜色选择器',
				COLOR_TITLE: '标题',
				COLOR_BORDER: '边框',
				COLOR_ICON: '图标',
				COLOR_ICON_OUTLINE: '图标轮廓',
				NO_ICON_FOUND: '未找到匹配图标',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: '调度列表',
				HEADER_TITLE: '报告调度程序',
				NEW_SCHEDULER_TOOLTIP: '创建新调度',
				NEW_SCHEDULER: '新建调度',
				COL_TITLE: '标题',
				COL_MEDIUM: '媒介',
				COL_SUBJECT: '主题',
				COL_RUNS: '运行',
				COL_MODIFIED_ON: '修改时间',
				COL_CREATED_ON: '创建时间',
				COL_ACTIONS: '操作',
				EDIT_TOOLTIP: '编辑调度',
				DELETE_TOOLTIP: '删除调度',
				MEDIUM_EMAIL: '邮件',
				MEDIUM_SMS: '短信',
				MEDIUM_CALL: '电话',
				SCHEDULER_DELETED: '调度已删除',
				DELETE_FAILED: '删除失败',
				OKAY: '确定',
				NO_REPORT: '未找到报告'
			},
			DETAILS: {
				TITLE: '调度',
				CREATE_TITLE: '创建调度',
				EDIT_DETAILS_TITLE: '编辑详情',
				SCHEDULE_DETAILS_TITLE: '调度详情',
				CANCEL: '取消',
				SAVE: '保存',
				SELECT_FACILITY: '选择设施',
				LOADING: '加载中...',
				SCHEDULE_RECURRING_REPORTS: '安排定期报告',
				MONTHS: '月份',
				ALL: '全部',
				DAY: '天',
				EVERY: '每',
				TH_DAY: '天',
				WEEKDAYS: '星期',
				TIME: '时间',
				SELECT_TIME: '选择时间',
				HOUR: '小时',
				MINUTE: '分钟',
				FILE_NAME_LABEL: '文件名',
				REPORT_NAME_LABEL: '报告名称',
				ENTER_NAME: '输入名称',
				REPORT_TITLE: '报告标题（最多20个字符）',
				ENTER_TITLE: '输入标题',
				REPORTING_INTERVAL: '报告间隔',
				MEDIUM: '媒介',
				TEMPLATE_NAME: '模板名称',
				SUBJECT: '主题',
				ENTER_SUBJECT: '输入主题',
				SELECT_USERS: '选择用户',
				SEARCH_BY_EMAIL: '按邮箱地址搜索',
				NO_MATCHING_EMAIL: '未找到匹配的邮箱地址',
				ADD_EMAILS_LABEL: '添加以逗号分隔的邮箱地址',
				OKAY: '确定',
				SELECT_AT_LEAST_ONE_UNIT: '请至少选择一个机组',
				SELECT_AT_LEAST_ONE_SYSTEM: '请至少选择一个系统',
				SELECT_USER_OR_EMAIL: '请至少选择一个用户或添加邮箱地址',
				INVALID_EMAILS: '输入的邮箱地址无效',
			},
			TEMPLATES: {
				DAILY_REPORT: '每日报告',
				BIWEEKLY_REPORT: '双周报告',
				KPI_REPORT_THERMAL: 'KPI报告 - 热工',
				ALERT_STATUS_UPDATE_REPORT: '告警状态更新报告',
				DATA_QUALITY_REPORT: '数据质量报告',
				DATA_LAG_REPORT: '数据延迟报告',
				IOW_REPORT: 'IOW报告',
				SERVER_EXCEPTION_REPORT: '服务器异常报告',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: '过去8小时',
				LAST_12_HOURS: '过去12小时',
				LAST_24_HOURS: '过去24小时',
				TODAY: '今天',
				YESTERDAY: '昨天',
				LAST_7_DAYS: '过去7天',
				THIS_WEEK: '本周',
				PREVIOUS_WEEK: '上周',
				LAST_15_DAYS: '过去15天',
				LAST_30_DAYS: '过去30天',
				THIS_MONTH: '本月',
				PREVIOUS_MONTH: '上月',
				THIS_QUARTER: '本季度',
				PREVIOUS_QUARTER: '上季度',
				LAST_3_MONTHS: '过去3个月',
				LAST_6_MONTHS: '过去6个月',
				LAST_12_MONTHS: '过去12个月',
				THIS_YEAR: '今年',
				PREVIOUS_YEAR: '去年',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: '无法从多个设施创建分析模板',
			TITLE: '分析与视图',
			CLOSE: '关闭',
			EXPORT_TO_EXTERNAL: '将所选标签导出到外部系统',
			SAVED_ANALYSIS: '已保存的分析',
			CREATE_NEW: '新建',
			SAVED_VIEWS: '已保存的视图',
			SAVE_CURRENT_VIEW: '保存当前视图',
			SAVE_DISABLED_TOOLTIP: '只有告警所有者才能保存或修改标签视图。',
			TEMPLATE_TAG: '[模板]',
			SNAPSHOT_TAG: '[快照]',
			EDIT: '编辑',
			DELETE: '删除',
			SAVED_DASHBOARDS: '已保存的仪表板',
			NO_DASHBOARDS: '暂无已保存的仪表板',
		},
		THRESHOLD_PANEL: {
			TITLE: '阈值',
			CLOSE: '关闭',
			ONGOING: '进行中',
			SHOW_LESS: '收起',
			SEE_MORE: '查看更多',
		},
		ACTIVITY_LOGS: {
			TITLE: '活动日志',
			ACTIONS: '操作 ({{count}})',
			CLOSE: '关闭',
			SEARCH_PLACEHOLDER: '搜索...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: '反馈',
			CLOSE: '关闭',
			APPROVED: '已批准',
			RELEARNED: '已重新学习',
			QUOTE_APPROVED_HYPOTHESIS: '已批准的假设',
			QUOTE_RELEARNED_HYPOTHESIS: '已重新学习的假设',
			QUOTE_APPROVED_CAUSAL: '已批准的因果链步骤',
			QUOTE_RELEARNED_CAUSAL: '已重新学习的因果链步骤',
			QUOTE_APPROVED_RECOMMENDATION: '已批准的建议',
			QUOTE_RELEARNED_RECOMMENDATION: '已重新学习的建议',
			QUOTE_OTHER: '其他',
			FILE_ALT: '文件',
			EMPTY_HEADING: '暂无反馈',
			EMPTY_CONTENT: '请批准或重新学习以添加反馈。',
		},
		DISCUSSION: {
			TITLE: '讨论',
			COMMENTS_COUNT: '评论 ({{count}})',
			CLOSE: '关闭',
			CREATE_CASE_TITLE: '创建案例以管理后续事项',
			CREATE_CASE: '创建案例',
			BACK: '返回',
			THREAD_BY: '话题发起人:',
			SEARCH_PLACEHOLDER: '搜索...',
			NO_COMMENTS_HEADING: '暂无评论',
			NO_COMMENTS_BODY: '留下您的第一条评论以开始关于此主题的讨论。',
			EDITED: '已编辑',
			RCA_VERSION_DELETED: '根因分析版本已删除',
			COMMENT_DELETED: '此评论已被删除。',
			COMMENT_DELETED_ALT: '此评论已被删除。',
			REPLY_SINGULAR: '条回复',
			REPLY_PLURAL: '条回复',
			LAST_REPLY: '最后回复',
			REPLY_PROMPT: '回复...',
			COMMENT_PLACEHOLDER: '添加评论，使用 @ 标记团队成员',
			REPLY_TO_COMMENT_PLACEHOLDER: '回复评论...',
		},
		RETRAIN_MODEL: {
			TITLE: '重新训练模型',
			CLOSE: '关闭',
			CURRENT_MODEL_DETAILS: '当前模型详情',
			DEPLOYED_VERSION_LABEL: '已部署版本 - 日期/时间',
			LAST_PREDICTION_LABEL: '最后预测 - 日期/时间',
			FORM_ERROR: '糟糕！请修改一些内容后重试提交。',
			TRAINING_PERIOD: '训练周期',
			DATE_RANGE_SELECTION_METHOD: '日期范围选择方法',
			SELECT_TRAINING_MODE_ARIA: '选择训练选择模式',
			CALENDAR_SELECTION: '日历选择',
			CHART_BASED_SELECTION: '基于图表的选择',
			VIEW_EDIT_NOTE: '查看/编辑备注',
			ADD_NOTE: '添加备注',
			ADD_TRAINING_RANGE: '添加训练范围',
			DELETE_TRAINING_RANGE: '删除训练范围',
			ADVANCED_SETTINGS: '高级设置',
			BAND_LEARNING_BEHAVIOUR: '带状学习行为',
			SELECT_BAND_LEARNING_ARIA: '选择带状学习行为',
			CONSERVATIVE_TOOLTIP: '在所选训练区域周围创建较窄的带状区域',
			CONSERVATIVE: '保守',
			MODERATE_TOOLTIP: '在所选训练区域周围创建均衡的带状区域',
			MODERATE: '适中',
			AGGRESSIVE_TOOLTIP: '在所选训练区域周围创建较宽的带状区域',
			AGGRESSIVE: '激进',
			PREDICTION_SMOOTHING_SETTINGS: '预测平滑设置',
			SMOOTHING: '平滑',
			WINDOW_SIZE: '窗口大小',
			WINDOW_SIZE_PLACEHOLDER: '窗口大小（小时）',
			VALUE_IS: '值是',
			REQUIRED: '必填',
			VALUE_MIN: '值必须大于或等于',
			POLYNOMIAL_ORDER: '多项式阶数',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: '选择关注标签',
			SEARCH_PLACEHOLDER: '搜索...',
			NO_MATCHING_TAGS: '未找到匹配的标签',
			SHOW_ALL_TAGS: '显示所有标签',
			SHOW_ATTENTION_TAGS_ONLY: '仅显示关注标签',
			MODELING_TECHNIQUE: '建模技术',
			AUTO_ENCODER: '自动编码器',
			ATTENTION_AUTO_ENCODER: '注意力自动编码器',
			CANCEL_TOOLTIP: '取消更改',
			CANCEL: '取消',
			RETRAIN_DEPLOY_TOOLTIP: '重新训练并部署',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: '关闭',
			ICON_ALT: '根因图标',
			NOT_GENERATED_MESSAGE: '您尚未生成根因分析。请生成以继续。',
			FAILED_MESSAGE: '您上次的根因分析失败了。<br> 请重新生成以继续。',
			GENERATE_NOW: '立即生成',
			REFRESH: '刷新',
			LAST_GENERATED: '最后生成时间',
			GENERATING: '正在生成根因分析',
			LOADER_ALT: '加载中',
			LIKE_ALT: '赞',
			DISLIKE_ALT: '踩图标',
			MONETARY_VALUE: '货币价值',
			FAILURE_HISTORY: '故障历史',
			INFO_CARD_ARIA: '信息卡',
			PREVIOUS_FAILURE_MODES: '以往故障模式',
			HYPOTHESIS_PREFIX: '假设',
			MOST_LIKELY: '（最可能）',
			CASCADES_AS_FOLLOWS: '。此根因可能按以下方式级联：',
			AGREE: '同意',
			PARTIALLY_AGREE: '部分同意',
			DISAGREE: '不同意',
			TELL_US_MORE: '告诉我们更多：',
			FEEDBACK_PLACEHOLDER: '欢迎补充具体细节',
			CANCEL: '取消',
			SUBMIT: '提交',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: '文档',
			CLOSE: '关闭',
			SEARCH_PLACEHOLDER: '搜索...',
			FILTER_TAGS: '筛选标签',
			EMPTY_HEADING: '暂无文档',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: '货币价值',
			CURRENCY_HINT: '货币价值以{{currency}}输入',
			RELIABILITY: '可靠性',
			MAINTENANCE: '维护',
			PERFORMANCE: '性能',
			POTENTIAL_SUFFIX: '（潜在）',
			ENTER_VALUE: '输入值',
			COMMENT_REQUIRED_ERROR: '评论不能为空。',
			AMOUNT_REQUIRED_ERROR: '必须至少输入一个值。',
			COMMENT: '评论',
			COMMENT_PLACEHOLDER: '添加您的评论',
			CANCEL: '取消',
			SAVE: '保存',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: '故障模式详情',
			OPEN_ALERT: '打开告警',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: '添加货币价值',
			CMMS_NUMBER_TOOLTIP: 'CMMS编号',
			MORE_SUFFIX: '更多',
			ADD_CMMS_NUMBER: '添加CMMS编号',
			BREAKDOWN_CATEGORY: '细分类别',
			BREAKDOWN_COMPONENT: '细分组件',
			ERROR_LABEL: '错误',
			TAG_CHARTS_SUFFIX: '标签图表',
		},
		DATA_QUALITY_PANEL: {
			TITLE: '数据质量',
			CLOSE: '关闭',
			SEE_LESS: '收起',
			SEE_MORE: '查看更多',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: '排序方式：',
			ASSET: '资产：',
			REASON: '原因：',
			RECOMMENDATIONS: '建议：',
			NA: '无',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: '报告问题',
			SUBTITLE: '告诉我们根因分析智能体出了什么问题。',
			CLOSE: '关闭',
			WARNING_BANNER: '此操作不会更新或重新运行当前的根因分析。要改进假设、因果链或建议，请使用根因分析中的反馈选项。',
			SECTION_TITLE: '出了什么问题？',
			SECTION_HINT: '选择所有适用项。',
			ISSUES_ERROR: '请至少选择一个选项。',
			DETAILS_ERROR: '请添加您遇到的问题的详细信息。',
			DETAILS_LABEL_REQUIRED: '附加详情（必填）',
			DETAILS_LABEL_OPTIONAL: '附加详情（可选）',
			DETAILS_PLACEHOLDER: '例如，根因分析识别出正确的压力趋势，但得出泵导致事件的结论，尽管维护记录表明是阀门故障。',
			DISCLAIMER: '提交此报告后，相关的根因分析数据和活动日志将与经授权的UptimeAI团队共享以供调查。',
			CANCEL: '取消',
			SUBMIT_REPORT: '提交报告',
			RUN_RCA_FIRST: '报告智能体问题前请先运行根因分析。',
			SUBMITTED_SUCCESS: '问题报告成功',
			SUBMIT_FAILED: '报告问题失败，请重试。',
			OPT_PLATFORM_DATA_LABEL: '未考虑相关平台数据',
			OPT_PLATFORM_DATA_HINT: '根因分析未使用平台上所有相关的告警、标签、趋势、事件或其他可用数据。',
			OPT_EVIDENCE_LABEL: '文档或证据未被正确考虑',
			OPT_EVIDENCE_HINT: '上传的文档、提议的证据或其他支持信息被忽略或被错误解读。',
			OPT_USER_INPUT_LABEL: '我的输入未被妥善考虑',
			OPT_USER_INPUT_HINT: '根因分析未妥善考虑我在此次调查或之前重新运行中提供的背景、指示、备注或反馈。',
			OPT_CAUSAL_LABEL: '因果推理有误',
			OPT_CAUSAL_HINT: '根因分析考虑了相关信息，但得出了错误的结论。',
			OPT_WEIGHTED_LABEL: '证据权重分配不当',
			OPT_WEIGHTED_HINT: '根因分析过度关注单一数据点，未充分考虑其他重要证据。',
			OPT_UNSUPPORTED_LABEL: '结论缺乏证据支持',
			OPT_UNSUPPORTED_HINT: '根因分析在没有充分支持数据或证据的情况下生成了主张或结论。',
			OPT_RECOMMENDATION_LABEL: '建议不具备可操作性',
			OPT_RECOMMENDATION_HINT: '该建议过于笼统、不切实际或在运营上没有用处。',
			OPT_UNCLEAR_LABEL: '解释不清楚',
			OPT_UNCLEAR_HINT: '推理难以理解或没有提供足够的依据。',
			OPT_OTHER_LABEL: '其他',
			OPT_OTHER_HINT: '报告上面未列出的问题。',
		},
		LIBRARY: {
			TITLE: '资料库',
			SUBTITLE: 'P&ID 图纸与工程文档（手册、数据表、报警 / 跳车清单）集中查看。',
			SEARCH: '搜索图纸、文档、设备或位号（例如 PT-0940）…',
			TAB_PIDS: 'P&ID',
			TAB_DOCS: '手册与数据',
			PIDS: {
				LOADING: '正在加载图纸…',
				FAILED: '无法加载图纸。',
				LOCATED: '显示 {{tag}} 的图纸',
				NOT_LOCATED: '{{tag}} 不在任何已索引的图纸上。',
				NO_MATCH: '没有与搜索匹配的图纸。',
				TAGS: '{{count}} 个位号',
				PICK: '在左侧选择图纸，或搜索位号以找到显示它的图纸。',
				VIEW_DRAWING: '图纸',
				VIEW_PDF: '完整 PDF',
				PDF_LOADING: '正在加载 PDF…',
				PDF_FAILED: '此图纸的 PDF 不可用。',
				OTHER: '其他图纸',
				REFERENCE: '图例与图纸目录',
			},
			DOCS: {
				LOADING: '正在加载文档…',
				FAILED: '无法加载文档。',
				EMPTY: '没有文档。',
				NO_MATCH: '没有与搜索匹配的文档。',
				PICK: '选择一个文档在此阅读。',
				GROUP_ITEM: '此位置',
				GROUP_ABOVE: '来自 {{floc}}',
				GROUP_BELOW: '此位置以下',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: '{{facility}} 资产树（SAP 功能位置）',
				SEARCH_PLACEHOLDER: '搜索功能位置、设备或历史库标签…',
				SEARCH_HINT: '匹配的资产列在下方；选择标签建议可在 P&ID 上显示。',
				HIDE_EMPTY: '隐藏无标签的位置',
				HIDE_EMPTY_HINT: '隐藏子树中没有历史库标签的功能位置。设备包和未分配组始终显示。',
				NODE_HITS: '匹配的资产（{{count}}）',
				CLOSE_HITS: '关闭结果',
				NODE_SEARCH_FAILED: '资产搜索失败，请重试。',
				NO_NODE_HITS: '没有与“{{query}}”匹配的资产。',
				REVEAL_FAILED: '无法在树中打开该资产。',
				TREE_EMPTY: '资产树为空。',
				TREE_HIDDEN: '已隐藏 {{count}} 个无标签的位置',
				CHILDREN_FAILED: '无法加载该节点的子节点。',
				CHILDREN_HIDDEN: '已隐藏 {{count}} 个没有历史库标签的子位置。',
				COUNT_TIP: '该子树中有 {{count}} 个历史库标签',
				PATH: '资产路径',
				UNASSIGNED_NAME: '未分配标签',
				UNASSIGNED_TIP: '没有功能位置或设备包映射的历史库标签，按标签名中的系统代码分组',
				UNASSIGNED_NOTE: '这些历史库标签既没有 SAP 功能位置，也没有设备包。它们仅按标签名中的系统代码分组（没有代码时归于站点级）；其所属设备未知。',
				PACKAGE_NOTE: '转动设备包：其标签映射到整个设备包，而不是某个单独的 SAP 功能位置。',
				LEVEL_SITE: '站点',
				LEVEL_SYSTEM: '系统',
				LEVEL_SUBSYSTEM: '子系统',
				LEVEL_EQUIPMENT: '设备',
				LEVEL_PACKAGE: '设备包',
				LEVEL_UNASSIGNED: '未分配',
				KIND_FLOC: 'SAP 功能位置',
				KIND_PACKAGE: '设备包',
				KIND_UNASSIGNED: '未分配标签组',
				SUBTREE_TAGS: '子树中 {{count}} 个标签',
				LOOP_TAGS_BADGE: '{{count}} 个同回路设备包标签',
				PIDS_SHOWING: '出现在 {{count}} 张 P&ID 上',
				PROP_FLOC: '功能位置代码',
				PROP_CODE: '设备包代码',
				PROP_LEVEL: '层级',
				PROP_KIND: '类型',
				PROP_LOOP: '回路号',
				PROP_OWN_TAGS: '本节点标签',
				PROP_SUBTREE_TAGS: '子树标签',
				WITH_DATA: '{{count}} 个有数据',
				N_TAGS: '{{count}} 个标签',
				INCLUDE_SUBTREE: '包含子树',
				TAGS_OWN_NOTE: '直接放置在本节点上的标签。',
				TAGS_SUBTREE_NOTE: '放置在本节点及其下所有节点上的标签。',
				DETAIL_FAILED: '无法加载该节点，请重试。',
				NO_OWN_TAGS: '本节点上没有放置历史库标签。',
				NO_OWN_TAGS_LOOP: '该功能位置本身没有放置历史库标签；下方列出了与其回路号相同的设备包标签。',
				TRUNCATED: '显示前 {{shown}} 个标签，共 {{total}} 个。',
				FILTER_TAGS: '筛选标签…',
				NO_FILTER_MATCH: '没有标签符合筛选条件。',
				COL_RULE: '放置规则',
				COL_DATA: '数据',
				PLACED_AT: '位于',
				LOOP_TITLE: '回路号相同的设备包标签（{{count}}）',
				LOOP_EXPLAIN: '这些标签属于转动设备包，而不属于该功能位置。之所以列出，是因为其标签名带有与该设备相同的回路号 {{loop}}。它们不计入本节点的标签总数。',
				LOOP_GROUP: '回路 {{loop}} · 设备包 {{package}}（{{count}}）',
				OPEN_PACKAGE: '打开设备包',
				PID_GROUP_NODE: '显示 {{name}}',
				PID_NODE_FOUND: '{{name}}（设备符号或其标签）出现在 {{count}} 张图纸上。',
				PID_NODE_NONE: '没有数字化 P&ID 显示 {{name}} 或其前几个标签。',
				CHIPS_MORE: '显示本节点 {{total}} 个标签中的 {{shown}} 个；可从概览表或搜索中添加其他标签。',
				RULE_FLOC_CURATED: '功能位置（人工整理）',
				RULE_FLOC_CURATED_HINT: '来自人工整理的标签–设备映射表的功能位置。',
				RULE_FLOC_BACKFILLED: '功能位置（补全）',
				RULE_FLOC_BACKFILLED_HINT: '来自历史库标签–资产映射的功能位置，在人工整理表中没有时使用。',
				RULE_FLOC_WELL: '经海底井定位',
				RULE_FLOC_WELL_HINT: '根据标签名中的井号，将海底标签放置到该井采油树的功能位置（或井的功能位置）。',
				RULE_FLOC_LOOP: '经回路号定位',
				RULE_FLOC_LOOP_HINT: '放置到代码以该标签回路号结尾的唯一设备功能位置。',
				RULE_PACKAGE_PREFIX: '经标签前缀归入设备包',
				RULE_PACKAGE_PREFIX_HINT: '映射到设备包；放置在标签名所编码的子系统下。',
				RULE_PACKAGE_SITE: '设备包（站点）',
				RULE_PACKAGE_SITE_HINT: '映射到设备包；标签名未编码子系统，因此位于站点级。',
				RULE_UNASSIGNED: '未分配（标签前缀）',
				RULE_UNASSIGNED_HINT: '没有功能位置或设备包；按标签名所编码的子系统分组。',
				RULE_SITE: '站点',
				RULE_SITE_HINT: '没有功能位置、设备包或子系统代码；保留在站点级。',
			},
			TITLE: '{{facility}} 资产层级',
			BREADCRUMB: '资产浏览器',
			RELOAD: '重新加载',
			LOADING_TREE: '正在加载资产层级…',
			LOAD_FAILED: '无法加载资产层级，请重试。',
			SEARCH_PLACEHOLDER: '搜索设备或历史库标签…',
			SEARCH_HINT: '输入内容可筛选树；选择标签可在 P&ID 上显示。',
			TREE_EMPTY: '没有与搜索匹配的资产。',
			EXPAND: '展开',
			COLLAPSE: '折叠',
			LEVEL_KICKER: '第 {{level}} 级',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} 个历史库标签',
			PIDS_LINKED: '{{count}} 张关联 P&ID',
			TAB_OVERVIEW: '概览',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: '时间序列',
			TAB_DOCS: '文档',
			DOCS: {
				VIEW: '文档 ({{count}})',
				HINT: '{{name}} 及其上级位置的手册、数据表和报警 / 跳车清单。',
				ALSO_PIDS: '另见 {{count}} 张 P&ID 图纸',
				OPEN_LIBRARY: '打开资料库',
				EMPTY: '此位置及其上级位置没有关联的文档。',
			},
			OPEN_KG: '在知识图谱中打开',
			VIEW_ALERTS: '查看报警',
			VIEW_PID: '查看 P&ID',
			VIEW_TELEMETRY: '查看时间序列',
			DESCRIPTION: '描述',
			NO_DESCRIPTION: '该资产没有描述记录。',
			CHILDREN: '子资产（{{count}}）',
			PROPERTIES: '属性',
			TAGS_TITLE: '历史库标签（{{count}}）',
			NO_TAGS: '没有映射到该资产的历史库标签。',
			COL_TAG: '标签',
			COL_COMPONENT: '部件',
			COL_RANGE: '运行范围',
			COL_UNIT: '单位',
			COL_ACTIONS: '操作',
			LOCATE_ON_PID: '在 P&ID 上显示',
			PLOT: '绘图',
			NO_SELECTION: '请在层级中选择资产或搜索标签。',
			LEVEL: {
				FACILITY: '设施',
				SYSTEM: '系统',
				SUBSYSTEM: '子系统',
				EQUIPMENT: '设备',
				COMPONENT: '部件',
				INSTRUMENT: '仪表',
			},
			PID: {
				SHEET: '图纸',
				SEARCH_SHEETS: '搜索图纸…',
				SEARCH_ON_DRAWING: '在此图纸上查找标签…',
				NO_MATCHES: '此图纸上没有匹配的标签。',
				FILTER_ALL: '全部',
				FILTER_INSTRUMENTS: '仪表',
				FILTER_EQUIPMENT: '设备',
				FILTER_NONE: '无',
				GROUP_LOCATED: '显示 {{tag}} 的图纸',
				GROUP_NODE: '关联到 {{name}}',
				GROUP_ALL: '所有图纸（{{count}}）',
				SOURCE_DIGITISED: '已数字化',
				SOURCE_TEXT: '文本索引',
				SOURCE_NEEDS_OCR: '需要 OCR',
				SOURCE_CATALOGUED: '已编目',
				SOURCE_BLANK: '无文本',
				DETECTIONS: '{{count}} 个对象',
				LOCATING: '正在 P&ID 上查找 {{tag}}…',
				LOCATE_FAILED: '无法在 P&ID 上查找 {{tag}}。',
				NOT_ON_PID: '{{tag}} 未出现在任何已数字化的 P&ID 上。',
				FOUND_ON: '{{tag}} 出现在 {{count}} 张图纸上',
				CLEAR_LOCATE: '清除',
				TYPE_INSTRUMENT: '仪表',
				TYPE_EQUIPMENT: '设备',
				CONFIDENCE: '置信度 {{pct}}%',
				CANONICAL: '规范标签',
				HISTORIAN_TAG: '历史库标签',
				NOT_LINKED: '未关联历史库标签',
				PLOT: '在时间序列中绘图',
			},
			PID_VIEWER: {
				ZOOM_IN: '放大',
				ZOOM_OUT: '缩小',
				FIT: '适应视图',
				FOCUS_HIGHLIGHT: '定位到高亮标签',
				FULLSCREEN: '全屏',
				EXIT_FULLSCREEN: '退出全屏',
				LOADING: '正在加载图纸…',
				NO_DRAWING: '未选择图纸。',
				LOAD_FAILED: '无法加载此图纸。',
				NO_IMAGE: '此图纸没有图像',
				NO_IMAGE_HINT: '图纸已数字化（{{count}} 个对象，{{highlighted}} 个高亮），但图像不可用。',
				PAN_HINT: '拖动平移 · 滚轮缩放',
				ASPECT_WARNING: '图像与图纸尺寸不一致，框可能有偏移。',
				HISTORIAN_TAG: '历史库标签',
				NOT_LINKED: '未关联',
				CLICK_HINT: '点击选择',
				UNTAGGED: '未标记对象',
			},
			TAG_SEARCH: {
				SEARCHING: '正在搜索…',
				FAILED: '标签搜索失败，请重试。',
				NO_RESULTS: '没有与“{{query}}”匹配的历史库标签。',
				HAS_DATA: '有数据',
				NO_DATA: '无数据',
				ALREADY_ADDED: '已选择',
			},
			TELEMETRY: {
				ACTIVE_TAGS: '图表中的标签（{{count}} / {{max}}）',
				SEARCH_PLACEHOLDER: '搜索要添加的历史库标签…',
				DROPPED: '最多 {{max}} 个标签：已移除 {{tag}} 以腾出位置。',
				REMOVE: '从图表中移除',
				WINDOW: '时间窗口',
				WINDOW_7D: '7天',
				WINDOW_30D: '30天',
				WINDOW_90D: '90天',
				WINDOW_1Y: '1年',
				CHART_TITLE: '历史库时间序列',
				POINTS: '{{count}} 个数据点',
				LOADING: '正在加载时间序列…',
				NO_DATA: '所选标签在此时间窗口内没有读数。',
				NO_TAGS: '搜索标签或在上方选择标签进行绘图。',
				SUMMARY: '汇总',
				LATEST: '最新',
				MIN: '最小',
				MAX: '最大',
				MEAN: '平均',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: '点击收起',
				NO_EXACT: '没有名为“{{tag}}”的节点',
				PICK_MATCH: '以下部分匹配，每个工厂部分一个 — 选择一个进行探索：',
				BREADCRUMB_OPS: '海上作业',
				BREADCRUMB_TWINS: '拓扑孪生',
				BREADCRUMB_GRAPH: 'Shell Vito 知识图谱',
				TITLE: '交互式工厂知识图谱',
				NODES: '{{n}} 个节点',
				RELATIONSHIPS: '{{n}} 条关系',
				LIVE: 'Neo4j 实时',
				CENTER_PLACEHOLDER: '中心位号（如 PT-1502、MTR-0900）…',
				EXPLORE: '探索',
				HOPS: '深度',
				HOPS_1: '1 跳：直接相邻',
				HOPS_2: '2 跳：相邻设备',
				HOPS_3: '3 跳：更大拓扑',
				SHOW_TYPE: '显示此类型',
				HIDE_TYPE: '隐藏此类型',
				ZOOM_IN: '放大',
				ZOOM_OUT: '缩小',
				FIT: '适应屏幕',
				SHOWING: '显示 {{shown}} / {{total}} 个节点',
				SHOW_MORE: '再显示 {{n}} 个',
				EXPAND_ALL: '展开所有分组',
				COLLAPSE_ALL: '收起分组',
				HINT: '悬停查看名称 · 点击分组展开 · 点击节点查看详情 · 拖动平移，滚动缩放',
				LOADING: '正在读取知识图谱…',
				LOAD_FAILED: '知识图谱加载失败',
				CLICK_TO_EXPAND: '点击列出并展开',
				GROUP: '分组节点',
				COLLAPSE_GROUP: '收起分组',
				CENTER_ON_NODE: '以此节点为中心',
				PROPERTIES: '节点属性',
				LOADING_RELATIONS: '正在加载关系…',
				OUTGOING: '出向关系（{{n}}）',
				INCOMING: '入向关系（{{n}}）',
				TYPE: {
					Equipment: '设备',
					ControlValve: '调节阀',
					Instrument: '仪表',
					Event: '告警',
					Event_PostJune2026: '告警（2026年6月后）',
					Alert: '告警',
					TripEvent: '跳车事件',
					RootCause: '根本原因',
					PhaScenario: 'PHA 场景',
					Detector: '检测器',
					Measurement: '测量',
					Document: '文档',
					PIDDrawing: 'P&ID 图纸',
					FLOC: 'FLOC',
					ProcessLine: '工艺管线',
					System: '系统',
				},
			},
			LIBRARY: {
				TITLE: '资料库专家',
				EXCERPTS_N: '{{n}} 段摘录 · {{docs}} 份文档',
				NONE: '范围内无手册',
				LIMITS_N: '{{n}} 个记载限值',
				SCOPE: '检索范围',
				HINT: '按 FLOC 归档到该设备的厂家手册、数据表及报警与跳车清单，按语义和关键词检索。代理以 LIB-n 引用。',
				QUESTIONS: '检索问题',
				NONE_HINT: '该设备及其上级 FLOC 未归档手册或数据表。',
				STATED_LIMITS: '该仪表的记载限值',
				EXCERPTS: '摘录',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: '限值',
				CLOSEST: '{{kind}} {{value}} · 余量 {{headroom}}%',
				NONE: '无已知限值',
				RULE_BREACHED: '满足 TMP 变化率规则',
				HINT: '告警位号的所有已知工程限值（Shell TMP 的 PSV 设定值 / DCS / PTM、SimpleLimits、同单位的手册值）与告警前最新读数及 24 小时峰值或谷值的比较。',
				NONE_HINT: '该位号没有已知的 TMP、SimpleLimits、检测器配置或手册限值。',
				SOURCE: '来源',
				LIMIT: '限值',
				VALUE: '数值',
				EXTREME_24H: '24 小时峰值 / 谷值',
				HEADROOM: '余量',
				STATUS: '状态',
				RATE_RULES: 'TMP 变化率规则',
				LARGEST_CHANGE: '最大变化 {{value}}',
				BREACHED: '已超出',
				NOT_BREACHED: '未超出',
				DETECTOR: '检测器配置',
				CONFLICT: 'TMP 数值冲突：',
				REACHED: '已达到',
				NEAR: '接近',
				CLEAR: '充足',
				NO_READING: '无读数',
			},
			PREFS: {
				TITLE: '偏好设置',
				HEIGHT: '图表首选高度',
				CONDENSED: '紧凑',
				NORMAL: '正常',
				EXPANDED: '展开',
				LIMITS_AND_VALUES: '标签限值和数值',
				SHOW: '显示',
				HIDE: '隐藏',
				OTHER: '默认绘制的限值线',
				TRIP_LINE: '跳闸线',
				ALARM_LINE: '报警线',
				THRESHOLD_LINE: '阈值线',
				INSTRUMENT_LINE: '仪表量程线',
				NOTE: '适用于所有分诊图表。阴影带为故障模式时段（信号开始至恢复正常）。限值仅来自已加载的 Shell 数据（TMP、SimpleLimits）。',
				RESET: '恢复默认',
			},
			PLAYBOOK: {
				TITLE: '现场作业手册校验',
				META: '已评估 {{count}} 条规则',
				META_HINT: '从此检测器的现场审核备注中提炼、告警时已生效的规则，基于截止前的证据进行检验',
				LEGEND: '✓ 成立 · ✗ 不成立 · ? 无法评估。“除非”项成立时规则不适用；无法用校验表达的部分由智能体判断。',
				OPEN_RULE: '在经验页中打开此规则',
				DISPOSITION_HINT: '此规则适用时现场的通常处置',
				UNLESS_HINT: '例外：任一成立则规则不适用',
				JUDGED_BY_AGENT: '由智能体判断',
				JUDGED_HINT: '此部分无法用机器校验表达；由智能体依据证据权衡',
				VALUE_YES: '成立',
				VALUE_NO: '不成立',
				VALUE_UNKNOWN: '无法评估',
				ST_MATCHED: '匹配',
				ST_MATCHED_HINT: '所有“当”项均成立且无例外成立',
				ST_PARTLY: '部分匹配',
				ST_PARTLY_HINT: '机器校验均成立；是否完全适用由智能体判断的部分决定',
				ST_EXCEPTED: '例外',
				ST_EXCEPTED_HINT: '本应适用，但例外（除非）成立',
				ST_UNDETERMINED: '无法确定',
				ST_UNDETERMINED_HINT: '截止前的证据不足以评估某项校验',
				ST_NOT_MATCHED: '不匹配',
				ST_NOT_MATCHED_HINT: '某项“当”校验不成立',
			},
			LEARNING_CHECK: {
				OR: '或',
				HOURS: '{{n}} 小时',
				DAYS: '{{n}} 天',
				ON_ITEM: '（本设备）',
				V_STOPPED: '停机',
				V_STARTED: '启动',
				V_RESTARTED: '重启',
				V_SHUTDOWN_OR_STARTUP: '停机或启动',
				V_NO_SIGNIFICANT_CHANGE: '无明显变化',
				V_PROCESS_OR_OPERATING_CHANGE: '工艺或运行变化',
				V_SINGLE_TAG_DEPARTURE: '单一位号单独偏离',
				V_MIXED: '混合模式',
				V_CONSISTENT: '与正常一致',
				V_MOVED_TOGETHER: '与之同步变化',
				MACHINE_EVENT: '机器在 {{window}} 内{{events}}',
				MACHINE_EVENT_NO_WINDOW: '机器{{events}}',
				MACHINE_EVENT_ANY: '{{window}} 内机器有停机或启动',
				SINCE_RESTART: '机器在告警前不超过 {{window}} 内重启',
				RUNNING: '告警时机器在运行',
				NOT_RUNNING: '告警时机器未运行',
				WITHIN_BASELINE: '告警时告警位号已回到正常范围',
				OUTSIDE_BASELINE: '告警时告警位号超出正常范围',
				SUSTAINED: '持续偏离正常',
				NOT_SUSTAINED: '无持续偏离',
				CHART_PATTERN: '趋势图显示{{patterns}}',
				CHART_PATTERN_ANY: '读取了趋势图模式',
				MULTIVARIATE: '多变量模型判定为{{values}}',
				MULTIVARIATE_ANY: '多变量模型给出结论',
				CONNECTED: '关联系统：{{values}}',
				CONNECTED_ANY: '已读取关联系统',
				MOVED_TOGETHER: '相关位号同步变化',
				NOT_MOVED_TOGETHER: '相关位号未同步变化',
				OPEN_WORK: '本设备有未关闭的通知单或工单',
				NO_OPEN_WORK: '本设备无未关闭的通知单或工单',
				COHORT: '同一系统同时出现多条告警（共因）',
				NO_COHORT: '同一系统无告警集中爆发',
				SENSOR_FAULT: '传感器故障或数据不可用',
				SENSOR_OK: '传感器数据可用',
				RETURNED: '告警前信号已恢复正常',
				NOT_RETURNED: '截至告警时信号未恢复正常',
				SHIFT_LOG: '最近 {{window}} 内的交接班记录提到“{{query}}”',
				NO_SHIFT_LOG: '最近 {{window}} 内的交接班记录未提到“{{query}}”',
				RECENT_WORK: '最近 {{window}} 内有与“{{query}}”相符的维护工作',
				NO_RECENT_WORK: '最近 {{window}} 内无与“{{query}}”相符的维护工作',
				OTHER_ALERTS: '{{window}} 内同一检测器至少还有 {{n}} 条其他告警',
				PRIOR_ALERTS: '最近 {{window}} 内此位号至少有 {{n}} 条早期告警',
				PRIOR_ALERTS_EVER: '此位号至少有 {{n}} 条早期告警',
			},
			LEARNING_EDIT: {
				TITLE: '编辑经验',
				ASOF_WARNING: '保存后将写入版本 v{{next}}，自现在起生效。较早告警的分诊仍使用其当时生效的版本（按时间点）。',
				F_TITLE: '标题',
				RECOMPILE: '将根据新条件重新编译机器校验。',
				ACTIVE_HINT: '智能体会参考',
				RETIRED_HINT: '自现在起撤回',
				REASON: '变更原因',
				REASON_HINT: '与新版本一同保存并显示在历史中。',
				NO_CHANGES: '尚无更改。',
				SAVE: '保存新版本',
				SAVED: '已保存为 v{{version}}，自现在起生效；较早的分诊保留之前的版本。',
			},
			LEARNING_DETAIL: {
				TITLE: '经验',
				EDIT: '编辑',
				CLOSE: '关闭',
				EFFECTIVE: '自 {{date}} 起生效',
				SUPPORT: '支持数：{{support}}',
				CONSISTENCY: '一致性 {{pct}}',
				MANUAL_FIELDS: '人工设定：{{fields}}',
				CONDITION: '条件',
				EXCEPTIONS: '例外',
				CHECKS: '机器校验',
				CHECKS_HINT: '将条件编译为智能体可在告警时证据上检验的事实；其余部分由智能体判断。',
				CHECKS_STALE: '条件已被编辑：其机器校验正在重新编译，完成前不会使用。',
				WHEN: '当',
				UNLESS: '除非',
				MANUAL: '由智能体判断',
				NO_CHECKS: '无可机器校验的条件',
				GROUPS: '其告警涉及的传感器组',
				TYPICAL_TAGS: '典型位号',
				QUOTES: '摘自审核备注',
				GRAPH: '知识图谱邻域',
				GRAPH_MISSING: '尚未写入知识图谱。',
				REL_DETECTOR: '对应检测器',
				REL_FLOC: '所在功能位置',
				REL_SUPERSEDES: '取代',
				NO_LINKS: '无检测器、位置或早期版本关联。',
				SIMILAR: '相似经验',
				NO_SIMILAR: '没有语义相近的生效经验。',
				OPEN_SIMILAR: '打开此经验',
				ASOF_NOTE: '版本不会被就地修改：时间 t 的分诊使用 t 时生效的版本。',
				NOW: '至今',
				CHANGED: '变更：',
				SHOW_DIFF: '显示规则差异',
				HIDE_DIFF: '隐藏差异',
				F_TITLE: '标题',
				F_RULE: '规则',
				F_DISPOSITION: '处置',
				F_STATUS: '状态',
				F_CONDITION: '条件',
				F_EXCEPTIONS: '例外',
				F_SUPPORT: '支持数',
				SHOW_ALL_SOURCES: '显示全部 {{count}} 条',
			},
			PID: {
				CLICK_TO_PLOT: '点击绘图',
				NO_HISTORIAN_DATA: '无历史数据',
				MORE_TAGS: '此项目还有 {{count}} 个标签',
				NO_DATA_AT_ALERT: '报警前 72 小时内无读数',
				CLICKABLE_COUNT: '{{total}} 个标签中有 {{clickable}} 个有数据',
				TAGS_FAILED: '无法加载此图纸的标签',
				HIDE_LEGEND: '隐藏图例',
				SHOW_LEGEND: '显示图例',
				LEGEND_DATA: '有历史数据（可点击）',
				LEGEND_NO_DATA: '无历史数据',
				LEGEND_ALERT: '报警标签',
				LEGEND_RELATED: '与报警同一设备/回路',
				LEGEND_SUGGESTED: '建议查看',
				ONLY_WITH_DATA: '仅显示有数据的标签',
				SHEET_N: '图纸 {{sheet}}',
				BACK: '返回',
				BACK_TIP: '返回上一张图纸（历史中 {{count}} 张）',
				SHOW_PANEL: '显示面板',
				HIDE_PANEL: '隐藏面板',
				FROM_UPSTREAM: '来自上游',
				TO_DOWNSTREAM: '去往下游',
				RESIZE: '拖动以调整面板宽度',
				ON_DRAWING: '图纸上',
				LOCATE_ITEM: '在图纸上显示',
				FROM_OTHER_SHEET: '在另一张图纸上选中',
				ITEM_TAGS: '此项目的标签（{{count}}）',
				SWITCH_TIP: '点击改为绘制此标签',
				ADD_TO_CHART: '添加到图表',
				REMOVE_FROM_CHART: '从图表移除',
				ON_CHART: '图表中 {{count}} / {{max}}',
				ALERT_WINDOW: '报警时间 {{asOf}} · 前 3 天至后 1 天',
				LAST_DAYS: '可用数据的最近 {{days}} 天',
				CHART_FULL: '最多可同时绘制 {{max}} 个标签',
				TIME_SERIES: '时间序列',
				LOOK_NEXT: '下一步查看',
				CONTEXT_FAILED: '无法加载相关标签',
				CONTEXT_UNKNOWN: '此标签不在传感器目录中',
				LOOP_N: '回路 {{loop}}',
				SAME_LOOP: '同一回路',
				SAME_EQUIPMENT: '同一设备',
				UPSTREAM: '上游单元',
				DOWNSTREAM: '下游单元',
				SERVICE: '服务公用工程',
				NONE_WITH_DATA: '没有带历史数据的',
				SHOW_MORE: '再显示 {{count}} 个',
				NO_UNITS: '无连接单元',
				HOPS: '{{count}} 跳',
				OPEN_DRAWING: '打开图纸',
				MORE_SENSORS: '还有 {{count}} 个传感器',
				TWIN: '并列机组：{{unit}}',
				TWIN_ON_CHART: '并列机组标签已在图表中',
				COMPARE_TWIN: '与并列机组比较',
				TWIN_NO_TAG: '{{unit}} 上没有已知的同位置标签',
				TWIN_SAME_MEASURE: '{{unit}} 上相同测量量',
				LOCATE_ON_SHEET: '在此图纸上显示',
				OTHER_CONNECTORS: '公用工程与泄放（{{count}}）',
				OTHER_CONNECTORS_TIP: '此图纸上的控制、公用工程和泄放连接',
				SIDE_BY_SIDE: '并排显示',
				SIDE_BY_SIDE_TIP: '全屏：图纸与面板并排显示',
				REL: {
					ALERT: '报警标签',
					LOOP: '同一回路',
					EQUIPMENT: '同一设备',
				},
			},
			BATCH: {
				TOGGLE: '批量',
				TOGGLE_HINT: '批量模式：列出同一 FLOC 在时间窗口内的告警组，并对每组一起分诊',
				TOGGLE_OFF_HINT: '返回单条告警列表',
				WINDOW_LABEL: '{{hours}} 小时窗口',
				WINDOW_HINT: '批量窗口：同一 FLOC 上在首条告警后这么多小时内的告警组成一组',
				WINDOW_TITLE: '批量窗口',
				WINDOW_OPTION: '{{hours}} 小时',
				HELP: '告警按 FLOC 分组。窗口从组内第一条告警开始；截止时间为最新的成员，因此每个成员都按当时已知的信息评估。一次调查覆盖整个组，并为每个成员给出各自的处置。分组使用日期、搜索、FLOC、目标和状态筛选。',
				GROUPS_TITLE: '批次 · {{hours}} 小时窗口',
				GROUPS_COUNT: '（{{groups}} 组 · {{considered}} 条告警中的 {{alerts}} 条）',
				NEWEST_FIRST: '最新优先',
				EMPTY: '没有批次',
				EMPTY_HINT: '在当前筛选下，没有 FLOC 在窗口内有两条或以上告警。',
				COL_SIZE: '数量',
				COL_SPAN: '时间跨度',
				COL_DETECTORS: '检测器',
				COL_CLASSES: '当前分类',
				COL_TAG: '位号',
				COL_AS_OF: '截至',
				TOGGLE_MEMBERS: '显示或隐藏此组的告警',
				N_ALERTS: '{{count}} 条告警',
				SPAN: '{{span}} 内 {{count}} 条告警',
				MINUTES: '{{count}} 分钟',
				HOURS_MINUTES: '{{hours}} 小时 {{minutes}} 分钟',
				CUTOFF: '截止',
				N_UNTRIAGED: '{{count}} 条未分诊',
				ALL_TRIAGED: '全部已分诊',
				RUNNING: '批量运行进行中',
				TRIAGE_BATCH: '分诊批次（{{count}}）',
				TRIAGE_SELECTED: '分诊所选 {{count}} 条',
				TRIAGE_HINT: '以最新成员为截止时间，对这些告警进行一次联合调查；每条告警获得各自的处置',
				SELECT_MIN: '请至少选择此组的 {{count}} 条告警',
				SELECT_MAX: '一个批次最多 {{count}} 条告警：最多选择 {{count}} 条',
				PAGE_HINT: '分页按组计数',
				RANGE: '第 {{start}}–{{end}} 组，共 {{total}} 组',
				DONE: '已分诊 {{count}} 条告警的批次',
				GATED: '批次未分析：数据质量检查阻止了此次运行（见画布）',
				FAILED: '批量运行未完成',
				ROW_CHIP: '{{count}} 条批次',
				ROW_CHIP_TIP: '最近一次运行将此告警与其 FLOC 上的 {{count}} 条告警一起分诊（一次调查，每条告警一个处置）',
				CARD_TITLE: '分组分诊',
				CARD_META: '{{count}} 条批次 · {{hours}} 小时窗口 · 截止 {{time}}',
				EPISODE_CLASS: '事件',
				EPISODE_HINT: '整个组的分类',
				THIS_MEMBER: '此告警',
				MEMBERS: '批次中的告警',
				THIS_ALERT: '此告警',
				NOW_IN_GROUP: '此告警目前位于其 FLOC 上 {{count}} 条告警的组中（{{hours}} 小时窗口，{{span}} 分钟，{{untriaged}} 条未分诊）。',
				MORE_DETECTORS: '另有 {{count}} 个',
				TRIAGE_WITH: '与此 FLOC 上的 {{count}} 条告警一起分诊',
			},
			UEV: {
				TITLE: '证据与反馈',
				HINT: '您在此添加的现场观察、SAP通知、历史库标签和文件会在重新运行时提供给智能体，标记为用户提供，并与截止时刻记录分开加权。',
				BADGE_N: '{{count}} 项',
				BADGE_CHANGED: '改变了结论',
				EMPTY: '尚未添加证据。',
				LOAD_ERROR: '无法加载证据',
				ADD: '添加证据',
				ADDED: '证据已添加',
				UPDATED: '证据已更新',
				REMOVED_NOTICE: '证据已移除',
				TYPE_OBSERVATION: '反馈 / 观察',
				TYPE_SAP: 'SAP通知',
				TYPE_TAG: '历史库标签',
				TYPE_FILE: '文件',
				TEXT_LABEL: '观察或测量到的内容',
				TEXT_PLACEHOLDER: '例如：现场压力表读数30 scfm；排放阀内漏',
				CONTEXT_LABEL: '与此告警的关系',
				CONTEXT_PLACEHOLDER: '给智能体的背景说明（可选）',
				NOTIF_LABEL: '通知编号',
				LOOKUP: '查询',
				NOTIF_NOT_FOUND: '未找到通知',
				NOTIF_AFTER: '告警后 {{hours}} 小时创建',
				NOTIF_BEFORE: '告警前创建',
				NOTIF_NAMES_TAG: '提及告警标签 {{tag}}',
				FLOC_EQUIPMENT: '同一设备',
				FLOC_UNIT: '同一单元',
				FLOC_FACILITY: '其他设备',
				RAISED: '创建于 {{time}}',
				COMPLETED: '完成于 {{time}}',
				TAG_LABEL: '历史库标签',
				TAG_PLACEHOLDER: '搜索标签（例如 LIC0920）',
				TAG_HINT: '智能体按告警时刻读取该标签，与其他标签相同。',
				FILE_CHOOSE: '选择文件',
				FILE_HINT: 'PDF、图片、文本、CSV、Word 或 Excel，最大 10 MB',
				FILE_TYPE_ERROR: '不支持的文件类型：请上传 PDF、PNG、JPG、文本、CSV、Word 或 Excel',
				FILE_SIZE_ERROR: '文件超过 10 MB',
				FILE_META: '{{pages}} 页，{{size}} KB',
				FILE_NO_TEXT: '未提取到文本（{{note}}）',
				OPEN_FILE: '打开文件',
				SAVE: '添加',
				CANCEL: '取消',
				EDIT: '编辑',
				REMOVE: '移除',
				REMOVE_CONFIRM: '移除此项？早期版本会保留，使用过它们的运行仍会引用。',
				REASON: '原因（可选）',
				SAVE_EDIT: '保存为新版本',
				VERSIONS: '历史',
				REMOVED: '已移除',
				SHOW_REMOVED: '显示已移除',
				HIDE_REMOVED: '隐藏已移除',
				BY: '{{name}} 添加 · {{time}}',
				EDITED_BY: 'v{{n}}（{{name}}） · {{time}}',
				AFTER_CUTOFF: '截止时刻之后',
				RERUN: '使用证据重新运行',
				RERUN_HINT: '使用 {{count}} 项有效证据重新运行分诊智能体，并在运行画布中实时跟踪',
				RERUN_BATCH: '重新运行批次（{{count}} 个告警）',
				RERUN_BATCH_HINT: '使用所有成员的有效证据重新运行该批次',
				LAST_RUN: '上次重新运行使用了 {{refs}}',
				OUTCOME_CHANGED: '结论已改变：{{from}} → {{to}}',
				OUTCOME_UNCHANGED: '结论未变',
				OUTCOME_NOT_ATTRIBUTED: '结论已改变（{{from}} → {{to}}），未归因于证据',
				OUTCOME_NO_BASELINE: '智能体表示证据决定了结论',
				AGENT_LINE: '来自使用用户证据 {{refs}} 的重新运行的结论',
				NODE: '用户证据',
				CANVAS_BADGE: '用户证据 · {{count}}',
				CANVAS_HINT: '使用用户提供证据的重新运行：{{refs}}',
				PICKER: '用户证据',
				INSPECTOR_ITEMS: '使用的项目（{{count}}）',
				INSPECTOR_BASELINE: '无此证据时的结论：{{cls}}',
				INSPECTOR_NO_BASELINE: '此前没有不含用户证据的运行',
				INSPECTOR_AUDIT: '用户提供的项目不进入截止时刻视图；泄漏检查仅覆盖框架事实。',
				ATTRIBUTION_USER_EVIDENCE: '由证据改变：{{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: '由证据决定（无先前运行）',
				ATTRIBUTION_NOT_ATTRIBUTED: '已改变，未归因：{{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: '未改变',
				EFFECT_CHANGED_ANSWER: '改变了结论',
				EFFECT_SUPPORTED_ANSWER: '支持结论',
				EFFECT_CONTRADICTED: '矛盾，未采纳',
				EFFECT_NO_BEARING: '无关',
				EFFECT_NOT_ADDRESSED: '未处理',
			},
			WATCH: {
				STATUS_WATCHING: '观察中',
				ACTION: '观察',
				ACTION_HINT: '稍后结合此次评估之后记录的数据再次查看此告警',
				UNWATCH: '取消观察',
				DIALOG_TITLE: '观察告警',
				DIALOG_LEAD: '告警将保持观察直到到期时间；之后可结合此次评估以来记录的所有数据重新评估。',
				ASSESSED_AS_OF: '当前评估截至',
				ASSESSED_HINT: '您正在查看的评估的截止时间。预设从该时间起算，而不是从今天。',
				LOOK_AGAIN: '再次查看',
				PRESET_HOURS: '+{{count}} 小时',
				PRESET_DAYS: '+{{count}} 天',
				PRESET_CUSTOM: '日期和时间',
				DUE_AT: '到期时间',
				DUE_LINE: '到期 {{time}}',
				DUE_BEFORE_ASSESSMENT: '必须晚于评估时间',
				SUGGESTED: '智能体建议',
				USE_SUGGESTION: '用作原因',
				REASON: '原因',
				REASON_HINT: '到期时需要检查的内容（必填）',
				CONFIRM: '观察',
				SET_NOTICE: '告警已设为观察',
				BANNER_DUE: '观察已到期',
				BANNER_WAITING: '观察中',
				CHIP_DUE: '已到期 · {{time}}',
				CHIP_WAITING: '观察中 · {{time}} 到期',
				TIP_DUE: '观察中，自 {{time}} 起已到期：请结合新数据重新评估',
				TIP_WAITING: '观察至 {{time}}',
				SET_BY: '由 {{name}} 于 {{date}} 设置',
				BASELINE: '观察截至 {{time}} 的评估',
				CHECKING: '正在检查此后记录的内容…',
				NOTHING_NEW: '自评估以来尚未记录新内容。',
				LATER_ALERTS: '后续告警',
				BEYOND: '之后另有 {{count}} 条',
				OPEN_LATER: '打开此告警',
				SAP_RECORDS: 'SAP 记录',
				SUPERVISOR_REPORTS: '主管报告',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} 小时',
				ON_TAGS: '{{count}} 个位号',
				WINDOW: '{{from}} 至 {{to}} 的新数据',
				REASSESS: '结合新数据重新评估',
				REASSESS_HINT: '将截止时间移到到期时间（不晚于现在）后重新分诊；画布跟踪此次运行',
				REASSESS_WAIT: '观察到期后可用',
				NEW_DATA: '新数据',
				NEW_DATA_DOT: '已到期，且有评估以来记录的数据',
				FILTER_LABEL: '观察',
				FILTER_DUE: '已到期',
				FILTER_WAITING: '观察中（未到期）',
				REASSESSED_HEADER: '已重新评估，截至 {{time}}（首次评估截至 {{previous}}：{{cls}}）',
			},
			SHELL: {
				TOGGLE: '显示 HIL 标签',
				TOGGLE_HINT: '将人在回路（HIL）审核标签和备注作为列加入以便比较。仅为验证数据：从不作为分诊代理的输入。',
				VALIDATION_ONLY: 'HIL（人在回路）标签是验证数据，从不作为分诊代理的输入。',
				COLUMN: 'HIL 标签',
				NOT_VETTED: '未审核',
				NOT_VETTED_TIP: '此告警没有 HIL 标签',
				STATE: 'HIL 状态',
				COMMENT: '备注',
				ACTION_TAKEN: '已采取的措施',
				RELIABILITY: '可靠性',
				INHERITED: '继承自上级事件',
				AGREES: '与 HIL 一致',
				DIFFERS: '与 HIL 不同',
				AGREES_TIP: '我们的分类与 HIL 标签一致',
				DIFFERS_TIP: '我们：{{ours}} · HIL：{{shell}}',
				AGREEMENT: '在 {{compared}} 条已分诊中与 HIL 一致 {{agree}} 条',
				AGREEMENT_TIP: '已筛选、已分诊（非待处理）且带有 HIL 标签的告警，以及其中类别相同的数量。\nHIL 标签是验证数据，从不作为代理输入。',
				CARD_TITLE: 'HIL 审核',
				FILTER_LABEL: 'HIL 标签',
				FILTER_NONE: '未审核',
				COLUMN_COMMENT: 'HIL 备注',
			},
			FACTS: {
				TITLE: '已读取的证据 — 最早 → 最新（全部早于截止时间）',
				HINT: '此次运行从每个来源读取的事实的时间范围。每个查询都止于截止时间。',
				CUTOFF: '截止 {{time}}',
				COL_SOURCE: '来源',
				COL_OLDEST: '最早',
				COL_NEWEST: '最新',
				COL_GAP: '早于截止',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'SAP 通知单',
				SOURCE_SAP_WORKORDER: 'SAP 工单',
				SOURCE_SUPERVISOR_REPORT: '主管报告',
				SOURCE_ALERTS: '告警',
				SOURCE_MEMORY: '记忆',
				NOT_READ: '未读取事实',
				POST_ALERT: '告警后的记录',
				POST_ALERT_NONE: '未获取：每个查询都止于截止时间',
				AFTER_CUTOFF: '晚于截止时间',
				GAP_SECONDS: '{{count}} 秒',
				GAP_MINUTES: '{{count}} 分钟',
				GAP_HOURS: '{{count}} 小时',
				GAP_DAYS: '{{count}} 天',
			},
			SENSOR: {
				MEASURE: {
					temperature: '温度',
					pressure: '压力',
					differential_pressure: '差压',
					level: '液位',
					flow: '流量',
					vibration: '振动',
					axial_position: '轴向位置',
					speed: '转速',
					current: '电流',
					power: '功率',
					voltage: '电压',
					valve_position: '阀位',
					status: '状态',
					composition: '成分',
				},
				GROUP: {
					vibration: '振动',
					bearing_temperature: '轴承温度',
					axial_position: '轴向位置',
					speed_run: '转速与运行状态',
					lube_oil: '润滑油',
					seal_gas: '密封气',
					suction: '吸入',
					discharge: '排出',
					cooling: '冷却',
					anti_surge: '防喘振',
					scrubber_level: '洗涤器液位',
					control_valve: '控制阀',
					motor_electrical: '电机电气',
					turbine: '涡轮',
				},
				ROLE: {
					process_value: '过程值',
					setpoint: '设定值',
					controller_output: '控制器输出',
					limit: '限值',
					mode: '模式',
					totaliser: '累计量',
				},
				GROUP_NONE: '其他',
				COL_SENSOR: '传感器',
				CONVENTION_ONLY: '仅依据位号命名',
				TIP_MEASURES: '测量：{{value}}',
				TIP_WHY: '监测原因（技术监测计划）',
				TIP_NO_REASON: '此传感器没有记录监测原因。',
				TIP_CONVENTION: '仅由 P&ID 位号命名规则描述，监测计划未涵盖。',
				TIP_ACTION: '建议措施',
				TIP_UNIT: '单位：{{unit}}',
				TIP_LIMITS: '限值：{{value}}',
				TIP_SOURCES: '来源：{{value}}',
				TIP_LOW: '仅位号名称描述此传感器，因此其含义不太确定。',
				LIMIT_LOW: '下限',
				LIMIT_HIGH: '上限',
			},
			CONNECTED: {
				USUALLY_LEADS: '通常超前 {{t}}（r {{r}}）',
				USUALLY_LAGS: '通常滞后 {{t}}（r {{r}}）',
				USUALLY_WITH: '通常与其同步变化（r {{r}}）',
				NOT_COUPLED: '通常不相关（r {{r}}）',
				USUAL_DELAY: '以其通常的延迟变化',
				NOT_USUAL_DELAY: '未按通常的延迟变化',
				COUPLING_HINT: '在运行基线期间该传感器与告警位号的通常关系：相关性最强时的延迟及其 r 值。“通常的延迟”将本次时序与之比较。',
				TITLE: '相连系统',
				VERDICT: {
					upstream_led: '上游先发生变化',
					service_related: '配套公用工程与其一同变化',
					downstream_followed: '下游随之变化——变化始于此处',
					moved_together: '相连单元一同变化',
					isolated: '相连系统保持稳定——问题局限于此设备',
					background_drift: '相连单元已偏离基线数天（背景）',
					moved_unordered: '相连单元有变化，先后顺序不明',
					insufficient: '传感器过少，无法判断',
				},
				UPSTREAM: '上游',
				DOWNSTREAM: '下游',
				SERVICE: '配套公用工程',
				REL_UPSTREAM: '上游',
				REL_DOWNSTREAM: '下游',
				REL_SERVICE: '公用工程',
				AS_OF: '按告警时刻读取——不使用告警之后的记录',
				OF_SENSORS: '/ {{total}} 个传感器有数据',
				RATIO_HINT: '相邻单元的接口传感器中，在告警前有可用读数的数量',
				ANCHOR_ONSET: '告警位号起始',
				PLOT: '告警位号与接口传感器',
				PLOT_TITLE: '相连系统图',
				PLOT_CAPTION: '黑色 = 告警位号 · 灰色阴影 = 机器停机 · 虚线 = 告警位号起始 · 灰色带 = 运行基线 ±3 sd 以内。点击放大。',
				NEIGHBOURS: '相连单元',
				NEIGHBOURS_META: '已读取 {{total}} 个相连单元，{{moved}} 个有变化',
				EXPAND_ALL: '全部展开',
				COLLAPSE_ALL: '收起未变化项',
				NO_NEIGHBOURS: '未读取任何相连单元。',
				OPEN_UNIT: '在工艺视图中打开此单元',
				LINK_HIGH: '连接：高',
				LINK_MEDIUM: '连接：中',
				LINK_LOW: '连接：低',
				LINK_HINT: '图纸对这两个单元相连的把握程度',
				STATE_MOVED: '有变化',
				STATE_HELD: '稳定',
				STATE_NO_DATA: '无数据',
				SENSORS_N: '{{count}} 个传感器',
				COL_SENSOR: '接口传感器',
				COL_STATE: '状态',
				COL_Z_LAST: 'z 末值',
				COL_Z_LAST_HINT: '告警前最后一个读数相对运行基线的偏差（标准差倍数）',
				COL_Z_DAY: 'z 24 小时',
				COL_Z_DAY_HINT: '告警前 24 小时内相对运行基线的中位偏差（标准差倍数）',
				COL_ONSET: '偏离开始',
				NO_READINGS: '告警前没有可用读数',
				RELIEF: '泄放总管',
				MORE: '显示更多',
				LESS: '收起',
				DUR_MIN: '{{n}} 分钟',
				DUR_H: '{{n}} 小时',
				DUR_D: '{{n}} 天',
				TIMING_BEFORE: '比告警位号早 {{t}} 变化',
				TIMING_BEFORE_SHORT: '早 {{t}}',
				TIMING_AFTER: '比告警位号晚 {{t}} 变化',
				TIMING_AFTER_SHORT: '晚 {{t}}',
				TIMING_TOGETHER: '与告警位号同时变化',
				TIMING_TOGETHER_SHORT: '同时',
				TIMING_EARLIER: '比告警位号早 {{t}} 开始——背景',
				TIMING_EARLIER_SHORT: '早 {{t}} · 背景',
				TIMING_EARLIER_NO_DUR: '远早于告警位号开始——背景',
				TIMING_EARLIER_NO_DUR_SHORT: '很早 · 背景',
				TIMING_HELD: '保持在基线附近',
				TIMING_NO_DATA: '告警前没有可用读数',
				TIMING_UNCLEAR: '有变化，时间不明',
			},
			GAPS: {
				TITLE: '缺少位号的预期传感器（{{count}}）',
				LINK: '缺少位号的预期传感器（{{count}}）',
				LINK_HINT: '机器模板预期但没有历史库位号的传感器',
				EXPLAIN: '这些是 C3 资产模板为该机器预期的传感器，但无法匹配到历史库位号 ID，因此无法读取其数据。此列表仅供参考，不能在此编辑。',
				NONE: '没有未匹配的传感器。',
				COL_MACHINE: '机器',
				COL_SENSOR: '预期传感器',
				COL_FAILURE_GROUP: '故障组',
				COL_UNIT_TYPE: '单位类型',
			},
			FLOC: {
				LEVEL_1: '资产',
				LEVEL_2: '设施',
				LEVEL_3: '系统',
				LEVEL_4: '子系统',
				LEVEL_5: '设备',
				PATH: 'FLOC 路径',
				LEGEND_TITLE: 'FLOC 层级',
				LEGEND_HINT: '每个位置都由其 SAP 功能位置（FLOC）代码标识。层级从资产一直到设备。',
				TREE_FILTER_PLACEHOLDER: '查找系统或设备（名称或 FLOC）…',
				SCOPE_N: '{{count}} 个 FLOC',
				SCOPE_TIP: '队列已按此 FLOC 及其下所有内容筛选',
				SCOPE_CLEAR: '清除位置筛选',
				UNPLACED_TIP: '没有功能位置的告警',
				ALERTS_TOTAL: '{{count}} 条告警',
				SOURCE_ASSET_CODE: '根据资产名称代码定位',
				SOURCE_WELL: '根据海底井号定位',
				SOURCE_TRAIN: '根据系列或撬装代码定位',
				SOURCE_TAG_MAPPING: '根据历史库位号映射定位',
				EXTRACT_HAD: '告警数据中的 FLOC 为 {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: '关键传感器（{{count}}）',
				KEY_SENSORS_HINT: '最能反映该单元状态的传感器',
				TITLE: '工艺视图',
				BUTTON: '工艺视图',
				OPEN: '打开工艺视图',
				OPEN_HINT: '厂区与工艺单元，按 P&ID 上的连接关系相连',
				BACK: '返回队列',
				UNITS_META: '{{areas}} 个区域中的 {{units}} 个工艺单元',
				LAYERS: '连接图层',
				SECONDARY: '显示次要连接（{{count}}）',
				RELIEF: '泄放 / 火炬（{{count}}）',
				UTILITY: '公用工程（{{count}}）',
				CONTROL: '控制信号（{{count}}）',
				TARGET_ONLY: '仅目标',
				LEGEND_BACKBONE: '工艺连接',
				LEGEND_LINK: '次要连接',
				LEGEND_RELIEF: '泄放 / 火炬',
				LEGEND_UTILITY: '公用工程',
				LEGEND_CONTROL: '控制信号',
				LEGEND_UP: '上游',
				LEGEND_DOWN: '下游',
				LEGEND_TARGET: '含目标 FLOC',
				LEGEND_LOAD: '告警量',
				LANE_META: '单元：{{units}} · 告警：{{alerts}}',
				LANE_TIP: '{{units}} 个单元，{{alerts}} 条告警，{{targets}} 个单元含目标 FLOC',
				EXPAND_LANE: '展开 {{name}}',
				COLLAPSE_LANE: '收起 {{name}}',
				LINKS: '工艺单元之间的连接',
				EDGE_ARIA: '从 {{from}} 到 {{to}} 的连接，{{medium}}',
				UNIT_ALERTS: '{{total}} 条告警（范围内 {{scope}}）',
				IN_SCOPE_N: '范围内 {{count}}',
				TARGETS_N: '{{count}} 个目标 FLOC',
				SHEET_N: '图纸 {{sheet}}',
				CHIP: '工艺：{{name}}',
				CHIP_HINT: '在工艺视图中打开此单元',
				UNITS_LABEL: '工艺单元',
				N_MORE: '另有 {{count}} 个',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: '介质',
				CONFIDENCE: '置信度',
				CONF_HIGH: '高',
				CONF_MEDIUM: '中',
				CONF_LOW: '低',
				WEAK: '弱连接',
				ONE_END: '仅在一张图纸上出现',
				TYPE: '类型',
				LAYER_BACKBONE: '工艺连接',
				LAYER_LINK: '次要连接',
				LAYER_RELIEF: '泄放 / 火炬',
				LAYER_UTILITY: '公用工程',
				LAYER_CONTROL: '控制信号',
				CONNECTORS_N: '图纸上有 {{count}} 个连接符',
				EVIDENCE_LOADING: '正在读取图纸依据…',
				PANEL_ARIA: '工艺单元详情',
				LOADING: '加载中…',
				SHOW_ALERTS: '显示此单元的告警',
				OPEN_EXPLORER: '在资产浏览器中打开',
				ALERTS: '告警',
				NO_ALERTS: '没有告警',
				DRAWINGS: '图纸（{{count}}）',
				NO_DRAWINGS: '此单元没有关联图纸',
				OPEN_DRAWING: '打开 P&ID',
				FLOCS: 'FLOC（{{count}}）',
				NO_FLOCS: '此单元没有关联 FLOC',
				OPEN_NODE: '在资产浏览器中打开',
				SHOW_FLOC_ALERTS: '显示此 FLOC 的告警',
				SHARED_FLOCS: '与其他单元共用（{{count}}）',
				INBOUND: '流入（{{count}}）',
				OUTBOUND: '流出（{{count}}）',
				NO_CONNECTIONS: '图纸上未找到连接',
				SHOW_ALL: '显示全部 {{count}} 项',
				SHOW_FEWER: '收起',
			},
			SEARCH_ALERTS_PLACEHOLDER: '搜索告警、ID、定义 ID、位号、FLOC…',
			CANVAS: {
				CAUSAL: {
					QUERIES: '问题（{{n}}）',
					COL_HYPOTHESIS: '假设',
					COL_FACET: '方面',
					COL_QUERY: '问题',
					COL_ADMITTED: '已采纳',
					NOTHING: '未采纳',
					ADMITTED: '已采纳的摘录（{{n}}）',
					EXCERPTS_FROM_TRACE: '摘录来自步骤追踪（前六条）；被拒绝的结果会在运行文档加载后显示。',
					REJECTED: '被拒绝的结果（{{n}}）',
					NONE_REJECTED: '没有被拒绝的结果。',
					FACET_DESIGN_BASIS: '设计基础 / 运行范围',
					FACET_ORIGINATING_CHANGE: '起因变更',
					FACET_MECHANISM_SENSITIVITY: '机理敏感性',
					FACET_PROTECTION_DETECTION: '保护 / 检测',
					FACET_SYMPTOM_DIAGNOSTIC: '症状 / 诊断',
					FACET_CORRECTIVE_ACTION: '纠正措施',
				},
				TIER: {
					STAGE_QUICK: '阶段 1 · 快速分诊（迷你智能体）',
					STAGE_DEEP: '阶段 2 · 深入调查',
					QUICK_ANSWER: '快速答案',
					FINAL_ANSWER: '最终答案',
					OUTCOME: '结果',
					ACCEPTED: '已采纳',
					ESCALATED: '已升级',
					ROUTE_ACCEPTED: '已采纳 → 结果',
					ROUTE_ESCALATED: '已升级 → 阶段 2',
					NO_GATE: '无关口（仅快速分诊）',
					DECIDING: '正在检查快速答案…',
					WAITING: '等待快速答案',
					NOT_NEEDED: '无需执行 — 快速答案已通过关口，节省了深入调查的时间和令牌。',
					NOT_RUN: '未执行 — 本次运行仅为快速分诊。',
					WOULD_HAVE_RUN: '原本会执行',
					DEEP_SPECIALISTS: '慢速专家',
					SKIP_VERDICTS: '重新检查判定',
					SKIP_ADJUDICATION: '完整性检查与第二次裁定',
					CHECK_NO_ACTION: '无需行动的答案',
					CHECK_CONFIDENCE: '置信度',
					CHECK_NOT_CAPPED: '未被封顶',
					CHECK_MODEL: '模型已作答',
					CHECK_NO_REAL_EVENT: '无真实事件判定',
					CEILING: '上限 {{pct}}',
					RULE_FALLBACK: '规则回退',
					QUICK_NODE_NOTE: '阶段 1 · 快速分诊：这是迷你智能体在关口之前的处理。',
					ESCALATED_NOTE: '已升级：至少一项检查未通过，因此执行了深入调查。',
					ACCEPTED_NOTE: '已采纳：所有检查均通过；快速答案即为结果。',
					CHECKS: '关口检查',
					COL_CHECK: '检查',
					COL_VALUE: '值',
					COL_THRESHOLD: '阈值',
					COL_RESULT: '结果',
					PASSED: '通过',
					FAILED: '未通过',
					REASONS: '升级原因',
					QUICK_VS_FINAL: '快速答案与最终答案',
				},
				TITLE: '运行画布',
				OPEN: '打开画布',
				OPEN_HINT: '逐步跟踪本次运行：每个代理、模型调用和查询',
				BACK: '返回警报',
				RUN_PICKER: '运行',
				RUN_PICKER_EMPTY: '尚无运行记录',
				LIVE: '实时',
				LIVE_HINT: '正在实时跟踪运行（每 1.5 秒刷新）',
				ELAPSED: '已用时',
				DURATION: '耗时',
				TOKENS: '输入 {{input}} / 输出 {{output}} 个 token',
				EVALUATION: '评估',
				EVENTS_N: '{{count}} 个事件',
				EVENTS_HINT: '{{llm}} 次模型调用 · {{lookups}} 次查询',
				ZOOM_FIT: '适应宽度',
				ZOOM_100: '实际大小',
				POLL_ERROR: '无法获取新事件：{{error}} — 正在重试',
				LOADING: '正在加载运行…',
				NO_RUNS: '该警报尚无运行记录',
				NO_EVENTS: '本次运行未记录任何事件（早于运行画布功能）',
				PICK_NODE: '选择一个节点，查看其输入与输出',
				IN_PROGRESS: '分诊代理正在运行。即使离开此页面，运行也会继续。',
				STALLED_NOTICE: '与运行失去联系；刷新页面后将显示结果。',
				RECONSTRUCTED: '根据已保存的追踪记录重建：本次运行早于事件流，因此没有输入、输出、模型调用和查询信息。',
				PASS_N: '第 {{n}} 轮',
				ROUND_N: '第 {{n}} 回合',
				STATUS: {
					RUNNING: '运行中',
					COMPLETED: '已完成',
					FAILED: '失败',
					GATED: '未分析',
					PENDING: '待处理',
					NO_DATA: '无数据',
					SKIPPED: '已跳过',
					STALLED: '连接中断',
				},
				COL: {
					PRE_RUN: '预处理',
					RESOLVE: '解析与信号',
					SPECIALISTS: '专项代理',
					VERDICTS: '判定',
					LOOP: '推理循环',
					DECISION: '决策',
				},
				NODE: {
					LIBRARY_CAUSAL: '资料库 · 因果依据',
					ESCALATION: '升级关口',
					LIBRARY: '资料库专家',
					CONNECTED: '相连系统',
					GATE: '数据质量门',
					TOPOLOGY: '拓扑',
					EVIDENCE: '证据',
					VIEW: '截止时点视图',
					FINAL: '结果',
					RESOLVER: '解析器',
					SIGNAL: '信号',
					COHORT: '同期警报',
					MAINTENANCE: '维护',
					MANUAL_PRECEDENT: '告警先例',
					LEARNINGS: '经验',
					PROFILE: '设备档案',
					MULTIVARIATE: '多变量',
					TMP: 'TMP',
					SHIFT_DPR: '班次与日报',
					VISUAL: '视觉分析',
					VERDICTS: '判定',
					HYPOTHESIZE: '假设',
					INVESTIGATE: '调查',
					COMPLETENESS: '完整性',
					ADJUDICATOR: '裁决',
					SUPERVISOR: '总控',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} 条摘录 · {{queries}} 个问题',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} 段摘录 · {{docs}} 份文档',
					LIBRARY_LIMITS: '{{n}} 段摘录 · {{limits}} 个限值',
					GATE_PASS: '通过',
					GATE_FAIL: '未通过',
					TAGS_N: '{{count}} 个标签',
					RECORDS_N: '{{count}} 条记录',
					WITHHELD_N: '{{count}} 条已排除',
					RESOLVED: '已解析',
					NOT_RESOLVED: '未解析',
					ALERTS_N: '{{count}} 条警报',
					FACTS_N: '{{count}} 条事实',
					PRIOR_N: '{{count}} 条先前',
					LEARNINGS_N: '{{count}} 条经验',
					LOADED: '已加载',
					NONE: '无',
					MOVED_N: '{{of}} 个中有 {{moved}} 个变动',
					VERDICTS_N: '{{count}} 项判定',
					LOOKUPS_N: '{{count}} 次查询',
					CHECKS_N: '{{of}} 项检查完成 {{ran}} 项',
					SPECIALISTS_N: '{{of}} 个专项代理中 {{n}} 个',
				},
				BATCH_BADGE: '{{floc}} 上的 {{count}} 条告警批次',
				BATCH_HINT: '作为同一事件一起分诊：{{ids}}',
				REASSESS_BADGE: '截至 {{t}} 的重新评估',
				REASSESS_HINT: '先前的评估：{{cls}}',
				ZONE: {
					EVIDENCE: '证据收集',
					PARALLEL: '并行',
					LOOP: '推理循环',
					DECISION: '决策',
				},
				LOOP: {
					CAUSAL_HINT: '在推理板第一轮之后，资料库针对每个假设提出工程问题（设计基础、变更、敏感性、保护、诊断、纠正措施），只采纳与该仪表或设备相关的摘录作为 LIB-n 证据',
					BOARD: '假设看板',
					INVESTIGATOR: '调查员',
					ROUND_OF: '第 {{n}} 轮（最多 {{max}} 轮）',
					HINT: '看板提出假设并发起查询，调查员执行查询，看板重新加权',
					ROUNDS_USED: '{{n}} / 最多 {{max}} 轮',
					REQUESTS_N: '{{count}} 个请求',
					REWEIGH: '结果 → 重新加权',
					LEAD_HINT: '领先假设、其权重以及相对上一轮的变化',
					WEIGHING: '正在权衡假设…',
					NEXT_PASS: '下一轮：重新加权',
					CALL_NO_HINT: '本次运行中 {{tool}} 的第 {{n}} 次调用',
					CITED_HINT: '被下一轮引用：{{hyps}}',
					REPEAT_OF: '与第 {{n}} 轮相同',
					CALLING: '正在执行查询…',
					MOVED: '第 {{n}} 次评估：',
					MOVED_HINT: '看板在读取本轮结果后的变化',
					SETTLED_FIRST: '在第 {{n}} 次评估时已确定：无需查询',
					SETTLED_AT: '在第 {{n}} 次评估时已确定：无需更多查询',
					BUDGET_SPENT: '轮次预算已用完（{{max}}/{{max}}）',
					SHELF: '工具栏',
					SHELF_HINT: '调查员可以用不同参数多次调用任意工具',
					UNUSED: '本次运行未使用',
				},
				TOOL: {
					SEARCH_LIBRARY: '检索资料库',
					SEARCH_LEARNINGS: '搜索经验',
					CONNECTED_EQUIPMENT: '相连设备',
					UNIT_SENSORS: '单元传感器',
					FIND_SENSORS: '查找传感器',
					PARALLEL_SYSTEMS: '并行系统',
					SISTER_TRAIN: '姊妹列',
					UNIT_ALERTS: '单元告警',
					TAG_WINDOW: '位号时间窗',
					TAG_HISTORY: '位号历史',
					SEARCH_RECORDS: '搜索记录',
					SEARCH_REPORTS: '搜索报告',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: '告警时已生效的经验与现场作业手册规则，按与问题的语义接近程度排序。',
					CONNECTED_EQUIPMENT: '上游、下游或相邻的工艺单元（来自流程图连接符）、其接口传感器，以及它们是在告警位号之前、同时还是之后变化。',
					UNIT_SENSORS: '指定工艺单元按所请求的测量量逐个传感器的表现。',
					FIND_SENSORS: '针对某个问题存在哪些传感器，以及每个传感器测量什么。',
					PARALLEL_SYSTEMS: '孪生列（FGC A ↔ B、GLC A ↔ B …）：同一时段内的传感器和告警 —— 共因还是局部原因？',
					SISTER_TRAIN: '另一列或同一回路的冗余探头：共因还是局部原因？',
					UNIT_ALERTS: '告警前数小时内某单元（上游、下游、孪生）产生的监控告警。',
					TAG_WINDOW: '告警前最近 N 小时内任意位号的统计。',
					TAG_HISTORY: '位号在最多 180 天内越出正常范围的频率，以及之后是否有检修工作。',
					SEARCH_RECORDS: '在 SAP 通知和工单（1 年）及交接班报告（6 个月）中按关键词搜索。',
					SEARCH_REPORTS: '最多一年内的主管和生产报告；所有词必须匹配，返回相关段落。',
				},
				CALL: {
					NTH: '本次运行中 {{tool}} 的第 #{{n}} 次调用',
					ARGS: '参数',
					NO_ARGS: '无参数',
					REPEAT_NOTE: '与第 {{n}} 轮的请求相同：未重新执行，沿用了之前的结果。',
					CITED: '被第 {{n}} 次评估引用',
					CALLS_N: '{{count}} 次调用',
					ROUNDS_LIST: '轮次 {{rounds}}',
					NOT_USED: '调查员在本次运行中未使用此工具。',
					GROUPED: '{{count}} 次查询 · 使用的工具：{{tools}}',
					CARRIED: '沿用了前几轮的 {{count}} 条观察',
				},
				EVO: {
					TITLE: '证据如何改变判断：每次评估的假设权重',
					HYPOTHESIS: '假设',
					AFTER_N: '第 {{n}} 轮后 · {{count}} 次查询',
					NOT_ON_BOARD: '本次评估中不在看板上',
					AFTER_ROUND: '第 {{n}} 轮后（{{count}} 次查询）',
					CITES: '新证据引用了 {{calls}}',
					MOVE_AFTER: '第 {{n}} 轮后：',
					PRECEDED_BY: '之前的查询：',
				},
				INSPECTOR: {
					TAB_INPUT: '输入',
					TAB_OUTPUT: '输出',
					TAB_MODEL_CALLS: '模型调用',
					TAB_LOOKUPS: '查询',
					TAB_TRACE: '追踪',
					EMPTY: '空',
					NOT_STARTED: '此步骤尚未开始',
					NO_INPUT: '此步骤未记录输入',
					STILL_RUNNING: '仍在运行 — 步骤完成后显示输出',
					NO_OUTPUT: '未记录输出',
					HYPOTHESES_N: '{{count}} 个假设',
					REQUESTS: '请求的查询',
					WINDOWS: '各时间窗口读数',
					LEAK_CHECK: '泄漏检查：{{value}}',
					MACHINE_STATE: '机器状态',
					PACKAGE_TEXT: '模型读取的信号包',
					ANOMALY_TEXT: '异常模型文本',
					NO_LOOKUPS: '此步骤没有查询',
					RAW: '全部输出（数据）',
					NO_MODEL_CALLS: '此步骤没有模型调用',
					ATTEMPT_N: '第 {{n}} 次尝试',
					PROMPT: '提示词',
					PROMPT_SIZE: '{{chars}} 个字符，{{images}} 张图片',
					IMAGE_PART: '图片（{{kb}} KB）',
					RESPONSE: '响应',
					NO_TRACE: '此节点没有追踪记录',
				},
			},
			VALIDATION: {
				COLUMN: '验证',
				FILTER: '验证方式',
				HUMAN: '人工',
				AGENT: '智能体',
				NONE: '未分诊',
				HUMAN_VALIDATED: '人工已验证',
				HUMAN_CORRECTED: '人工已纠正',
				AGENT_VALIDATED: '智能体已验证',
				TIP_AGENT: '由智能体分诊，尚无人审核',
				TIP_HUMAN_UNKNOWN: '已由人员验证',
				TIP_REPLAY: 'HIL 标签由 {{reviewer}} 于 {{date}} 回放',
				TIP_UI: '{{reviewer}} 于 {{date}} 在 UptimeAI 中审核',
				TIP_CORRECTED: '人工纠正了智能体：{{agent}} → {{human}}',
				TIP_ABSTAINED: '智能体交由人工审核；人工分类为 {{human}}',
				TIP_AGREED: '人工同意智能体：{{human}}',
				CSV: {
					VALIDATED_BY: '验证方',
					REVIEWER: '审核人',
					REVIEW_SOURCE: '审核来源',
				},
			},
			REVIEW: {
				TITLE: 'SME 审核',
				SOURCE_REPLAY: 'HIL 标签（回放）',
				SOURCE_UI: '在 UptimeAI 中审核',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} 次审核',
				LABEL: '标签',
				RELIABILITY: '可信度：{{value}}',
				RELIABILITY_HIGH: '高',
				RELIABILITY_MEDIUM: '中',
				RELIABILITY_LOW: '低',
				RELIABILITY_HINT: '该标签作为真实依据的可信程度——人工标签也可能出错',
				ACTION_TAKEN: '已采取的措施',
				NO_LABEL: '未记录标签',
				AGENT_VS_HUMAN: '智能体 vs 人工',
				AGREEMENT_AGREE: '一致',
				AGREEMENT_DISAGREE: '不一致',
				AGREEMENT_ABSTAINED: '弃权',
				AGENT_CONFIDENCE: '智能体置信度 {{value}}',
				OUTCOMES: '之后 30 天内的 SAP 通知（事后）',
				REASONS: '原因',
				AGENT_SAW_CHART: '智能体的图表判断',
				AGENT_SAW_STATE: '当时的设备状态',
				LEARNINGS_CHANGED: '此次审核更新的经验（{{count}}）',
				EARLIER: '更早的审核',
				VERDICT: {
					CONFIRMED: '已确认',
					CONFIRMED_HINT: '智能体与人工选择了相同的分类。',
					AGENT_WRONG: '智能体有误',
					AGENT_WRONG_HINT: '以审核人的分类为准，智能体已被纠正。',
					AGENT_ABSTAINED: '智能体弃权',
					AGENT_ABSTAINED_HINT: '智能体交由人工审核；以人工标签确定分类。',
					HUMAN_LIKELY_WRONG: '人工可能有误',
					HUMAN_LIKELY_WRONG_HINT: '标记为无需处理，但 30 天内该设备出现了 SAP 通知；不纳入记忆。',
					CONTESTED: '有争议',
					CONTESTED_HINT: '智能体与人工意见不一致，后续证据也无法定论。',
					HUMAN_OVERRIDE: '人工覆盖',
					HUMAN_OVERRIDE_HINT: 'UptimeAI 中的人员选择了与智能体不同的分类，以其判断为准。',
				},
			},
			MEMORY: {
				SIMILAR: '相似 {{sim}}',
				SIMILAR_HINT: '不在此告警自身的范围内：因语义与告警相近而加入（相似度 0–1）',
				PROFILE: '检测器画像',
				TITLE: '已使用的运行记忆',
				CHIP: '记忆：{{learnings}} 条经验，{{precedents}} 个已审核先例',
				CHIP_HINT: '智能体参考的、在此警报之前已知的经验和人工审核先例',
				NO_LEARNINGS: '未应用经验',
				PRECEDENTS: '{{count}} 个已审核先例',
				SHOW_TRACE: '在追踪中查看',
			},
			LEARNINGS: {
				STATUS_RETIRED: '已停用',
				SCOPE_PLAYBOOK: '现场作业手册',
				SCOPE_PROFILE: '检测器画像',
				ALL_SCOPES: '全部范围类型',
				MEANING_PLACEHOLDER: '按语义搜索，例如：重启后的轴承温度',
				MEANING_SEARCH: '搜索',
				MEANING_HINT: '按与输入内容的语义接近程度（向量嵌入）对当前经验进行排序，而非精确匹配词语。按回车搜索；清空输入框可列出全部。',
				RANKED_BY: '按语义排序：“{{q}}”',
				COL_SIMILARITY: '相似度',
				SIMILARITY_HINT: '语义余弦相似度（0–1）；约 0.8 以上为高度相近',
				COL_LEARNING: '经验',
				COL_EDITED: '编辑人',
				EDITED_BY: '由 {{name}} 编辑',
				EDIT_REASON: '原因：{{reason}}',
				NO_DISPOSITION: '无（仅上下文）',
				N_ALERTS: '{{count}} 条告警',
				NO_MATCH: '没有语义相近的经验',
				NO_MATCH_HINT: '请换用其他词语，或清空搜索以列出全部经验。',
				BUTTON: '经验',
				BUTTON_HINT: '来自人工审核的经验与运行记忆',
				TITLE: '经验与运行记忆',
				SUBTITLE: '从同类警报的人工审核中提炼的规则；智能体仅参考每个警报之前已知的规则',
				REFRESH: '刷新',
				STAT_REVIEWS: '人工审核',
				STAT_REPLAYED: '已回放 {{count}} 个 HIL 标签',
				STAT_IN_APP: '{{count}} 条在 UptimeAI 中',
				STAT_AGREEMENT: '智能体 vs 人工',
				STAT_RECONCILIATION: '核对结果',
				STAT_LEARNINGS: '经验',
				STATUS_ACTIVE: '生效',
				STATUS_CANDIDATE: '候选',
				STATUS_CONTESTED: '有争议',
				SCOPE_SIGNAL: '信号',
				SCOPE_EQUIPMENT: '设备 + 检测器',
				SCOPE_DETECTOR: '检测器',
				SEARCH: '搜索范围、检测器或规则',
				N_SHOWN: '{{shown}} / {{total}}',
				EMPTY: '暂无经验',
				EMPTY_HINT: '人员审核已分诊的警报后，经验将显示在此。',
				COL_SCOPE: '范围',
				COL_SCOPE_TYPE: '范围类型',
				COL_DISPOSITION: '处置',
				COL_SUPPORT: '支持度',
				COL_SUPPORT_HINT: '与处置一致的审核数 / 范围内审核数 · 一致性',
				COL_STATUS: '状态',
				COL_EFFECTIVE: '生效时间',
				COL_CORRECTED: '纠正智能体',
				COL_CORRECTED_HINT: '人员纠正了智能体的审核数',
				COL_VERSION: '版本',
				RULE: '运行规则',
				AUTHOR: '作者：{{author}}',
				CLASS_COUNTS: '人工分类',
				REASONS: '原因',
				CHART_PATTERNS: '图表形态',
				MACHINE_STATES: '设备状态',
				SOURCE_ALERTS: '来源警报（{{count}}）',
				OPEN_ALERT: '打开警报',
				VERSIONS: '版本历史',
				SUPERSEDED: '被取代时间',
				CURRENT: '当前',
			},
			PROCESS: {
				TITLE: '工艺拓扑与层级',
				FLOW_SUMMARY: '上游 {{up}} · 下游 {{down}}',
				FLOW_SUMMARY_UNITS: '上游 {{up}} · 下游 {{down}}（工艺单元）',
				PROCESS_UNITS: '工艺单元（PEFS）',
				NO_PID_LINE: '数字化P&ID中未追踪到管线；连接来自流程图接续符',
				IN_UNIT: '工艺单元：{{name}}',
				SERVING: '公用工程',
				RELIEF: '泄放',
				UNIT_TIP: '{{hops}} 跳 · {{media}} · 置信度 {{confidence}}',
				SOURCE_PID: '设备流程来自数字化P&ID（单张图纸内追踪的管线）。',
				SOURCE_BOTH: '设备流程来自数字化P&ID（逐张图纸）；工艺单元来自PEFS跨图接续符，与关联系统分析所用视图相同。',
				HIERARCHY: '资产层级',
				LEVEL_SITE: '厂区',
				LEVEL_SYSTEM: '系统',
				LEVEL_SUBSYSTEM: '子系统',
				LEVEL_EQUIPMENT: '设备',
				LEVEL_PACKAGE: '成套装置',
				LEVEL_OTHER: '层级',
				NOT_IN_TREE: '不在资产树中',
				NOT_IN_TREE_HINT: '告警设备在 SAP 资产树中没有功能位置。',
				PARTIAL_TREE: '路径只有一部分能定位到资产树中。',
				SIBLINGS: '{{parent}} 中的其他 {{count}} 台设备',
				SHOW_ALL: '显示全部 {{count}} 项',
				SHOW_FEWER: '收起',
				N_TAGS: '{{count}} 个位号',
				NO_TREE_TAGS: '此节点上没有历史库位号',
				FLOW: '工艺流程',
				UPSTREAM: '上游',
				DOWNSTREAM: '下游',
				ALERT_EQUIPMENT: '告警设备',
				MEASURED_BY: '告警仪表',
				HOPS: '相距 {{count}} 级',
				NONE_UPSTREAM: '无上游',
				NONE_DOWNSTREAM: '无下游',
				NO_FLOW: '数字化 P&ID 中没有此设备的工艺流程连接',
				NOT_IN_PIDS: '在数字化 P&ID 中未找到该设备',
				NOT_IN_PIDS_HINT: '告警设备没有匹配的 P&ID，无法显示上下游。',
				CONNECTED: '相连项目',
				NO_CONNECTED: '数字化 P&ID 中没有其他项目与此设备相连。',
				EDGE_SERVES: '服务于',
				EDGE_SENSES: '检测',
				EDGE_CONTROLS: '控制',
				EDGE_PROTECTS: '保护',
				EDGE_SAME_LINE: '同一工艺管线',
				EDGE_MEASURES: '测量',
				EDGE_FLOWS_TO: '流向',
				EDGE_OTHER: '其他连接',
				CHART_TAGS: '在“位号”标签页中绘制此项目的位号',
				NO_TAGS_FOR_ITEM: '此项目没有关联的历史库位号',
				NO_DATA_TAGS: '资产树未给此项目分配位号',
				TAGS_FAILED: '无法加载此项目的位号',
				FROM_TREE: '位号数量来自资产树',
				CLICK_HINT: '点击项目以绘制其历史库位号（最多 8 个，有数据的优先）。',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: '按语义找到',
				FOUND_BY_MEANING_SIM: '按语义找到 · {{sim}}',
				FOUND_BY_MEANING_HINT: '混合检索：按词语和语义（向量嵌入）查找记录。此条记录由语义检索从同一子系统中加入；数字为其与告警的相似度（0–1）。',
				LEVEL_SHIFTS: '电平阶跃',
				LEVEL_SHIFTS_HINT: '截止时间前，建模位号跃迁到新水平并保持的时间点（幅度以基线标准差计，前均值 → 后均值）。',
				MODEL_CACHED: '模型已复用（每台机器每天训练一次）',
				MODEL_CACHED_HINT: '该机器当天已训练过模型，所用数据均早于本次截止时间；因此直接复用而未重新训练。',
				REGIMES: '按 {{tag}} 的运行工况分别拟合：{{parts}}（相距 {{sep}} 个标准差）',
				REGIMES_HINT: '运行位号呈现两个明显不同的运行水平（时间占比 @ 水平），因此分别学习各自的正常状态。',
				TRAINED_ON: '训练数据：{{from}} – {{to}}',
				WINDOW_3M: '3 个月',
				WINDOW_1W: '1 周',
				WINDOW_1D: '1 天',
				REASONING: '推理',
				SETTLED: '已定论',
				UNSETTLED: '未定论',
				SETTLED_HINT: '假设看板已停止，因为再多的查询也无法改变领先假设',
				UNSETTLED_HINT: '看板达到轮次上限而停止，仍有待执行的查询',
				BOARD_META: '{{passes}} 轮 · {{lookups}} 次查询',
				HYPOTHESES: '假设',
				WEIGHT_HINT: '该假设在看板上的权重（所有假设合计 100%）',
				IMPLIES_HINT: '若该假设成立所对应的分类',
				STATUS_VALIDATED: '已验证',
				STATUS_REFINED: '已细化',
				STATUS_DEBUNKED: '已否定',
				STATUS_OPEN: '待定',
				FOR: '支持',
				AGAINST: '反对',
				NONE: '无',
				CONFLICTS: '矛盾',
				LOOKUPS: '调查员查询',
				ROUND_N: '第 {{n}} 轮',
				ROUND_OTHER: '其他查询',
				WHY_ASKED: '查询原因：',
				RESULT: '结果',
				SIGNAL_TITLE: '信号与设备',
				N_TAGS: '{{n}} 个位号',
				RUNNING_AT_CUTOFF: '截止时运行中',
				STOPPED_AT_CUTOFF: '截止时已停机',
				SINCE_RESTART: '自重启',
				SINCE_STOP: '自停机',
				HOURS: '{{n}} 小时',
				LAST_SHUTDOWN: '最近一次停机',
				ONGOING: '进行中',
				RUN_SOURCE: '运行状态：{{source}}（{{tag}}）',
				RUNNING_PCT_HINT: '窗口内设备运行（绿色）与停机（红色）的时间占比',
				RUNNING: '运行',
				SHUTDOWNS: '次停机',
				DOWN: '停机',
				MACHINE_UNKNOWN: '设备运行状态未知：该设备没有运行状态位号。',
				CHARTS_READ: '模型读取的图表',
				ANOMALY_SCORE: '异常评分',
				ENLARGE: '点击放大',
				READ_ALERT_TAG: '告警位号',
				READ_RELATED: '相关位号',
				READ_MACHINE: '设备',
				READ_ANOMALY: '模型解读',
				CONSISTENT_WITH_HISTORY: '与历史一致',
				NOT_CONSISTENT_WITH_HISTORY: '与历史不一致',
				STATS_TITLE: '统计与基线对比',
				STATS_HINT: '— 悬停单元格可查看 p5–p95、斜率及首次超出 3 sd 的时间',
				COL_TAG: '位号',
				COL_MEDIAN: '中位数',
				COL_LAST: '最新',
				COL_Z: 'z（中位）',
				COL_Z_HINT: '窗口中位数相对基线的标准差倍数',
				COL_OUT: '超出 %',
				COL_OUT_HINT: '超出基线 p5–p95 区间的读数占比',
				ALERT_TAG: '告警',
				RUN_TAG: '运行',
				TIP_BASELINE: '基线：中位数 {{median}} ± {{sd}} sd，p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: '已剔除尖峰：{{value}}',
				TIP_MASKED: '已屏蔽故障读数：{{n}}',
				TIP_RANGE: 'p5–p95：{{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: '斜率：{{value}} {{unit}}/天',
				TIP_Z_LAST: 'z（最新）：{{value}} · 最大 |z|：{{max}}',
				TIP_FIRST_3SD: '首次超出 3 sd：{{value}} UTC',
				TIP_NEVER_3SD: '该窗口内从未超出 3 sd',
				FOOT_SPIKES: '统计前已剔除孤立尖峰：{{value}}。',
				FOOT_MASKED: '已屏蔽 {{n}} 个故障读数（质量差 / 超量程）。',
				ANOMALY_TITLE: '异常模型',
				NOT_AVAILABLE: '不可用',
				VERDICT_CONSISTENT: '一致',
				VERDICT_CHANGED: '已变化',
				VERDICT_STARTUP: '启动瞬态',
				VERDICT_INSUFFICIENT: '数据不足',
				MODEL_META: 'PCA {{k}} 个成分 · 方差 {{pct}} · {{rows}} 行训练数据',
				ONSET: '持续偏离起点',
				NO_ONSET: '无',
				FIRST_TO_DEVIATE: '最先偏离的位号',
				ABOVE_LIMIT_24H: '近 24 小时超限占比',
				T2_SPE_HINT: '评分相对于训练数据的 99.5 百分位（1.0 = 限值）。T² 高 = 位号共同移动到不常见的运行点；SPE 高 = 某个位号与其他位号不再吻合（局部故障或仪表问题）；AE = 自编码器重构误差。',
				AT_CUTOFF: '截止时',
				AT_PEAK: '近 24 小时峰值',
				IN_TRANSIENT: '处于启动瞬态内',
				SCORE: '评分',
				KIND_NORMAL: '正常范围内',
				KIND_SPE: '关系破坏（SPE）：某个位号与其他位号不再吻合',
				KIND_T2: '运行点偏移（T²）：位号共同移动，关系保持',
				KIND_BOTH: '运行点异常且关系破坏',
				ACTUAL_VS_EXPECTED: '实际值与根据其他位号得出的预期值',
				NOT_MODELLED: '未建模（运行历史过少）：{{tags}}',
				RECORDS_TITLE: '已读记录',
				OPEN_KNOWN_ISSUE: '存在未关闭的已知问题',
				NO_OPEN_KNOWN_ISSUE: '无未关闭的已知问题',
				OPEN_KNOWN_ISSUE_HINT: '告警时是否已有未关闭的通知单或工单覆盖此状况',
				RECORDS_COUNT: '已读 {{read}} / {{total}} 条记录 · 引用 {{cited}} 条',
				RECORDS_COUNT_HINT: '告警前已有的记录：维护 {{work}} 条、班报 {{reports}} 份、产量损失 {{deferments}} 条；已读取排名靠前的记录',
				OPERATING_EVENTS: '告警前的运行事件',
				FACTS: '引用的事实',
				NO_FACTS: '没有与此告警相关的记录。',
				RELEVANCE_DIRECT: '直接',
				RELEVANCE_RELATED: '相关',
				RELEVANCE_BACKGROUND: '背景',
				IMPL_KNOWN_ISSUE: '已知问题未关闭',
				IMPL_RECENT_WORK: '近期工作可解释',
				IMPL_OPERATING_EVENT: '运行事件',
				IMPL_INSTRUMENT: '仪表问题',
				IMPL_DEGRADATION: '劣化信号',
				DIR_NO_ACTION: '支持无需处理',
				DIR_SERVICE: '支持检修',
				DIR_NEUTRAL: '中性',
				OPEN_IN_MAINTENANCE: '在“维护”标签页中显示',
				OPEN_IN_REPORTS: '在“报告”标签页中显示',
				DROPPED: '已读但不相关 {{n}} 条：{{ids}}',
			},
			VISUAL: {
				TITLE: '图表审查',
				PATTERN_TOGETHER: '位号同步变化',
				PATTERN_DEPARTED: '单个位号单独偏离',
				PATTERN_SHUTDOWN: '停机 / 启动',
				PATTERN_NO_CHANGE: '无显著变化',
				PATTERN_SPLIT: '相关位号走势分化',
				PATTERN_INSUFFICIENT: '数据过少无法判断',
				PATTERN_UNKNOWN: '未分类',
				CONFIDENCE: '置信度 {{value}}',
				CONFIDENCE_HINT: '最终判断的置信度',
				MOVED_TOGETHER_YES: '同步变化',
				MOVED_TOGETHER_NO: '未同步变化',
				DISAGREE: '统计结果与图表不一致——请先查看图表，再采信此判断。',
				AGREE: '图表与统计结果一致',
				STATISTICS_SAY: '统计结论',
				CHARTS_SAY: '图表结论',
				LED_BY: '领先位号',
				LED_BY_HINT: '最先变化的位号',
				DEPARTED_ALONE: '单独偏离',
				DEPARTED_ALONE_HINT: '相关位号保持稳定时单独变化的位号',
				REASONING: '推理',
				CHARTS: '模型读取的图表（{{count}}）',
				NO_CHARTS: '本次运行未保存图表图像。',
				OPEN_CHART: '打开图表 {{n}}',
				CHART_ALT: '截至告警时间的图表 {{n}}',
				CHART_FAILED: '无法加载图表图像',
				CHART_N_OF: '图表 {{n}} / {{total}}',
				CHART_DIALOG_HINT: '图表截止于告警时间之前。使用 ← / → 浏览。',
				PREV_CHART: '上一张图表',
				NEXT_CHART: '下一张图表',
				REVIEWS: '逐位号审查（{{count}}）',
				LEVEL: '水平：{{value}}',
				FLUCTUATION: '波动：{{value}}',
				MODEL: '审查模型：{{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: '关联图',
				CHOOSE_DRAWING: '选择图纸',
				ITEMS_COUNT: '{{count}} 个高亮',
				HAS_INSTRUMENT: '报警仪表',
				HAS_EQUIPMENT: '报警设备',
				TITLE_INSTRUMENT: '{{tag}} 的仪表位置（已高亮）',
				TITLE_EQUIPMENT: '{{tag}} 的设备位置（已高亮）',
				LOADING: '正在加载工艺上下文…',
				LOAD_FAILED: '无法加载此报警的工艺上下文。',
				UNRESOLVED: '报警的设备和仪表不在知识图谱中',
				UNRESOLVED_HINT: '无法显示 P&ID 位置或关联资产。',
				NO_DRAWING: '没有已数字化的 P&ID 显示此设备',
				NO_DRAWING_HINT: '请使用关联图查看关联资产。',
				SAME_LINE: '同一管线',
				SAME_LINE_EMPTY: '同一工艺管线上没有对象。',
				CONNECTED_ON_DRAWING: '图纸上的关联项',
				CONNECTED_EMPTY: '此图纸上没有关联项。',
				CONNECTED_ELSEWHERE: '已关联但不在此图纸上',
				LOCATE: '在图纸上显示',
				ADD_TO_CHART: '将 {{tag}} 添加到图表',
				NOT_LINKED: '未关联',
				GRAPH_EMPTY: '未找到此报警的关联资产。',
				GRAPH_HINT: '大小 = 标签数量 · 点击带历史库标签的节点可绘图',
				ROLE: {
					ALERT_EQUIPMENT: '报警设备',
					ALERT_INSTRUMENT: '报警仪表',
					CONNECTED: '关联',
					SAME_LINE: '同一工艺管线',
					OTHER: '其他',
				},
				EDGE: {
					FLOWS_TO: '流向',
					SERVES: '服务于',
					SENSES: '检测',
					CONTROLS: '控制',
					PROTECTS: '保护',
					SAME_LINE: '同一管线',
					MEASURES: '测量',
					RELATED: '相关',
				},
				NODE_TYPE: {
					EQUIPMENT: '设备',
					INSTRUMENT: '仪表',
					CONTROLVALVE: '控制阀',
					PROCESSLINE: '工艺管线',
				},
				TOOLTIP: {
					TAG: '标签',
					HISTORIAN_TAG: '历史库标签',
					TYPE: '类型',
					ROLE: '角色',
					TAG_COUNT: '历史库标签数',
					LINE: '管线',
					DRAWING: '图纸',
				},
			},
			PAGE_TITLE: '警报',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: '搜索...',
			SEARCH_OWNER: '搜索负责人...',
			OWNER_FILTER: '按负责人筛选',
			CHOOSE_STATUSES: '选择要显示的状态',
			ALL_STATUSES: '所有状态',
			FILTERS: '筛选',
			MORE: '更多',
			WATCHERS: '关注者',
			COLLAPSE_PANEL: '收起面板',
			EXPAND_PANEL: '展开面板',
			RETRY: '重试',
			CLOSE: '关闭',
			PREVIOUS: '上一条警报',
			NEXT: '下一条警报',
			SCORE: '分数',
			SEE_MORE: '查看更多',
			SEE_LESS: '收起',
			CLASS: {
				FALSE_NO_ACTION: '误报 – 无需操作',
				FALSE_DQ: '误报 – 数据质量 (DQ)',
				VALID_NO_ACTION: '有效 – 无需操作',
				CREATE_SERVICE: '有效 – 创建服务',
				HUMAN_REVIEW: 'SME 审核',
				PENDING: '待处理',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'SME 审核（需人工评估）',
				CREATE_SERVICE: '创建案例（启动调查与处理）',
				VALID_NO_ACTION: '有效-无需处理（关闭事件-无服务）',
				FALSE_NO_ACTION: '误报-无需处理（关闭事件-无服务）',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: '未处理',
				APPROVED: '已批准',
				RELEARNED: '已重新学习',
			},
			STATE: {
				ACTIVE: '活动',
				RETURNED_TO_NORMAL: '已恢复正常',
			},
			TELEMETRY: {
				TITLE: '时间序列',
				AVAILABLE: '可用',
				MISSING: '缺失',
				TIP_AVAILABLE: '警报前 24 小时内 {{tag}} 有历史数据',
				TIP_NO_DATA: '警报前 24 小时内 {{tag}} 没有历史数据',
				TIP_NOT_IN_HISTORIAN: '历史数据库中没有 {{tag}}',
				TIP_NO_TAG: '该警报未指定历史数据标签',
				UNUSABLE: '不可用',
				TIP_UNKNOWN: '无法检查可用性',
			},
			TAGX: {
				THIS_EQUIPMENT: '本设备',
				ALL_EQUIPMENT: '所有相关设备 ({{count}})',
				FILTER: '筛选',
				HISTORIAN_RESULTS: '历史库搜索',
				MODE_FUNCTION: '按功能',
				MODE_RELATION: '按关系',
				FILTER_MEASURE: '按测量量筛选',
				FILTER_GROUP: '按功能组筛选',
				CLEAR_FILTERS: '清除筛选',
				SHOW_ALL: '显示全部（还有 {{count}} 个）',
				NO_MATCHES_FILTERED: '所选筛选条件下没有匹配项',
				TITLE: '显示其他位号',
				SEARCH_PLACEHOLDER: '按名称或描述搜索位号',
				MIN_CHARS: '请至少输入 2 个字符',
				SEARCHING: '正在搜索…',
				NO_MATCHES: '没有匹配的位号',
				HAS_DATA: '有历史库数据',
				NO_DATA: '无历史库数据',
				SELECTED: '已选 {{count}} / {{max}}',
				MAX_REACHED: '最多可选择 {{max}} 个位号',
				CLEAR: '清除选择',
				CHART_TOGETHER: '一起绘图',
				HIDE_CHART: '隐藏图表',
				IN_LIST: '已在列表中',
				VIA: '经由 {{via}}',
				GROUP_ALERT: '告警位号',
				GROUP_COMPONENT: '同一部件',
				GROUP_EQUIPMENT: '同一撬装 / 设备',
				GROUP_CONNECTED: '相连设备',
				GROUP_PID: 'P&ID 仪表',
				GROUP_OTHER: '其他相关',
				GROUP_SEARCH: '从搜索添加',
				NO_TAGS: '未找到相关位号',
				LOADING: '正在加载相关位号…',
				FILTER_EMPTY: '没有与“{{q}}”匹配的相关位号',
			},
			QUEUE: {
				DATE_FIELD: '按日期字段筛选',
				DATE_FIELD_EVENT: '事件时间',
				DATE_FIELD_RAISED: '触发时间',
				SORT_OLDEST: '最早优先（点击切换）',
				SORT_NEWEST: '最新优先（点击切换）',
				PAGE_SIZE: '每页行数',
				RANGE: '第 {{start}}–{{end}} 条，共 {{total}} 条',
				FIRST_PAGE: '第一页',
				PREV_PAGE: '上一页',
				NEXT_PAGE: '下一页',
				LAST_PAGE: '最后一页',
				GROUPED_PAGE_HINT: '分组基于本页的告警',
				ON_THIS_PAGE: '本页',
				SIGNAL_START: '事件开始',
				RAISED: '创建于',
				RETURNED_TO_NORMAL_AT: '最后活动（恢复正常）',
				BASELINE_REF: '基线参考',
				BASELINE_REF_TIP: '检测器基线参考时间（{{time}}）：告警描述中“last recorded on …”的时间。它不是事件时间。',
				NOT_ANALYSED: '未分析：{{reason}}',
				NOT_ON_PAGE: '该重复告警不在本页。打开查看详情。',
				COLUMNS: '列',
				RESET_COLUMNS: '显示所有列',
				SET_STATUS: '设置所选告警的状态',
				CSV: {
					PROCESS_UNIT: '工艺单元',
					FLOC: 'FLOC',
					POINTS: '位号',
					DEFINITION_ID: '定义ID',
					NUMBER: '#',
					ALERT_ID: '告警 ID',
					SYSTEM_NAME: '系统名称',
					SYSTEM: '系统',
					STATUS: '状态',
					CLASSIFICATION: '分类',
					CONFIDENCE: '置信度',
					ALERT_NAME: '告警名称',
					SOURCE: '来源',
					EVENT_TIME: '事件开始（信号开始）',
					RAISED: '创建于',
					RETURNED_TO_NORMAL: '最后活动（恢复正常）',
					BASELINE_REF: '基线参考',
					STATE: '运行状态',
					TIME_SERIES: '时间序列',
					ANCHOR_TAG: '锚定标签',
					NOT_ANALYSED: '未分析（DQ 闸门）',
					OWNER: '负责人',
				},
				COLUMN_NUMBER: '编号',
				SORT_BY_COLUMN: '按此列排序',
				DATE_ON_EVENT: '日期范围作用于事件开始',
				DATE_ON_CREATED: '日期范围作用于创建时间（排序列）',
				SHOW_COLUMNS: '显示列',
				SEARCH_COLUMNS: '搜索...',
				SELECT_ALL_COLUMNS: '全选',
				RESET_DEFAULT_COLUMNS: '恢复默认',
				RESIZE_COLUMN: '拖动以调整宽度',
				STILL_ACTIVE: '仍在活动',
			},
			GROUP_BY: {
				TITLE: '分组依据',
				EQUIPMENT: 'Equipment',
				NONE: '无',
				SYSTEM: '系统',
				FACILITY: '设施',
				SOURCE: '来源',
				CLASSIFICATION: '分类',
				ALERT_STATUS: '警报状态',
			},
			MENU: {
				EXPORT: '导出数据',
				COLLAPSE_GROUPS: '折叠所有分组',
				EXPAND_WITHIN_GROUP: '展开组内所有项目',
				AUTO_REFRESH: '自动刷新',
			},
			AUTO_REFRESH: {
				OFF: '关闭',
				LIVE: '实时',
				MIN_5: '5 分钟',
				MIN_15: '15 分钟',
				MIN_30: '30 分钟',
				HOUR_1: '1 小时',
			},
			FILTER: {
				TITLE: '筛选条件',
				SEARCH_ALERT_NAME: '按警报名称搜索...',
				START_TYPING: '输入以搜索',
				APPLY: '应用',
				CLEAR_ALL: '全部清除',
				TARGET_ONLY: '仅目标 FLOC',
				TARGET_TIP: '仅显示资产层级 → FLOC 层级表中所列目标 FLOC 上的警报',
				TARGET_COUNT: '当前视图中有 {{count}} 条警报',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} 个位号',
				DEFINITION_ID: '定义 ID',
				ALERTS: '警报',
				N_ALERTS: '{{count}} 条警报',
				SYSTEM_NAME: '系统名称',
				STATUS: '状态',
				CLASSIFICATION: '分类',
				CONFIDENCE: '置信度',
				ALERT_NAME: '警报名称',
				SOURCE: '来源',
				EVENT_TIME: '事件开始',
				STATE: '状态',
				OWNER: '负责人',
				EMPTY: '没有符合当前筛选条件的警报',
				RECURRING: '重复：本次事件中出现 {{count}} 次',
				TOGGLE_RECURRING: '显示重复警报',
				CREATED_ON: '创建于',
				LAST_ACTIVE: '最后活动',
			},
			BULK: {
				ITEMS: '项',
				ASSIGN_OWNER: '为所选警报分配负责人',
				CHANGE_CLASSIFICATION: '更改分类',
				DONE: '已更新 {{count}} 条警报',
				PARTIAL: '已更新 {{ok}} 条警报，{{failed}} 条无法更新',
			},
			ACTIONS: {
				APPROVE: '批准',
				APPROVED: '已批准',
				RELEARN: '重新学习',
				RELEARNED: '已重新学习',
				CLASSIFY: '分类',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: '位号读取自 SignalMeasurementText',
				POINTS_FROM_DESCRIPTION: '位号读取自告警描述',
				PRIMARY: '主要',
				TAGS_TIP: '此告警涉及的位号（{{count}}）：',
				TAGS_N: '位号（{{count}}）',
				LABEL: '检测器',
				MECHANISM: '检测机制',
				MONITORED_TAG: '监控位号',
				CLUSTER_SIZE: '集群大小',
				FREQUENCY: '频率',
				WINDOW_SPAN: '时间窗口',
				N_ALERTS: '{{count}} 条警报',
				PER_HOUR: '{{value}} 条/小时',
				HOURS: '{{value}} 小时',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: '数据质量（DQ）评估',
				FROZEN: '平线',
				IMPOSSIBLE_ROC: '变化率',
				DOMAIN_RANGE: '超出范围',
				JITTER: '不稳定',
				PASS_FROZEN: '通过（动态）',
				PASS_IMPOSSIBLE_ROC: '通过',
				PASS_DOMAIN_RANGE: '在限值内',
				PASS_JITTER: '信号正常',
				FAIL_FROZEN: '已冻结',
				FAIL_IMPOSSIBLE_ROC: '未通过',
				FAIL_DOMAIN_RANGE: '超出范围',
				FAIL_JITTER: '信号不稳定',
				NOT_ASSESSED: '未评估',
				STATUS_PASS: '通过',
				STATUS_WARN: '警告',
				STATUS_FAIL: '失败',
				STATUS_NO_DATA: '无数据',
				STATUS_UNKNOWN: '未评估',
				NOT_ANALYSED: '未分析',
				READINGS: '{{n}} 个读数 · {{bad}} 个已屏蔽',
				CHECK_INFO: '仅供参考',
				NO_GATE: '此告警尚未进行数据质量评估',
				SCORE: 'DQ 评分：{{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: '快速分诊 · 以 {{pct}} 采纳（{{time}} · {{tokens}} 令牌）— 无需深入调查',
				TIER_QUICK_ONLY: '仅快速分诊 · {{pct}}（{{time}} · {{tokens}} 令牌）',
				TIER_ESCALATED: '已升级至深入调查：',
				TIER_QUICK_WAS: '快速答案：{{cls}} {{pct}}（{{time}} · {{tokens}} 令牌）',
				TIER_FINAL_IS: '最终：{{cls}} {{pct}}',
				MANUAL_CHIP: '手册 · {{label}}',
				TITLE: '分诊代理',
				RECOMMENDATION: '建议',
				NOT_RUN: '尚未对此警报运行分诊代理。点击“运行分诊代理”按钮以自动分类此警报。',
				NO_RECOMMENDATION: '暂无建议。',
				RUN: '运行分诊代理',
				RUNNING: '运行中…',
				RERUN: '重新运行分诊代理',
				CREATES_CASE: '将创建案例',
				CONFIDENCE: '置信度 {{value}}',
				CAPPED: '已封顶',
				CAPPED_HINT: '由于部分证据检查未能运行，置信度上限为 {{value}}',
				VERIFIED_FACTS: '已验证事实与遥测',
				N_VERIFIED: '{{count}} 项已验证',
				HYPOTHESIS: '工作假设与物理机理（原因）',
				SUPPORTING_TAGS: '支持位号',
				FMEA: '动态 FMEA',
				FAILURE_MODE: '故障模式',
				MECHANISM: '物理机理',
				IMPACT: '系统影响',
				REMEDIATION: '处置措施',
				DISCIPLINE: '专业',
				ACTIONABLE: '可执行的工程建议',
				WHAT_WOULD_CHANGE: '何种情况会改变此结论',
				DECIDED_BY: '由 {{model}} 判定',
				HARNESS_VERSION: '框架 {{v}}',
				STALE_RUN: "已过期：此运行早于 {{date}} 的框架更新；请重新运行以查看当前代理",
				DEGRADED: '规则回退',
				DEGRADED_HINT: '判定 LLM 不可用，此结论来自确定性规则。请在批准前复核。',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: '重新学习分类',
				CLASSIFY_TITLE: '分类',
				CORRECT_CLASSIFICATION: '正确分类',
				SELECT_CLASS: '选择新的分类类别...',
				FEEDBACK: '反馈',
				FEEDBACK_REQUIRED: '修订时必填',
				CANCEL: '取消',
				CONFIRM: '确认',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: '本次运行未记录（该部分上线之前的运行）。',
				DROP_TAGS_HINT: '从“显示标签”面板拖动标签以添加图表',
				TAGS: '位号',
				MAINTENANCE: '维护',
				REPORTS: '报告',
				ALERTS: '警报',
				DOCUMENTS: '文档',
				REASONING: '推理',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: '资料库',
					LIMITS: '限值',
					REASONING: '推理',
					PLAYBOOK: '剧本检查',
					SIGNAL: '信号与机器',
					CONNECTED: '关联系统',
					ANOMALY: '异常模型',
					RECORDS: '已读记录',
				},
				NO_TELEMETRY: '这些位号没有历史数据',
				NO_TELEMETRY_HINT: '历史数据库未覆盖证据位号的警报时间窗口。',
				NO_DATA_FOR: '无历史数据',
				NOTIFICATIONS: '通知单',
				NOTIFICATION: '通知单',
				WORK_ORDERS: '工单',
				WORK_ORDER: '工单',
				NONE: '暂无记录',
				ON_THIS_ITEM: '针对此设备',
				DESCRIPTION: '描述',
				NOTIFICATION_NO: '通知单号',
				TYPE: '类型',
				PRIORITY: '优先级',
				RAISED_ON: '创建日期',
				COMPLETED_ON: '完成日期',
				FLOC: '功能位置',
				HIERARCHY_TIER: '层级',
				SUPERVISOR_REPORTS: '主管报告',
				SHIFT_LOGS: '交接班日志',
				RECENT_ALERTS: '近期警报',
				RELATED_ALERTS: '相关警报',
				FIRED_AT: '触发时间',
				CONTEXT: '上下文',
				SHOW_AFTER_ALERT: '显示警报之后的记录',
				HINDSIGHT_HINT: '关闭：仅显示警报触发时已有的记录（与智能体所见一致）。开启：同时显示之后创建的记录。',
				HINDSIGHT_ON: '事后视角已开启：警报之后创建的记录已显示并标记为“警报之后”。智能体未看到这些记录。',
				AFTER_ALERT: '警报之后',
				HIDDEN_AFTER_ALERT: '已隐藏 {{n}} 条警报之后的记录',
				NONE_AT_ALERT: '警报时无记录',
				NOT_ANALYSED: '未分析',
				NO_TIME_SERIES: '无时间序列：{{reason}}',
				TELEMETRY_NO_DATA: '警报前 24 小时内历史库中没有该警报位号的读数',
				TELEMETRY_NOT_IN_HISTORIAN: '警报位号不在历史库中',
				TELEMETRY_NO_TAG: '该警报没有监测位号',
				TELEMETRY_UNKNOWN: '历史库数据可用性未知',
				ADD_TAGS: '添加位号',
				HIDE_TAG_LIST: '隐藏位号列表',
				INCLUDE_BASELINE: '包含基线参考',
				ALERT_WINDOW: '警报时间窗',
				BASELINE_REF_AT: '检测器基线参考：{{at}}',
				CHARTED_TOGETHER: '位号合并图表',
				NO_TAGS_CHARTED: '未绘制位号',
				NO_TAGS_CHARTED_HINT: '在位号列表中搜索或选择相关位号以绘制图表。',
				TAG_LOAD_FAILED: '无法加载该位号',
				OVERLAY: '叠加 – 实际值，每个单位一个 Y 轴',
				OVERLAY_NORMALISED: '所有位号共用一个坐标轴（z 分数，单位不同）',
				STATUS_AT_ALERT: '警报时状态',
				STATUS_NOW: '当前',
				OPEN_AT_ALERT: '警报时未关闭',
				CLOSED_AT_ALERT: '警报时已关闭',
				NOT_RAISED_AT_ALERT: '警报时尚未创建',
				SCOPE_ITEM: '本设备',
				SCOPE_PARENT: '上级',
				BREAKDOWN: '故障停机',
				NUMBER: '编号',
				EQUIPMENT: '设备',
				REPORTED_BY: '报告人',
				PLANNING_GROUP: '计划组',
				WORK_CENTER: '工作中心',
				SYMPTOM: '症状',
				CREATED_ON: '创建时间',
				SCHEDULED_START: '计划开始',
				SCHEDULED_FINISH: '计划完成',
				ESTIMATED_DURATION: '预计时长',
				HOURS_N: '{{n}} 小时',
				COST_ESTIMATE: '成本估算',
				KNOWN_AT: '记录时间',
				LONG_TEXT: '详细信息',
				STATUS_HISTORY: '状态历史',
				PRODUCTION_REPORTS: '生产报告',
				DEFERMENT_REPORTS: '减产报告',
				SUPERVISOR_REPORT: '主管报告',
				PRODUCTION_REPORT: '每日生产报告',
				DEFERMENT_REPORT: '减产报告',
				FULL_SCREEN: '全屏',
				EXIT_FULL_SCREEN: '退出全屏',
				BACK_TO_DOCUMENTS: '返回文档',
				DOWNLOAD: '下载',
				HSSE: 'HSSE',
				PRODUCTION: '生产',
				HSSE_GRADE: 'HSSE 评级',
				PRODUCTION_GRADE: '生产评级',
				REPORT_DATE: '报告日期',
				SOURCE_FILE: '源文件',
				SUMMARY: '摘要',
				PRODUCTION_COMMENT: '生产备注',
				SUPERVISOR_COMMENTS: '主管备注',
				ACTIVITIES: '作业活动',
				FORECAST: '预测 / 后续计划',
				ALARMS: '报警',
				DEFERMENT: '减产',
				OOS: '停用设备',
				IOW: 'DOW / IOW 超限',
				MOCS: '临时 MOC',
				NO_REPORT_TEXT: '无报告内容',
				CATEGORY: '类别',
				MAIN_CAUSE: '主要原因',
				SUB_CAUSE: '次要原因',
				EQUIPMENT_SYSTEM: '设备系统',
				EQUIPMENT_TYPE: '设备类型',
				EVENT_START: '事件开始',
				EVENT_END: '事件结束',
				ENDED_BEFORE_ALERT: '警报前已结束',
				ONGOING_AT_ALERT: '警报时仍在进行',
				RECENT_ALERTS_HINT: '同一位号 / 功能位置',
				RELATED_ALERTS_HINT: '±60 分钟内，同系统优先',
				SUB_ALERTS: '事件子警报',
				SUB_ALERTS_HINT: '归入本事件',
				SAME_SYSTEM: '同一系统',
				OPEN_ALERT: '打开此警报',
				NO_DOCUMENTS: '该设备没有关联文档',
				PID: 'P&ID',
				PAGES_N: '{{n}} 页',
				UPDATED: '更新于',
				SOURCE: '来源',
				REVISION: '版本',
				DOCUMENT_TYPE: '文档类型',
				DOCUMENT_PREVIEW: '文档预览',
				FILE_NAME: '文件名',
				PREVIEW_UNAVAILABLE: '无法预览',
				PREVIEW_UNAVAILABLE_HINT: '文档库中没有该文档的文件。',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: '在最近一次运行中，代理阅读了 {{read}} 份主管报告并引用了 {{cited}} 份——请先阅读被引用的报告。',
				ONLY_AGENT_READ: '仅显示代理阅读过的报告',
				AGENT_CITED: '代理已引用 · {{relevance}}',
				AGENT_READ: '代理已阅读 · 未引用',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: '跳闸',
				LIMIT_ALARM: '报警',
				LIMIT_THRESHOLD: '阈值',
				LIMIT_INSTRUMENT: '仪表量程',
				LIMIT: '限值',
				LIMIT_NONE: '此标签未加载数值',
				TAG_LEGEND: '标签图例',
				MASKED_HIDDEN: '已排除 {{count}} 个被屏蔽的读数（数据质量）',
				NO_UNIT: '无单位',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: '实际值',
				BASELINE: '基线',
				SIGNAL_START: '信号开始',
				RAISED: '触发',
				RTN: '最后活动',
				BASELINE_REF: '基线参考',
				NORMAL_MIN: '正常下限',
				NORMAL_MAX: '正常上限',
				MASKED: '已屏蔽读数（DQ）',
				MASKED_HOVER: '已屏蔽读数',
				ARTEFACT: '替代值 / 数据伪影',
				ARTEFACT_HOVER: '数据伪影（非过程读数）',
				TIME_AXIS: '时间（{{zone}}）',
				OFF_SCALE: '超出刻度',
				MIN: '最小',
				MAX: '最大',
				RANGE_BAND: '最小–最大',
				LOADING: '正在加载数据…',
				LOAD_ERROR: '无法加载此范围的数据',
				NO_DATA_IN_WINDOW: '此时间窗口内无读数',
				HISTORIAN_SPAN: '历史库数据范围：{{first}} 至 {{last}}',
				CLOSE: '关闭图表',
				ZOOM_HINT: '拖动以缩放或平移，将自动加载更多数据。双击重置。',
				LAYOUT_STACKED: '堆叠',
				LAYOUT_OVERLAY: '叠加',
				NORM_NONE: '原始值',
				NORM_ZSCORE: 'Z 分数',
				NORM_RANGE: '范围百分比',
				NORMALISED_Z: 'Z 分数（σ）',
				NORMALISED_PCT: '范围百分比',
				REMOVE_TAG: '移除位号',
				NO_TAGS: '选择位号以一起绘图',
				TOGETHER_TITLE: '一起绘制的位号',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: '目标 FLOC',
				OPEN_ALERT: '打开告警',
				BACK_TO_QUEUE: '返回告警列表',
				ALERT_ANALYSIS: '告警分析',
				EVIDENCE: '证据',
				EVENT_TIME: '事件时间',
				EVENT_TIME_HINT: '信号开始（偏离开始）的时间',
				RAISED: '触发时间',
				RAISED_HINT: '监控系统创建告警的时间。智能体只使用此时已知的信息。',
				RTN: '恢复正常',
				BASELINE_REF: '基线参考',
				BASELINE_REF_HINT: '检测器的参考时间（其基线最后记录的时间），不是事件时间',
				CLASSIFICATION_HINT: '当前分类。选择其他类别以对此告警进行分类或重新学习。',
				CHANGE_CLASS: '更改分类',
				CURRENT_CLASS: '当前分类：{{value}}',
				PREVIOUSLY_APPROVED: '此前已批准',
				PREVIOUSLY_RELEARNED: '此前已重新学习',
				HUMAN_REVIEW_REQUIRED: 'SME 审核 — 需要人工评估',
				NOT_CLASSIFIED: '尚未分类',
				AGENT_PROPOSED: '由分诊智能体提出',
				NOT_ANALYSED_HINT: '分诊智能体不会分析此告警：其数据未通过告警前检查。如有需要请手动分类。',
				NOT_ANALYSED_REASON: '未分析：{{reason}}',
				RUN_BLOCKED: '无法分析',
				RUN_BLOCKED_WHY: '不会分析：{{reason}}',
				RUN_GATED: '未分析',
				EVENT_START: '事件开始',
				CREATED_ON: '创建于',
				LAST_ACTIVE: '最后活跃',
				LAST_ACTIVE_HINT: '告警恢复正常的时间（最后活跃）；仍处于活跃状态时显示“活跃”',
			},
			CASE: {
				CHIP: '案例 #{{id}}',
				CREATE: '创建案例',
				MANAGE_HINT: '创建案例以管理后续工作',
				CREATED: '已创建案例 #{{id}}',
				EXISTS: '案例 #{{id}} 已关联到此告警',
				CREATE_FAILED: '无法创建案例',
				BULK_CREATED: '已创建 {{count}} 个案例。',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: '活动日志',
				DISCUSSION: '讨论',
				TRACES: '追踪',
				PREFERENCES: '偏好设置',
				ANALYSIS: '分析与视图',
				OTHER_TAGS: '显示标签',
				OTHER_TAGS_HINT: '点击标签或将其拖到图表上，即可添加到“标签”选项卡。',
				DOCUMENTS: '文档',
				NO_DOCUMENTS: '没有与此告警关联的文档',
				NO_DOCUMENTS_HINT: '没有手册、P&ID 或报告引用此设备。',
				OPEN_IN_DOCUMENTS: '在“文档”选项卡中显示',
				REVISION: '版本 {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: '将所选标签导出到外部系统',
				SAVED_ANALYSIS: '已保存的分析',
				SAVED_VIEWS: '已保存的视图',
				SAVED_DASHBOARDS: '已保存的仪表盘',
				NOT_AVAILABLE: '分诊告警暂不支持',
				PREFERENCES_NOTE: '分诊图表暂不支持停机区域着色以及跳闸 / 报警 / 阈值线。',
			},
			ACTIVITY: {
				N_ACTIONS: '操作（{{count}}）',
				EMPTY: '暂无活动',
			},
			DISCUSSION: {
				N_COMMENTS: '评论（{{count}}）',
				EMPTY: '暂无评论',
				PLACEHOLDER: '撰写评论...',
				REPLY: '回复',
				REPLY_PLACEHOLDER: '撰写回复...',
				SEND: '发送',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'TMP 行归档于 {{component}} 下，未应用',
				TITLE: '代理流水线追踪',
				EXPAND_ALL: '全部展开',
				COLLAPSE_ALL: '全部收起',
				COMPLETED: '已完成',
				FAILED: '失败',
				N_AGENTS: '{{count}} 个代理',
				NO_RUN: '尚无流水线运行记录',
				NO_RUN_HINT: '运行分诊代理以查看全部 14 个代理的逐步追踪。',
				STATUS_COMPLETED: '已完成',
				STATUS_NO_DATA: '无可用数据',
				STATUS_FAILED: '失败',
				STATUS_SKIPPED: '已跳过',
				TOKENS: 'LLM 令牌：输入 {{input}} / 输出 {{output}}',
			},
			ERRORS: {
				LOAD: '无法加载分诊数据',
				ACTION: '无法完成该操作',
				RUN_FAILED: '分诊代理运行失败',
			},
			TIMELINE: {
				TITLE: '事件时间线',
				N_EVENTS: '{{n}} 个事件',
				RELATED_ALERTS: '近期及相关告警',
				RANGE_ALL: '全部',
				RANGE_90D: '90 天',
				RANGE_30D: '30 天',
				RANGE_7D: '7 天',
				RANGE_1D: '24 小时',
				RESET_ZOOM: '重置缩放',
				ZOOM_IN: '放大',
				N_MORE: '还有 {{n}} 个',
				EMPTY: '此告警没有工单、通知、报告或减产记录。',
				CLICK_TO_OPEN: '点击在下方打开',
				MINUTES: '{{n}} 分钟',
				HOURS: '{{n}} 小时',
				DAYS: '{{n}} 天',
				N_ALERTS_IN: '{{span}} 内 {{n}} 个告警',
				N_EVENTS_IN: '{{span}} 内 {{n}} 个事件',
				KIND_SELF: '此告警',
				KIND_ALERT: '告警',
				KIND_WORK_ORDER: '工单',
				KIND_NOTIFICATION: '通知',
				KIND_SUPERVISOR: '主管报告',
				KIND_PRODUCTION: '生产报告',
				KIND_DEFERMENT: '减产',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
